import { HttpClient, HttpRequest, HttpClientModule } from '@angular/common/http';
import { Injectable, ɵɵdefineInjectable, ɵɵinject, Inject, ComponentFactoryResolver, SecurityContext, NgModule } from '@angular/core';
import { SharedUrlRoutes, UtilHttpStatus, AccessManager, UtilArray, UtilType, UtilDocumentId, VersionManager, UtilSequenceProcess, UtilError, DocumentUpdater, UtilDocument, UtilSystemHeader, UtilValidation, UtilIncludeRuleSet, SearchResultsProcessor, RulesetError, ESQueryUtils, RuleHelper, UtilConflict, UtilRules, UtilString, DocumentIdValidator, FormbirdSharedModule } from '@formbird/shared';
import { SharedConstants, FtError, ChangeSourceType, FormbirdTypesModule } from '@formbird/types';
import { __awaiter, __decorate, __metadata } from 'tslib';
import { distinctUntilChanged, filter, map, concatMap, switchMap } from 'rxjs/operators';
import { Observable, Subject, Subscription, ReplaySubject, from, BehaviorSubject } from 'rxjs';
import { cloneDeep, merge, isObject, isArray, toLower, isEmpty, extend, isEqual, startsWith, isFunction, includes, isDate, isString, isError } from 'lodash';
import { compile } from 'handlebars';
import Dexie__default from 'dexie';
import { Notyf } from 'notyf';
import { DOCUMENT } from '@angular/common';
import loadjs from 'loadjs';
import { whilst, eachSeries } from 'async';
import { combineReducers, createStore, compose, applyMiddleware } from 'redux';
import { enablePatches, produce, applyPatches } from 'immer';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { connect } from 'socket.io-client';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/store/app.store.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This is the public interface of \@formbird/services. It wraps the global
 * redux store and adds a few other add on methods. It's what you'll inject
 * into your Angular application as a service.
 * @abstract
 * @template RootState
 */
class AppStore {
}
/**
 * \@hidden, \@deprecated
 */
AppStore.instance = undefined;
if (false) {
    /**
     * \@hidden, \@deprecated
     * @type {?}
     */
    AppStore.instance;
    /**
     * Configures a Redux store and allows AppStore to observe and dispatch
     * to it.
     *
     * This should only be called once for the lifetime of your app, for
     * example in the constructor of your root component.
     *
     * \@param rootReducer Your app's root reducer
     * \@param initState Your app's initial state
     * \@param middleware Optional Redux middlewares
     * \@param enhancers Optional Redux store enhancers
     * @type {?}
     */
    AppStore.prototype.configureStore;
    /**
     * Accepts a Redux store, then sets it in AppStore and
     * allows AppStore to observe and dispatch to it.
     *
     * This should only be called once for the lifetime of your app, for
     * example in the constructor of your root component. If configureStore
     * has been used this cannot be used.
     *
     * \@param store Your app's store
     * @type {?}
     */
    AppStore.prototype.provideStore;
    /** @type {?} */
    AppStore.prototype.dispatch;
    /** @type {?} */
    AppStore.prototype.getState;
    /** @type {?} */
    AppStore.prototype.subscribe;
    /** @type {?} */
    AppStore.prototype.replaceReducer;
    /** @type {?} */
    AppStore.prototype.select;
    /** @type {?} */
    AppStore.prototype.configureSubStore;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/decorators/helpers.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used with the `\@WithSubStore` class decorator to define a SubStore (AKA a
 * fractal store).
 *
 * For more info on substores, see
 * https://github.com/angular-redux/platform/blob/master/packages/store/articles/fractal-store.md
 * @record
 */
function FractalStoreOptions() { }
if (false) {
    /**
     * The name of an instance method that will define the
     * base path for the subStore. This method is expected to return an array
     * of property names or undefined/null.
     * @type {?}
     */
    FractalStoreOptions.prototype.basePathMethodName;
    /**
     * The localReducer for the substore in question.
     * @type {?}
     */
    FractalStoreOptions.prototype.localReducer;
}
/**
 * OPTIONS_KEY: this is per-class (static) and holds the config from the
 * \@SubStore decorator.
 * @type {?}
 */
const OPTIONS_KEY = '@angular-redux::substore::class::options';
/**
 * INSTANCE_SUBSTORE_KEY, INSTANCE_SELECTIONS_KEY: these are per-instance
 * (non-static) and holds references to the substores/selected observables
 * to be used by an instance of a decorated class. I'm not using
 * reflect-metadata here because I want
 *
 * 1. different instances to have different substores in the case where
 * `basePathMethodName` is dynamic.
 * 2. the instance substore to be garbage collected when the instance is no
 * longer reachable.
 * This is therefore an own-property on the actual instance of the decorated
 * class.
 * @type {?}
 */
const INSTANCE_SUBSTORE_KEY = '@angular-redux::substore::instance::store';
/** @type {?} */
const INSTANCE_SELECTIONS_KEY = '@angular-redux::substore::instance::selections';
/**
 * Used to detect when the base path changes - this allows components to
 * dynamically adjust their selections if necessary.
 * @type {?}
 */
const INSTANCE_BASE_PATH_KEY = '@angular-redux::substore::instance::basepath';
/** @type {?} */
const getClassOptions = (/**
 * @param {?} decoratedInstance
 * @return {?}
 */
(decoratedInstance) => decoratedInstance.constructor[OPTIONS_KEY]);
const ɵ0 = getClassOptions;
/**
 * @hidden
 * @type {?}
 */
const setClassOptions = (/**
 * @param {?} decoratedClassConstructor
 * @param {?} options
 * @return {?}
 */
(decoratedClassConstructor, options) => {
    decoratedClassConstructor[OPTIONS_KEY] = options;
});
// I want the store to be saved on the actual instance so
// 1. different instances can have distinct substores if necessary
// 2. the substore/selections will be marked for garbage collection when the
//    instance is destroyed.
/** @type {?} */
const setInstanceStore = (/**
 * @param {?} decoratedInstance
 * @param {?=} store
 * @return {?}
 */
(decoratedInstance, store) => (decoratedInstance[INSTANCE_SUBSTORE_KEY] = store));
const ɵ1 = setInstanceStore;
/** @type {?} */
const getInstanceStore = (/**
 * @param {?} decoratedInstance
 * @return {?}
 */
(decoratedInstance) => decoratedInstance[INSTANCE_SUBSTORE_KEY]);
const ɵ2 = getInstanceStore;
/** @type {?} */
const getInstanceSelectionMap = (/**
 * @param {?} decoratedInstance
 * @return {?}
 */
(decoratedInstance) => {
    /** @type {?} */
    const map = decoratedInstance[INSTANCE_SELECTIONS_KEY] || {};
    decoratedInstance[INSTANCE_SELECTIONS_KEY] = map;
    return map;
});
const ɵ3 = getInstanceSelectionMap;
/** @type {?} */
const hasBasePathChanged = (/**
 * @param {?} decoratedInstance
 * @param {?=} basePath
 * @return {?}
 */
(decoratedInstance, basePath) => decoratedInstance[INSTANCE_BASE_PATH_KEY] !== (basePath || []).toString());
const ɵ4 = hasBasePathChanged;
/** @type {?} */
const setInstanceBasePath = (/**
 * @param {?} decoratedInstance
 * @param {?=} basePath
 * @return {?}
 */
(decoratedInstance, basePath) => {
    decoratedInstance[INSTANCE_BASE_PATH_KEY] = (basePath || []).toString();
});
const ɵ5 = setInstanceBasePath;
/** @type {?} */
const clearInstanceState = (/**
 * @param {?} decoratedInstance
 * @return {?}
 */
(decoratedInstance) => {
    decoratedInstance[INSTANCE_SELECTIONS_KEY] = null;
    decoratedInstance[INSTANCE_SUBSTORE_KEY] = null;
    decoratedInstance[INSTANCE_BASE_PATH_KEY] = null;
});
const ɵ6 = clearInstanceState;
/**
 * Gets the store associated with a decorated instance (e.g. a
 * component or service)
 * @hidden
 * @type {?}
 */
const getBaseStore = (/**
 * @param {?} decoratedInstance
 * @return {?}
 */
(decoratedInstance) => {
    // The root store hasn't been set up yet.
    if (!AppStore.instance) {
        return undefined;
    }
    /** @type {?} */
    const options = getClassOptions(decoratedInstance);
    // This is not decorated with `@WithSubStore`. Return the root store.
    if (!options) {
        return AppStore.instance;
    }
    // Dynamic base path support:
    /** @type {?} */
    const basePath = decoratedInstance[options.basePathMethodName]();
    if (hasBasePathChanged(decoratedInstance, basePath)) {
        clearInstanceState(decoratedInstance);
        setInstanceBasePath(decoratedInstance, basePath);
    }
    if (!basePath) {
        return AppStore.instance;
    }
    /** @type {?} */
    const store = getInstanceStore(decoratedInstance);
    if (!store) {
        setInstanceStore(decoratedInstance, AppStore.instance.configureSubStore(basePath, options.localReducer));
    }
    return getInstanceStore(decoratedInstance);
});
/**
 * Creates an Observable from the given selection parameters,
 * rooted at decoratedInstance's store, and caches it on the
 * instance for future use.
 * @hidden
 * @type {?}
 */
const getInstanceSelection = (/**
 * @template T
 * @param {?} decoratedInstance
 * @param {?} key
 * @param {?} selector
 * @param {?=} transformer
 * @param {?=} comparator
 * @return {?}
 */
(decoratedInstance, key, selector, transformer, comparator) => {
    /** @type {?} */
    const store = getBaseStore(decoratedInstance);
    if (store) {
        /** @type {?} */
        const selections = getInstanceSelectionMap(decoratedInstance);
        selections[key] =
            selections[key] ||
                (!transformer
                    ? store.select(selector, comparator)
                    : store.select(selector).pipe((/**
                     * @param {?} obs$
                     * @return {?}
                     */
                    obs$ => transformer(obs$, decoratedInstance)), distinctUntilChanged(comparator)));
        return selections[key];
    }
    return undefined;
});

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/decorators/select.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Selects an observable from the store, and attaches it to the decorated
 * property.
 *
 * ```ts
 *  import { select } from '\@formbird/services';
 *
 *  class SomeClass {
 * \@select(['foo','bar']) foo$: Observable<string>
 * }
 * ```
 *
 * @template T
 * @param {?=} selector
 * A selector function, property name string, or property name path
 * (array of strings/array indices) that locates the store data to be
 * selected
 *
 * @param {?=} comparator Function used to determine if this selector has changed.
 * @return {?}
 */
function select(selector, comparator) {
    return (/**
     * @param {?} target
     * @param {?} key
     * @return {?}
     */
    (target, key) => {
        /** @type {?} */
        const adjustedSelector = selector
            ? selector
            : String(key).lastIndexOf('$') === String(key).length - 1
                ? String(key).substring(0, String(key).length - 1)
                : key;
        decorate(adjustedSelector, undefined, comparator)(target, key);
    });
}
/**
 * Selects an observable using the given path selector, and runs it through the
 * given transformer function. A transformer function takes the store
 * observable as an input and returns a derived observable from it. That derived
 *  observable is run through distinctUntilChanges with the given optional
 * comparator and attached to the store property.
 *
 * Think of a Transformer as a FunctionSelector that operates on observables
 * instead of values.
 *
 * ```ts
 * import { select$ } from 'angular-redux/store';
 *
 * export const debounceAndTriple = obs$ => obs$
 *  .debounce(300)
 *  .map(x => 3 * x);
 *
 * class Foo {
 * \@select$(['foo', 'bar'], debounceAndTriple)
 *  readonly debouncedFooBar$: Observable<number>;
 * }
 * ```
 * @template T
 * @param {?} selector
 * @param {?} transformer
 * @param {?=} comparator
 * @return {?}
 */
function select$(selector, transformer, comparator) {
    return decorate(selector, transformer, comparator);
}
/**
 * @param {?} selector
 * @param {?=} transformer
 * @param {?=} comparator
 * @return {?}
 */
function decorate(selector, transformer, comparator) {
    return (/**
     * @param {?} target
     * @param {?} key
     * @return {?}
     */
    function decorator(target, key) {
        /**
         * @this {?}
         * @return {?}
         */
        function getter() {
            return getInstanceSelection(this, key, selector, transformer, comparator);
        }
        // Replace decorated property with a getter that returns the observable.
        if (delete target[key]) {
            Object.defineProperty(target, key, {
                get: getter,
                enumerable: true,
                configurable: true,
            });
        }
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/LocalStorageKeys.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * constants for local storage keys
 * @type {?}
 */
const LocalStorageKeys = {
    LOGGED_IN_USER_ID: 'LoggedInUserID',
    // Also used as offline database table name
    LOGGED_IN_USER: 'LoggedInUser',
    LOGGED_IN_ACCOUNT_CONTROL_DOCUMENT: 'LoggedInAccountControlDocument',
    USER_SETTINGS: 'UserSettings',
    COMMAND_BAR_CSS: 'commandBarCSS',
    APP_VERSION: 'AppVersion',
    CHECK_PUBLIC_USER: "CheckPublicUser"
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UrlBasePathUtil.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
let basePath = '';
/** @type {?} */
const baseTag = document.getElementsByTagName('base')[0];
if (baseTag) {
    basePath = baseTag.href.split('/')[3] || '';
}
/** @type {?} */
const UrlBasePathUtil = {
    basePath: basePath,
    basePathWithSlashPrefix: basePath !== '' ? '/' + basePath : ''
};
class UrlBasePathService {
    /**
     * @return {?}
     */
    getBasePath() {
        return UrlBasePathUtil.basePath;
    }
}
UrlBasePathService.decorators = [
    { type: Injectable }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/local-storage/local-storage.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LocalStorageService {
    /**
     * @param {?} urlBasePathService
     */
    constructor(urlBasePathService) {
        this.urlBasePathService = urlBasePathService;
    }
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    setItem(key, value) {
        key = this.urlBasePathService.getBasePath() + key;
        return localStorage.setItem(key, value);
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getItem(key) {
        key = this.urlBasePathService.getBasePath() + key;
        return localStorage.getItem(key);
    }
    /**
     * @param {?} key
     * @return {?}
     */
    removeItem(key) {
        key = this.urlBasePathService.getBasePath() + key;
        return localStorage.removeItem(key);
    }
}
LocalStorageService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
LocalStorageService.ctorParameters = () => [
    { type: UrlBasePathService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    LocalStorageService.prototype.urlBasePathService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/page-visibility.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger = console;
/** @type {?} */
let pageVisibilityService$;
class PageVisibilityService {
    constructor() {
        // main snippet source: https://www.html5rocks.com/en/tutorials/pagevisibility/intro/
        this.visibilityListeners = [];
        this.evtname = null;
        pageVisibilityService$ = this;
    }
    /**
     * @private
     * @return {?}
     */
    getHiddenProp() {
        /** @type {?} */
        const prefixes = ['webkit', 'moz', 'ms', 'o'];
        // if 'hidden' is natively supported just return it
        if ('hidden' in document) {
            return 'hidden';
        }
        // otherwise loop over all the known prefixes until we find one
        for (let i = 0; i < prefixes.length; i++) {
            if ((prefixes[i] + 'Hidden') in document) {
                return prefixes[i] + 'Hidden';
            }
        }
        // otherwise it's not supported
        return null;
    }
    /**
     * @return {?}
     */
    isHidden() {
        /** @type {?} */
        const prop = pageVisibilityService$.getHiddenProp();
        if (!prop) {
            return false;
        }
        return document[prop];
    }
    /**
     * @private
     * @return {?}
     */
    visChange() {
        /** @type {?} */
        const hidden = pageVisibilityService$.isHidden();
        for (let x = 0; x < pageVisibilityService$.visibilityListeners.length; x++) {
            pageVisibilityService$.visibilityListeners[x](hidden);
        }
    }
    /**
     * @return {?}
     */
    startListeningForPageVisibility() {
        if (this.evtname !== null) { // done init, skip.
            return;
        }
        // use the property name to generate the prefixed event name
        /** @type {?} */
        const visProp = pageVisibilityService$.getHiddenProp();
        if (visProp) {
            this.evtname = visProp.replace(/[H|h]idden/, '') + 'visibilitychange';
            document.addEventListener(this.evtname, this.visChange);
        }
        else {
            logger.error('Visibility API not supported by browser.');
        }
    }
    /**
     * @return {?}
     */
    stopListeningForPageVisibility() {
        document.removeEventListener(this.evtname, this.visChange);
        this.evtname = null; // reset so we can enable it back via startListening..
    }
    /**
     * Listeners should execute as fast as possible.
     *
     * It is the responsibility of the listener to implement its own debounce logic so to avoid unnecessary repetitive
     * execution.
     *
     * At the moment, debounce will not be implemented here to allow the listeners to react in the shortest
     * possible time.
     * @param {?} listener the listener
     * @return {?}
     */
    registerVisibilityListener(listener) {
        this.visibilityListeners.push(listener);
    }
    /**
     * @param {?} listener
     * @return {?}
     */
    removeVisibilityListener(listener) {
        throw new Error('Unsupported operation exception.');
    }
}
PageVisibilityService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
PageVisibilityService.ctorParameters = () => [];
/** @nocollapse */ PageVisibilityService.ɵprov = ɵɵdefineInjectable({ factory: function PageVisibilityService_Factory() { return new PageVisibilityService(); }, token: PageVisibilityService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    PageVisibilityService.prototype.visibilityListeners;
    /**
     * @type {?}
     * @private
     */
    PageVisibilityService.prototype.evtname;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/actions/user.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$1 = console;
/** @type {?} */
const USER_SET_USER = 'USER_SET_USER';
/**
 * @record
 */
function IUserSetUserAction() { }
if (false) {
    /** @type {?} */
    IUserSetUserAction.prototype.payload;
}
/**
 * @param {?} user
 * @return {?}
 */
function userSetUser(user) {
    return {
        type: USER_SET_USER,
        payload: {
            user
        }
    };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/user/logged-in-user.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const serverRoutes = SharedUrlRoutes.serverRoutes;
/** @type {?} */
const logger$2 = console;
/** @type {?} */
let LoggedInUserService$;
class LoggedInUserService {
    // listeners for 'set' events in the user config.
    /**
     * @param {?} http
     * @param {?} localStorageService
     * @param {?} pageVisibilityService
     * @param {?} appStore
     */
    constructor(http, localStorageService, pageVisibilityService, appStore) {
        this.http = http;
        this.localStorageService = localStorageService;
        this.pageVisibilityService = pageVisibilityService;
        this.appStore = appStore;
        this.user = {
            welcomeMsg: '',
            account: null,
            filteredAccount: null,
            menu: null,
            publicAccount: false,
            accountPublicURL: null,
            accountControlDocument: null,
            accountGroupConfigDocument: null
        };
        this.userConfigItemListeners = []; // listeners for 'set' events in the user config.
        LoggedInUserService$ = this;
        this.pageVisibilityService.registerVisibilityListener((/**
         * @param {?} isPageHidden
         * @return {?}
         */
        (isPageHidden) => {
            if (isPageHidden) {
                return;
            }
            /** @type {?} */
            const trueUserId = this.localStorageService.getItem(LocalStorageKeys.LOGGED_IN_USER_ID);
            /** @type {?} */
            const registeredUserId = this.user.account == null ? null : this.user.account.documentId;
            if (trueUserId !== registeredUserId) { // user changed
                window.location.reload(); // just reload the page so that everything is checked from its initial state.
            }
        }));
        this.user$.subscribe((/**
         * @param {?} user
         * @return {?}
         */
        (user) => this.user = user));
    }
    /**
     * get the id of the logged in user
     * @return {?}
     */
    getUserId() {
        return this.user.account != null ? this.user.account.documentId : this.localStorageService.getItem(LocalStorageKeys.LOGGED_IN_USER_ID);
    }
    /**
     * set the user on login
     * @param {?} account - the account to set
     * @return {?}
     */
    setUser(account) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            if (account) {
                this.user.filteredAccount = this.filterAcct(cloneDeep(account));
                this.user.account = account;
                this.user.menu = account.menu;
                if (account.systemHeader) {
                    this.user.welcomeMsg = account.systemHeader.summaryName;
                }
                this.localStorageService.setItem(LocalStorageKeys.LOGGED_IN_USER_ID, account.documentId);
                try {
                    /** @type {?} */
                    const accountGroupConfigDocument = yield this.loggedUserAccountGroupConfigDocument();
                    this.setUserAccountGroupConfigDocument(accountGroupConfigDocument);
                }
                catch (err) {
                    logger$2.error("Error on getting accountGroupConfig document " + err.message);
                }
                this.loggedUserAccountControlDocument().subscribe((/**
                 * @param {?} resp
                 * @return {?}
                 */
                resp => {
                    this.setUserControlDocument(resp);
                    resolve();
                }));
            }
            else {
                resolve();
            }
        })));
    }
    /**
     * @param {?} controlDocument
     * @return {?}
     */
    setUserControlDocument(controlDocument) {
        if (controlDocument) {
            this.user.accountControlDocument = controlDocument;
            if (controlDocument.publicAccount) {
                this.user.publicAccount = controlDocument.publicAccount;
                this.user.accountPublicURL = controlDocument.accountPublicURL;
            }
        }
        this.appStore.dispatch(userSetUser(this.user));
    }
    /**
     * @return {?}
     */
    getUserControlDocument() {
        return this.user.accountControlDocument;
    }
    /**
     * @return {?}
     */
    loggedUserAccountControlDocument() {
        /** @type {?} */
        const url = serverRoutes.loggedUserAccountControlDocument;
        return this.http.get(url);
    }
    /**
     * @param {?} groupConfigDocument
     * @return {?}
     */
    setUserAccountGroupConfigDocument(groupConfigDocument) {
        if (groupConfigDocument) {
            this.user.accountGroupConfigDocument = groupConfigDocument;
        }
        this.appStore.dispatch(userSetUser(this.user));
    }
    /**
     * @return {?}
     */
    loggedUserAccountGroupConfigDocument() {
        /** @type {?} */
        const url = serverRoutes.loggedUserAccountGroupConfigDocument;
        return this.http.get(url);
    }
    /**
     * @return {?}
     */
    getUserAccountGroupConfigDocument() {
        return this.user.accountGroupConfigDocument;
    }
    /**
     * remove the user on logout
     * @return {?}
     */
    logoutUser() {
        this.resetUser();
        localStorage.removeItem(LocalStorageKeys.LOGGED_IN_USER_ID);
        this.userConfigItemListeners = [];
    }
    /**
     * @private
     * @param {?} account
     * @return {?}
     */
    filterAcct(account) {
        /** @type {?} */
        const fieldsToRemove = [
            'accessKeys',
            'attachKeys',
            'components',
            'menu',
            'provider'
        ];
        for (let i = 0; i < fieldsToRemove.length; i++) {
            delete account[fieldsToRemove[i]];
        }
        return account;
    }
    /**
     * @return {?}
     */
    resetUser() {
        // reset only values. See http://stackoverflow.com/questions/19744462/update-scope-value-when-service-data-is-changed
        this.user.welcomeMsg = '';
        this.user.account = null;
        this.user.filteredAccount = null;
        this.user.menu = null;
    }
    /**
     * Custom user configuration is saved in local storage so that they survive across logins.
     * To that end, they should only contain flags or basic values keeping in mind the
     * limited storage capacity of local storage.
     * @return {?}
     */
    getUserConfig() {
        /** @type {?} */
        const userId = this.getUserId();
        if (userId == null) {
            logger$2.error('Requesting for user config with no user logged in.');
            return;
        }
        /** @type {?} */
        let userConfig;
        userConfig = this.localStorageService.getItem(userId);
        if (userConfig == null) {
            // add default user config here
            userConfig = {
                cachingEnabled: false,
                idbCurrentVersion: 0,
                searchIndexes: [],
                // pending
                registeredSearchIndexes: [],
                lastSyncDate: 0 // last time we synched offline
            };
            this.localStorageService.setItem(userId, JSON.stringify(userConfig));
        }
        else {
            userConfig = JSON.parse(userConfig);
        }
        return userConfig;
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getUserConfigItem(key) {
        if (key == null) {
            logger$2.error('Missing key on requesting user config.');
            return;
        }
        /** @type {?} */
        const userConfig = this.getUserConfig();
        if (userConfig == null) {
            return;
        }
        return userConfig[key];
    }
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    setUserConfigItem(key, value) {
        if (key == null) {
            logger$2.error('Missing key on setting user config.');
            return;
        }
        /** @type {?} */
        let userConfig;
        userConfig = this.getUserConfig();
        if (userConfig == null) {
            return;
        }
        userConfig[key] = value;
        this.localStorageService.setItem(this.getUserId(), JSON.stringify(userConfig));
        for (let x = 0; x < this.userConfigItemListeners.length; x++) {
            /** @type {?} */
            const listener = this.userConfigItemListeners[x];
            if (listener.key === key) {
                listener.listener(value); // informs the listener of the new value
            }
        }
    }
    /**
     * Custom implementation for listening to changes in user config items. Originally this should
     * have been done via using StorageEventListener but unfortunately it fires events only if other
     * tabs had modified the offline storage.
     * @param {?} key the key
     * @param {?} listener the listener
     * @return {?}
     */
    addUserConfigItemListener(key, listener) {
        if (key == null || listener == null) {
            return;
        }
        this.userConfigItemListeners.push({ key: key, listener: listener });
    }
    /**
     * @return {?}
     */
    isUserOfflineMode() {
        return this.getUserConfigItem('cachingEnabled') === true;
    }
    /**
     * @return {?}
     */
    getLoggedInUser() {
        return this.user.account;
    }
    /**
     * @return {?}
     */
    loadLoggedUser() {
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const url = serverRoutes.loggedUserData;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.http.get(url).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                /** @type {?} */
                const userBean = response;
                _self.setUserControlDocument(response.controlDoc);
                _self.setUserAccountGroupConfigDocument(response.groupConfigDoc);
                _self.appStore.dispatch(userSetUser(_self.user));
                return resolve(userBean);
            }), (/**
             * @param {?} error
             * @return {?}
             */
            error => {
                if (_self.isUserOfflineMode() && error.status === UtilHttpStatus.SERVER_UNRESPONSIVE) { // account will be retrieved
                    resolve({ user: _self.user.account });
                }
                else {
                    reject(error);
                }
            }));
        }));
    }
    /**
     * @return {?}
     */
    setLoggedUser() {
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const url = serverRoutes.loggedUserData;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.http.get(url).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            (response) => {
                /** @type {?} */
                const userBean = response;
                /** @type {?} */
                const account = userBean.user;
                _self.user.filteredAccount = _self.filterAcct(cloneDeep(account));
                _self.user.account = account;
                _self.user.menu = account.menu;
                if (account.systemHeader) {
                    _self.user.welcomeMsg = account.systemHeader.summaryName;
                }
                _self.localStorageService.setItem(LocalStorageKeys.LOGGED_IN_USER_ID, account.documentId);
                _self.setUserControlDocument(userBean.controlDoc);
                _self.setUserAccountGroupConfigDocument(userBean.groupConfigDoc);
                resolve(userBean);
            }), (/**
             * @param {?} error
             * @return {?}
             */
            error => {
                if (_self.isUserOfflineMode() && error.status === UtilHttpStatus.SERVER_UNRESPONSIVE) { // item will be retried
                    resolve({ user: _self.user.account });
                }
                else {
                    reject(error);
                }
            }));
        }));
    }
    /**
     * @return {?}
     */
    observableUser() {
        return this.user$;
    }
}
LoggedInUserService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
LoggedInUserService.ctorParameters = () => [
    { type: HttpClient },
    { type: LocalStorageService },
    { type: PageVisibilityService },
    { type: AppStore }
];
/** @nocollapse */ LoggedInUserService.ɵprov = ɵɵdefineInjectable({ factory: function LoggedInUserService_Factory() { return new LoggedInUserService(ɵɵinject(HttpClient), ɵɵinject(LocalStorageService), ɵɵinject(PageVisibilityService), ɵɵinject(AppStore)); }, token: LoggedInUserService, providedIn: "root" });
__decorate([
    select(['userState', 'user']),
    __metadata("design:type", Observable)
], LoggedInUserService.prototype, "user$", void 0);
if (false) {
    /** @type {?} */
    LoggedInUserService.prototype.user$;
    /**
     * @type {?}
     * @private
     */
    LoggedInUserService.prototype.user;
    /**
     * @type {?}
     * @private
     */
    LoggedInUserService.prototype.userConfigItemListeners;
    /**
     * @type {?}
     * @private
     */
    LoggedInUserService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    LoggedInUserService.prototype.localStorageService;
    /**
     * @type {?}
     * @private
     */
    LoggedInUserService.prototype.pageVisibilityService;
    /**
     * @type {?}
     * @private
     */
    LoggedInUserService.prototype.appStore;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/access/client-access.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ClientAccessService {
    /**
     * @param {?} loggedInUserService
     */
    constructor(loggedInUserService) {
        this.loggedInUserService = loggedInUserService;
        this.user$.subscribe((/**
         * @param {?} user
         * @return {?}
         */
        (user) => this.user = user));
    }
    /**
     * @param {?} targetDocument
     * @param {?} operation
     * @return {?}
     */
    checkAccess(targetDocument, operation) {
        if (!targetDocument) {
            return true;
        }
        return AccessManager.checkAccess(targetDocument, this.user.accountControlDocument, operation);
    }
    /**
     * @param {?} targetDocument
     * @param {?} operations
     * @return {?}
     */
    hasPermission(targetDocument, operations) {
        if (!targetDocument) {
            return true;
        }
        return AccessManager.hasPermission(targetDocument, this.user.accountControlDocument, operations);
    }
    // Document access determined by comparing systemHeader.keyIds against the user's attachKeys.
    // A new document inherits keyIds from its template and from the user that created it.
    /**
     * @param {?} document
     * @param {?} template
     * @return {?}
     */
    writeKeysToDocument(document, template) {
        /** @type {?} */
        const userAccountControlDocument = this.user.accountControlDocument;
        AccessManager.writeKeysToDocument(document, template, userAccountControlDocument);
    }
}
ClientAccessService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ClientAccessService.ctorParameters = () => [
    { type: LoggedInUserService }
];
/** @nocollapse */ ClientAccessService.ɵprov = ɵɵdefineInjectable({ factory: function ClientAccessService_Factory() { return new ClientAccessService(ɵɵinject(LoggedInUserService)); }, token: ClientAccessService, providedIn: "root" });
__decorate([
    select(['userState', 'user']),
    __metadata("design:type", Observable)
], ClientAccessService.prototype, "user$", void 0);
if (false) {
    /** @type {?} */
    ClientAccessService.prototype.user$;
    /** @type {?} */
    ClientAccessService.prototype.user;
    /**
     * @type {?}
     * @private
     */
    ClientAccessService.prototype.loggedInUserService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/broadcast/broadcast.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function BroadcastEvent() { }
if (false) {
    /** @type {?} */
    BroadcastEvent.prototype.key;
    /** @type {?|undefined} */
    BroadcastEvent.prototype.data;
}
class BroadcastService {
    constructor() {
        this._eventBus = new Subject();
    }
    /**
     * @param {?} key
     * @param {?=} data
     * @return {?}
     */
    broadcast(key, data) {
        this._eventBus.next({ key, data });
    }
    /**
     * @template T
     * @param {?} key
     * @return {?}
     */
    on(key) {
        return this._eventBus
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        event => event.key === key)))
            .pipe(map((/**
         * @param {?} event
         * @return {?}
         */
        event => (/** @type {?} */ (event.data)))));
    }
}
BroadcastService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
BroadcastService.ctorParameters = () => [];
if (false) {
    /**
     * @type {?}
     * @private
     */
    BroadcastService.prototype._eventBus;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/IndexedDBConstants.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const IndexedDBConstants = (/** @type {?} */ ({
    VERSION: 9,
    FT_DOCUMENTS_DB_NAME_PREFIX: 'ft-documents-',
    FT_PROPERTIES_TABLE_NAME: 'ftProperties',
    FT_PROPERTIES_TABLE_INDEX_KEY: 'key',
    DB_NAME: 'formbird',
    DB_INDEXES: 'indexedDBIndexes',
    // document store constants
    DOCUMENT_TABLE_NAME: 'documents',
    DOCUMENT_INDEX_PENDING_OPERATION: 'systemHeader.offlineDetails.status',
    DOCUMENT_INDEX_VERSION_ID: 'systemHeader.versionId',
    DOCUMENT_INDEX_DOCUMENT_ID: 'documentId',
    DOCUMENT_INDEX_SYSTEM_TYPE: 'systemHeader.systemType',
    DOCUMENT_INDEX_SUMMARY_NAME: 'systemHeader.summaryName',
    // under offlineFiles store
    OFFLINE_FILE_TABLE_NAME: 'offlineFiles',
    OFFLINE_FILE_INDEX_STATUS: 'status',
    OFFLINE_FILE_INDEX_FILENO: 'fileNo',
    // universal offline statuses
    OFFLINE_STATUS_UPLOADED: 1,
    // cached or already uploaded
    OFFLINE_STATUS_PENDING: 0,
    // waiting for upload
    OFFLINE_STATUS_UPLOADING: 2,
    // uploading
    OFFLINE_STATUS_FAILED: -1
}));
// the systemHeader.versionId needs to be first because it is the primary key
IndexedDBConstants.DOCUMENT_INDEXES = [IndexedDBConstants.DOCUMENT_INDEX_VERSION_ID,
    IndexedDBConstants.DOCUMENT_INDEX_DOCUMENT_ID,
    IndexedDBConstants.DOCUMENT_INDEX_SYSTEM_TYPE,
    IndexedDBConstants.DOCUMENT_INDEX_PENDING_OPERATION,
    IndexedDBConstants.DOCUMENT_INDEX_SUMMARY_NAME];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/notification/notification.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NotificationService {
    constructor() {
        this.queue = [];
        this.currentMessage = {};
        this._scope = null;
        this.notyf = new Notyf({
            ripple: false,
            types: [
                {
                    type: 'warning',
                    className: 'notyf-warning',
                    icon: {
                        className: 'material-icons',
                        tagName: 'i',
                        text: 'warning'
                    }
                },
                {
                    type: 'info',
                    className: 'notyf-info',
                    dismissible: true,
                    icon: {
                        className: 'material-icons',
                        tagName: 'i',
                        text: 'info'
                    }
                }
            ]
        });
    }
    /**
     * position:
     *     { x: 'right', y: 'top' }
     *     { x: 'center', y: 'top' }
     *     { x: 'left', y: 'top' }
     *     { x: 'right', y: 'bottom' }
     *     { x: 'center', y: 'bottom' }
     *     { x: 'left', y: 'bottom' }
     *      /**
     * (e.g) position: { x: 'right', y: 'top' }
     *     notyf position options
     *     Param |       Type                | Details
     *     x     |  left ; center or right  | x-position
     *     y     | top  ; center or bottom  |  y-position
     * @private
     * @param {?} message
     * @param {?} messageType
     * @param {?} title
     * @param {?} position
     * @param {?} preventDuplicate
     * @param {?} onClickFunction
     * @param {?} timeOut
     * @return {?}
     */
    printNotyfMessage(message, messageType, title, position, preventDuplicate, onClickFunction, timeOut) {
        if (!messageType) {
            messageType = SharedConstants.STATUS_INFO;
        }
        if (!position || /^toast/.test(position)) {
            position = { x: 'right', y: 'top' };
        }
        preventDuplicate = preventDuplicate ? preventDuplicate : false;
        /** @type {?} */
        const notyfMessage = !(!title || title === '') ? '<i class="notyf-message-type">[' + messageType + ']</i><b>' +
            title + '</b> <br/>' + message : message;
        /** @type {?} */
        const lowerCaseMessageType = messageType.toLowerCase();
        /** preventDuplicate condition
         * if value is true, do not display duplicate notification
         * if value is false, display duplicate notification
         **/
        if (preventDuplicate) {
            /** @type {?} */
            const notyfTextContent = this.notyf.view.container.textContent;
            /** @type {?} */
            let compareMessage = !(!title || title === '') ? '[' + messageType + ']' + title + ' ' + message : message;
            if (lowerCaseMessageType === 'warning') {
                compareMessage = 'warning' + compareMessage;
            }
            else if (lowerCaseMessageType === 'info') {
                compareMessage = 'info' + compareMessage;
            }
            /**The message is duplicate if notyfTextContent.split(compareMessage).length greater than 1
             * The message is duplicate if preventDuplicate value is true and
             * [title, message and messageType] are similar with new notification message
             * */
            if (notyfTextContent.split(compareMessage).length > 1) {
                if (lowerCaseMessageType === 'success') {
                    console.log('%cDuplicate ' + lowerCaseMessageType + ' notification: ' + notyfMessage, `background: #3dc663;color:white`);
                }
                else if (lowerCaseMessageType === 'info') {
                    console.log('%cDuplicate ' + lowerCaseMessageType + ' notification: ' + notyfMessage, `background: blue;color:white`);
                }
                else if (lowerCaseMessageType === 'warning') {
                    console.log('%cDuplicate ' + lowerCaseMessageType + ' notification: ' + notyfMessage, `background: orange;color:white`);
                }
                else if (lowerCaseMessageType === 'error') {
                    console.log('%cDuplicate ' + lowerCaseMessageType + ' notification: ' + notyfMessage, `background: #ed3d3d;color:white`);
                }
                else if (lowerCaseMessageType === 'forbidden') {
                    console.log('%cDuplicate ' + lowerCaseMessageType + ' notification: ' + notyfMessage, `background: #ed3d3d;color:white`);
                }
                return;
            }
        }
        switch (lowerCaseMessageType) {
            case SharedConstants.STATUS_SUCCESS:
                this.notyf.open({ type: 'success', duration: timeOut, message: notyfMessage, dismissible: true, position: position });
                break;
            case SharedConstants.STATUS_INFO:
                this.notyf.open({ type: 'info', duration: timeOut, message: notyfMessage, dismissible: true, position: position });
                break;
            case SharedConstants.STATUS_WARNING:
                this.notyf.open({ type: 'warning', duration: timeOut, message: notyfMessage, dismissible: true, position });
                break;
            case SharedConstants.STATUS_ERROR:
                this.notyf.open({ type: 'error', message: notyfMessage, duration: timeOut, dismissible: true, position: position });
                break;
            case SharedConstants.STATUS_FORBIDDEN:
                this.notyf.error({ message: notyfMessage, duration: timeOut, dismissible: true, position: position });
                break;
        }
    }
    /**
     * position:
     *     { x: 'right', y: 'top' }
     *     { x: 'center', y: 'top' }
     *     { x: 'left', y: 'top' }
     *     { x: 'right', y: 'bottom' }
     *     { x: 'center', y: 'bottom' }
     *     { x: 'left', y: 'bottom' }
     *      /**
     * (e.g) position: { x: 'right', y: 'top' }
     *     notyf position options
     *     Param |       Type                | Details
     *     x     |  left ; center or right  | x-position
     *     y     | top  ; center or bottom  |  y-position
     * @private
     * @param {?} message
     * @param {?} messageType
     * @param {?} title
     * @param {?} position
     * @param {?} preventDuplicate
     * @param {?} onClickFunction
     * @param {?} timeOut
     * @return {?}
     */
    printHTML5Notification(message, messageType, title, position, preventDuplicate, onClickFunction, timeOut) {
        ((/** @type {?} */ (window))).Notification.requestPermission((/**
         * @param {?} permission
         * @return {?}
         */
        function (permission) {
            /** @type {?} */
            let icon;
            /** @type {?} */
            const lowerCaseMessageType = messageType.toLowerCase();
            switch (lowerCaseMessageType) {
                case SharedConstants.STATUS_SUCCESS:
                    icon = './images/notifications/success.png';
                    break;
                case SharedConstants.STATUS_INFO:
                    icon = './images/notifications/info.png';
                    break;
                case SharedConstants.STATUS_WARNING:
                    icon = './images/notifications/warning.png';
                    break;
                case SharedConstants.STATUS_ERROR:
                    icon = './images/notifications/error.png';
                    break;
                case SharedConstants.STATUS_FORBIDDEN:
                    icon = './images/notifications/warning.png';
                    break;
            }
            /** @type {?} */
            const notification = new ((/** @type {?} */ (window))).Notification('Formbird', {
                body: message,
                icon: icon,
                dir: 'auto'
            });
            notification.onclick = (/**
             * @return {?}
             */
            function () {
                onClickFunction();
            });
            setTimeout((/**
             * @return {?}
             */
            function () {
                notification.close();
            }), timeOut);
        }));
    }
    /**
     * Display both messages
     * @param {?} message
     * @param {?=} messageType
     * @param {?=} title
     * @param {?=} position
     * @param {?=} preventDuplicate
     * @param {?=} displayDesktopNotification
     * @param {?=} onClickFunction
     * @param {?=} timeOut
     * @param {?=} isPermanent
     * @return {?}
     */
    printMessage(message, messageType, title, position, preventDuplicate, displayDesktopNotification, onClickFunction, timeOut, isPermanent) {
        if (isPermanent) {
            timeOut = 0;
        }
        else if (!timeOut) {
            timeOut = 3000;
        }
        if (!onClickFunction) {
            onClickFunction = (/**
             * @return {?}
             */
            function () { });
        }
        if (displayDesktopNotification) {
            this.printHTML5Notification(message, messageType, title, position, preventDuplicate, onClickFunction, timeOut);
        }
        this.printNotyfMessage(message, messageType, title, position, preventDuplicate, onClickFunction, timeOut);
    }
    /**
     * @param {?} message
     * @return {?}
     */
    set(message) {
        /** @type {?} */
        const msg = message;
        this.queue.push(msg);
    }
    /**
     * @return {?}
     */
    get() {
        return this.currentMessage;
    }
    /**
     * @param {?} message
     * @param {?=} title
     * @param {?=} displayDesktopNotification
     * @return {?}
     */
    error(message, title, displayDesktopNotification) {
        /** @type {?} */
        const messageType = SharedConstants.STATUS_ERROR;
        /** @type {?} */
        const position = '';
        /** @type {?} */
        const preventDuplicate = false;
        /** @type {?} */
        const onClickFunction = null;
        // leave this undefined so the default will be used
        /** @type {?} */
        const timeOut = 0;
        /** @type {?} */
        const isPermanent = true;
        this.printMessage(message, messageType, title, position, preventDuplicate, displayDesktopNotification, onClickFunction, timeOut, isPermanent);
    }
    /**
     * @param {?} message
     * @param {?=} title
     * @param {?=} displayDesktopNotification
     * @return {?}
     */
    forbidden(message, title, displayDesktopNotification) {
        if (!title) {
            title = 'Forbidden';
        }
        this.error(message, title, displayDesktopNotification);
    }
    /**
     * @param {?} message
     * @param {?=} title
     * @param {?=} displayDesktopNotification
     * @return {?}
     */
    info(message, title, displayDesktopNotification) {
        this.printMessage(message, SharedConstants.STATUS_INFO, title, '', undefined, displayDesktopNotification);
    }
    /**
     * @param {?} message
     * @param {?=} title
     * @param {?=} displayDesktopNotification
     * @return {?}
     */
    success(message, title, displayDesktopNotification) {
        this.printMessage(message, SharedConstants.STATUS_SUCCESS, title, '', undefined, displayDesktopNotification);
    }
    /**
     * @param {?} message
     * @param {?=} title
     * @param {?=} displayDesktopNotification
     * @return {?}
     */
    warning(message, title, displayDesktopNotification) {
        this.printMessage(message, SharedConstants.STATUS_WARNING, title, '', undefined, displayDesktopNotification);
    }
    /**
     * @param {?} scope
     * @param {?} maxAlertMessages
     * @return {?}
     */
    setupAlert(scope, maxAlertMessages) {
        this._scope = scope;
        this._scope.MaxAlertMessages = [];
        if (!maxAlertMessages) {
            maxAlertMessages = 5;
        }
        for (let i = 0; i < maxAlertMessages; i++) {
            /** @type {?} */
            const alertPlaceholderId = 'alert_placeholder_' + i;
            this._scope.MaxAlertMessages.push(alertPlaceholderId);
        }
    }
    /**
     * @return {?}
     */
    reverseSetupAlert() {
        if (this._scope != null && this._scope.MaxAlertMessages != null) {
            delete this._scope.MaxAlertMessages;
        }
    }
}
NotificationService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
NotificationService.ctorParameters = () => [];
/** @nocollapse */ NotificationService.ɵprov = ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(); }, token: NotificationService, providedIn: "root" });
if (false) {
    /** @type {?} */
    NotificationService.prototype.notyf;
    /**
     * @type {?}
     * @private
     */
    NotificationService.prototype.queue;
    /**
     * @type {?}
     * @private
     */
    NotificationService.prototype.currentMessage;
    /**
     * @type {?}
     * @private
     */
    NotificationService.prototype._scope;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/indexeddb/indexed-dbconnector.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$3 = console;
// Flags used to indicate if we need to wait for onupgradeneeded function to complete. This is to solve 10049#c33176
// retrieve the db without upgrading it (like when the user refreshes the page after db was created)
/** @type {?} */
const GET_DB_EVENT_DEFAULT = 0;
// create the db, perform the default upgrade function and retrieve the db
/** @type {?} */
const GET_DB_EVENT_INIT = 1;
// perform search index upgrade function and retrieve the db
/** @type {?} */
const GET_DB_EVENT_REG_SEARCH_INDEXES = 2;
/** @type {?} */
let IndexedDBConnectorService$;
class IndexedDBConnectorService {
    /**
     * @param {?} loggedInUserService
     * @param {?} pageVisibilityService
     * @param {?} notificationService
     */
    constructor(loggedInUserService, pageVisibilityService, notificationService) {
        this.loggedInUserService = loggedInUserService;
        this.pageVisibilityService = pageVisibilityService;
        this.notificationService = notificationService;
        this.offlineDatabase = {
            idb: null,
            // indexedDB database reference
            idbVersion: 0,
            name: '',
            // typically the logged-in user id
            state: 'closed',
            // opening, opened, error (prob when opening)
            pendingRequests: [] // requests that arrived while idb is being opened.
        };
        this.pageVisibilityService.registerVisibilityListener((/**
         * @param {?} isPageHidden
         * @return {?}
         */
        (isPageHidden) => {
            if (isPageHidden) {
                return;
            }
            this.getDatabase().then((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                let trueIdbVersion = this.loggedInUserService.getUserConfigItem('idbCurrentVersion');
                trueIdbVersion = trueIdbVersion == null ? 0 : trueIdbVersion;
                /** @type {?} */
                let registeredIdbVersion = this.offlineDatabase.idbVersion;
                registeredIdbVersion = registeredIdbVersion == null ? 0 : registeredIdbVersion;
                // reload since there's a new version of idb due to cache being enabled by another tab, or new search indexes
                // registered by another tab.
                if (typeof window !== 'undefined' && trueIdbVersion !== registeredIdbVersion) {
                    window.location.reload();
                }
            }));
        }));
        IndexedDBConnectorService$ = this;
    }
    /**
     * @return {?}
     */
    getLoggedInUserService() {
        return this.loggedInUserService;
    }
    /**
     * @return {?}
     */
    getDatabase() {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            if (_self.offlineDatabase.idb) {
                resolve(_self.offlineDatabase.idb);
            }
            else {
                // lazy-load Dexie so it is not loaded until offline is enabled
                // TODO: lazy-load dexie back when undefined dexie's GlobalPromise issue resolved
                _self.tryPersistWithoutPromptingUser().then((/**
                 * @param {?} persist
                 * @return {?}
                 */
                function (persist) {
                    switch (persist) {
                        case "never":
                            logger$3.info("Not possible to persist storage");
                            break;
                        case "persisted":
                            logger$3.info("Successfully persisted storage silently");
                            break;
                        case "prompt":
                            logger$3.info("Not persisted, but we may prompt user when we want to.");
                            navigator.storage.persist().then((/**
                             * @param {?} persistent
                             * @return {?}
                             */
                            function (persistent) {
                                if (persistent) {
                                    logger$3.info("Not persisted, but we may prompt user when we want to.");
                                }
                                else {
                                    logger$3.warn("Storage may be cleared by the UA under storage pressure.");
                                    /** @type {?} */
                                    const message = "If your device is low on storage, the offline database may be cleared\ " +
                                        "in this browser. Please choose a browser that does not have this limitation";
                                    _self.notificationService.printMessage(message, 'warn', null, { x: 'right', y: 'top' });
                                }
                            }));
                            break;
                    }
                }));
                /** @type {?} */
                const idbName = IndexedDBConstants.FT_DOCUMENTS_DB_NAME_PREFIX + _self.loggedInUserService.getUserId();
                /** @type {?} */
                const db = new Dexie__default(idbName);
                /** @type {?} */
                const documentIndexes = IndexedDBConstants.DOCUMENT_INDEXES;
                /** @type {?} */
                let indexes = _self.loggedInUserService.getUserConfigItem('searchIndexes');
                indexes = _self.getIndexKeyFromAccountGroupConfig(indexes);
                for (let i = 0; i < indexes.length; i++) {
                    UtilArray.add(documentIndexes, indexes[i], true, null);
                }
                /** @type {?} */
                let currentVersion = _self.loggedInUserService.getUserConfigItem('idbCurrentVersion');
                currentVersion = currentVersion ? currentVersion : IndexedDBConstants.VERSION;
                // open the database as a dexie database
                db.version(IndexedDBConstants.VERSION).stores({
                    // each table has a list of indexes assigned. The first index is the primary key,
                    // so systemHeader.versionId
                    // is the primary key for documents
                    documents: documentIndexes.toString(),
                    ftProperties: 'key',
                    offlineFiles: 'fileNo, status'
                });
                _self.offlineDatabase.idb = db;
                _self.offlineDatabase.idbVersion = currentVersion;
                _self.loggedInUserService.setUserConfigItem('searchIndexes', documentIndexes);
                _self.loggedInUserService.setUserConfigItem('idbCurrentVersion', currentVersion);
                resolve(_self.offlineDatabase.idb);
            }
        }));
    }
    /**
     * @return {?}
     */
    tryPersistWithoutPromptingUser() {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (!navigator.storage || !navigator.storage.persisted) {
                resolve("never");
            }
            navigator.storage.persisted().then((/**
             * @param {?} persisted
             * @return {?}
             */
            function (persisted) {
                if (persisted) {
                    resolve("persisted");
                }
                else {
                    if (!navigator.permissions || !navigator.permissions.query) {
                        resolve("prompt");
                    }
                    navigator.permissions.query({ name: "persistent-storage" }).then((/**
                     * @param {?} permission
                     * @return {?}
                     */
                    function (permission) {
                        if (permission.state === "granted") {
                            navigator.storage.persist().then((/**
                             * @param {?} persisted
                             * @return {?}
                             */
                            function (persisted) {
                                if (persisted) {
                                    resolve("persisted");
                                }
                                else {
                                    reject(new Error("Failed to persist"));
                                }
                            }));
                        }
                        if (permission.state === "prompt") {
                            resolve("prompt");
                        }
                        resolve("never");
                    }));
                }
            }));
        }));
    }
    /**
     * @return {?}
     */
    upgradeOfflineDatabase() {
        /** @type {?} */
        const currentVersion = this.loggedInUserService.getUserConfigItem('idbCurrentVersion');
        /** @type {?} */
        const nextVersion = Number(currentVersion) + 1;
        /** @type {?} */
        const indexes = this.loggedInUserService.getUserConfigItem('searchIndexes');
        /** @type {?} */
        const db = this.offlineDatabase.idb;
        if (db) {
            db.close();
            db.version(nextVersion).stores({
                documents: indexes.toString(),
                ftProperties: 'key',
                offlineFiles: 'fileNo, status'
            });
            db.open();
            this.loggedInUserService.setUserConfigItem('idbCurrentVersion', nextVersion);
            this.offlineDatabase.idb = db;
            logger$3.info('Offline DB has been upgraded to version: ' + nextVersion);
        }
    }
    // /**
    //  THIS METHOD IS NOT USED ANY WHERE. WILL BE CONVERTED TO ANGULAR LATER.
    //  * Generic function for opening
    //  * @param version
    //  * @param requestEvent
    //  * @returns {jQuery.promise|promise|*}
    //  */
    // function openOfflineDatabase(version, requestEvent){
    //   var deferred = $q.defer();
    //
    //   var onsuccessComplete = false;
    //   //we should wait for upgrade in two cases: [1]upon creating the database & [2]upon registering search indexes
    //   var dontWaitForUpgrade = requestEvent === GET_DB_EVENT_DEFAULT;
    //   var onupgradeComplete = dontWaitForUpgrade;//regard as completed if don't wait
    //
    //   /**
    //    * Chrome and Firefox do not behave the same way when it comes to the order/timing which IDBDatabase.onsuccess
    //    * and IDBDatabase.onupgradeneeded functions. resolveOpenRequest will make sure that onupgradeneeded function
    //    * completes before we return the IDBDatabase reference to those who request it via the getDatabase function.
    //    *
    //    * See 10049#c33176
    //    */
    //   var resolveOpenDBRequest = function(IDBDatabase){
    //     if(onsuccessComplete && onupgradeComplete){
    //       deferred.resolve(IDBDatabase);
    //       $rootScope.$digest();
    //       return deferred.promise;
    //     }
    //   };
    //
    //   var idbName = LoggedInUserService.getUserId();
    //
    //   var dbRequest = indexedDB.open(idbName, parseInt(version));
    //
    //   dbRequest.onblocked = function(event) {
    //     logger.info("IndexedDB Event: indexedDB blocked. ");
    //   };
    //
    //   dbRequest.onerror = function (event) {
    //     var msg = "Error opening indexedDB: " + event.target.error.message;
    //     logger.error(msg);
    //     if (event.target.error.name === "VersionError") {
    //
    //       var nextVersion = parseInt(version) + 1;
    //       LoggedInUserService.setUserConfigItem('idbCurrentVersion', nextVersion);
    //       logger.info("Reloading page to open IDB with version: " + nextVersion);
    //
    //       $window.location.reload();
    //
    //     } else if (event.target.error.name === "AbortError") {
    //       logger.error("Error: AbortError.");
    //     } else {
    //       logger.error("Error: " + event.target.error.name);
    //       deferred.reject(event.target.error);
    //     }
    //   };
    //
    //   dbRequest.onsuccess = function (event) {
    //     // only set the database version when the upgrade is successful
    //     LoggedInUserService.setUserConfigItem('idbCurrentVersion', version);
    //
    //     logger.info('IndexedDB Event: ' + indexedDBConstants.DB_NAME + ' storage opened successfully. Version: ' + version);
    //
    //     var database = dbRequest.result;
    //
    //     database.onclose = function (evt) {
    //       logger.info("Closing indexedDB database: " + database.name);
    //       $window.alert("Offline database closed.");
    //     };
    //
    //     database.onabort = function (evt) {
    //       logger.error("IndexedDB abort occured: " + evt.target.error.message);
    //       logger.error(evt);
    //     };
    //
    //     database.onversionchange = function (evt) {//another tab might have upgraded the database
    //       logger.info('IndexedDB Event: database version changed.');
    //
    //       ModalService.showDialog('A new version for the offline database is available. Please reload.',
    //         'WARNING',
    //         function () {
    //           $window.location.reload();
    //         },
    //         function () {
    //
    //         });
    //     };
    //
    //     database.onerror = function(evt){
    //       logger.error('IDBDatabase error occurred: ' + evt.target.error.message);
    //       logger.error(evt);
    //     };
    //
    //     onsuccessComplete = true;
    //     resolveOpenDBRequest(database);
    //
    //   };
    //
    //   var defaultUpgradeFunc =  function (event) {
    //
    //     var database = event.target.result;
    //     //If the an objectStore's structure is modified in a future version, make sure to remove
    //     //the old version of the objectStore (if it exists)
    //
    //     //recreate tables to prep for whatever structural changes in the indexes
    //     var tables = [
    //       {
    //         name: indexedDBConstants.DOCUMENT_TABLE_NAME,
    //         param: { keyPath: "systemHeader.versionId", autoIncrement: false},
    //         indexes : [
    //           {
    //             name:  indexedDBConstants.DOCUMENT_INDEX_VERSION_ID,
    //             path: "systemHeader.versionId",
    //             unique: true
    //           },
    //           {
    //             name: indexedDBConstants.DOCUMENT_INDEX_DOCUMENT_ID,
    //             path: "documentId",
    //             unique: false
    //           },
    //           {
    //             name: indexedDBConstants.DOCUMENT_INDEX_PENDING_OPERATION,
    //             path: "systemHeader.offlineDetails.status",
    //             unique: false
    //           },
    //           {
    //             name: indexedDBConstants.DOCUMENT_INDEX_SYSTEM_TYPE,
    //             path: "systemHeader.systemType",
    //             unique: false
    //           }
    //         ]
    //       },
    //       {
    //         name: indexedDBConstants.FT_PROPERTIES_TABLE_NAME,
    //         param:{ keyPath: "key", autoIncrement: false},
    //         indexes : [
    //           { name: "key", path: "key", unique: true }
    //         ]
    //       },
    //       {
    //         name: indexedDBConstants.OFFLINE_FILE_TABLE_NAME,
    //         param: { keyPath: 'fileNo', autoIncrement : false},
    //         indexes:[
    //           { name: "fileNo", path: "fileNo", unique: true },
    //           { name: "status", path: "status", unique: false }
    //         ]
    //       }
    //     ];
    //
    //     //recreate tables for new structural changes in the indexes
    //     for(var i = 0 ; i < tables.length ; i++){
    //       var tbl = tables[i];
    //       //Do not add recreate already existing objectStores else an ConstraintError error will be thrown.
    //       if(database.objectStoreNames.contains(tbl.name)){
    //         database.deleteObjectStore(tbl.name);
    //       }
    //       var store = database.createObjectStore(tbl.name, tbl.param);
    //       for(var z = 0 ; z < tbl.indexes.length; z++){
    //         var index = tbl.indexes[z];
    //         createIndex(store, index.name, index.path, index.unique);
    //       }
    //     }
    //
    //     logger.info("IndexedDB Event: Default offline database indexes set.");
    //
    //     onupgradeComplete = true;
    //     resolveOpenDBRequest(database);
    //
    //   };
    //
    //   var registerSearchIndexesFunc = function (event) {
    //
    //     var searchIndexes = LoggedInUserService.getUserConfigItem('searchIndexes');
    //     var objectStore = event.target.transaction.objectStore(indexedDBConstants.DOCUMENT_TABLE_NAME);
    //
    //     for(var x = 0 ; x < searchIndexes.length ; x++){
    //       var value = searchIndexes[x].replace(".", "___");
    //       createIndex(objectStore, value, value, false);
    //     }
    //
    //     //record all registered indexes
    //     var registered = LoggedInUserService.getUserConfigItem('registeredSearchIndexes');
    //     LoggedInUserService.setUserConfigItem('registeredSearchIndexes', angular.extend(registered, searchIndexes));
    //
    //     logger.info("Search indexes registered." + searchIndexes);
    //
    //     onupgradeComplete = true;
    //     var database = event.target.result;
    //     resolveOpenDBRequest(database);
    //   };
    //
    //   var regSearchIndexes = requestEvent === GET_DB_EVENT_REG_SEARCH_INDEXES;
    //
    //   dbRequest.onupgradeneeded = regSearchIndexes ? registerSearchIndexesFunc: defaultUpgradeFunc;
    //
    //   return deferred.promise;
    //
    // }
    /**
     * @return {?}
     */
    upgradeIndexedDB() {
        /** @type {?} */
        const searchIndexes = this.loggedInUserService.getUserConfigItem('searchIndexes');
        /** @type {?} */
        const registered = this.loggedInUserService.getUserConfigItem('registeredSearchIndexes');
        /** @type {?} */
        let hasUnregisteredIndex = false;
        for (let k = 0; k < searchIndexes.length; k++) {
            hasUnregisteredIndex = registered.indexOf(searchIndexes[k]) === -1;
            if (hasUnregisteredIndex) {
                break;
            }
        }
        if (!hasUnregisteredIndex) {
            return Promise.resolve(); // just return a resolved promise
        }
        return this.getDatabase();
    }
    /**
     * open an IndexedDB cursor
     * @param {?} cursorIndexName - the name of the index to open a cursor on
     * @param {?} cursorRange - an IndexedDBKeyRange (part of the IndexedDB api) of the cursor to open
     * @return {?} promise.promise|*|jQuery.promise the promise
     */
    openCursor(cursorIndexName, cursorRange) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.getDatabase().then((/**
             * @param {?} db
             * @return {?}
             */
            function (db) {
                /** @type {?} */
                const tbl = IndexedDBConstants.DOCUMENT_TABLE_NAME;
                /** @type {?} */
                const transaction = db.transaction(tbl, 'readwrite');
                /** @type {?} */
                const store = transaction.objectStore(tbl);
                /** @type {?} */
                const index = store.index(cursorIndexName);
                /** @type {?} */
                const request = index.openCursor(cursorRange);
                request.onsuccess = (/**
                 * @return {?}
                 */
                function () {
                    /** @type {?} */
                    const cursor = request.result;
                    resolve(cursor);
                });
                request.onerror = (/**
                 * @return {?}
                 */
                function () {
                    reject('Error opening indexedDB cursor in table: ' + tbl);
                });
            }));
        }));
    }
    /**
     * @private
     * @param {?} objectStore
     * @param {?} indexName
     * @param {?} keyPath
     * @param {?} isUnique
     * @return {?}
     */
    createIndex(objectStore, indexName, keyPath, isUnique) {
        if (!UtilArray.contains(objectStore.indexNames, indexName)) {
            objectStore.createIndex(indexName, keyPath, { unique: !!isUnique });
        }
    }
    /**
     * @return {?}
     */
    closeDatabase() {
        if (this.offlineDatabase.idb != null) {
            this.offlineDatabase.idb.close();
            this.offlineDatabase.idb = null;
            this.offlineDatabase.idbVersion = null;
            this.offlineDatabase.state = 'closed';
        }
        return Promise.resolve();
    }
    /**
     * @param {?} indexes
     * @return {?}
     */
    getIndexKeyFromAccountGroupConfig(indexes) {
        /** @type {?} */
        let accountConfig = this.loggedInUserService.getUserAccountGroupConfigDocument();
        if (accountConfig && accountConfig.indexedDBIndexes && accountConfig.indexedDBIndexes.length > 0) {
            indexes = UtilArray.union(indexes, accountConfig.indexedDBIndexes);
        }
        return indexes;
    }
}
IndexedDBConnectorService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
IndexedDBConnectorService.ctorParameters = () => [
    { type: LoggedInUserService },
    { type: PageVisibilityService },
    { type: NotificationService }
];
/** @nocollapse */ IndexedDBConnectorService.ɵprov = ɵɵdefineInjectable({ factory: function IndexedDBConnectorService_Factory() { return new IndexedDBConnectorService(ɵɵinject(LoggedInUserService), ɵɵinject(PageVisibilityService), ɵɵinject(NotificationService)); }, token: IndexedDBConnectorService, providedIn: "root" });
if (false) {
    /** @type {?} */
    IndexedDBConnectorService.prototype.offlineDatabase;
    /**
     * @type {?}
     * @private
     */
    IndexedDBConnectorService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBConnectorService.prototype.pageVisibilityService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBConnectorService.prototype.notificationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilService.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilService {
    /**
     * @param {?} url
     * @param {?=} id
     * @return {?}
     */
    static getDataUrl(url, id) {
        /** @type {?} */
        let dataUrl = url;
        if (UtilType.hasValue(id)) {
            dataUrl += '/' + id;
        }
        return dataUrl;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    static hasValue(val) {
        return UtilType.hasValue(val);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    static isDefined(val) {
        return UtilType.isDefined(val);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/config/config.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ConfigService {
    constructor() { }
    /**
     * @return {?}
     */
    clientConfig() {
        return window['ftClientConfig'];
    }
}
ConfigService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ConfigService.ctorParameters = () => [];
/** @nocollapse */ ConfigService.ɵprov = ɵɵdefineInjectable({ factory: function ConfigService_Factory() { return new ConfigService(); }, token: ConfigService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/ClientConstants.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
'use strict';
/**
 * A constants object for constants that are used on the client-side only
 * @type {?}
 */
const ClientConstants = {
    // Used for the search filter
    FILTER: 'filter',
    FILTERED_QUERY: 'queryToBeFiltered',
    HTTP_STATUS_LOGIN_REJECTED: 401,
    OPERATION_TYPE_POST: 'POST',
    // HTTP Post (insert) operation
    OPERATION_TYPE_PUT: 'PUT',
    // HTTP Put (update) operation
    OPERATION_TYPE_DELETE: 'DELETE',
    // HTTP Delete operation
    LAST_ENTERED_STATE_URL: 'LastEnteredStateUrl',
    URL_EQUAL_REPLACEMENT_STRING: 'fttf',
    // element ids
    TOGGLE_ID_LEFT: 'left_close',
    // broadcasts
    DOCUMENT_NEW: 'document:new',
    DOCUMENT_SAVING: 'document:saving',
    DOCUMENT_CHANGED: 'document:changed',
    DOCUMENT_DESTROYED: 'document:destroyed',
    DOCUMENT_LOADED: 'document:loaded',
    DOCUMENT_LOAD_ERROR: 'document:loadError',
    VALIDATE_FORM_FIELDS: 'document:validateFormFields',
    DOCUMENT_FORM_UPDATED: 'document:formUpdated',
    PRESAVE_DOCUMENT_FORM_RESET: 'document:preSaveDocumentReset',
    FORM_DETECT_CHANGES: 'form:detectChanges',
    URL_CLICKED: 'url:clicked',
    FORM_DIRTY_UPDATED: 'formDirty',
    SPINNER_UPDATED: 'showSpinner',
    FORM_RESET: 'formReset',
    // validation
    VALIDATION_INTERVAL_TIME: 500,
    // 500 milliseconds
    VALIDATION_REQUIRED_KEY: 'required',
    VALIDATION_REQUIRED_MESSAGE: 'This field is required.',
    VALIDATION_MIN_LENGTH_KEY: 'hasMinLength',
    VALIDATION_MIN_LENGTH_MESSAGE: 'This field is required at least %s characters long.',
    VALIDATION_MAX_LENGTH_KEY: 'hasMaxLength',
    VALIDATION_MAX_LENGTH_MESSAGE: 'This field is required max %s characters long.',
    MAIN_DOCUMENT_INFO_LIST: 'MainDocumentInfoList',
    CHILD_DOCUMENT_INFO_LIST: 'ChildDocumentInfoList',
    DIALOG_DOCUMENT_INFO_LIST: 'DialogDocumentInfoList',
    CHANGED_DOCUMENT_LIST_ID_KEY: '___DOCUMENT_LIST_ID___',
    FILE_SENT_EVENT_NAME: 'FileSentEventName',
    LOCAL_STORAGE_OFFLINE_STATUS_KEY: 'OfflineStatus',
    BEFORE_INSTALL_PROMPT: 'beforeinstallprompt',
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/actions/offline.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$4 = console;
/** @type {?} */
const OFFLINE_SET_OFFLINE_STATUS = 'OFFLINE_SET_OFFLINE_STATUS';
/**
 * @record
 */
function IOfflineSetOfflineStatusAction() { }
if (false) {
    /** @type {?} */
    IOfflineSetOfflineStatusAction.prototype.payload;
}
/**
 * @param {?} offlineStatus
 * @return {?}
 */
function offlineSetOfflineStatus(offlineStatus) {
    return {
        type: OFFLINE_SET_OFFLINE_STATUS,
        payload: {
            offlineStatus
        }
    };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/offline-status/offline-status.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class OfflineStatusService {
    /**
     * @param {?} loggedInUserService
     * @param {?} appStore
     * @param {?} broadcastService
     * @param {?} localStorageService
     */
    constructor(loggedInUserService, appStore, broadcastService, localStorageService) {
        this.loggedInUserService = loggedInUserService;
        this.appStore = appStore;
        this.broadcastService = broadcastService;
        this.localStorageService = localStorageService;
        this.offlineStatus = {
            unsyncedCount: 0,
            connected: true,
            incomingCacheCount: 0,
            maxCacheCount: 0,
            currentCacheCount: 0,
            cacheLoading: false,
            pendingDocumentCount: 0,
            errorCacheCount: 0,
            cachingApp: false,
            initialCachingComplete: true,
            connectionText: null,
            currentStaticResourceCount: 0,
            totalStaticResourceCount: 0,
            tileServerCacheCount: 0,
            tileServerMaxCacheCount: 0,
            errorCacheAttachedFile: []
        };
        this.offlineStatusSubject = new Subject();
        this.offlineStatus$ = this.offlineStatusSubject.asObservable();
        this.pageDownloadProgress = {
            pageNumber: 0,
            loaded: 0,
            total: 0
        };
    }
    /**
     * @return {?}
     */
    getLastSyncDate() {
        // initial value is zero see this.loggedInUserService;
        // fetch directly from the User settings so it will still work across logins
        return this.loggedInUserService.getUserConfigItem('lastSyncDate');
    }
    /**
     * @param {?} document
     * @return {?}
     */
    setLastSyncDate(document) {
        // update the last sync date if the date is later than the stored value. This will be used to sync new objects
        // when data is saved or the app is loaded again. The sync will only happen from the last sync date value
        if (document && document.systemHeader && document.systemHeader.serverUpdatedDate) {
            // use the number of values since the epoch (1/1/1970) in milliseconds, as returned by the valueOf() function,
            // so it can be used to easily compare
            /** @type {?} */
            const syncDate = new Date(document.systemHeader.serverUpdatedDate).valueOf();
            if (syncDate > this.getLastSyncDate()) {
                this.loggedInUserService.setUserConfigItem('lastSyncDate', syncDate);
            }
        }
    }
    /**
     * @return {?}
     */
    setOfflineStatusToLocalStorage() {
        this.localStorageService.setItem(ClientConstants.LOCAL_STORAGE_OFFLINE_STATUS_KEY, JSON.stringify(this.offlineStatus));
        // publish offline status subject.
        // This can be changed to publish the subject in other tabs when the data changes in localStorage
        this.offlineStatusSubject.next(this.offlineStatus);
        this.appStore.dispatch(offlineSetOfflineStatus(this.offlineStatus));
        this.broadcastService.broadcast('offlineStatus:updated', this.offlineStatus);
    }
    /**
     * Displays the loading cache status in the page
     * @param {?} isCacheLoading
     * returns true if all pending documents had been cached.
     * @return {?}
     */
    setCacheLoadingStatus(isCacheLoading) {
        this.offlineStatus.cacheLoading = isCacheLoading;
        this.setOfflineStatusToLocalStorage();
        return this.offlineStatus.currentCacheCount === this.offlineStatus.maxCacheCount;
    }
    /**
     * @return {?}
     */
    setConnected() {
        this.offlineStatus.connected = true;
        this.offlineStatus.connectionText = 'Online';
        this.setOfflineStatusToLocalStorage();
    }
    /**
     * @return {?}
     */
    setDisconnected() {
        this.offlineStatus.connected = false;
        this.offlineStatus.connectionText = 'Offline';
        this.setOfflineStatusToLocalStorage();
    }
    /**
     * @param {?} count
     * @return {?}
     */
    addToMaxCacheCount(count) {
        if (count) {
            this.offlineStatus.maxCacheCount += count;
            this.setOfflineStatusToLocalStorage();
        }
    }
    /**
     * @param {?} doc
     * @return {?}
     */
    ignoreCacheDocument(doc) {
        this.offlineStatus.currentCacheCount++;
        this.offlineStatus.errorCacheCount++;
        this.setOfflineStatusToLocalStorage();
    }
    /**
     * @return {?}
     */
    getErrorCacheCount() {
        return this.offlineStatus.errorCacheCount;
    }
    /**
     * @param {?} document
     * @return {?}
     */
    initialCacheQuerySuccess(document) {
        this.offlineStatus.currentCacheCount++;
        if (this.offlineStatus.currentCacheCount === this.offlineStatus.maxCacheCount) {
            this.offlineStatus.currentCacheCount = 0;
            this.offlineStatus.maxCacheCount = 0;
        }
        this.setOfflineStatusToLocalStorage();
        this.setLastSyncDate(document);
    }
    /**
     * @param {?} complete
     * @return {?}
     */
    setInitialCachingComplete(complete) {
        this.offlineStatus.initialCachingComplete = (complete === true);
        this.setOfflineStatusToLocalStorage();
    }
    /**
     * @param {?} pendingCount
     * @return {?}
     */
    setPendingDocumentCount(pendingCount) {
        this.offlineStatus.pendingDocumentCount = pendingCount;
        this.setOfflineStatusToLocalStorage();
    }
    /**
     * @return {?}
     */
    incPendingDocumentCount() {
        this.offlineStatus.pendingDocumentCount++;
        this.setOfflineStatusToLocalStorage();
    }
    /**
     * @return {?}
     */
    decPendingDocumentCount() {
        this.offlineStatus.pendingDocumentCount--;
        this.setOfflineStatusToLocalStorage();
    }
    /**
     * @return {?}
     */
    isConnected() {
        return this.offlineStatus.connected;
    }
    /**
     * @param {?} isCachingApp
     * @return {?}
     */
    setCachingAppStatus(isCachingApp) {
        this.offlineStatus.cachingApp = isCachingApp;
        this.setOfflineStatusToLocalStorage();
    }
    /**
     * @param {?} count
     * @return {?}
     */
    setCurrentStaticResourceCount(count) {
        this.offlineStatus.currentStaticResourceCount = count;
        this.setOfflineStatusToLocalStorage();
    }
    /**
     * @param {?} count
     * @return {?}
     */
    setTotalStaticResourceCount(count) {
        this.offlineStatus.totalStaticResourceCount = count;
        this.setOfflineStatusToLocalStorage();
    }
    /**
     * @param {?} offlineStatus
     * @return {?}
     */
    mergeOfflineStatusData(offlineStatus) {
        merge(this.offlineStatus, offlineStatus);
    }
}
OfflineStatusService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
OfflineStatusService.ctorParameters = () => [
    { type: LoggedInUserService },
    { type: AppStore },
    { type: BroadcastService },
    { type: LocalStorageService }
];
if (false) {
    /** @type {?} */
    OfflineStatusService.prototype.offlineStatus;
    /**
     * @type {?}
     * @private
     */
    OfflineStatusService.prototype.offlineStatusSubject;
    /** @type {?} */
    OfflineStatusService.prototype.offlineStatus$;
    /** @type {?} */
    OfflineStatusService.prototype.pageDownloadProgress;
    /**
     * @type {?}
     * @private
     */
    OfflineStatusService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    OfflineStatusService.prototype.appStore;
    /**
     * @type {?}
     * @private
     */
    OfflineStatusService.prototype.broadcastService;
    /**
     * @type {?}
     * @private
     */
    OfflineStatusService.prototype.localStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/indexeddb/dexie-search.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$5 = console;
class DexieSearchService {
    /**
     * @param {?} indexedDBConnectorService
     */
    constructor(indexedDBConnectorService) {
        this.indexedDBConnectorService = indexedDBConnectorService;
    }
    /**
     * @private
     * @return {?}
     */
    getDatabase() {
        return this.indexedDBConnectorService.getDatabase();
    }
    /**
     * @param {?} query
     * @return {?}
     */
    search(query) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            logger$5.debug('Doing search in DexieSearchService...');
            if (query.dexieSearchFunction) {
                _self.getDatabase().then((/**
                 * @param {?} db
                 * @return {?}
                 */
                function (db) {
                    query.dexieSearchFunction(db, (/**
                     * @param {?} err
                     * @param {?} data
                     * @return {?}
                     */
                    function (err, data) {
                        if (err) {
                            /** @type {?} */
                            const message = 'Error in Dexie: ' + err;
                            reject(new Error(message));
                        }
                        else {
                            /** @type {?} */
                            let results;
                            results = {};
                            results.total = data.length;
                            results.statusCode = UtilHttpStatus.OK;
                            results.data = data;
                            results.searchProvier = 'dexie';
                            resolve(results);
                        }
                    }));
                }));
            }
            else {
                /** @type {?} */
                const msg = 'Dexie search not specified for offline querying';
                reject(new Error(msg));
            }
        }));
    }
}
DexieSearchService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
DexieSearchService.ctorParameters = () => [
    { type: IndexedDBConnectorService }
];
/** @nocollapse */ DexieSearchService.ɵprov = ɵɵdefineInjectable({ factory: function DexieSearchService_Factory() { return new DexieSearchService(ɵɵinject(IndexedDBConnectorService)); }, token: DexieSearchService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    DexieSearchService.prototype.indexedDBConnectorService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/indexeddb/ElasticSearchFilter.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$6 = console;
class ElasticSearchFilter {
    /**
     * filter not where clause - these are fields that should not match in the query.
     * return false if any of the values in the not where clause match
     * @param {?} filterDocument
     * @param {?} notWhereClause
     * @return {?}
     */
    static filterNotWhere(filterDocument, notWhereClause) {
        for (let i = 0; i < notWhereClause.length; i++) {
            // return false if any of the values in the not where clause match
            /** @type {?} */
            const key = notWhereClause[i].key;
            /** @type {?} */
            const filterDocumentValue = filterDocument[key];
            if (Array.isArray(filterDocumentValue)) {
                for (let j = 0; j < filterDocumentValue.length; j++) {
                    if (notWhereClause[i].value === filterDocumentValue[j]) {
                        return false;
                    }
                }
            }
            else if (notWhereClause[i].value === filterDocumentValue) {
                return false;
            }
        }
        // there are no matching conditions to the not-where
        return true;
    }
    /**
     * filter should clause - these are fields where a minimum number of shoulds need to match the condition. So if minimum_should_match
     * is 1 then 1 of the should statements needs to match. If minimum_should_match is 0 then none of them need to match but the score
     * is impacted in standard ElasticSearch. In our case 0 will mean none of them need to match so we don't need to check them.
     * We don't currently do the score but if we do in the future we'll need to start checking them
     * @param {?} filterDocument
     * @param {?} shouldClause
     * @param {?} minimumShouldMatch
     * @return {?}
     */
    static filterShould(filterDocument, shouldClause, minimumShouldMatch) {
        // if minimumShouldMatch is 0, no filtering is required - it only impacts the score
        // but doesn't stop documents from showing. We don't have the score in IndexedDB at
        // this stage
        if (minimumShouldMatch === 0 || shouldClause.length === 0) {
            return true;
        }
        else {
            /** @type {?} */
            let numMatches = 0;
            for (let i = 0; i < shouldClause.length; i++) {
                // return false if the number of values matching the should is less than minimum_should_match
                /** @type {?} */
                const key = shouldClause[i].key;
                /** @type {?} */
                const filterDocumentValue = filterDocument[key];
                if (Array.isArray(filterDocumentValue)) {
                    for (let j = 0; j < filterDocumentValue.length; j++) {
                        if (shouldClause[i].value === filterDocumentValue[j]) {
                            // use the prefix ++ so the value is incremented before checking
                            if (++numMatches >= minimumShouldMatch) {
                                return true;
                            }
                        }
                    }
                }
                else if (shouldClause[i].value === filterDocumentValue) {
                    // use the prefix ++ so the value is incremented before checking
                    if (++numMatches >= minimumShouldMatch) {
                        return true;
                    }
                }
            }
        }
        // there are no matching conditions to the not-where
        return false;
    }
    /**
     * filter range clause
     * @param {?} filterDocument - filterDocument
     * @param {?} rangeQueries - rangeQueries
     * @param {?} isNotClause
     * @return {?} boolean - the result
     */
    static filterRange(filterDocument, rangeQueries, isNotClause) {
        if (rangeQueries && rangeQueries.length > 0) {
            for (let i = 0; i < rangeQueries.length; i++) {
                /** @type {?} */
                const keys = Object.keys(rangeQueries[i]);
                for (let j = 0; j < keys.length; j++) {
                    /** @type {?} */
                    const key = keys[j];
                    /** @type {?} */
                    const result = this.checkRange(rangeQueries[i][key], filterDocument[key]);
                    if (isNotClause && result) { // range in must_not query
                        return false;
                    }
                    else if (!isNotClause && !result) { // range in must query
                        return false;
                    }
                }
            }
        }
        return true;
    }
    /**
     * @private
     * @param {?} rangeEntry
     * @param {?} fieldValue
     * @return {?}
     */
    static checkRange(rangeEntry, fieldValue) {
        /** @type {?} */
        const lessThanValue = rangeEntry.lt;
        /** @type {?} */
        const lessOrEqualValue = rangeEntry.lte;
        /** @type {?} */
        const greaterThanValue = rangeEntry.gt;
        /** @type {?} */
        const greaterOrEqualValue = rangeEntry.gte;
        /** @type {?} */
        let result = true;
        if (fieldValue !== undefined) {
            if (lessOrEqualValue && greaterOrEqualValue) {
                result = fieldValue <= lessOrEqualValue &&
                    fieldValue >= greaterOrEqualValue;
            }
            else if (lessOrEqualValue) {
                result = fieldValue <= lessOrEqualValue;
            }
            else if (greaterOrEqualValue) {
                result = fieldValue >= greaterOrEqualValue;
            }
            if (lessThanValue && greaterThanValue) {
                result = fieldValue < lessThanValue &&
                    fieldValue > greaterThanValue;
            }
            else if (lessThanValue) {
                result = fieldValue < lessThanValue;
            }
            else if (greaterThanValue) {
                result = fieldValue > greaterThanValue;
            }
        }
        else {
            result = false;
        }
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/indexeddb/ElasticSearchWhereClause.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$7 = console;
class ElasticSearchWhereClause {
    /**
     * add a where clause entry to an array. This will be called when the where clause is an array rathear than an object
     * @param {?} key - the key
     * @param {?} value - the value
     * @param {?} whereClause - where clause
     * @param {?} additionalWhereClauseArray
     * @return {?}
     */
    static addWhereClauseEntryToArray(key, value, whereClause, additionalWhereClauseArray) {
        if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
                /** @type {?} */
                const whereClauseEntry = {
                    key: key,
                    value: value[i]
                };
                if (!additionalWhereClauseArray || i === 0) {
                    if (Array.isArray(whereClause)) {
                        whereClause.push(whereClauseEntry);
                    }
                    else {
                        whereClause[key] = value[i];
                    }
                }
                else if (additionalWhereClauseArray) {
                    additionalWhereClauseArray.push(whereClauseEntry);
                }
            }
        }
        else {
            /** @type {?} */
            const whereClauseEntry = {
                key: key,
                value: value
            };
            if (Array.isArray(whereClause)) {
                whereClause.push(whereClauseEntry);
            }
            else {
                whereClause[key] = value;
            }
        }
    }
    /**
     * add an entry to the where clause. whereClause will be passed as an object and the key and value will be added as a
     * key/value pair
     * @private
     * @param {?} whereClause - the initial whereClause. This can only have one occurrence of each field
     * @param {?} key - key
     * @param {?} value - value
     * @param {?} additionalWhereClauseArray
     * @return {?}
     */
    static addWhereClauseEntry(whereClause, key, value, additionalWhereClauseArray) {
        // we can only have one entry per field because the initial query run for Dexie can only deal with one occurrence of a
        // field in the initial query - any additional criteria on the same field need to be filtered out after running the
        // initial query. Eg. You can't query on appTags = "ticket" and appTags = "water" in the same initial where query.
        // For this reason, we need to add only one occurrence of each field to the initial where clause and then add any
        // additional occurrences to a where clause that can be used in filtering the documents after the initial query has
        // run
        /** @type {?} */
        const keyContainsDot = key.indexOf('.') > 0;
        // if the where clause is an array, there is no need to add entries to the additionalWhereClause
        if (Array.isArray(whereClause)) {
            this.addWhereClauseEntryToArray(key, value, whereClause, null);
        }
        else {
            if (keyContainsDot || whereClause[key]) {
                this.addWhereClauseEntryToArray(key, value, additionalWhereClauseArray, null);
            }
            else {
                this.addWhereClauseEntryToArray(key, value, whereClause, additionalWhereClauseArray);
            }
        }
    }
    /**
     * add each entry in the ElasticSearch query to a must query that can be passed to the dexie where function as an object.
     * Terms queries are split to some arrays of term and only handled in must_not to not match all the values.
     * @param {?} whereClause - where clause
     * @param {?} elasticSearchClause - elastic search clause
     * @param {?} additionalWhereClauseArray - additional where clause array
     * @param {?} shouldHandleTerms - should handle term
     * @return {?} boolean - the result
     */
    static addMustQueryToWhereClause(whereClause, elasticSearchClause, additionalWhereClauseArray, shouldHandleTerms) {
        if (!isObject(whereClause)) {
            logger$7.error('Please pass the where clause as an object to addMustQueryToWhereClause');
            return false;
        }
        /** @type {?} */
        let hasAdded = false;
        if (elasticSearchClause) {
            if (Array.isArray(elasticSearchClause)) {
                for (let i = 0; i < elasticSearchClause.length; i++) {
                    // match - {key: {query: value}}
                    // match - {key: value}
                    if (elasticSearchClause[i]['match']) {
                        elasticSearchClause[i]['match'].forEach((/**
                         * @param {?} bean
                         * @param {?} key
                         * @return {?}
                         */
                        function (bean, key) {
                            /** @type {?} */
                            const value = bean.query ? bean.query : bean;
                            this.addWhereClauseEntry(whereClause, key, value, additionalWhereClauseArray);
                            hasAdded = true;
                        }));
                    }
                    // match_phrase - {key: {query: value}}
                    // match_phrase - {key: value}
                    if (elasticSearchClause[i]['match_phrase']) {
                        elasticSearchClause[i]['match_phrase'].forEach((/**
                         * @param {?} bean
                         * @param {?} key
                         * @return {?}
                         */
                        function (bean, key) {
                            /** @type {?} */
                            const value = bean.query ? bean.query : bean;
                            this.addWhereClauseEntry(whereClause, key, value, additionalWhereClauseArray);
                            hasAdded = true;
                        }));
                    }
                    // term - {key: value}
                    if (elasticSearchClause[i]['term']) {
                        elasticSearchClause[i]['term'].forEach((/**
                         * @param {?} bean
                         * @param {?} key
                         * @return {?}
                         */
                        function (bean, key) {
                            /** @type {?} */
                            const value = bean;
                            this.addWhereClauseEntry(whereClause, key, value, additionalWhereClauseArray);
                            hasAdded = true;
                        }));
                    }
                    if (shouldHandleTerms) {
                        // terms - {key: [value1, value2]}
                        if (elasticSearchClause[i]['terms']) {
                            elasticSearchClause[i]['terms'].forEach((/**
                             * @param {?} bean
                             * @param {?} key
                             * @return {?}
                             */
                            function (bean, key) {
                                /** @type {?} */
                                const value = bean;
                                this.addWhereClauseEntry(whereClause, key, value, additionalWhereClauseArray);
                            }));
                        }
                    }
                }
            }
            else {
                /** @type {?} */
                const keys = Object.keys(elasticSearchClause);
                for (let i = 0; i < keys.length; i++) {
                    /** @type {?} */
                    const key = keys[i];
                    // term - {key: value}
                    if (key === 'term') {
                        elasticSearchClause[key].forEach((/**
                         * @param {?} bean
                         * @param {?} index
                         * @return {?}
                         */
                        function (bean, index) {
                            /** @type {?} */
                            const value = bean;
                            this.addWhereClauseEntry(whereClause, index, value, additionalWhereClauseArray);
                            hasAdded = true;
                        }));
                    }
                    if (shouldHandleTerms) {
                        // terms - {key: [value1, value2]}
                        if (key === 'terms') {
                            elasticSearchClause[key].forEach((/**
                             * @param {?} bean
                             * @param {?} index
                             * @return {?}
                             */
                            function (bean, index) {
                                /** @type {?} */
                                const value = bean;
                                this.addWhereClauseEntry(whereClause, index, value, additionalWhereClauseArray);
                                hasAdded = true;
                            }));
                        }
                    }
                    // match - {key: {query: value}}
                    // match - {key: value}
                    if (key === 'match') {
                        elasticSearchClause[key].forEach((/**
                         * @param {?} bean
                         * @param {?} index
                         * @return {?}
                         */
                        function (bean, index) {
                            /** @type {?} */
                            const value = bean.query ? bean.query : bean;
                            this.addWhereClauseEntry(whereClause, index, value, additionalWhereClauseArray);
                            hasAdded = true;
                        }));
                    }
                    // match_phrase - {key: {query: value}}
                    // match_phrase - {key: value}
                    if (key === 'match_phrase') {
                        elasticSearchClause[key].forEach((/**
                         * @param {?} bean
                         * @param {?} index
                         * @return {?}
                         */
                        function (bean, index) {
                            /** @type {?} */
                            const value = bean.query ? bean.query : bean;
                            this.addWhereClauseEntry(whereClause, index, value, additionalWhereClauseArray);
                            hasAdded = true;
                        }));
                    }
                }
            }
        }
        return hasAdded;
    }
    /**
     * add a should clause to a data array. This will be called when the where clause is an array rather than an object
     * @private
     * @param {?} shouldDataArray - should data array
     * @param {?} key - key
     * @param {?} value - value
     * @param {?} minimumShouldMatch - minimum should match
     * @return {?}
     */
    static addShouldClauseEntryToDataArray(shouldDataArray, key, value, minimumShouldMatch) {
        /** @type {?} */
        const shouldClauseArray = [];
        if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
                /** @type {?} */
                const shouldClauseEntry = {
                    key: key,
                    value: value[i]
                };
                shouldClauseArray.push(shouldClauseEntry);
            }
        }
        else {
            /** @type {?} */
            const whereClauseEntry = {
                key: key,
                value: value
            };
            shouldClauseArray.push(whereClauseEntry);
        }
        /** @type {?} */
        const entry = {
            shouldClauseArray: shouldClauseArray,
            minimumShouldMatch: minimumShouldMatch
        };
        shouldDataArray.push(entry);
    }
    /**
     * add each entry in the ElasticSearch terms query to a should query array that can be passed to the
     * dexie where function as an array
     * @param {?} shouldClauseDataArray - shouldClauseDataArray
     * @param {?} elasticSearchClause - elasticSearchClause
     * @param {?} minimumShouldMatch - elasticSearchClause
     * @return {?} boolean - the result
     */
    static addTermsQueryToShouldClauseArray(shouldClauseDataArray, elasticSearchClause, minimumShouldMatch) {
        if (!Array.isArray(shouldClauseDataArray)) {
            logger$7.error('Please pass the should clause map as an array to addTermsQueryToShouldClauseArray');
            return false;
        }
        /** @type {?} */
        let hasAdded = false;
        if (elasticSearchClause) {
            if (Array.isArray(elasticSearchClause)) {
                for (let i = 0; i < elasticSearchClause.length; i++) {
                    // terms - {key: [value1, value2]}
                    if (elasticSearchClause[i]['terms']) {
                        elasticSearchClause[i]['terms'].forEach((/**
                         * @param {?} bean
                         * @param {?} key
                         * @return {?}
                         */
                        function (bean, key) {
                            /** @type {?} */
                            const value = bean;
                            this.addShouldClauseEntryToDataArray(shouldClauseDataArray, key, value, minimumShouldMatch);
                            hasAdded = true;
                        }));
                    }
                }
            }
            else {
                /** @type {?} */
                const keys = Object.keys(elasticSearchClause);
                for (let i = 0; i < keys.length; i++) {
                    /** @type {?} */
                    const key = keys[i];
                    // terms - {key: [value1, value2]}
                    if (key === 'terms') {
                        elasticSearchClause[key].forEach((/**
                         * @param {?} bean
                         * @param {?} index
                         * @return {?}
                         */
                        function (bean, index) {
                            /** @type {?} */
                            const value = bean;
                            this.addShouldClauseEntryToDataArray(shouldClauseDataArray, index, value, minimumShouldMatch);
                            hasAdded = true;
                        }));
                    }
                }
            }
        }
        return hasAdded;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/indexeddb/elastic-indexed-db.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$8 = console;
class ElasticIndexedDBService {
    /**
     * @param {?} indexedDBConnectorService
     */
    constructor(indexedDBConnectorService) {
        this.indexedDBConnectorService = indexedDBConnectorService;
    }
    /**
     * @private
     * @return {?}
     */
    getDatabase() {
        return this.indexedDBConnectorService.getDatabase();
    }
    /**
     * @private
     * @param {?} query
     * @return {?}
     */
    getMinimumShouldMatch(query) {
        if (query && query.bool && query.bool.should) {
            if (query.bool.minimum_should_match !== null &&
                query.bool.minimum_should_match !== undefined) {
                return query.bool.minimum_should_match;
            }
            //                TODO reinstate the following as part of Mantis 12596. There are differences between the default
            //                minimum_should_match in ElasticSearch 6 and ElasticSearch 2
            //                var must = query.bool.must;
            //                var filter = query.bool.filter;
            //
            //                if (!UtilType.hasValue(must) && !UtilType.hasValue(filter)) {
            //                 return 1;
            //                }
            //                if (UtilType.hasValue(filter) && UtilType.hasValue(filter.bool) && UtilType.hasValue(filter.bool.should)) {
            //                 return 1;
            //                }
            //                if (UtilType.hasValue(must) || UtilType.hasValue(filter)) {
            //                 return 0;
            //                }
        }
        // return 1 until we move to ElasticSearch 6 in Mantis 12596
        return 1;
    }
    // /**
    //  THIS METHOD IS NOT USED ANY WHERE. WILL BE CONVERTED TO ANGULAR LATER.
    //  * add each entry in the ElasticSearch query to a must query that can be passed to the dexie where function as an object
    //  * @param whereClause
    //  * @param mustClause
    //  */
    // addRangeQueryToWhereClause(whereClause, mustClause) {
    //   // whereClause can be an object or an array - an object is only used for running the initial where clause because
    //   // passing an array to dexie requires a compound index on all fields and we can't do that with arrays like appTags that
    //   // are commonly used
    //   if (!isObject(whereClause)) {
    //     logger.error("Please pass the where clause as an object to ElasticSearchWhereClause.addMustQueryToWhereClause");
    //     return;
    //   }
    //
    //   let hasAdded = false;
    //   if (mustClause) {
    //     if (isArray(mustClause)) {
    //       for (let i = 0; i < mustClause.length; i++) {
    //         //match - {key: {query: value}}
    //         //match - {key: value}
    //         if (mustClause[i]['match']) {
    //           angular.forEach(mustClause[i]['match'], function (bean, key) {
    //             var value = bean.query ? bean.query : bean;
    //             addWhereClauseEntry(whereClause, key, value);
    //             hasAdded = true;
    //           });
    //         }
    //         //match_phrase - {key: {query: value}}
    //         //match_phrase - {key: value}
    //         if (mustClause[i]['match_phrase']) {
    //           angular.forEach(mustClause[i]['match_phrase'], function (bean, key) {
    //             var value = bean.query ? bean.query : bean;
    //             addWhereClauseEntry(whereClause, key, value);
    //             hasAdded = true;
    //           });
    //         }
    //         //term - {key: value}
    //         if (mustClause[i]['term']) {
    //           angular.forEach(mustClause[i]['term'], function (bean, key) {
    //             var value = bean;
    //             addWhereClauseEntry(whereClause, key, value);
    //             hasAdded = true;
    //           });
    //         }
    //         //terms - {key: [value1, value2]}
    //         if (mustClause[i]['terms']) {
    //           angular.forEach(mustClause[i]['terms'], function (bean, key) {
    //             var value = bean;
    //             addWhereClauseEntry(whereClause, key, value);
    //             whereClause.push(obj);
    //           });
    //         }
    //       }
    //     } else {
    //       var keys = Object.keys(mustClause);
    //       for (var i = 0; i < keys.length; i++) {
    //         var key = keys[i];
    //
    //         //term - {key: value}
    //         if (key === 'term') {
    //           angular.forEach(mustClause[key], function (bean, key) {
    //             var value = bean;
    //             addWhereClauseEntry(whereClause, key, value);
    //             hasAdded = true;
    //           });
    //         }
    //         //terms - {key: [value1, value2]}
    //         if (key === 'terms') {
    //           angular.forEach(mustClause[key], function (bean, key) {
    //             var value = bean;
    //             addWhereClauseEntry(whereClause, key, value);
    //             hasAdded = true;
    //           });
    //         }
    //         //match - {key: {query: value}}
    //         //match - {key: value}
    //         if (key === 'match') {
    //           angular.forEach(mustClause[key], function (bean, key) {
    //             var value = bean.query ? bean.query : bean;
    //             addWhereClauseEntry(whereClause, key, value);
    //             hasAdded = true;
    //           });
    //         }
    //         //match_phrase - {key: {query: value}}
    //         //match_phrase - {key: value}
    //         if (key === 'match_phrase') {
    //           angular.forEach(mustClause[key], function (bean, key) {
    //             var value = bean.query ? bean.query : bean;
    //             addWhereClauseEntry(whereClause, key, value);
    //             hasAdded = true;
    //           });
    //         }
    //       }
    //     }
    //   }
    //   return hasAdded;
    // };
    /**
     * @private
     * @param {?} filter
     * @param {?} ranges
     * @return {?}
     */
    getRangeQueries(filter, ranges) {
        if (!isArray(ranges)) {
            logger$8.error('Ranges passed to getRangeQueries should be an array');
            return;
        }
        if (filter) {
            if (isArray(filter)) {
                filter.forEach((/**
                 * @param {?} obj
                 * @return {?}
                 */
                function (obj) {
                    if (obj.range) {
                        ranges.push(obj.range);
                    }
                }));
                return ranges;
            }
            else {
                ranges.push(filter.range);
            }
            return ranges;
        }
        return null;
    }
    /**
     * @param {?} options
     * @return {?}
     */
    search(options) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            logger$8.debug('Doing search in ElasticIndexedDBService...');
            if (options.filter) {
                /** @type {?} */
                let queryObject;
                if (UtilType.isString(options.filter)) {
                    queryObject = options.filter.replace(/'/g, '"');
                    queryObject = UtilType.isString(queryObject) ? JSON.parse(queryObject) : queryObject;
                }
                else {
                    queryObject = options.filter;
                }
                logger$8.info('Elastic IndexedDB Query:');
                logger$8.info(queryObject);
                if (queryObject
                    && queryObject.query
                    && queryObject.query.bool) {
                    /** @type {?} */
                    const must = queryObject.query.bool.must;
                    /** @type {?} */
                    const filter = queryObject.query.bool.filter;
                    /** @type {?} */
                    const should = queryObject.query.bool.should;
                    /** @type {?} */
                    const mustNot = queryObject.query.bool.must_not;
                    /** @type {?} */
                    const minimumShouldMatch = _self.getMinimumShouldMatch(queryObject.query);
                    /** @type {?} */
                    const whereClause = {};
                    // where clause run in the initial query - this can only have one occurrence of any field
                    /** @type {?} */
                    const additionalWhereClauseArray = [];
                    // field in the query, it will be placed in here to overcome the limitation
                    // of having one occurrence of a field in the initial where clause
                    ElasticSearchWhereClause.addMustQueryToWhereClause(whereClause, must, additionalWhereClauseArray, false);
                    ElasticSearchWhereClause.addMustQueryToWhereClause(whereClause, filter, additionalWhereClauseArray, false);
                    /** @type {?} */
                    const notWhereClauseArray = [];
                    ElasticSearchWhereClause.addMustQueryToWhereClause(notWhereClauseArray, mustNot, null, true);
                    /** @type {?} */
                    const shouldClauseDataArray = [];
                    /** @type {?} */
                    const shouldClauseArray = [];
                    // don't process the shoulds if minimum should match is 0 because we don't do the score. If minimum should match
                    // is 0 then it doesn't cause documents to be excluded - only to increase the score if the document matches the
                    // should. If we add the score in future we would need to remove the following if statement
                    ElasticSearchWhereClause.addMustQueryToWhereClause(shouldClauseArray, should, null, false);
                    shouldClauseDataArray.push({
                        shouldClauseArray: shouldClauseArray,
                        minimumShouldMatch: minimumShouldMatch
                    });
                    ElasticSearchWhereClause.addTermsQueryToShouldClauseArray(shouldClauseDataArray, must, 1);
                    ElasticSearchWhereClause.addTermsQueryToShouldClauseArray(shouldClauseDataArray, filter, 1);
                    ElasticSearchWhereClause.addTermsQueryToShouldClauseArray(shouldClauseDataArray, should, minimumShouldMatch);
                    /** @type {?} */
                    const rangeQueries = [];
                    _self.getRangeQueries(queryObject.query.range, rangeQueries);
                    _self.getRangeQueries(must, rangeQueries);
                    _self.getRangeQueries(filter, rangeQueries);
                    /** @type {?} */
                    const notRangeQueries = [];
                    _self.getRangeQueries(mustNot, notRangeQueries);
                    logger$8.info('Must Not Range Clause: ' + JSON.stringify(notRangeQueries));
                    logger$8.info('Where Clause: ' + JSON.stringify(whereClause));
                    logger$8.info('Not Where Clause: ' + JSON.stringify(notWhereClauseArray));
                    logger$8.info('Should Clause Data: ' + JSON.stringify(shouldClauseDataArray));
                    logger$8.info('Additional where clause: ' + JSON.stringify(additionalWhereClauseArray));
                    logger$8.info('Range clause: ' + JSON.stringify(rangeQueries));
                    /** @type {?} */
                    const ors = {
                        match: [],
                        matchPhrase: [],
                        term: [],
                        terms: [],
                        range: []
                    };
                    _self.getDatabase().then((/**
                     * @param {?} database
                     * @return {?}
                     */
                    function success(database) {
                        // use a dexie filter to filter out the documents that do not match the not where clause in the query.
                        // details of the filters are at http://dexie.org/docs/Collection/Collection.and()
                        /** @type {?} */
                        const dexieFilter = (/**
                         * @param {?} filterObject
                         * @return {?}
                         */
                        function (filterObject) {
                            // initialise filter result to true - then it will be changed to false if any of the conditions
                            // are not met
                            /** @type {?} */
                            let result = true;
                            /** @type {?} */
                            const filterDocument = filterObject;
                            // PROCESS THE ADDITIONAL WHERE CLAUSES
                            for (let k = 0; k < additionalWhereClauseArray.length; k++) {
                                /** @type {?} */
                                let fieldName = additionalWhereClauseArray[k].key;
                                // if there is a dot in the fieldName - it can be a search for a value within an array or a
                                // search for a plain field value
                                /** @type {?} */
                                const fieldNameDotPos = fieldName.indexOf('.');
                                /** @type {?} */
                                let nestedFieldName;
                                if (fieldNameDotPos > 0) {
                                    nestedFieldName = fieldName.substring(fieldNameDotPos + 1);
                                    fieldName = fieldName.substring(0, fieldNameDotPos);
                                }
                                if (isArray(filterDocument[fieldName])) {
                                    /** @type {?} */
                                    let found = false;
                                    for (let l = 0; l < filterDocument[fieldName].length; l++) {
                                        /** @type {?} */
                                        const comparisonField = fieldNameDotPos > 0 ?
                                            filterDocument[fieldName][l][nestedFieldName] :
                                            filterDocument[fieldName][l];
                                        if (comparisonField === additionalWhereClauseArray[k].value) {
                                            found = true;
                                            break;
                                        }
                                    }
                                    if (!found) {
                                        result = false;
                                    }
                                }
                                else {
                                    /** @type {?} */
                                    let comparisonValue;
                                    if (fieldNameDotPos > 0) {
                                        if (filterDocument[fieldName] && filterDocument[fieldName][nestedFieldName]) {
                                            comparisonValue = filterDocument[fieldName][nestedFieldName];
                                        }
                                    }
                                    else {
                                        comparisonValue = filterDocument[fieldName];
                                    }
                                    /** @type {?} */
                                    const whereClauseValue = additionalWhereClauseArray[k].value;
                                    if (comparisonValue !== whereClauseValue) {
                                        result = false;
                                        break;
                                    }
                                }
                            }
                            if (result) {
                                result = ElasticSearchFilter.filterNotWhere(filterDocument, notWhereClauseArray);
                            }
                            if (result) {
                                for (let idx = 0; idx < shouldClauseDataArray.length; idx++) {
                                    /** @type {?} */
                                    const item = shouldClauseDataArray[idx];
                                    result = ElasticSearchFilter.filterShould(filterDocument, item.shouldClauseArray, item.minimumShouldMatch);
                                    if (!result) {
                                        break;
                                    }
                                }
                            }
                            if (result) {
                                result = ElasticSearchFilter.filterRange(filterDocument, notRangeQueries, true);
                            }
                            return result;
                        });
                        /** @type {?} */
                        let collections;
                        if (whereClause && Object.keys(whereClause).length) {
                            collections = database.documents.where(whereClause);
                        }
                        else {
                            // in case no where clause, just get all
                            collections = database.documents.toCollection();
                        }
                        /** @type {?} */
                        const filterCollection = collections.filter(dexieFilter);
                        /** @type {?} */
                        const isCountQuery = options.size === 0;
                        // promise that will be returned depending on whether this is a count query or a normal query. A count
                        // query is when the size is set to 0 and the count function will be executed instead of the each
                        // function
                        /** @type {?} */
                        let eachPromise;
                        // write results in the same format as the Elastic search results so the client will be able to process
                        // the results as though they are from ElasticSearch
                        /** @type {?} */
                        const esResult = {
                            data: {
                                hits: {
                                    total: 0,
                                    hits: []
                                }
                            },
                            statusCode: UtilHttpStatus.OK
                        };
                        if (!isCountQuery) {
                            eachPromise = filterCollection.each((/**
                             * @param {?} document
                             * @return {?}
                             */
                            function (document) {
                                if (document) {
                                    // add the result to the ElasticSearch results
                                    /** @type {?} */
                                    const esSource = {
                                        _source: document
                                    };
                                    esResult.data.hits.hits.push(esSource);
                                    esResult.data.hits.total++;
                                }
                                else {
                                    logger$8.warn('ElasticSearch IndexedDB Result returned with no document');
                                }
                            }));
                        }
                        else {
                            eachPromise = filterCollection.count((/**
                             * @param {?} count
                             * @return {?}
                             */
                            function (count) {
                                esResult.data.hits.total = count;
                            }));
                        }
                        // resolve the promise for the results
                        eachPromise.then((/**
                         * @return {?}
                         */
                        function () {
                            resolve(esResult);
                        }));
                    }), (/**
                     * @param {?} err
                     * @return {?}
                     */
                    function errorFunc(err) {
                        reject(new Error('Could not open indexedDB!'));
                    }));
                }
                else {
                    /** @type {?} */
                    const msg = 'Query is empty or searching text on indexedDB is not supported at the moment.';
                    reject(new Error(msg));
                }
            }
        }));
    }
}
ElasticIndexedDBService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ElasticIndexedDBService.ctorParameters = () => [
    { type: IndexedDBConnectorService }
];
/** @nocollapse */ ElasticIndexedDBService.ɵprov = ɵɵdefineInjectable({ factory: function ElasticIndexedDBService_Factory() { return new ElasticIndexedDBService(ɵɵinject(IndexedDBConnectorService)); }, token: ElasticIndexedDBService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ElasticIndexedDBService.prototype.indexedDBConnectorService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/indexeddb/indexed-db.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$9 = console;
class IndexedDBService {
    /**
     * @param {?} http
     * @param {?} indexedDBConnectorService
     * @param {?} offlineStatusService
     * @param {?} loggedInUserService
     * @param {?} elasticIndexedDBService
     * @param {?} dexieSearchService
     * @param {?} clientAccessService
     * @param {?} broadcastService
     * @param {?} notificationService
     */
    constructor(http, indexedDBConnectorService, offlineStatusService, loggedInUserService, elasticIndexedDBService, dexieSearchService, clientAccessService, broadcastService, notificationService) {
        this.http = http;
        this.indexedDBConnectorService = indexedDBConnectorService;
        this.offlineStatusService = offlineStatusService;
        this.loggedInUserService = loggedInUserService;
        this.elasticIndexedDBService = elasticIndexedDBService;
        this.dexieSearchService = dexieSearchService;
        this.clientAccessService = clientAccessService;
        this.broadcastService = broadcastService;
        this.notificationService = notificationService;
        this.constants = IndexedDBConstants;
        this.checkQuotaExceededError = (/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            if ((error.name === 'QuotaExceededError') || (error.inner && error.inner.name === 'QuotaExceededError')) {
                /** @type {?} */
                const message = "The disk is full, please free up disk space. " + error.message;
                logger$9.error(message);
                this.notificationService.printMessage(message, 'error', null, { x: 'right', y: 'top' });
            }
        });
        this.onDocumentUpdated();
        this.userSub = this.loggedInUserService.observableUser().subscribe((/**
         * @param {?} user
         * @return {?}
         */
        (user) => this.user = user));
        // this.user$.subscribe((user: User) => this.user = user);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.userSub.unsubscribe();
        this.terminateService();
    }
    /**
     * @return {?}
     */
    initialise() {
        logger$9.warn('-----TODO get unprocessed docs on initialise - but not on first initialisation');
        return this.getDatabase();
    }
    /**
     * @return {?}
     */
    terminateService() {
        return this.indexedDBConnectorService.closeDatabase();
    }
    /**
     * @param {?} options
     * @return {?}
     */
    search(options) {
        /** @type {?} */
        const _self = this;
        if (options.searchOptions && options.searchOptions.dexieSearchFunction) {
            return _self.dexieSearchService.search(options.searchOptions);
        }
        else {
            return _self.elasticIndexedDBService.search(options);
        }
    }
    /**
     * @param {?} bean
     * @return {?}
     */
    insert(bean) {
        if (!bean.systemHeader) {
            bean.systemHeader = {};
        }
        // set versionId
        bean.systemHeader.versionId = UtilDocumentId.generateId();
        // set currentVersion for new document
        bean.systemHeader.currentVersion = true;
        // set created date for version
        bean.systemHeader.createdDate = new Date();
        /** @type {?} */
        const userId = this.user ? this.user.account.documentId : null;
        if (userId) {
            bean.systemHeader.createdBy = userId;
        }
        if (!bean.systemHeader.documentCreatedDate) {
            bean.systemHeader.documentCreatedDate = new Date();
        }
        if (userId && !bean.systemHeader.documentCreatedBy) {
            bean.systemHeader.documentCreatedBy = userId;
        }
        return this.persist(bean, ClientConstants.OPERATION_TYPE_POST, null);
    }
    /**
     * @param {?} id
     * @param {?} url
     * @param {?} cachingRequired
     * @param {?} templateId
     * @param {?} previousVersionId
     * @return {?}
     */
    destroy(id, url, cachingRequired, templateId, previousVersionId) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.getDocumentCurrentVersion(id, (/**
             * @param {?} originalRecord
             * @return {?}
             */
            function (originalRecord) {
                /** @type {?} */
                const originalBean = originalRecord;
                // save version as an insert
                /** @type {?} */
                const versionDoc = VersionManager.createVersion(originalBean);
                _self.cacheDocument(versionDoc, true).then((/**
                 * @param {?} record
                 * @return {?}
                 */
                function successFunc(record) {
                    /** @type {?} */
                    const newBean = cloneDeep(originalBean);
                    newBean.systemHeader.deleted = true;
                    // perform newBean update
                    // Aside from the differences in data between originalBean and newbean, newBean will always
                    // have its previousVersionId = originalBean's versionId. newBean will also be set as the
                    // current version with a new versionId
                    if (newBean.systemHeader.versionId) {
                        newBean.systemHeader.previousVersionId = originalBean.systemHeader.versionId;
                    }
                    // update createdBy every time because when we update the doc it's a new version
                    newBean.systemHeader.createdBy = _self.user ?
                        _self.user.account.documentId : null;
                    newBean.systemHeader.createdDate = new Date();
                    newBean.systemHeader.versionId = UtilDocumentId.generateId();
                    _self.persist(newBean, ClientConstants.OPERATION_TYPE_DELETE).then((/**
                     * @param {?} rec
                     * @return {?}
                     */
                    function sucF(rec) {
                        resolve(rec);
                    }), (/**
                     * @param {?} error
                     * @return {?}
                     */
                    function errF(error) {
                        reject(error);
                    }));
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function errorFunc(err) {
                    reject(err);
                }));
            }));
        }));
    }
    /**
     * @param {?} url
     * @param {?} id
     * @return {?}
     */
    getDocument(url, id) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            _self.getDocumentCurrentVersion(id, (/**
             * @param {?} cacheObject
             * @return {?}
             */
            function (cacheObject) {
                if (cacheObject == null) {
                    reject('Document not available in offline database.');
                }
                else {
                    resolve(cacheObject);
                }
            }));
        }));
    }
    /**
     * @return {?}
     */
    getDatabase() {
        return this.indexedDBConnectorService.getDatabase();
    }
    /**
     * @return {?}
     */
    closeDatabase() {
        this.getDatabase().then((/**
         * @param {?} db
         * @return {?}
         */
        function (db) {
            db.close();
        }));
    }
    /**
     * @return {?}
     */
    backupData() {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.getDatabase().then((/**
             * @param {?} db
             * @return {?}
             */
            function (db) {
                /** @type {?} */
                const promises = [];
                for (let i = 0; i < db.objectStoreNames.length; i++) {
                    promises.push(new Promise((/**
                     * @param {?} res
                     * @param {?} rej
                     * @return {?}
                     */
                    (res, rej) => {
                        /** @type {?} */
                        const objectstore = db.objectStoreNames[i];
                        /** @type {?} */
                        const transaction = db.transaction([objectstore], 'readwrite');
                        /** @type {?} */
                        const content = [];
                        transaction.oncomplete = (/**
                         * @param {?} event
                         * @return {?}
                         */
                        function (event) {
                            res({ name: objectstore, data: content });
                        });
                        transaction.onerror = (/**
                         * @param {?} event
                         * @return {?}
                         */
                        function (event) {
                            rej(event);
                        });
                        /** @type {?} */
                        const handleResult = (/**
                         * @param {?} event
                         * @return {?}
                         */
                        function (event) {
                            /** @type {?} */
                            const cursor = event.target.result;
                            if (cursor) {
                                content.push({ key: cursor.key, value: cursor.value });
                                cursor.continue();
                            }
                        });
                        /** @type {?} */
                        const objectStore = transaction.objectStore(objectstore);
                        objectStore.openCursor().onsuccess = handleResult;
                    })));
                }
                Promise.all(promises).then((/**
                 * @param {?} result
                 * @return {?}
                 */
                function successFunc(result) {
                    /** @type {?} */
                    let savedData = {};
                    for (let i = 0; i < result.length; i++) {
                        /** @type {?} */
                        const tmp = result[i];
                        savedData[tmp.name] = tmp.data;
                    }
                    savedData = JSON.stringify(savedData);
                    resolve(savedData);
                }));
            }));
        }));
    }
    /**
     * @return {?}
     */
    clearData() {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.getDatabase().then((/**
             * @param {?} db
             * @return {?}
             */
            function (db) {
                /** @type {?} */
                const tblName = IndexedDBConstants.DOCUMENT_TABLE_NAME;
                db.transaction('rw', db[tblName], (/**
                 * @param {?} result
                 * @return {?}
                 */
                (result) => {
                    db[tblName].clear().then((/**
                     * @return {?}
                     */
                    () => {
                        _self.loggedInUserService.setUserConfigItem('cachingEnabled', false);
                        _self.loggedInUserService.setUserConfigItem('lastSyncDate', 0);
                        _self.loggedInUserService.setUserConfigItem('idbCurrentVersion', 0);
                        resolve(true);
                    }), (/**
                     * @param {?} e
                     * @return {?}
                     */
                    (e) => {
                        logger$9.error('An error occured while clearing cached documents.');
                        logger$9.error(e.stack || e);
                        resolve(false);
                    }));
                })).catch((/**
                 * @param {?} e
                 * @return {?}
                 */
                e => {
                    logger$9.error('An error occured while clearing cached documents.');
                    logger$9.error(e.stack || e);
                    resolve(false);
                }));
            }));
        }));
    }
    /**
     * set indexeddb indexes in document stored in IndexedDB so that it can be queried
     * @private
     * @param {?} document the document
     * @return {?}
     */
    setIndexedDBIndexes(document) {
        if (!document || !document.systemHeader) {
            return;
        }
        /** @type {?} */
        const templateType = document.systemHeader.systemType === SharedConstants.SYSTEM_TYPE_TEMPLATE;
        /** @type {?} */
        const withSearchIndexes = document[IndexedDBConstants.DB_INDEXES] && document[IndexedDBConstants.DB_INDEXES].length;
        if (templateType && withSearchIndexes) {
            /** @type {?} */
            const templateIndexes = document[IndexedDBConstants.DB_INDEXES];
            /** @type {?} */
            let indexes = this.loggedInUserService.getUserConfigItem('searchIndexes');
            indexes = UtilArray.union(indexes, templateIndexes, null);
            this.loggedInUserService.setUserConfigItem('searchIndexes', indexes);
        }
    }
    /**
     * cache a document
     * @param {?} document the document
     * @param {?} updateOfflineStatus
     * @return {?} PromiseLike<any> the Promise
     */
    doCacheDocument(document, updateOfflineStatus) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (!document.documentId) {
                _self.offlineStatusService.ignoreCacheDocument(document);
                /** @type {?} */
                const errMsg = "Document has no documentId " + JSON.stringify(document);
                logger$9.error(errMsg);
                reject(new Error(errMsg));
                return;
            }
            _self.setIndexedDBIndexes(document);
            _self.cacheDocument(document, false).then((/**
             * @param {?} cacheObject
             * @return {?}
             */
            function successFunc(cacheObject) {
                /** @type {?} */
                const doc = cacheObject;
                // update the last sync time in local storage with the time of this record if
                // it is later than the stored value
                if (updateOfflineStatus !== false) {
                    _self.offlineStatusService.initialCacheQuerySuccess(doc);
                }
                resolve(doc);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function errorFunc(err) {
                /** @type {?} */
                const errorMsg = 'Error caching document: ' + document.documentId + ': ' + err;
                logger$9.error(errorMsg);
                if (updateOfflineStatus !== false) {
                    _self.offlineStatusService.ignoreCacheDocument(document);
                }
                reject(new Error(errorMsg));
            }));
        }));
    }
    /**
     * Updates or inserts a given row in the indexedb database under the table. For tables that uses inline keys
     * only (the primary key is on the object).
     * @param {?} tblName - table name
     * @param {?} record - record
     * @param {?=} callback
     * @return {?}
     */
    saveEntry(tblName, record, callback) {
        /** @type {?} */
        const _self = this;
        if (!record) {
            if (typeof callback !== 'undefined') {
                callback(new Error('Document not specified in IndexedDB saveEntry'));
            }
            return;
        }
        if (record && record.systemHeader && record.systemHeader.versionId) {
            //                logger.info('Saving IndexedDB entry with documentId: ' +
            //                    record.documentId + '. systemHeader.versionId: ' + record.systemHeader.versionId );
        }
        this.getDatabase().then((/**
         * @param {?} db
         * @return {?}
         */
        function success(db) {
            db.transaction('rw', db[tblName], (/**
             * @param {?} result
             * @return {?}
             */
            (result) => {
                db[tblName].put(record).then((/**
                 * @param {?} data
                 * @return {?}
                 */
                (data) => {
                    if (callback != null) {
                        callback();
                    }
                }), (/**
                 * @param {?} e
                 * @return {?}
                 */
                (e) => {
                    _self.checkQuotaExceededError(e);
                    logger$9.error('Error on IndexedDBService.saveEntry:');
                    logger$9.error(e);
                    if (callback != null) {
                        callback(e);
                    }
                }));
            })).catch((/**
             * @param {?} e
             * @return {?}
             */
            e => {
                _self.checkQuotaExceededError(e);
                logger$9.error('Error adding entry to IndexedDB: ' + e.stack || e);
                callback(e);
            }));
        }));
    }
    /**
     * Request errors will set the callback function's first argument to null.
     * Returns the file entry object as the callback function's first argument.
     * @param {?} fileNo - the file number
     * @param {?} callback - the callback
     * @return {?}
     */
    getFile(fileNo, callback) {
        /** @type {?} */
        const tblName = IndexedDBConstants.OFFLINE_FILE_TABLE_NAME;
        /** @type {?} */
        const indexName = IndexedDBConstants.OFFLINE_FILE_INDEX_FILENO;
        /** @type {?} */
        const indexValue = fileNo;
        this.getEntries(tblName, indexName, indexValue, (/**
         * @param {?} entriesArr
         * @return {?}
         */
        function (entriesArr) {
            if (entriesArr.length > 0) {
                callback(entriesArr[0]); // get the first entry -- which is the only entry, fileNos are unique
                return;
            }
            callback(null);
        }));
    }
    /**
     * Record format should be:
     *    var record = {
     * fileNo : fileNo,
     * status : status, //'UPLOADED' or 'PENDING'
     * blob: blob,
     * uploadConfig : uploadConfig
     * };
     * @param {?} record
     * @param {?=} status
     * @param {?=} errMessage
     * @param {?=} errorCount
     * @return {?}
     */
    saveFile(record, status, errMessage, errorCount) {
        record.errorMessage = errMessage;
        record.errorCount = errorCount;
        /** @type {?} */
        const tblName = IndexedDBConstants.OFFLINE_FILE_TABLE_NAME;
        this.saveEntry(tblName, record, (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            if (err) {
                logger$9.error('Failed to save file to offline database: ' + err.message);
            }
        }));
    }
    // ***End of Low level functions
    /**
     * Retrieve entries from a table
     * @param {?} tblName - the table name
     * @param {?} indexName - the index to search for
     * @param {?} indexValue - the value to search for in the index
     * @param {?} callback - callback that passes the entries in an array
     * @return {?}
     */
    getEntries(tblName, indexName, indexValue, callback) {
        this.getDatabase().then((/**
         * @param {?} db
         * @return {?}
         */
        function success(db) {
            db[tblName].where(indexName).equals(indexValue).toArray((/**
             * @param {?} results
             * @return {?}
             */
            results => {
                callback(results);
            })).catch((/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                logger$9.error('Error getting dexie entries: ' + error.message);
            }));
        }));
    }
    /**
     * Delete entries from a table
     * @param {?} tblName - the table name
     * @param {?} indexName - the index to search for
     * @param {?} indexValue - the value to search for in the index
     * @param {?} callback - callback that passes deleted entries in an array. (optional)
     * @return {?}
     */
    deleteEntries(tblName, indexName, indexValue, callback) {
        this.getDatabase().then((/**
         * @param {?} db
         * @return {?}
         */
        function success(db) {
            db[tblName].where(indexName).equals(indexValue).delete().then((/**
             * @param {?} deleteCount
             * @return {?}
             */
            deleteCount => {
                callback(null, deleteCount);
            })).catch((/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                callback(error, null);
            }));
        }));
    }
    /**
     * Seeks out the current version of the document in indexedDB document table and passes it via callback
     * @param {?} id - either versionId or documentId. Evaluate it as documentId first, if that fails then treat it as a version id
     * @param {?} callback - first param is the actual document. null if not found
     * @return {?}
     */
    getDocumentCurrentVersion(id, callback) {
        /** @type {?} */
        const _self = this;
        if (id === undefined || id === null) {
            callback(null);
            return;
        }
        /** @type {?} */
        const tblName = IndexedDBConstants.DOCUMENT_TABLE_NAME;
        /** @type {?} */
        const indexName = IndexedDBConstants.DOCUMENT_INDEX_DOCUMENT_ID;
        /** @type {?} */
        const indexValue = id;
        _self.getEntries(tblName, indexName, indexValue, (/**
         * @param {?} cachedObjects
         * @return {?}
         */
        function (cachedObjects) {
            for (let x = 0; x < cachedObjects.length; x++) {
                /** @type {?} */
                const cacheObject = cachedObjects[x];
                if (cacheObject.systemHeader.currentVersion === true) {
                    callback(cacheObject);
                    return;
                }
            }
            _self.loadDocByVersion(id, callback);
        }));
    }
    /**
     * @private
     * @param {?} docId
     * @param {?} callback
     * @return {?}
     */
    loadDocsById(docId, callback) {
        if (docId === undefined || docId === null) {
            callback(null);
            return;
        }
        /** @type {?} */
        const tblName = IndexedDBConstants.DOCUMENT_TABLE_NAME;
        /** @type {?} */
        const indexName = IndexedDBConstants.DOCUMENT_INDEX_DOCUMENT_ID;
        /** @type {?} */
        const indexValue = docId;
        this.getEntries(tblName, indexName, indexValue, (/**
         * @param {?} cachedObjects
         * @return {?}
         */
        function (cachedObjects) {
            callback(cachedObjects);
        }));
    }
    /*
       offlineDetails
    
       Once offline, if a document has this object under it, it means that it is subject to an operation yet
       to be submitted to the server.
    
       This object will have the following attributes {type, status, lastRequestStatus, tries}
    
       type - From ClientConstants: OPERATION_TYPE_DELETE, OPERATION_TYPE_PUT, OPERATION_TYPE_POST
       status - IndexedDBConstants: (1)OFFLINE_STATUS_UPLOADED, (2)OFFLINE_STATUS_PENDING,
       (3)OFFLINE_STATUS_UPLOADING (4)OFFLINE_STATUS_FAILED
    
       lastRequestStatus - http status of last attempt to upload this operation
       tries - integer count of the number of times this document's pending operation has been uploaded to the server
    
       Should not be used to cache documents. Use cacheDocument function instead.
       Used for saving documents that needs to be sent to and processed by the server.
    
       */
    /**
     * @private
     * @param {?} cacheObject
     * @param {?=} operation
     * @param {?=} options
     * @return {?}
     */
    persist(cacheObject, operation, options) {
        /** @type {?} */
        const self = this;
        cacheObject.systemHeader.offlineDetails = {
            type: operation,
            status: IndexedDBConstants.OFFLINE_STATUS_PENDING,
            lastRequestStatus: '',
            tries: 0,
            deleteOnComplete: false,
            // if true, the cache object is removed from offline db after completing the operation
            updates: options ? options.updates : null,
            isUpdateFromPreviousVersion: options ? options.isUpdateFromPreviousVersion : false,
            createdDate: new Date(),
            makeCurrentVersion: options ? options.makeCurrentVersion : false,
            importPreviousVersion: options ? options.importPreviousVersion : false
        };
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            self.saveCacheObject(cacheObject, (/**
             * @param {?} err
             * @param {?} cacheObj
             * @return {?}
             */
            function onCacheObjectSaved(err, cacheObj) {
                if (err) {
                    reject(err);
                }
                else {
                    self.offlineStatusService.incPendingDocumentCount();
                    resolve(cacheObj);
                }
            }));
        }));
    }
    /**
     * @param {?} callback
     * @return {?}
     */
    getUnprocessedDocs(callback) {
        /** @type {?} */
        const tbl = IndexedDBConstants.DOCUMENT_TABLE_NAME;
        /** @type {?} */
        const index = IndexedDBConstants.DOCUMENT_INDEX_PENDING_OPERATION;
        /** @type {?} */
        const searchValue = IndexedDBConstants.OFFLINE_STATUS_PENDING;
        this.getEntries(tbl, index, searchValue, callback); // function callback(docsArray)
    }
    /**
     * @param {?} callback
     * @return {?}
     */
    getProcessedCurrentVersionDocs(callback) {
        /** @type {?} */
        const tbl = IndexedDBConstants.DOCUMENT_TABLE_NAME;
        /** @type {?} */
        const index = IndexedDBConstants.DOCUMENT_INDEX_PENDING_OPERATION;
        /** @type {?} */
        const searchValue = IndexedDBConstants.OFFLINE_STATUS_UPLOADED;
        this.getEntries(tbl, index, searchValue, callback); // function callback(docsArray)
    }
    /**
     * @param {?} callback
     * @return {?}
     */
    getUnsentOfflineFilesInQueue(callback) {
        /** @type {?} */
        const tbl = IndexedDBConstants.OFFLINE_FILE_TABLE_NAME;
        /** @type {?} */
        const index = IndexedDBConstants.OFFLINE_FILE_INDEX_STATUS;
        /** @type {?} */
        const searchValue = IndexedDBConstants.OFFLINE_STATUS_PENDING;
        this.getEntries(tbl, index, searchValue, callback);
    }
    /**
     * Cache the document in IndexedDB for offline use
     * @param {?} document - the document to cache
     * @param {?} force
     * @return {?}
     */
    cacheDocument(document, force) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            _self.loadDocByVersion(document.systemHeader.versionId, docWithVersionFound);
            /**
             * @param {?} err
             * @param {?} cacheObject
             * @return {?}
             */
            function docWithVersionFound(err, cacheObject) {
                // Do not cache the document twice unless forced to (when saving a version document. see jsonPatchUpdate)
                if (!force && cacheObject != null) {
                    resolve(document);
                    return;
                }
                _self.saveCacheObject(document, onCacheObjectSaved);
                /**
                 * @param {?} error
                 * @param {?} doc
                 * @return {?}
                 */
                function onCacheObjectSaved(error, doc) {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(doc);
                    }
                }
            }
        }));
    }
    /**
     * cache document received from websocket
     * @param {?} docInfo - the info used to load full document and changed versions
     * @param {?} versions - the versions of document
     * @param {?=} updateOfflineStatus - flag indicates that should update offline caching status
     * @return {?} Promise
     */
    cachePushedDocument(docInfo, versions, updateOfflineStatus) {
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        let currentVersion = null;
        versions.forEach((/**
         * @param {?} version
         * @return {?}
         */
        function (version) {
            if (version && version.systemHeader && version.systemHeader.currentVersion) {
                currentVersion = version;
            }
        }));
        /**
         * @param {?} version
         * @return {?}
         */
        function cacheVersion(version) {
            return new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            (resolve, reject) => {
                _self.saveCacheObject(version, (/**
                 * @param {?} err
                 * @param {?} savedVersion
                 * @return {?}
                 */
                function (err, savedVersion) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(savedVersion);
                    }
                }));
            }));
        }
        /**
         * @return {?}
         */
        function cacheExistingCurrentDoc() {
            // If the currentVersion in indexedDB is before the first prev version in above list so it would not
            // be set to non-currentVersion. This step set the value to false.
            _self.getDocumentCurrentVersion(docInfo.documentId, (/**
             * @param {?} doc
             * @return {?}
             */
            function (doc) {
                if (doc && currentVersion && doc.systemHeader.versionId !== currentVersion.systemHeader.versionId) {
                    doc.systemHeader.currentVersion = false;
                    _self.saveCacheObject(doc, cacheDone);
                }
            }));
        }
        /**
         * @param {?} err
         * @param {?} version
         * @return {?}
         */
        function cacheDone(err, version) {
            if (err) {
                logger$9.error('Caching version error: ' + err);
            }
            else {
                logger$9.info('Caching version done: ' + version.systemHeader.versionId);
            }
        }
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const hasOfflineAccess = _self.clientAccessService.checkAccess(currentVersion, SharedConstants.OPERATION_TYPE_OFFLINE);
            if (hasOfflineAccess) {
                _self.setIndexedDBIndexes(currentVersion);
                if (docInfo.versionIds && docInfo.versionIds.length) { // in case of updating versions from pushed document
                    // in case of updating versions from pushed document
                    /** @type {?} */
                    const promises = [];
                    versions.forEach((/**
                     * @param {?} version
                     * @return {?}
                     */
                    function (version) {
                        promises.push(cacheVersion(version));
                    }));
                    Promise.all(promises).then((/**
                     * @param {?} versions2
                     * @return {?}
                     */
                    function ok(versions2) {
                        cacheExistingCurrentDoc();
                        if (updateOfflineStatus !== false) {
                            _self.offlineStatusService.initialCacheQuerySuccess(currentVersion);
                        }
                        resolve(versions2);
                    }), (/**
                     * @param {?} error
                     * @return {?}
                     */
                    function fail(error) {
                        /** @type {?} */
                        const msg = 'Error in caching version of document: ' + docInfo.documentId;
                        logger$9.error(msg);
                        reject(new Error(msg));
                    }));
                }
                else { // in case of updating each current version from websocket reconnect event or browser reloading
                    cacheVersion(currentVersion).then(cacheExistingCurrentDoc).then((/**
                     * @return {?}
                     */
                    function () {
                        if (updateOfflineStatus !== false) {
                            _self.offlineStatusService.initialCacheQuerySuccess(currentVersion);
                        }
                        resolve(currentVersion);
                    }));
                }
            }
        }));
    }
    /**
     * load a document by systemHeader.versionId
     * @private
     * @param {?} versionId - the version id
     * @param {?=} callback - will be called at completion of retrieving data. Parameters are:
     *                   err - an error object
     *                   result - the document found matching systemHeader.versionId
     * @return {?}
     */
    loadDocByVersion(versionId, callback) {
        /** @type {?} */
        const _self = this;
        // if no callback then promisify
        if (!callback) {
            return new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            (resolve, reject) => {
                _self.loadDocByVersion(versionId, (/**
                 * @param {?} err
                 * @param {?} result
                 * @return {?}
                 */
                (err, result) => {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(result);
                    }
                }));
            }));
        }
        if (!versionId) {
            callback(new Error('versionId not specified in loadDocByVersion'));
            return;
        }
        this.getDatabase().then((/**
         * @param {?} db
         * @return {?}
         */
        function success(db) {
            db[IndexedDBConstants.DOCUMENT_TABLE_NAME].where(IndexedDBConstants.DOCUMENT_INDEX_VERSION_ID).equals(versionId)
                .first((/**
             * @param {?} result
             * @return {?}
             */
            result => {
                // return null as error object because there is no error
                callback(null, result);
            })).catch((/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                logger$9.error('Error getting document version ' + versionId + '. Error: ' + error.message);
                callback(error);
            }));
        }));
    }
    /**
     * @param {?} documentId
     * @param {?} versionId
     * @param {?} callback
     * @return {?}
     */
    loadCachedDocByVersion(documentId, versionId, callback) {
        /** @type {?} */
        const tblName = IndexedDBConstants.DOCUMENT_TABLE_NAME;
        /** @type {?} */
        const indexName = IndexedDBConstants.DOCUMENT_INDEX_DOCUMENT_ID;
        /** @type {?} */
        const indexValue = documentId;
        this.getEntries(tblName, indexName, indexValue, (/**
         * @param {?} entriesArr
         * @return {?}
         */
        function (entriesArr) {
            if (entriesArr.length > 0) {
                for (let i = 0; i < entriesArr.length; i++) {
                    if (entriesArr[i].systemHeader.versionId === versionId) {
                        callback(entriesArr[i]);
                        return;
                    }
                }
            }
            logger$9.info('No cached document found for this version: ' + versionId + ' of doc: ' + documentId);
            callback(null);
        }));
    }
    /**
     * @private
     * @param {?} document
     * @return {?}
     */
    cacheAttachedFilesOffline(document) {
        return __awaiter(this, void 0, void 0, function* () {
            // Cache file attachments sequence here
            // Searches for a file attachment in the document
            // Just visit every array property and if it contains an item with a property
            // named fileNo then load that file from the server into the cache system
            // Cache file attachments sequence here
            // Searches for a file attachment in the document
            // Just visit every array property and if it contains an item with a property
            // named fileNo then load that file from the server into the cache system
            /** @type {?} */
            const properties = Object.keys(document);
            for (let i = 0; i < properties.length; i++) {
                /** @type {?} */
                const pValue = document[properties[i]];
                if (pValue instanceof Array) {
                    for (let ix = 0; ix < pValue.length; ix++) {
                        /** @type {?} */
                        const specimen = pValue[ix];
                        if (specimen && specimen.fileNo) { // this is a file attachment by ftUploader
                            try {
                                yield this.loadFileAsync(specimen.fileNo);
                            }
                            catch (err) {
                                /** @type {?} */
                                const msg = 'Error getting file ' + err.status + " : " + err.message;
                                logger$9.error(msg);
                                logger$9.error(err);
                                this.offlineStatusService.offlineStatus.errorCacheAttachedFile.push(msg);
                            }
                        }
                    }
                }
            }
        });
    }
    /**
     * @param {?} blob
     * @return {?}
     */
    toBase64Str(blob) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const reader = new FileReader();
            reader.onloadend = (/**
             * @return {?}
             */
            function () {
                resolve(reader.result);
            });
            reader.onerror = (/**
             * @return {?}
             */
            function () {
                reject('Error converting to base64str blob.');
            });
            reader.readAsDataURL(blob);
        }));
    }
    // caches file blob into indexeddb
    /**
     * @private
     * @param {?} fileNo
     * @return {?}
     */
    loadFileAsync(fileNo) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const url = SharedUrlRoutes.serverRoutes.loadFile + '/' + fileNo;
            _self.http.get(url, { responseType: 'blob' }).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                /** @type {?} */
                const data = response;
                if (data) {
                    _self.toBase64Str(data).then((/**
                     * @param {?} base64str
                     * @return {?}
                     */
                    function (base64str) {
                        /** @type {?} */
                        const offlineFileRecord = {
                            fileNo: fileNo,
                            status: IndexedDBConstants.OFFLINE_STATUS_UPLOADED,
                            uploadConfig: {
                                data: {
                                    uploadedFile: base64str
                                }
                            }
                        };
                        _self.saveFile(offlineFileRecord);
                        resolve(true);
                    }));
                }
                else {
                    logger$9.warn('No data from remote file.');
                    resolve(true);
                }
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                reject(err);
            }));
        }));
    }
    /**
     *  Removes all versions of this document and leave the current version behind.
     *  'document' here is the current version fetched from the server. See DataService.getDocumentOfflineMode
     * @param {?} documentId
     * @return {?}
     */
    documentReset(documentId) {
        /** @type {?} */
        const tblName = IndexedDBConstants.DOCUMENT_TABLE_NAME;
        /** @type {?} */
        const indexName = IndexedDBConstants.DOCUMENT_INDEX_DOCUMENT_ID;
        /** @type {?} */
        const indexValue = documentId;
        this.deleteEntries(tblName, indexName, indexValue, (/**
         * @param {?} err
         * @param {?} count
         * @return {?}
         */
        function (err, count) {
            logger$9.info('Document reset cleared ' + count + ' versions of ' + indexValue);
        }));
    }
    /**
     * @param {?} offlineCacheObject
     * @param {?} callback
     * @return {?}
     */
    saveCacheObject(offlineCacheObject, callback) {
        /** @type {?} */
        const tbl = IndexedDBConstants.DOCUMENT_TABLE_NAME;
        // versionId is the primary key, hence, redundancy is avoided in cache see IndexedDBConnectorService
        this.saveEntry(tbl, offlineCacheObject, (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            if (!err) {
                callback(null, offlineCacheObject);
            }
            else {
                callback(err);
            }
        }));
        // if there are blobs, then save them into cache too
        this.cacheAttachedFilesOffline(offlineCacheObject);
    }
    /**
     * @private
     * @return {?}
     */
    onDocumentUpdated() {
        /** @type {?} */
        const _self = this;
        this.broadcastService.on('document:updated').subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            if (data) {
                /** @type {?} */
                const record = data[0];
                if (record && record.systemHeader && record.systemHeader.systemType === SharedConstants.SYSTEM_TYPE_TEMPLATE) {
                    /** @type {?} */
                    const indexes = _self.loggedInUserService.getUserConfigItem('searchIndexes');
                    if (record.indexedDBIndexes && record.indexedDBIndexes.length) {
                        /** @type {?} */
                        let needtoUpgraded = false;
                        record.indexedDBIndexes.forEach((/**
                         * @param {?} indexName
                         * @return {?}
                         */
                        function (indexName) {
                            /** @type {?} */
                            const isUpgraded = UtilArray.add(indexes, indexName, true);
                            needtoUpgraded = isUpgraded ? isUpgraded : needtoUpgraded;
                        }));
                        if (needtoUpgraded) {
                            _self.loggedInUserService.setUserConfigItem('searchIndexes', indexes);
                            _self.indexedDBConnectorService.upgradeOfflineDatabase();
                        }
                    }
                }
            }
        }));
    }
    /**
     * @param {?} newBean
     * @param {?} originalBean
     * @param {?} options
     * @return {?}
     */
    jsonPatchUpdate(newBean, originalBean, options) {
        return __awaiter(this, void 0, void 0, function* () {
            // Use the doc saved in indexeddb because original bean has been mutated
            // to not have offlineDetails. See https://mantis.formbird.com/view.php?id=14351
            /** @type {?} */
            const orig = yield this.loadDocByVersion(originalBean.systemHeader.versionId);
            /** @type {?} */
            const versionDoc = VersionManager.createVersion(orig);
            yield this.cacheDocument(versionDoc, true);
            // perform newBean update
            // Aside from the differences in data between originalBean and newbean, newBean will always have
            // its previousVersionId = originalBean's versionId. newBean will also be set as the current version
            // with a new versionId
            newBean.systemHeader.previousVersionId = versionDoc.systemHeader.versionId;
            // if versionId not yet generated
            if (newBean.systemHeader.versionId === versionDoc.systemHeader.versionId) {
                newBean.systemHeader.versionId = UtilDocumentId.generateId();
            }
            // update createdBy every time because when we update the doc it's a new version
            newBean.systemHeader.createdBy = this.user ?
                this.user.account.documentId : null;
            newBean.systemHeader.createdDate = new Date();
            /** @type {?} */
            const savedDocument = yield this.persist(newBean, ClientConstants.OPERATION_TYPE_PUT, options);
            return savedDocument;
        });
    }
    /**
     * @param {?} newBean
     * @param {?} originalBean
     * @param {?} options
     * @return {?}
     */
    deepDiffUpdate(newBean, originalBean, options) {
        return this.jsonPatchUpdate(newBean, originalBean, options);
    }
    /**
     * @param {?} documents
     * @param {?} updateOfflineStatus
     * @return {?}
     */
    doCacheBulkDocuments(documents, updateOfflineStatus) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            for (let i = 0; i < documents.length; i++) {
                try {
                    /** @type {?} */
                    let document;
                    document = documents[i];
                    _self.setIndexedDBIndexes(document);
                    // if there are blobs, then save them into cache too
                    this.cacheAttachedFilesOffline(document);
                }
                catch (err) {
                    logger$9.error(err);
                }
            }
            this.getDatabase().then((/**
             * @param {?} db
             * @return {?}
             */
            function success(db) {
                /** @type {?} */
                const tblName = IndexedDBConstants.DOCUMENT_TABLE_NAME;
                db.transaction('rw', db[tblName], (/**
                 * @param {?} result
                 * @return {?}
                 */
                (result) => {
                    db[tblName].bulkPut(documents).then((/**
                     * @param {?} data
                     * @return {?}
                     */
                    (data) => {
                        if (updateOfflineStatus !== false) {
                            _self.offlineStatusService.offlineStatus.currentCacheCount += (documents.length - 1);
                            _self.offlineStatusService.initialCacheQuerySuccess(documents[documents.length - 1]);
                        }
                        resolve(data);
                    }), (/**
                     * @param {?} e
                     * @return {?}
                     */
                    (e) => {
                        logger$9.error('Error caching bulk documents: ' + e.name + ": " + e.message);
                        reject(e);
                    }));
                })).catch((/**
                 * @param {?} e
                 * @return {?}
                 */
                e => {
                    logger$9.error('Error adding entry to IndexedDB: ' + e.stack || e);
                    reject(e);
                }));
            }));
        }));
    }
    /**
     * @param {?} options
     * @return {?}
     */
    executeComponentFunction(options) {
        logger$9.info('Executing component function in indexed-db Service');
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.indexedDBConnectorService.getDatabase().then((/**
             * @param {?} db
             * @return {?}
             */
            function (db) {
                try {
                    db.documents.where('systemHeader.systemType').equals('query').toArray((/**
                     * @param {?} documents
                     * @return {?}
                     */
                    function (documents) {
                        return __awaiter(this, void 0, void 0, function* () {
                            /** @type {?} */
                            let queryDocument;
                            /** @type {?} */
                            const results = yield documents.filter((/**
                             * @param {?} document
                             * @return {?}
                             */
                            function (document) {
                                return document.name === options.offlineComponentLibraryName && document.systemHeader.currentVersion === true &&
                                    toLower(document.searchProvider) === 'dexie';
                            }));
                            if (results && results.length > 0) {
                                queryDocument = results[0];
                                if (queryDocument && !isEmpty(queryDocument.filter)) {
                                    /** @type {?} */
                                    let fun;
                                    try {
                                        /** @type {?} */
                                        const funcStr = queryDocument.filter;
                                        fun = eval('(' + funcStr + ')');
                                        fun(db, (/**
                                         * @param {?} err
                                         * @param {?} data
                                         * @return {?}
                                         */
                                        function (err, data) {
                                            if (err) {
                                                /** @type {?} */
                                                const message = 'Error in Dexie: ' + err;
                                                reject(new Error(message));
                                            }
                                            else {
                                                resolve(data);
                                            }
                                        }));
                                    }
                                    catch (err) {
                                        reject(err);
                                    }
                                }
                            }
                            else {
                                reject(new Error("Offline component Library document not found."));
                            }
                        });
                    }));
                }
                catch (err) {
                    reject(err);
                }
            }));
        }));
    }
}
IndexedDBService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
IndexedDBService.ctorParameters = () => [
    { type: HttpClient },
    { type: IndexedDBConnectorService },
    { type: OfflineStatusService },
    { type: LoggedInUserService },
    { type: ElasticIndexedDBService },
    { type: DexieSearchService },
    { type: ClientAccessService },
    { type: BroadcastService },
    { type: NotificationService }
];
/** @nocollapse */ IndexedDBService.ɵprov = ɵɵdefineInjectable({ factory: function IndexedDBService_Factory() { return new IndexedDBService(ɵɵinject(HttpClient), ɵɵinject(IndexedDBConnectorService), ɵɵinject(OfflineStatusService), ɵɵinject(LoggedInUserService), ɵɵinject(ElasticIndexedDBService), ɵɵinject(DexieSearchService), ɵɵinject(ClientAccessService), ɵɵinject(BroadcastService), ɵɵinject(NotificationService)); }, token: IndexedDBService, providedIn: "root" });
if (false) {
    /** @type {?} */
    IndexedDBService.prototype.user;
    /** @type {?} */
    IndexedDBService.prototype.userSub;
    /** @type {?} */
    IndexedDBService.prototype.constants;
    /** @type {?} */
    IndexedDBService.prototype.checkQuotaExceededError;
    /**
     * @type {?}
     * @private
     */
    IndexedDBService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    IndexedDBService.prototype.indexedDBConnectorService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBService.prototype.offlineStatusService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBService.prototype.elasticIndexedDBService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBService.prototype.dexieSearchService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBService.prototype.clientAccessService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBService.prototype.broadcastService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBService.prototype.notificationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/actions/form-new.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FORM_SETUP_DOCUMENT_LIST = 'FORM_SETUP_DOCUMENT_LIST';
/** @type {?} */
const FORM_UPDATE_DOCUMENT = 'FORM_UPDATE_DOCUMENT';
/** @type {?} */
const FORM_CHANGE_DOCUMENT = 'FORM_CHANGE_DOCUMENT';
/** @type {?} */
const FORM_RESET_CHANGE_DOCUMENT = 'FORM_RESET_CHANGE_DOCUMENT';
/** @type {?} */
const FORM_SET_DOCUMENT = 'FORM_SET_DOCUMENT';
/** @type {?} */
const FORM_DELETE_DOCUMENT = 'FORM_DELETE_DOCUMENT';
/** @type {?} */
const FORM_UPDATE_COMPONENT_DEFINITION = 'FORM_UPDATE_COMPONENT_DEFINITION';
/** @type {?} */
const FORM_RESET_TEMPLATE_COMPONENT_DEFINITION = 'FORM_RESET_TEMPLATE_COMPONENT_DEFINITION';
/** @type {?} */
const FORM_SET_COMPONENT_FLAG_TEMPLATE = 'FORM_SET_COMPONENT_FLAG_TEMPLATE';
/** @type {?} */
const FORM_SET_LIST_COMPONENTS_FLAG_TEMPLATE = 'FORM_SET_LIST_COMPONENTS_FLAG_TEMPLATE';
/** @type {?} */
const FORM_CLEAR_DOCUMENT = 'FORM_CLEAR_DOCUMENT';
/** @type {?} */
const FORM_RESET_TO_ORG_DOCUMENT = 'FORM_RESET_TO_ORG_DOCUMENT';
/** @type {?} */
const FORM_SET_ORG_DOCUMENT = 'FORM_SET_ORG_DOCUMENT';
/** @type {?} */
const FORM_SET_DOCUMENT_INFO = 'FORM_SET_DOCUMENT_INFO';
/** @type {?} */
const FORM_RESET_DOCUMENT_INFO = 'FORM_RESET_DOCUMENT_INFO';
/** @type {?} */
const FORM_UPDATE_INIT_DOCUMENT_DATA = 'FORM_UPDATE_INIT_DOCUMENT_DATA';
/** @type {?} */
const FORM_RESET_INIT_DOCUMENT_DATA = 'FORM_RESET_INIT_DOCUMENT_DATA';
/** @type {?} */
const FORM_UNDO = 'FORM_UNDO';
/** @type {?} */
const FORM_REDO = 'FORM_REDO';
/** @type {?} */
const FORM_RESET_UNDO_REDO = 'FORM_RESET_UNDO_REDO';
/** @type {?} */
const FORM_SET_DISABLE_SAVE_FIELD_DOCUMENT = 'FORM_SET_DISABLE_SAVE_FIELD_DOCUMENT';
/** @type {?} */
const FORM_SET_DOCUMENT_SESSION = 'FORM_SET_DOCUMENT_SESSION';
/**
 * Document List section
 * @record
 */
function IFormSetupDocumentListAction() { }
if (false) {
    /** @type {?} */
    IFormSetupDocumentListAction.prototype.payload;
}
/**
 * @param {?} documentListId
 * @param {?} documentListType
 * @param {?=} isMainDoc
 * @return {?}
 */
function formSetupDocumentList(documentListId, documentListType, isMainDoc) {
    return {
        type: FORM_SETUP_DOCUMENT_LIST,
        payload: {
            documentListId,
            documentListType,
            isMainDoc
        }
    };
}
/**
 * Change document section
 * @record
 */
function IFormDocumentChangedAction() { }
if (false) {
    /** @type {?} */
    IFormDocumentChangedAction.prototype.payload;
}
/**
 * @param {?} documentChangedInfo
 * @return {?}
 */
function formDocumentUpdated(documentChangedInfo) {
    return {
        type: FORM_UPDATE_DOCUMENT,
        payload: {
            documentChangedInfo
        }
    };
}
/**
 * @param {?} documentChangedInfo
 * @return {?}
 */
function formDocumentChanged(documentChangedInfo) {
    return {
        type: FORM_CHANGE_DOCUMENT,
        payload: {
            documentChangedInfo
        }
    };
}
/**
 * @record
 */
function IFormResetDocumentChangedAction() { }
/**
 * @return {?}
 */
function formResetDocumentChanged() {
    return {
        type: FORM_RESET_CHANGE_DOCUMENT
    };
}
/**
 * Clear document section
 * @record
 */
function IFormClearDocumentsAction() { }
/**
 * @return {?}
 */
function formClearDocuments() {
    return {
        type: FORM_CLEAR_DOCUMENT
    };
}
/**
 * Set document section
 * @record
 */
function IFormSetDocumentAction() { }
if (false) {
    /** @type {?} */
    IFormSetDocumentAction.prototype.payload;
}
/**
 * @record
 */
function IFormDeleteDocumentAction() { }
if (false) {
    /** @type {?} */
    IFormDeleteDocumentAction.prototype.payload;
}
/**
 * @record
 */
function IFormUpdateComponentDefinitionAction() { }
if (false) {
    /** @type {?} */
    IFormUpdateComponentDefinitionAction.prototype.payload;
}
/**
 * @record
 */
function IFormResetTemplateComponentDefinitionAction() { }
if (false) {
    /** @type {?} */
    IFormResetTemplateComponentDefinitionAction.prototype.payload;
}
/**
 * @record
 */
function IFormSetComponentFlagAction() { }
if (false) {
    /** @type {?} */
    IFormSetComponentFlagAction.prototype.payload;
}
/**
 * @record
 */
function IFormSetListComponentsFlagAction() { }
if (false) {
    /** @type {?} */
    IFormSetListComponentsFlagAction.prototype.payload;
}
/**
 * @record
 */
function IFormResetToOrgDocumentAction() { }
if (false) {
    /** @type {?} */
    IFormResetToOrgDocumentAction.prototype.payload;
}
/**
 * @param {?} document
 * @param {?=} versionId
 * @return {?}
 */
function formSetDocument(document, versionId) {
    return {
        type: FORM_SET_DOCUMENT,
        payload: {
            document,
            versionId
        }
    };
}
/**
 * @param {?} templateId
 * @param {?} fieldName
 * @param {?} key
 * @param {?} componentDef
 * @return {?}
 */
function formUpdateComponentDefinition(templateId, fieldName, key, componentDef) {
    return {
        type: FORM_UPDATE_COMPONENT_DEFINITION,
        payload: {
            templateId,
            fieldName,
            key,
            componentDef
        }
    };
}
/**
 * @param {?} templateId
 * @return {?}
 */
function formResetTemplateComponentDefinition(templateId) {
    return {
        type: FORM_RESET_TEMPLATE_COMPONENT_DEFINITION,
        payload: {
            templateId
        }
    };
}
/**
 * @param {?} templateId
 * @param {?} fieldName
 * @param {?} flagName
 * @param {?} flagValue
 * @return {?}
 */
function formSetComponentFlagTemplate(templateId, fieldName, flagName, flagValue) {
    return {
        type: FORM_SET_COMPONENT_FLAG_TEMPLATE,
        payload: {
            templateId,
            fieldName,
            flagName,
            flagValue
        }
    };
}
/**
 * @param {?} templateId
 * @param {?} fieldNames
 * @param {?} flagName
 * @param {?} flagValue
 * @return {?}
 */
function formSetListComponentsFlagTemplate(templateId, fieldNames, flagName, flagValue) {
    return {
        type: FORM_SET_LIST_COMPONENTS_FLAG_TEMPLATE,
        payload: {
            templateId,
            fieldNames,
            flagName,
            flagValue
        }
    };
}
/**
 * @param {?} document
 * @param {?=} versionId
 * @return {?}
 */
function formSetOrgDocument(document, versionId) {
    return {
        type: FORM_SET_ORG_DOCUMENT,
        payload: {
            document,
            versionId
        }
    };
}
/**
 * @param {?} documentId
 * @return {?}
 */
function formDeleteDocument(documentId) {
    return {
        type: FORM_DELETE_DOCUMENT,
        payload: {
            documentId
        }
    };
}
/**
 * @param {?} documentId
 * @return {?}
 */
function formResetToOrgDocument(documentId) {
    return {
        type: FORM_RESET_TO_ORG_DOCUMENT,
        payload: {
            documentId
        }
    };
}
/**
 * Document info section
 * @record
 */
function IFormSetDocumentInfoAction() { }
if (false) {
    /** @type {?} */
    IFormSetDocumentInfoAction.prototype.payload;
}
/**
 * @param {?} documentListId
 * @param {?} documentInfo
 * @return {?}
 */
function formSetDocumentInfo(documentListId, documentInfo) {
    return {
        type: FORM_SET_DOCUMENT_INFO,
        payload: {
            documentInfo,
            unsavedDocumentListId: documentListId
        }
    };
}
/**
 * @record
 */
function IFormResetDocumentInfoAction() { }
if (false) {
    /** @type {?} */
    IFormResetDocumentInfoAction.prototype.payload;
}
/**
 * @param {?} unsavedDocumentListId
 * @return {?}
 */
function formResetDocumentInfo(unsavedDocumentListId) {
    return {
        type: FORM_RESET_DOCUMENT_INFO,
        payload: {
            unsavedDocumentListId
        }
    };
}
/**
 * @record
 */
function IFormUpdateInitDocumentDataAction() { }
if (false) {
    /** @type {?} */
    IFormUpdateInitDocumentDataAction.prototype.payload;
}
/**
 * @param {?} unsavedDocumentListId
 * @param {?} fieldName
 * @param {?} fieldValue
 * @return {?}
 */
function formUpdateInitDocumentData(unsavedDocumentListId, fieldName, fieldValue) {
    return {
        type: FORM_UPDATE_INIT_DOCUMENT_DATA,
        payload: {
            unsavedDocumentListId,
            fieldName,
            fieldValue
        }
    };
}
/**
 * @record
 */
function IFormResetInitDocumentDataAction() { }
if (false) {
    /** @type {?} */
    IFormResetInitDocumentDataAction.prototype.payload;
}
/**
 * @param {?} unsavedDocumentListId
 * @return {?}
 */
function formResetInitDocumentData(unsavedDocumentListId) {
    return {
        type: FORM_RESET_INIT_DOCUMENT_DATA,
        payload: {
            unsavedDocumentListId
        }
    };
}
/**
 * Undo/Redo document section
 * @record
 */
function IFormUndoDocumentAction() { }
/**
 * @record
 */
function IFormRedoDocumentAction() { }
/**
 * @record
 */
function IFormResetUnRedoDocumentAction() { }
/**
 * @return {?}
 */
function formUndoDocument() {
    return {
        type: FORM_UNDO
    };
}
/**
 * @return {?}
 */
function formRedoDocument() {
    return {
        type: FORM_REDO
    };
}
/**
 * @return {?}
 */
function resetUndoRedoDocument() {
    return {
        type: FORM_RESET_UNDO_REDO
    };
}
/**
 * @record
 */
function IFormSetDisabledSaveAction() { }
if (false) {
    /** @type {?} */
    IFormSetDisabledSaveAction.prototype.payload;
}
/**
 * @param {?} documentId
 * @param {?} disabledFields
 * @return {?}
 */
function formSetDisableSaveFieldDocument(documentId, disabledFields) {
    return {
        type: FORM_SET_DISABLE_SAVE_FIELD_DOCUMENT,
        payload: {
            documentId,
            disabledFields
        }
    };
}
/**
 * @record
 */
function IFormSetDocumentSessionAction() { }
if (false) {
    /** @type {?} */
    IFormSetDocumentSessionAction.prototype.payload;
}
/**
 * @param {?} documentSession
 * @param {?} documentId
 * @return {?}
 */
function formSetDocumentSession(documentSession, documentId) {
    return {
        type: FORM_SET_DOCUMENT_SESSION,
        payload: {
            documentSession,
            documentId
        }
    };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/actions/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/document-session.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$a = console;
class DocumentSessionService {
    /**
     * @param {?} appStore
     */
    constructor(appStore) {
        this.appStore = appStore;
        this.subs = new Subscription();
        this.documentSession = {};
        if (this.documentSession$) {
            this.documentSession$.subscribe((/**
             * @param {?} documentSession
             * @return {?}
             */
            documentSession => {
                // logger.info("Changed documentSession value : " + JSON.stringify(documentSession));
            }));
        }
    }
    /**
     * @param {?} documentId
     * @return {?}
     */
    initialize(documentId) {
        this.setDocumentSession(documentId, {});
    }
    /**
     * @param {?} documentId
     * @param {?=} document
     * @return {?}
     */
    setDocumentSession(documentId, document) {
        this.appStore.dispatch(formSetDocumentSession(document, documentId));
    }
    /**
     * @param {?} documentId
     * @return {?}
     */
    getDocumentSession(documentId) {
        this.documentSession = cloneDeep(this.appStore.getState().formState.documentSession[documentId]);
        return this.documentSession ? this.documentSession : {};
    }
}
DocumentSessionService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
DocumentSessionService.ctorParameters = () => [
    { type: AppStore }
];
/** @nocollapse */ DocumentSessionService.ɵprov = ɵɵdefineInjectable({ factory: function DocumentSessionService_Factory() { return new DocumentSessionService(ɵɵinject(AppStore)); }, token: DocumentSessionService, providedIn: "root" });
__decorate([
    select(['formState', 'documentSession']),
    __metadata("design:type", Observable)
], DocumentSessionService.prototype, "documentSession$", void 0);
if (false) {
    /** @type {?} */
    DocumentSessionService.prototype.documentSession$;
    /**
     * @type {?}
     * @private
     */
    DocumentSessionService.prototype.subs;
    /**
     * @type {?}
     * @private
     */
    DocumentSessionService.prototype.documentSession;
    /**
     * @type {?}
     * @private
     */
    DocumentSessionService.prototype.appStore;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/data/rest-data.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const serverRoutes$1 = SharedUrlRoutes.serverRoutes;
/** @type {?} */
const logger$b = console;
class RestDataService {
    /**
     * @param {?} http
     * @param {?} loggedInUserService
     * @param {?} configService
     * @param {?} offlineStatusService
     * @param {?} indexedDBService
     * @param {?} documentSessionService
     */
    constructor(http, loggedInUserService, configService, offlineStatusService, indexedDBService, documentSessionService) {
        this.http = http;
        this.loggedInUserService = loggedInUserService;
        this.configService = configService;
        this.offlineStatusService = offlineStatusService;
        this.indexedDBService = indexedDBService;
        this.documentSessionService = documentSessionService;
    }
    /**
     * @param {?} url
     * @param {?} id
     * @param {?=} includeDeleted
     * @return {?}
     */
    checkDocumentExists(url, id, includeDeleted) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            let fullUrl = url;
            if (id) {
                fullUrl += '/' + id;
            }
            if (includeDeleted === true) {
                fullUrl += '/' + includeDeleted;
            }
            _self.http.get(fullUrl).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                /** @type {?} */
                const msg = err ? err.message : 'Something went wrong when checking document exists.';
                /** @type {?} */
                const error = new FtError(msg);
                if (err) {
                    error.status = err.status;
                    error.statusText = err.statusText;
                    error.message = err.message;
                }
                reject(error);
            }));
        }));
    }
    /**
     * @param {?} url
     * @param {?} id
     * @return {?}
     */
    getDocument(url, id) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            let fullUrl = url;
            if (id) {
                fullUrl += '/' + id;
            }
            _self.http.get(fullUrl).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                /** @type {?} */
                const msg = err ? err.message : 'Something went wrong when getting document.';
                /** @type {?} */
                const error = new FtError(msg);
                if (err) {
                    error.status = err.status;
                    error.statusText = err.statusText;
                    error.message = err.error;
                }
                reject(error);
            }));
        }));
    }
    /**
     * @param {?} syncStartTime
     * @param {?} isInitialize
     * @return {?}
     */
    loadDataCache(syncStartTime, isInitialize) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.getCachedDocumentCount(syncStartTime).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                /** @type {?} */
                const data = res;
                logger$b.info('Loading data cache. With info: ', data);
                _self.offlineStatusService.addToMaxCacheCount(data.docCount);
                /**
                 * @param {?} page
                 * @return {?}
                 */
                function loadEach(page) {
                    return _self.loadCachedDocuments(syncStartTime, page, isInitialize);
                }
                UtilSequenceProcess.processRange(1, data.pages, loadEach).then((/**
                 * @param {?} result
                 * @return {?}
                 */
                function allPromiseSuccessFunc(result) {
                    resolve(result);
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function errorFunc(err) {
                    reject(err);
                }));
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                /** @type {?} */
                const msg = 'Error requesting offline document count. Status: ' + err.status;
                logger$b.error(err.message);
                reject(new FtError(msg));
            }));
        }));
    }
    /**
     * @private
     * @param {?} documents
     * @param {?=} isInitialize
     * @param {?=} updateOfflineStatus
     * @return {?}
     */
    processCachingDocuments(documents, isInitialize, updateOfflineStatus) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const promises = [];
            if (isInitialize === true) {
                promises.push(_self.indexedDBService.doCacheBulkDocuments(documents, updateOfflineStatus));
            }
            else {
                for (let i = 0; i < documents.length; i++) {
                    /** @type {?} */
                    const document = documents[i];
                    if (isInitialize === false) {
                        promises.push(_self.indexedDBService.cachePushedDocument(document, [document], updateOfflineStatus));
                    }
                    else {
                        promises.push(_self.indexedDBService.doCacheDocument(document, updateOfflineStatus));
                    }
                }
            }
            Promise.all(promises).then((/**
             * @param {?} results
             * @return {?}
             */
            function successFunction(results) {
                resolve(results);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function errorFunction(err) {
                _self.indexedDBService.checkQuotaExceededError(err);
                reject(new Error(err.message));
            }));
        }));
    }
    /**
     * @return {?}
     */
    getIndexedDBIndexes() {
        /** @type {?} */
        let indexedDBIndexes = [];
        //getting indexKey from user account group config document as well
        /** @type {?} */
        let accountConfig = this.loggedInUserService.getUserAccountGroupConfigDocument();
        if (accountConfig && accountConfig.indexedDBIndexes && accountConfig.indexedDBIndexes.length > 0) {
            indexedDBIndexes = accountConfig.indexedDBIndexes;
        }
        /** @type {?} */
        const options = {
            filter: {
                query: {
                    'bool': {
                        'must': [
                            {
                                'exists': {
                                    'field': 'indexedDBIndexes'
                                }
                            },
                            {
                                'term': {
                                    'systemHeader.systemType': 'template'
                                }
                            }
                        ]
                    }
                }
            },
            sourceFilter: 'indexedDBIndexes'
        };
        return this.search(options).then((/**
         * @param {?} results
         * @return {?}
         */
        function (results) {
            if (results.data.hits.total) {
                for (let i = 0; i < results.data.hits.hits.length; i++) {
                    /** @type {?} */
                    const template = results.data.hits.hits[i]._source;
                    /** @type {?} */
                    const indexes = template.indexedDBIndexes;
                    if (indexes) {
                        for (let j = 0; j < indexes.length; j++) {
                            UtilArray.add(indexedDBIndexes, indexes[j], true);
                        }
                    }
                }
            }
            return Promise.resolve(indexedDBIndexes);
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            return Promise.reject(error);
        }));
    }
    /**
     * @private
     * @param {?} syncStartTime
     * @return {?}
     */
    getCachedDocumentCount(syncStartTime) {
        /** @type {?} */
        const fullUrl = serverRoutes$1.syncDocumentsCountURL + '/' + syncStartTime;
        return this.http.get(fullUrl);
    }
    /**
     * @private
     * @param {?} syncStartTime
     * @param {?} pageNo
     * @param {?} isInitialize
     * @return {?}
     */
    loadCachedDocuments(syncStartTime, pageNo, isInitialize) {
        logger$b.info('Loading cached documents for page: ' + pageNo);
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const fullUrl = serverRoutes$1.syncDocuments + '/' + syncStartTime + '/' + pageNo;
        // ensures request is processed only when ui turned idle
        this.offlineStatusService.pageDownloadProgress.pageNumber = pageNo;
        /** @type {?} */
        const getParams = {
            // Them TT check request progress
            eventHandlers: {
                progress: (/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) {
                    if (e.lengthComputable) {
                        _self.offlineStatusService.pageDownloadProgress.loaded = e.loaded;
                        _self.offlineStatusService.pageDownloadProgress.total = e.total;
                    }
                })
            }
        };
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.http.get(fullUrl).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                /** @type {?} */
                const data = res;
                /** @type {?} */
                const templates = data.templates;
                /** @type {?} */
                const documents = data.documents;
                // Cache templates first to register indexes, no need to update offline count.
                // It will be set in the full list of offline documents in the next step
                _self.processCachingDocuments(templates, isInitialize, false).then((/**
                 * @return {?}
                 */
                function cachedOk() {
                    // Then caching document to make sure the corresponding template is ready to use
                    _self.processCachingDocuments(documents, isInitialize).then((/**
                     * @param {?} results
                     * @return {?}
                     */
                    function successFunction(results) {
                        resolve(results);
                    }), (/**
                     * @param {?} err
                     * @return {?}
                     */
                    function errorFunction(err) {
                        reject(new Error(err.message));
                    }));
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function cachedFailed(err) {
                    logger$b.warn('Some templates could not be cached successfully: ' + err);
                    _self.processCachingDocuments(documents, isInitialize).then((/**
                     * @param {?} results
                     * @return {?}
                     */
                    function successFunction(results) {
                        resolve(results);
                    }), (/**
                     * @param {?} error
                     * @return {?}
                     */
                    function errorFunction(error) {
                        reject(new Error(error.message));
                    }));
                }));
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                /** @type {?} */
                const msg = 'Error caching data. Network data will be used: ' + err.status;
                logger$b.error(msg);
                reject(err);
            }));
        }));
    }
    // get full rest url from a url without the host and webapp section, so a url of 'cases' will become
    // {hostname}:{port}/{webappname}/cases. eg localhost:8090/focus-rest/cases
    /**
     * @private
     * @param {?} url
     * @param {?=} id
     * @return {?}
     */
    getFullRestURL(url, id) {
        /** @type {?} */
        let fullUrl = url;
        if (UtilType.hasValue(id)) {
            fullUrl += '/' + id;
        }
        return fullUrl;
    }
    /**
     * As per 10539, we send the new document directly to the server and let it run jsonPatch.
     * For simplicity, other parameters from the old deep Update was
     * removed because the server can resolve them with just the newDocument value.
     *
     * @param {?} newDocument the new document to update
     * @param {?} options
     * @return {?} promise|*|jQuery.promise the promise
     */
    jsonPatchUpdate(newDocument, options) {
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const updateUrl = SharedUrlRoutes.serverRoutes.documentDeepDiffUpdate + '/' + newDocument.documentId;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const putData = {
                document: newDocument,
                options: options
            };
            _self.http.put(updateUrl, putData)
                .subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                console.log(err);
                /** @type {?} */
                const error = err ? new Error(err.error) : new Error('Something went wrong when updating document.');
                reject(error);
            }));
        }));
    }
    /*
       insert function
       parameters:
       bean - the bean to insert
       url - the url for the restful web service. This will also be used as a key in the database
       successFunction - a function to execute on success to do post save steps
       cachingRequired - whether to save the record to the local database. Records that never need
       to be loaded in the app on their own, such as events, can have this set to false
       */
    /**
     * @param {?} bean
     * @param {?} url
     * @return {?}
     */
    insert(bean, url) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const fullUrl = _self.getFullRestURL(url, bean.id);
            /** @type {?} */
            const options = { headers: {
                    options: JSON.stringify({
                        documentSession: this.documentSessionService.getDocumentSession(bean.documentId)
                    })
                } };
            _self.http.post(fullUrl, bean, options).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                console.log(err);
                /** @type {?} */
                const error = err ? new Error(err.error) : new Error('Something went wrong when inserting document.');
                reject(error);
            }));
        }));
    }
    /*
       destroy function
       parameters:
       id - the id of the bean to delete
       url - the url for the restful web service
       cachingRequired - whether to save the record to the local database. Records that never need
       templateId - template used when deleting document
       versionId - version of document during deletion
       to be loaded in the app on their own, such as events, can have this set to false
       */
    /**
     * @param {?} id
     * @param {?} url
     * @param {?} cachingRequired
     * @param {?} templateId
     * @param {?} previousVersionId
     * @return {?}
     */
    destroy(id, url, cachingRequired, templateId, previousVersionId) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const fullUrl = _self.getFullRestURL(url, id) + '/' + templateId + '/' + previousVersionId;
            _self.http.delete(fullUrl).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                console.log(err);
                /** @type {?} */
                const error = err ? new Error(err.error) : new Error('Something went wrong when destroying document.');
                reject(error);
            }));
        }));
    }
    /**
     * @param {?} options
     * @return {?}
     */
    search(options) {
        logger$b.info('Doing search in RestDataService');
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.http.post('api/documentSearch', options, { headers: { 'Content-Type': 'application/json' } }).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                /** @type {?} */
                let msg;
                if (err && err.error) {
                    msg = err.error.message || err.message;
                }
                else {
                    msg = 'Something went wrong when searching document. Status: ' + err.status;
                }
                if (err && err.status === UtilHttpStatus.SERVER_UNRESPONSIVE) {
                    reject(UtilError.createError(msg, UtilError.SERVER_UNRESPONSE_ERROR));
                }
                else {
                    reject(new Error(msg));
                }
            }));
        }));
    }
    /**
     * @param {?} versionIds
     * @return {?}
     */
    loadVersions(versionIds) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (!versionIds || !versionIds.length) {
                resolve();
            }
            else {
                /** @type {?} */
                const url = SharedUrlRoutes.serverRoutes.versionFetch;
                /** @type {?} */
                const options = {
                    versionIds: versionIds,
                    'includeAllVersions': true
                };
                _self.http.post(url, options).subscribe((/**
                 * @param {?} res
                 * @return {?}
                 */
                res => {
                    resolve(res);
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                err => {
                    /** @type {?} */
                    const msg = 'Error requesting versions. Status: ' + err.status;
                    logger$b.error(err.message);
                    reject(new Error(msg));
                }));
            }
        }));
    }
    /*
       undestroy function
       parameters:
       id - the id of the bean to undelete
       url - the url for the restful web service
       */
    /**
     * @param {?} id
     * @param {?} url
     * @return {?}
     */
    undestroy(id, url) {
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const fullUrl = this.getFullRestURL(url, id);
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.http.put(fullUrl, null).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                /** @type {?} */
                const error = err ? new Error(err.error) : new Error('Something went wrong when undestroying document.');
                reject(error);
            }));
        }));
    }
    /*
      bulkUploadDocuments function
      parameters:
      documents - the array of documents to upload.
      url - the url for the restful web service
      */
    /**
     * @param {?} documents
     * @param {?} url
     * @return {?}
     */
    bulkUploadDocuments(documents, url) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const fullUrl = _self.getFullRestURL(url);
            _self.http.post(fullUrl, documents).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                /** @type {?} */
                const error = err ? new Error(err) : new Error('Something went wrong when uploading documents.');
                reject(error);
            }));
        }));
    }
    /**
     * @param {?} options
     * @return {?}
     */
    executeComponentFunction(options) {
        logger$b.info('Executing component function in RestDataService');
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.http.post('api/execute', options, { headers: { 'Content-Type': 'application/json' } }).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                /** @type {?} */
                let msg;
                if (err && err.message) {
                    msg = 'executing component function failed with error: ';
                    msg += err.message;
                }
                else {
                    msg = 'Something went wrong when executing component function. Status: ' + err.status;
                }
                if (err && err.status === UtilHttpStatus.SERVER_UNRESPONSIVE) {
                    reject(UtilError.createError(msg, UtilError.SERVER_UNRESPONSE_ERROR));
                }
                else {
                    reject(new Error(msg));
                }
            }));
        }));
    }
}
RestDataService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
RestDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: LoggedInUserService },
    { type: ConfigService },
    { type: OfflineStatusService },
    { type: IndexedDBService },
    { type: DocumentSessionService }
];
/** @nocollapse */ RestDataService.ɵprov = ɵɵdefineInjectable({ factory: function RestDataService_Factory() { return new RestDataService(ɵɵinject(HttpClient), ɵɵinject(LoggedInUserService), ɵɵinject(ConfigService), ɵɵinject(OfflineStatusService), ɵɵinject(IndexedDBService), ɵɵinject(DocumentSessionService)); }, token: RestDataService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    RestDataService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    RestDataService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    RestDataService.prototype.configService;
    /**
     * @type {?}
     * @private
     */
    RestDataService.prototype.offlineStatusService;
    /**
     * @type {?}
     * @private
     */
    RestDataService.prototype.indexedDBService;
    /**
     * @type {?}
     * @private
     */
    RestDataService.prototype.documentSessionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/data/data.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const serverRoutes$2 = SharedUrlRoutes.serverRoutes;
/** @type {?} */
const logger$c = console;
class DataService {
    /**
     * @param {?} indexedDBConnectorService
     * @param {?} loggedInUserService
     * @param {?} restDataService
     * @param {?} offlineStatusService
     * @param {?} indexedDBService
     * @param {?} clientAccessService
     * @param {?} documentSessionService
     */
    constructor(indexedDBConnectorService, loggedInUserService, restDataService, offlineStatusService, indexedDBService, clientAccessService, documentSessionService) {
        this.indexedDBConnectorService = indexedDBConnectorService;
        this.loggedInUserService = loggedInUserService;
        this.restDataService = restDataService;
        this.offlineStatusService = offlineStatusService;
        this.indexedDBService = indexedDBService;
        this.clientAccessService = clientAccessService;
        this.documentSessionService = documentSessionService;
        if (this.user$) {
            this.user$.subscribe((/**
             * @param {?} data
             * @return {?}
             */
            (data) => this.user = data));
        }
    }
    //
    // // the preferred service. This can be configured to either check the cache for data first or go to the
    // // network first. The service to call first will be set based on the ConfigService.clientConfig.preferCachedData value
    // var preferredService = null;
    //
    // // the secondaryService will be tried if the preferred service fails
    // var secondaryService = null;
    ////////////////////////////////////////
    // local service functions
    /**
     * cache a document for offline use
     * @param {?} docInfo - the document used to load full document to cache
     * @param {?} versions - the versions used to cache
     * @return {?}
     */
    cacheDocument(docInfo, versions) {
        /** @type {?} */
        const _self = this;
        if (_self.loggedInUserService.getUserConfigItem('cachingEnabled') === true) {
            if (!versions || !versions.length) {
                return _self.restDataService.loadVersions(docInfo.versionIds).then((/**
                 * @param {?} versions
                 * @return {?}
                 */
                (versions) => {
                    return _self.indexedDBService.cachePushedDocument(docInfo, versions);
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                (error) => {
                    return Promise.reject(error);
                }));
            }
            return _self.indexedDBService.cachePushedDocument(docInfo, versions);
        }
        return Promise.resolve(versions);
    }
    /**
     * @param {?} documentId
     * @param {?=} includeDeleted
     * @return {?}
     */
    documentExists(documentId, includeDeleted) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!documentId) {
                throw new Error('No documentId specified for check exist!');
            }
            /** @type {?} */
            const offlineMode = this.loggedInUserService.getUserConfigItem('cachingEnabled') === true;
            try {
                return offlineMode ? yield this.checkDocumentExistsOfflineMode(documentId)
                    : yield this.checkDocumentExistFromServer(documentId, includeDeleted);
            }
            catch (err) {
                throw UtilError.createErrorObject(err);
            }
        });
    }
    /**
     * get a document
     * @param {?} id
     * @return {?}
     */
    getDocument(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!id) {
                // old code reject this error as string
                // tslint:disable-next-line:no-string-throw
                throw 'No documentId specified for getDocument!';
            }
            try {
                /** @type {?} */
                const offlineMode = this.loggedInUserService.getUserConfigItem('cachingEnabled') === true;
                /** @type {?} */
                const doc = offlineMode ? yield this.getDocumentOfflineMode(id) : yield this.getDocumentFromServer(id);
                if (doc.systemHeader && doc.systemHeader.offlineDetails) {
                    delete doc.systemHeader.offlineDetails;
                }
                return doc;
            }
            catch (err) {
                /** @type {?} */
                let error;
                if (err.status === UtilHttpStatus.FORBIDDEN) {
                    error = UtilError.createError(err.message, UtilError.FORBIDDEN_ERROR);
                }
                else if (err.status === UtilHttpStatus.NOT_FOUND) {
                    error = UtilError.createError(err.message, UtilError.NOT_FOUND_ERROR);
                }
                else if (err.status === UtilHttpStatus.GONE) {
                    error = UtilError.createError(err.message, UtilError.DELETED_ERROR);
                }
                else {
                    error = UtilError.createErrorObject(err);
                }
                throw error;
            }
        });
    }
    /* if offline mode then retrieve the latest version of the document from offline db and name as cachedDoc
       * if the cachedDoc is not yet sent to server then return it;
       * else query the server for the latest versionId of the document
       * if versions don't match, use server's version and perform 'documentReset'
       *
       * DocumentReset will remove all versions of a document
       * and start from the beginning as a single version (that current version from the server)
       *
       * DocumentReset is there primarily there to simplify retrieving documents once there have
       * been version conflicts that have been resolved by the server: when two users modifies
       * a single document at the same time offline. If this do not occur, then documentReset will not happen.
       */
    /**
     * @param {?} id
     * @return {?}
     */
    getDocumentOfflineMode(id) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.indexedDBService.getDocumentCurrentVersion(id, (/**
             * @param {?} cacheDoc
             * @return {?}
             */
            (cacheDoc) => {
                if (cacheDoc == null) { // not found in offline? retrieve from server
                    _self.getDocumentFromServer(id).then(resolve, reject);
                }
                else {
                    resolve(cacheDoc);
                }
                // Do not retrieve the server's version if this document is still unsent.
                // var unsent = cacheDoc.offlineDetails &&
                //     cacheDoc.offlineDetails.status === IndexedDBConstants.OFFLINE_STATUS_PENDING;
                // if (unsent) {
                //     deferred.resolve(cachedObject);
                //     return;
                // }
                // //let's see if we have conflicts from the server:
                // getDocumentFromServer(id).then((doc) => {
                //     var identicalDocuments = doc.systemHeader.versionId === cachedDoc.systemHeader.versionId;
                //     if (!identicalDocuments) {//version conflict! see 10049 & 10539
                //         IndexedDBService.documentReset(doc.documentId);
                //     //doc here is the latest version from the document that have been resolved by the server from conflict
                //         cacheDocument(doc);
                //     }
                //
                //     deferred.resolve(doc);
                //
                // }, function err(statusCode){
                //     //we could not retrieve from the server due to some error, return the cachedDoc instead
                //     deferred.resolve(cachedDoc);
                //
                // });
            }));
        }));
    }
    /**
     * @param {?} id
     * @return {?}
     */
    getDocumentFromServer(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.restDataService.getDocument(serverRoutes$2.document, id);
            }
            catch (error) {
                /** @type {?} */
                const offlineMode = this.loggedInUserService.getUserConfigItem('cachingEnabled') === true;
                if (offlineMode && error && error.status === UtilHttpStatus.SERVER_UNRESPONSIVE) {
                    error.status = UtilHttpStatus.NOT_FOUND;
                }
                throw error;
            }
        });
    }
    /**
     * @private
     * @param {?} id
     * @return {?}
     */
    checkDocumentExistsOfflineMode(id) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const _self = this;
            /** @type {?} */
            let found = yield new Promise((/**
             * @param {?} resolve
             * @return {?}
             */
            (resolve) => {
                _self.indexedDBService.getDocumentCurrentVersion(id, (/**
                 * @param {?} cacheDoc
                 * @return {?}
                 */
                cacheDoc => {
                    resolve(!!cacheDoc);
                }));
            }));
            try {
                if (!found) {
                    found = !!(yield _self.checkDocumentExistFromServer(id));
                }
            }
            catch (err) {
                throw err;
            }
            return found;
        });
    }
    /**
     * @private
     * @param {?} id
     * @param {?=} includeDeleted
     * @return {?}
     */
    checkDocumentExistFromServer(id, includeDeleted) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const _self = this;
            try {
                return yield _self.restDataService.checkDocumentExists(serverRoutes$2.documentExists, id, includeDeleted);
            }
            catch (error) {
                /** @type {?} */
                const offlineMode = _self.loggedInUserService.getUserConfigItem('cachingEnabled') === true;
                if (offlineMode && error && error.status === UtilHttpStatus.SERVER_UNRESPONSIVE) {
                    error.status = UtilHttpStatus.NOT_FOUND;
                    error.message = 'Network connection lost. Could not retrieve.';
                }
                throw error;
            }
        });
    }
    /**
     * @param {?} query
     * @param {?=} searchContext
     * @return {?}
     */
    findByElastic(query, searchContext) {
        /** @type {?} */
        const options = {
            filter: query
        };
        return this.search(options, searchContext);
    }
    /**
     * @param {?} options
     * @param {?} searchContext
     * @return {?}
     */
    search(options, searchContext) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (searchContext) {
                /** @type {?} */
                const keys = Object.keys(searchContext);
                if (keys && keys.length) {
                    for (const key of keys) {
                        options[key] = searchContext[key];
                    }
                }
            }
            /** @type {?} */
            const offlineMode = _self.loggedInUserService.getUserConfigItem('cachingEnabled') === true;
            /** @type {?} */
            const searchOffline = (/**
             * @return {?}
             */
            () => {
                _self.indexedDBService.search(options).then((/**
                 * @param {?} data2
                 * @return {?}
                 */
                (data2) => {
                    resolve(data2);
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                (err) => {
                    /** @type {?} */
                    const msg = 'Search by indexedDB failed with error: ' + err;
                    logger$c.error(msg);
                    reject(new Error(msg));
                }));
            });
            if (options.text || options.filter) {
                if (options.document) {
                    /** @type {?} */
                    const doc = {
                        document: options.document,
                        account: _self.user.account
                    };
                    if (!UtilType.isString(options.filter)) {
                        options.filter = JSON.stringify(options.filter);
                    }
                    if (!(options === null || options === void 0 ? void 0 : options.disableHandlebars)) {
                        /** @type {?} */
                        const hbTemplate = compile(options.filter);
                        options.filter = hbTemplate(doc);
                    }
                    delete options.document;
                }
                if (options.searchOfflineOnly) {
                    if (!offlineMode) {
                        reject(new Error('Please enable caching before performing a search configured as offline only'));
                    }
                    else {
                        searchOffline();
                    }
                }
                else {
                    _self.restDataService.search(options).then((/**
                     * @param {?} data
                     * @return {?}
                     */
                    (data) => {
                        if (!data.statusCode && data.statusCode !== UtilHttpStatus.OK && offlineMode) {
                            searchOffline();
                        }
                        else {
                            resolve(data);
                        }
                    }), (/**
                     * @param {?} err
                     * @return {?}
                     */
                    (err) => {
                        if (offlineMode) {
                            searchOffline();
                        }
                        else {
                            reject(err);
                        }
                    }));
                }
            }
            else {
                /** @type {?} */
                const er = UtilError.createError('Undefined search text or query!');
                reject(er);
            }
        }));
    }
    /**
     * initialise the service passed in and return a promise for initialisation completion
     *
     * @param {?} service - the service to initialise
     * @return {?}
     */
    initialiseService(service) {
        if (service && service.initialise) {
            return service.initialise();
        }
        // no initialise function in service
        return Promise.resolve();
    }
    /**
     * @param {?} service
     * @return {?}
     */
    terminateService(service) {
        if (service && service.terminateService) {
            return service.terminateService();
        }
        // no terminateService function in service
        return Promise.resolve();
    }
    /**
     * set the versionId and previousVersionId fields
     * @param {?} document
     * @return {?}
     */
    setVersionFields(document) {
        if (document && document.systemHeader) {
            if (document && document.systemHeader.versionId) {
                document.systemHeader.previousVersionId = document.systemHeader.versionId;
                document.systemHeader.versionId = UtilDocumentId.generateId();
                // update createdBy every time because when we save the doc it's a new version
                document.systemHeader.createdBy = this.user ?
                    this.user.account.documentId : null;
            }
        }
    }
    /**
     * @private
     * @param {?} document
     * @return {?}
     */
    hasOfflineAccess(document) {
        return this.clientAccessService.hasPermission(document, SharedConstants.OPERATION_TYPE_OFFLINE);
    }
    /**
     * @private
     * @param {?} doc
     * @return {?}
     */
    isAccountDoc(doc) {
        return doc.systemHeader && (doc.systemHeader.systemType === SharedConstants.SYSTEM_TYPE_ACCOUNT ||
            doc.systemHeader.systemType === SharedConstants.SYSTEM_TYPE_ACCOUNT_SECURITY ||
            doc.systemHeader.systemType === SharedConstants.SYSTEM_TYPE_ACCOUNT_CONTROL);
    }
    /**
     * @param {?} originalBean
     * @param {?} newBean
     * @param {?=} updateOption
     * @return {?}
     */
    jsonPatchUpdate(originalBean, newBean, updateOption) {
        return __awaiter(this, void 0, void 0, function* () {
            // set the details like the versionId and previousVersionId
            this.setVersionFields(newBean);
            // set the systemHeader.createdDate in the new version. The systemHeader.createdDate is the created date of the
            // version, rather than the document, so each version needs to have a new createdDate. See Mantis 10816 for further
            // details
            newBean.systemHeader.createdDate = Date.now();
            // always use the Database Service if caching is enabled, so that the items will be placed in the
            // queue to be sent to the server, otherwise items can be saved in the wrong
            // order if there is anything already in the queue
            /** @type {?} */
            const updates = yield DocumentUpdater.getUpdates(originalBean, newBean);
            /** @type {?} */
            const options = {
                updates: updates,
                isUpdateFromPreviousVersion: UtilDocument.isPreviousVersion(newBean),
                template: updateOption ? updateOption.templateId : null,
                makeCurrentVersion: updateOption ? updateOption.makeCurrentVersion : null,
                importPreviousVersion: updateOption ? updateOption.importPreviousVersion : null,
                documentSession: this.documentSessionService.getDocumentSession(originalBean.documentId)
            };
            if (this.loggedInUserService.getUserConfigItem('cachingEnabled') === true
                && this.hasOfflineAccess(originalBean) && !this.isAccountDoc(newBean)) {
                return this.indexedDBService.jsonPatchUpdate(newBean, originalBean, options);
            }
            return this.restDataService.jsonPatchUpdate(newBean, options);
        });
    }
    /**
     * Called in CacheLoadService.enable cache to re-arrange primary and secondary data service
     * @return {?}
     */
    initialise() {
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const offlineMode = _self.loggedInUserService.getUserConfigItem('cachingEnabled') === true;
        _self.preferredService = offlineMode ? _self.indexedDBService : _self.restDataService;
        _self.secondaryService = offlineMode ? _self.restDataService : null;
        return _self.initialiseService(_self.preferredService).then((/**
         * @return {?}
         */
        () => {
            return _self.initialiseService(_self.secondaryService);
        }));
    }
    // terminateService DataServices on logout. See InitialisationService.terminateDefaultServices
    /**
     * @return {?}
     */
    reset() {
        /** @type {?} */
        const _self = this;
        return _self.terminateService(_self.preferredService).then((/**
         * @return {?}
         */
        () => {
            return _self.terminateService(_self.secondaryService);
        })).then((/**
         * @return {?}
         */
        () => {
            // RestDataService is necessary for login.
            // Make RestDataService as the preferred service and reset.
            _self.preferredService = _self.restDataService;
            return _self.initialiseService(_self.preferredService);
        }));
    }
    /*
      jsonPatchUpdate function
      parameters:
      bean - the bean to update
      cachingRequired - whether to save the record to the local database. Records that never need
      to be loaded in the app on their own, such as events, can have this set to false
      */
    /**
     * @param {?} originalBean
     * @param {?} newBean
     * @param {?=} options
     * @return {?}
     */
    deepDiffUpdate(originalBean, newBean, options) {
        return this.jsonPatchUpdate(originalBean, newBean, options);
    }
    /*
       insert function
       parameters:
       bean - the bean to insert
       successFunction - a function to execute on success to do post save steps
       cachingRequired - whether to save the record to the local database. Records that never need
       to be loaded in the app on their own, such as events, can have this set to false
       */
    /**
     * @param {?} bean
     * @param {?=} cachingRequired
     * @return {?}
     */
    insert(bean, cachingRequired) {
        return __awaiter(this, void 0, void 0, function* () {
            // set the details like the versionId and previousVersionId
            this.setVersionFields(bean);
            // a different version of the data service will be used depending on whether offline is enabled.
            // assign the service that is to be used rather than the function because assigning a function that is a member of
            // a class means the this object of the function will not be defined
            /** @type {?} */
            let dataSaveService;
            /** @type {?} */
            let hasOfflineAccess = true;
            try {
                if (bean.systemHeader && bean.systemHeader.templateId) {
                    /** @type {?} */
                    const template = yield this.getDocument(bean.systemHeader.templateId);
                    hasOfflineAccess = this.hasOfflineAccess(template);
                }
                // always use the Database Service if caching is enabled, so that the items will be placed in the
                // queue to be sent to the server, otherwise items can be saved in the wrong
                // order if there is anything already in the queue
                if (this.loggedInUserService.getUserConfigItem('cachingEnabled') === true
                    && hasOfflineAccess && !this.isAccountDoc(bean)) {
                    dataSaveService = this.indexedDBService;
                }
                else {
                    dataSaveService = this.restDataService;
                }
                /** @type {?} */
                const fullUrl = UtilService.getDataUrl(serverRoutes$2.document);
                return yield dataSaveService.insert(bean, fullUrl, cachingRequired);
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * @param {?} id
     * @param {?=} templateId
     * @param {?=} versionId
     * @return {?}
     */
    destroy(id, templateId, versionId) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const document = yield this.getDocument(id);
            /** @type {?} */
            let destroyService;
            try {
                if (this.loggedInUserService.getUserConfigItem('cachingEnabled') === true
                    && this.hasOfflineAccess(document)) {
                    destroyService = this.indexedDBService;
                }
                else {
                    destroyService = this.restDataService;
                }
                return yield destroyService.destroy(id, serverRoutes$2.document, null, templateId, versionId);
            }
            catch (err) {
                logger$c.log('Delete failed with error: ' + err);
                throw new Error(err);
            }
        });
    }
    /**
     * load unsynced and cache documents into indexedDB
     * @param {?=} isInitialize - whether in the case the documents are cached in the first time
     * @return {?}
     */
    loadDataCache(isInitialize) {
        /** @type {?} */
        const _self = this;
        if (!_self.loggedInUserService.getUserConfigItem('cachingEnabled') === true || this.isRunningPreviousSync) {
            return Promise.resolve();
        }
        /** @type {?} */
        let syncStartTime = _self.offlineStatusService.getLastSyncDate();
        if (!syncStartTime) {
            syncStartTime = 0;
            logger$c.log('Loading data cache from beginning of time');
        }
        else {
            logger$c.log('Loading data cache from time: ' + syncStartTime);
        }
        this.isRunningPreviousSync = true;
        return _self.restDataService.loadDataCache(syncStartTime, isInitialize).then((/**
         * @param {?} results
         * @return {?}
         */
        (results) => {
            logger$c.log('Done caching offline documents. Adding any search indexes from indexedDBIndexes.');
            // registers search indexes
            return _self.indexedDBConnectorService.upgradeIndexedDB().then((/**
             * @return {?}
             */
            () => {
                return Promise.resolve(results);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            (err) => {
                return Promise.reject(err);
            }));
        }), (/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            logger$c.error('Error caching offline documents.');
            logger$c.error(err);
            this.isRunningPreviousSync = false;
            return Promise.reject(err);
        })).then((/**
         * @param {?} results
         * @return {?}
         */
        (results) => {
            logger$c.log('Done registering search indexes.');
            this.isRunningPreviousSync = false;
            return Promise.resolve(results);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            logger$c.error('Error in registering search indexes.');
            logger$c.error(err);
            this.isRunningPreviousSync = false;
            return Promise.reject(err);
        }));
    }
    /**
     * @return {?}
     */
    clearData() {
        /** @type {?} */
        const _self = this;
        if (_self.loggedInUserService.getUserConfigItem('cachingEnabled') === true) {
            return _self.indexedDBService.clearData();
        }
        else {
            return Promise.reject(new Error('You did not enable caching.'));
        }
    }
    /**
     * @param {?} isFirstTime
     * @return {?}
     */
    backupData(isFirstTime) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (_self.loggedInUserService.getUserConfigItem('cachingEnabled') === true) {
                _self.indexedDBService.backupData().then(resolve, reject);
            }
            else {
                reject(new Error('You did not enable caching.'));
            }
        }));
    }
    /**
     * @return {?}
     */
    getIndexedDBIndexes() {
        return this.restDataService.getIndexedDBIndexes();
    }
    /**
     * @param {?} id
     * @return {?}
     */
    undestroy(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loggedInUserService.getUserConfigItem('cachingEnabled') === true) {
                /** @type {?} */
                const errMsg = 'You need to be online to undelete a document. ';
                logger$c.error(errMsg);
                throw new Error(errMsg);
            }
            else {
                /** @type {?} */
                const url = 'api/undelete';
                try {
                    return yield this.restDataService.undestroy(id, url);
                }
                catch (err) {
                    logger$c.error('Delete failed with error: ' + err);
                    throw new Error(err);
                }
            }
        });
    }
    /**
     * @param {?} documents
     * @return {?}
     */
    bulkUploadDocuments(documents) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loggedInUserService.getUserConfigItem('cachingEnabled') === true) {
                /** @type {?} */
                const errMsg = 'You need to be online to upload multiple documents. ';
                console.error(errMsg);
                throw new Error(errMsg);
            }
            else {
                /** @type {?} */
                const url = 'api/bulkUploadDocuments';
                try {
                    return yield this.restDataService.bulkUploadDocuments(documents, url);
                }
                catch (err) {
                    console.error('Upload documents failed with error: ' + err);
                    throw new Error(err);
                }
            }
        });
    }
    /**
     * @param {?} options
     * @return {?}
     */
    executeComponentFunction(options) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const offlineMode = _self.loggedInUserService.getUserConfigItem('cachingEnabled') === true;
            if (options.componentWebServiceName) {
                /** @type {?} */
                const searchOffline = (/**
                 * @return {?}
                 */
                () => {
                    _self.indexedDBService.executeComponentFunction(options).then((/**
                     * @param {?} data2
                     * @return {?}
                     */
                    (data2) => {
                        resolve(data2);
                    }), (/**
                     * @param {?} err
                     * @return {?}
                     */
                    (err) => {
                        reject(err);
                    }));
                });
                if (options.searchOfflineOnly) {
                    if (!offlineMode) {
                        reject(new Error('Please enable caching before performing a search configured as offline only'));
                    }
                    else {
                        searchOffline();
                    }
                }
                else {
                    _self.restDataService.executeComponentFunction(options).then((/**
                     * @param {?} data
                     * @return {?}
                     */
                    (data) => {
                        if (!data.statusCode && data.statusCode !== UtilHttpStatus.OK && offlineMode) {
                            searchOffline();
                        }
                        else {
                            resolve(data);
                        }
                    }), (/**
                     * @param {?} err
                     * @return {?}
                     */
                    (err) => {
                        if (offlineMode) {
                            searchOffline();
                        }
                        else {
                            reject(err);
                        }
                    }));
                }
            }
            else {
                /** @type {?} */
                const er = UtilError.createError('Undefined executeComponentFunction componentWebServiceName and functionParameters!');
                reject(er);
            }
        }));
    }
}
DataService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
DataService.ctorParameters = () => [
    { type: IndexedDBConnectorService },
    { type: LoggedInUserService },
    { type: RestDataService },
    { type: OfflineStatusService },
    { type: IndexedDBService },
    { type: ClientAccessService },
    { type: DocumentSessionService }
];
/** @nocollapse */ DataService.ɵprov = ɵɵdefineInjectable({ factory: function DataService_Factory() { return new DataService(ɵɵinject(IndexedDBConnectorService), ɵɵinject(LoggedInUserService), ɵɵinject(RestDataService), ɵɵinject(OfflineStatusService), ɵɵinject(IndexedDBService), ɵɵinject(ClientAccessService), ɵɵinject(DocumentSessionService)); }, token: DataService, providedIn: "root" });
__decorate([
    select(['userState', 'user']),
    __metadata("design:type", Observable)
], DataService.prototype, "user$", void 0);
if (false) {
    /** @type {?} */
    DataService.prototype.preferredService;
    /** @type {?} */
    DataService.prototype.secondaryService;
    /** @type {?} */
    DataService.prototype.user$;
    /** @type {?} */
    DataService.prototype.user;
    /** @type {?} */
    DataService.prototype.isRunningPreviousSync;
    /**
     * @type {?}
     * @private
     */
    DataService.prototype.indexedDBConnectorService;
    /**
     * @type {?}
     * @private
     */
    DataService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    DataService.prototype.restDataService;
    /**
     * @type {?}
     * @private
     */
    DataService.prototype.offlineStatusService;
    /**
     * @type {?}
     * @private
     */
    DataService.prototype.indexedDBService;
    /**
     * @type {?}
     * @private
     */
    DataService.prototype.clientAccessService;
    /**
     * @type {?}
     * @private
     */
    DataService.prototype.documentSessionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/unsaved-document.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$d = console;
class UnsavedDocumentService {
    /**
     * @param {?} appStore
     */
    constructor(appStore) {
        this.appStore = appStore;
    }
    /**
     * create a new unsaved document list. The unsaved document list is a list of documents that will be saved in a single
     * operation. This allows saving of documents independently of the nav bar save button. Eg. If you open up a dialog with a
     * template with a child doc then you need to save several documents on dialog close without saving the main document loaded
     * in the form. We can't put parameters in the save function to handle special cases like whether the save is for a dialog
     * because we would have to keep adding more special cases for saving from different locations.
     * @param {?} name
     * @param {?=} existingUnsavedDocumentListId
     * @return {?}
     */
    createUnsavedDocumentList(name, existingUnsavedDocumentListId) {
        // generate an unsaved document list id, this will be used by the caller to keep track of this list. It will be passed
        // to the save function to trigger the save of the documents in that list
        /** @type {?} */
        const unsavedDocumentListId = existingUnsavedDocumentListId ? existingUnsavedDocumentListId : UtilDocumentId.generateId();
        /** @type {?} */
        const isMainDoc = name === ClientConstants.MAIN_DOCUMENT_INFO_LIST;
        this.appStore.dispatch(formSetupDocumentList(unsavedDocumentListId, name, isMainDoc));
        return unsavedDocumentListId;
    }
    /**
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    getUnsavedDocumentInfo(unsavedDocumentListId) {
        return this.appStore.getState().formState.documentInfo[unsavedDocumentListId];
    }
    /**
     * add a document to the list, so it will be included in the list of unsaved documents
     * @param {?} document the document
     * @param {?} unsavedDocumentListId the unsavedDocumentListId
     * @return {?}
     */
    addDocumentToUnsavedList(document, unsavedDocumentListId) {
        if (!document || !document.documentId) {
            throw new Error('No document or documentId provided in addDocumentToUnsavedList');
        }
        else if (!unsavedDocumentListId) {
            throw new Error('No unsavedDocumentListId provided in addDocumentToUnsavedList');
        }
        else {
            /** @type {?} */
            const docInfo = {
                documentId: document.documentId
            };
            this.appStore.dispatch(formSetDocumentInfo(unsavedDocumentListId, docInfo));
            this.appStore.dispatch(formSetDocument(document));
        }
    }
    /**
     * add a template to the list
     * @param {?} template the template obj
     * @param {?} unsavedDocumentListId the unsaved list
     * @param {?} orgTemplateId the original template id
     * @return {?}
     */
    addTemplateToUnsavedList(template, unsavedDocumentListId, orgTemplateId) {
        if (!template || !template.documentId) {
            throw new Error('No template provided in addTemplateToUnsavedList');
        }
        else if (!unsavedDocumentListId) {
            throw new Error('No unsavedDocumentListId provided in addTemplateToUnsavedList');
        }
        else {
            /** @type {?} */
            const docInfo = {};
            /** @type {?} */
            const templateId = template.documentId;
            // in case alt template
            if (orgTemplateId && templateId !== orgTemplateId) {
                docInfo.templateId = orgTemplateId;
                docInfo.altTemplateId = templateId;
            }
            else {
                docInfo.templateId = templateId;
            }
            this.appStore.dispatch(formSetDocumentInfo(unsavedDocumentListId, docInfo));
        }
    }
    /**
     * get the document from the unsaved document list. The document will be set in the document parameter rather than returned
     * so that the document directly references the value in the unsaved list
     * @param {?} documentResult - the document will be placed in the document parameter of documentResult. It needs to be done this
     *                         way because if you assign to an object directly, the reference that the object points at changes
     * @param {?} unsavedDocumentListId the unsaved list Id
     * @param {?} documentId the document Id
     * @return {?}
     */
    getDocument(documentResult, unsavedDocumentListId, documentId) {
        /** @type {?} */
        const formState = this.appStore.getState().formState;
        /** @type {?} */
        const documents = formState.documents;
        /** @type {?} */
        const docInfo = formState.documentInfo;
        if (!documentResult) {
            throw new Error('The documentResult must be passed as an object to getDocument so the document can be set under it');
        }
        else if (!unsavedDocumentListId) {
            throw new Error('Unsaved document list id not provided in getDocument');
        }
        else if (!docInfo[unsavedDocumentListId]) {
            throw new Error('GetDocument: Unsaved document list has not been initialised with id: ' + unsavedDocumentListId);
        }
        else if (!docInfo[unsavedDocumentListId][documentId]) {
            throw new Error('Unsaved document list does not contain document: ' + documentId);
        }
        // set the document from loaded docs in the document parameter
        documentResult.document = documents[documentId];
    }
    /**
     * get the template from the unsaved document list. The template will be set in the template result parameter
     * rather than returned so that the template directly references the value in the unsaved list
     * @param {?} documentResult - the template will be placed in the template parameter of documentResult. It needs to
     * be done this way because if you assign to an object directly, the reference that the object points at changes
     * @param {?} unsavedDocumentListId the unsaved list Id
     * @param {?} templateId the template Id
     * @return {?}
     */
    getTemplate(documentResult, unsavedDocumentListId, templateId) {
        /** @type {?} */
        const formState = this.appStore.getState().formState;
        /** @type {?} */
        const documents = formState.documents;
        /** @type {?} */
        const docInfo = formState.documentInfo;
        if (!documentResult) {
            throw new Error('The documentResult must be passed as an object to getTemplate so the template can be set under it');
        }
        else if (!unsavedDocumentListId) {
            throw new Error('Unsaved document list id not provided in getTemplate');
        }
        else if (!docInfo[unsavedDocumentListId]) {
            throw new Error('GetTemplate: Unsaved document list has not been initialised with id: ' + unsavedDocumentListId);
        }
        if (docInfo[unsavedDocumentListId].templateId === templateId || docInfo[unsavedDocumentListId].altTemplateId === templateId) {
            // set the template from loaded templates in the document parameter
            documentResult.template = documents[templateId];
        }
        if (!templateId) {
            throw new Error('Unsaved document list does not contain template: ' + templateId);
        }
    }
    /**
     * @param {?} unsavedDocumentListId
     * @param {?} document
     * @return {?}
     */
    setDocument(unsavedDocumentListId, document) {
        if (!unsavedDocumentListId) {
            throw new Error('Unsaved document list id not provided in setDocument');
        }
        /** @type {?} */
        const docInfo = {
            documentId: document.documentId
        };
        this.appStore.dispatch(formSetDocumentInfo(unsavedDocumentListId, docInfo));
        this.appStore.dispatch(formSetDocument(document));
    }
    /**
     * @param {?} unsavedDocumentListId
     * @param {?} documentId
     * @param {?} template
     * @return {?}
     */
    setTemplate(unsavedDocumentListId, documentId, template) {
        if (!unsavedDocumentListId) {
            throw new Error('Unsaved document list id not provided in setTemplate');
        }
        else if (!template || !template.documentId) {
            throw new Error('Template not provided in setTemplate');
        }
        /** @type {?} */
        const docInfo = {
            templateId: template.documentId
        };
        this.appStore.dispatch(formSetDocumentInfo(unsavedDocumentListId, docInfo));
        this.appStore.dispatch(formSetDocument(template));
    }
    /**
     * get the document from a unsaved document list.
     * @param {?} documentId the document Id
     * @return {?}
     */
    getDocumentOnly(documentId) {
        return this.appStore.getState().formState.documents[documentId];
    }
    /**
     * get the template from the unsaved document list.
     * @param {?} templateId the template Id
     * @return {?}
     */
    getTemplateOnly(templateId) {
        return this.getDocumentOnly(templateId);
    }
    /**
     * @param {?} unsavedDocumentListId
     * @param {?} documentId
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    setDocumentListOptions(unsavedDocumentListId, documentId, key, value) {
        if (!unsavedDocumentListId) {
            throw new Error('Unsaved document list id not provided in getDocumentOptions');
        }
        /** @type {?} */
        const docInfo = {
            options: {
                [key]: value
            }
        };
        this.appStore.dispatch(formSetDocumentInfo(unsavedDocumentListId, docInfo));
    }
    /**
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    getDocumentListOptions(unsavedDocumentListId) {
        /** @type {?} */
        const docInfo = this.appStore.getState().formState.documentInfo;
        if (!unsavedDocumentListId) {
            throw new Error('Unsaved document list id not provided in getDocumentOptions');
        }
        else if (!docInfo[unsavedDocumentListId] || !docInfo[unsavedDocumentListId].options) {
            throw new Error('getDocumentOptions: Unsaved document list has not been initialised with id: ' + unsavedDocumentListId);
        }
        return docInfo[unsavedDocumentListId].options;
    }
    /**
     * @param {?} unsavedDocumentListId
     * @param {?} documentId
     * @param {?} optionKey
     * @return {?}
     */
    getDocumentOptionKey(unsavedDocumentListId, documentId, optionKey) {
        /** @type {?} */
        const docInfo = this.appStore.getState().formState.documentInfo;
        if (!unsavedDocumentListId) {
            throw new Error('Unsaved document list id not provided in getDocumentOptions');
        }
        else if (!docInfo[unsavedDocumentListId] || !docInfo[unsavedDocumentListId].options) {
            throw new Error('getDocumentOptionKey: Unsaved document list has not been initialised with id: ' + unsavedDocumentListId);
        }
        return docInfo[unsavedDocumentListId].options[optionKey];
    }
    /**
     * get the template from a unsaved document list.
     * @param {?} templateId the template id
     * @param {?} documentId the document id
     * @return {?}
     */
    getTemplateWithNoUnSaveList(templateId, documentId) {
        if (templateId && documentId) {
            /** @type {?} */
            const docInfo = this.appStore.getState().formState.documentInfo;
            /** @type {?} */
            const documents = this.appStore.getState().formState.documents;
            /** @type {?} */
            const unsavedDocumentListIds = Object.keys(docInfo);
            for (let i = 0; i < unsavedDocumentListIds.length; i++) {
                /** @type {?} */
                const unsavedDocumentListId = unsavedDocumentListIds[i];
                if (docInfo[unsavedDocumentListId].documentId === documentId) {
                    if (docInfo[unsavedDocumentListId].templateId === templateId || docInfo[unsavedDocumentListId].altTemplateId === templateId) {
                        /** @type {?} */
                        const template = documents[templateId];
                        if (template) {
                            return template;
                        }
                    }
                }
            }
        }
    }
    /**
     * get the unsaved documents for the unsaved document list
     * @param {?} unsavedDocumentListId - the id of the list to get the loaded docs for
     * @return {?}
     */
    getUnsavedDocuments(unsavedDocumentListId) {
        /** @type {?} */
        const documents = this.appStore.getState().formState.documents;
        /** @type {?} */
        const documentId = this.getUnsavedDocumentId(unsavedDocumentListId);
        return [documents[documentId]];
    }
    /**
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    getUnsavedDocumentId(unsavedDocumentListId) {
        /** @type {?} */
        const docInfo = this.appStore.getState().formState.documentInfo;
        if (!unsavedDocumentListId) {
            throw new Error('Unsaved document list id not specified when getting loaded documents');
        }
        else if (!docInfo[unsavedDocumentListId]) {
            throw new Error('Unsaved documents not found with id ' + unsavedDocumentListId);
        }
        return docInfo[unsavedDocumentListId].documentId;
    }
    /**
     * get the unsaved templates for the unsaved document list
     * @param {?} unsavedDocumentListId - the id of the list to get the loaded templates for
     * @return {?}
     */
    getUnsavedTemplates(unsavedDocumentListId) {
        /** @type {?} */
        const documents = this.appStore.getState().formState.documents;
        /** @type {?} */
        const templateId = this.getUnsavedTemplateId(unsavedDocumentListId);
        return [documents[templateId]];
    }
    /**
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    getUnsavedTemplateId(unsavedDocumentListId) {
        /** @type {?} */
        const docInfo = this.appStore.getState().formState.documentInfo;
        if (!unsavedDocumentListId) {
            throw new Error('Unsaved document list id not specified when getting loaded templates');
        }
        else if (!docInfo[unsavedDocumentListId]) {
            throw new Error('Unsaved documents not found with id ' + unsavedDocumentListId);
        }
        return docInfo[unsavedDocumentListId].templateId;
    }
    /**
     * remove a document from a list. This will be needed when a document is no longer to be part of the list, eg. when
     * cancelling the save of a particular document
     * @param {?} unsavedDocumentListId the unsaved list Id
     * @param {?} documentId the document Id
     * @return {?}
     */
    removeDocumentFromList(unsavedDocumentListId, documentId) {
        // if (!unsavedDocumentListId) {
        //   throw new Error('Unsaved document list id not provided in getDocument');
        //
        // } else if (!this.documents[unsavedDocumentListId] || !this.documents[unsavedDocumentListId].loadedDocs) {
        //   throw new Error('RemoveDocumentFromList: Unsaved document list has not been initialised with id: ' + unsavedDocumentListId);
        //
        // } else if (!this.documents[unsavedDocumentListId].loadedDocs[documentId]) {
        //   throw new Error('Unsaved document list does not contain document: ' + documentId);
        // }
        //
        // delete this.documents[unsavedDocumentListId].loadedDocs[documentId];
        //
        // this.documents[unsavedDocumentListId].loadedDocs = {};
    }
    /**
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    removeDocumentList(unsavedDocumentListId) {
        this.appStore.dispatch(formResetDocumentInfo(unsavedDocumentListId));
    }
    /**
     * @param {?} type
     * @return {?}
     */
    getDocumentListByType(type) {
        /** @type {?} */
        const docInfo = this.appStore.getState().formState.documentInfo;
        /** @type {?} */
        const unsavedDocumentListIds = Object.keys(docInfo);
        /** @type {?} */
        const documentLists = [];
        for (let i = 0; i < unsavedDocumentListIds.length; i++) {
            /** @type {?} */
            const unsavedDocumentListId = unsavedDocumentListIds[i];
            if (docInfo[unsavedDocumentListId].name === type) {
                documentLists.push(docInfo[unsavedDocumentListId]);
            }
        }
        return documentLists;
    }
    /**
     * store a document hierarchy info to a list. This will be needed when retrieve information to load a child
     * document from a parent one
     * @param {?} hierarchyInfo (parentId and childId)
     * @param {?} unsavedDocumentListId the unsaved list Id
     * @return {?}
     */
    setHierarchyInfoToUnsavedList(hierarchyInfo, unsavedDocumentListId) {
        /** @type {?} */
        const docInfo = {};
        docInfo.hierarchyInfo = hierarchyInfo;
        this.appStore.dispatch(formSetDocumentInfo(unsavedDocumentListId, docInfo));
    }
    /**
     * @return {?}
     */
    clearDocuments() {
        // this.documents = {};
    }
    /**
     * @param {?=} excludedOptions
     * @return {?}
     */
    getAllLoadedDocs(excludedOptions) {
        /** @type {?} */
        const docInfo = this.appStore.getState().formState.documentInfo;
        /** @type {?} */
        const documents = this.appStore.getState().formState.documents;
        /** @type {?} */
        const loadedDocs = [];
        /** @type {?} */
        const unsavedDocumentListIds = Object.keys(docInfo);
        unsavedDocumentListIds.forEach((/**
         * @param {?} unsavedDocumentListId
         * @return {?}
         */
        function (unsavedDocumentListId) {
            /** @type {?} */
            const options = docInfo[unsavedDocumentListId].options;
            /** @type {?} */
            const docIds = Object.keys(documents);
            docIds.forEach((/**
             * @param {?} docId
             * @return {?}
             */
            function (docId) {
                /** @type {?} */
                const doc = documents[docId];
                if (excludedOptions) {
                    if (!UtilDocument.hasIntersect(options[docId], excludedOptions)) {
                        loadedDocs.push(doc);
                    }
                }
                else {
                    loadedDocs.push(doc);
                }
            }));
        }));
        return loadedDocs;
    }
    /**
     * @param {?} documentId
     * @return {?}
     */
    documentIsLoaded(documentId) {
        /** @type {?} */
        const docInfo = this.appStore.getState().formState.documentInfo;
        /** @type {?} */
        const documents = this.appStore.getState().formState.documents;
        /** @type {?} */
        let result = false;
        /** @type {?} */
        const unsavedDocumentListIds = Object.keys(docInfo);
        unsavedDocumentListIds.forEach((/**
         * @param {?} unsavedDocumentListId
         * @return {?}
         */
        function (unsavedDocumentListId) {
            if (documents[documentId] && docInfo[unsavedDocumentListId].documentId === documentId) {
                result = true;
            }
        }));
        return result;
    }
    /**
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    isDocumentsDefined(unsavedDocumentListId) {
        return !!this.appStore.getState().formState.documentInfo[unsavedDocumentListId];
    }
    /**
     * @return {?}
     */
    getDocuments() {
        return this.appStore.getState().formState.documentInfo;
    }
    /**
     * @param {?} documentId
     * @return {?}
     */
    resetToOrgDocument(documentId) {
        this.appStore.dispatch(formResetToOrgDocument(documentId));
    }
    /**
     * @param {?} templateId
     * @return {?}
     */
    resetTemplateComponent(templateId) {
        this.appStore.dispatch(formResetTemplateComponentDefinition(templateId));
    }
}
UnsavedDocumentService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
UnsavedDocumentService.ctorParameters = () => [
    { type: AppStore }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    UnsavedDocumentService.prototype.appStore;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/document.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$e = console;
class DocumentService {
    /**
     * @param {?} dataService
     * @param {?} clientAccessService
     * @param {?} unsavedDocumentService
     * @param {?} localStorageService
     * @param {?} appStore
     */
    constructor(dataService, clientAccessService, unsavedDocumentService, localStorageService, appStore) {
        this.dataService = dataService;
        this.clientAccessService = clientAccessService;
        this.unsavedDocumentService = unsavedDocumentService;
        this.localStorageService = localStorageService;
        this.appStore = appStore;
    }
    /**
     * Return the cached document that can be the document getting from DB or successful created document on form
     * @param {?} documentId the document Id
     * @return {?} the existing document
     */
    getExistingDocument(documentId) {
        return cloneDeep(this.appStore.getState().formState.orgDocuments[documentId]);
    }
    /**
     * @private
     * @param {?} callback
     * @param {?} result
     * @return {?}
     */
    callbackResult(callback, result) {
        if (typeof callback === 'function') {
            callback(result);
        }
    }
    /**
     * @private
     * @param {?} document
     * @param {?} callback
     * @return {?}
     */
    execFindDocument(document, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let hasAccess = this.clientAccessService.checkAccess(document, SharedConstants.OPERATION_TYPE_READ);
            if (hasAccess) {
                // return the cached document in a callback and promise
                this.callbackResult(callback, document);
                return document;
            }
            else {
                if (document.systemHeader.systemType === SharedConstants.SYSTEM_TYPE_TEMPLATE
                    && document.altTemplateIds && document.altTemplateIds.length !== 0) {
                    /** @type {?} */
                    const docIds = [];
                    for (let i = 0; i < document.altTemplateIds.length; i++) {
                        docIds.push(document.altTemplateIds[i]);
                    }
                    /** @type {?} */
                    const query = {
                        'query': {
                            'bool': {
                                'must': [
                                    { 'terms': { 'documentId': docIds } }
                                ]
                            }
                        }
                    };
                    /** @type {?} */
                    const results = yield this.dataService.findByElastic(query);
                    /** @type {?} */
                    let accessibleDocument;
                    /** @type {?} */
                    const templates = results.data.hits.hits;
                    for (let i = 0; i < templates.length; i++) {
                        /** @type {?} */
                        const result = templates[i]._source;
                        hasAccess = this.clientAccessService.checkAccess(result, SharedConstants.OPERATION_TYPE_READ);
                        if (hasAccess) {
                            logger$e.info('Returning Alt Template');
                            accessibleDocument = result;
                            break;
                        }
                    }
                    if (accessibleDocument) {
                        this.callbackResult(callback, accessibleDocument);
                        return Promise.resolve(accessibleDocument);
                    }
                }
                return Promise.reject(UtilError.createForbiddenError(document, SharedConstants.OPERATION_TYPE_READ));
            }
        });
    }
    /**
     * return the document using a promise. This will be used to load documents into the data that is bound to,
     * before determining whether the document is a template or other document
     * @param {?} documentId
     * @param {?=} options
     * @param {?=} callback
     * @return {?}
     */
    getDocumentOnly(documentId, options, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            // if the document is already in the cache, return the document from the cache, otherwise get it from the
            // data service
            /** @type {?} */
            const document = this.getExistingDocument(documentId);
            if (document) {
                if (document.systemHeader && document.systemHeader.deleted) {
                    /** @type {?} */
                    const deletedMsg = 'Document has been deleted';
                    return Promise.reject(UtilError.createError(deletedMsg, UtilError.DELETED_ERROR));
                }
                else {
                    return yield this.execFindDocument(document, callback);
                }
            }
            else {
                /** @type {?} */
                const data = yield this.dataService.getDocument(documentId);
                if (data.systemHeader && data.systemHeader.deleted) {
                    /** @type {?} */
                    const deletedMsg = 'Document has been deleted';
                    return Promise.reject(UtilError.createError(deletedMsg, UtilError.DELETED_ERROR));
                }
                else {
                    if (!(options === null || options === void 0 ? void 0 : options.ignoreSettingFormData)) {
                        // cache the document for future use
                        this.appStore.dispatch(formSetDocument(data));
                    }
                    this.appStore.dispatch(formSetOrgDocument(data));
                    return yield this.execFindDocument(data, callback);
                }
            }
        });
    }
    /**
     * @param {?} documentId
     * @return {?}
     */
    getLoadedDocument(documentId) {
        return this.appStore.getState().formState.documents[documentId];
    }
    /**
     * get the document
     * @param {?} documentId the document Id
     * @param {?} documentData - the result. The result will be put under a data element in documentData so it can
     * be bound to
     * @return {?} promise
     */
    getDocument(documentId, documentData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!documentData || typeof documentData !== 'object') {
                /** @type {?} */
                const msg = 'The documentData needs to be an object so data can be set under it, which allows it to be bound to';
                throw UtilError.createError(msg);
            }
            yield this.getDocumentOnly(documentId);
            /** @type {?} */
            let document = this.getExistingDocument(documentId);
            if (document) {
                documentData.document = document;
            }
            else {
                document = yield this.dataService.getDocument(documentId);
                this.appStore.dispatch(formSetDocument(document));
                documentData.document = document;
            }
            return document;
        });
    }
    /**
     * @private
     * @param {?} document
     * @param {?} template
     * @return {?}
     */
    setInitialValues(document, template) {
        /** @type {?} */
        let hasInitialized = false;
        if (template && template.components && template.components.length) {
            if (!document) {
                document = {};
            }
            /** @type {?} */
            const initialDataKey = 'initialData:' + template.documentId;
            /** @type {?} */
            let initialData = null;
            try {
                initialData = JSON.parse(this.localStorageService.getItem(initialDataKey));
            }
            catch (e) {
            }
            localStorage.removeItem(initialDataKey);
            template.components.forEach((/**
             * @param {?} component
             * @return {?}
             */
            function (component) {
                if (!UtilType.hasValue(document[component.name])) {
                    if (UtilType.hasValue(component.defaultValue)) {
                        document[component.name] = component.defaultValue;
                    }
                    if (initialData && UtilType.hasValue(initialData[component.name])) {
                        document[component.name] = initialData[component.name];
                    }
                }
            }));
        }
        return hasInitialized;
    }
    /**
     * initialise a new document. The documentId will be set straight away so it can be passed through to child
     * docs without waiting for the main document to be saved. This allows the save to be performed in one operation
     * and reduces the chance of the child doc being saved without having the parent id set
     * @private
     * @param {?} documentData the result inside documentData object
     * @param {?} template
     * @return {?}
     */
    initialiseNewDocument(documentData, template) {
        if (documentData && template) {
            // set the isNew value to indicate that the document is a new document being created
            documentData.isNew = true;
            /** @type {?} */
            const newDocument = this.setInitialDocument(template);
            newDocument.documentId = UtilDocumentId.generateId();
            if (documentData.document) {
                extend(newDocument, documentData.document);
            }
            this.updateDocumentData(documentData, newDocument, template);
            logger$e.info('Initialised new document: ' + newDocument.documentId);
        }
        else {
            logger$e.error('Template not provided when initialising new document');
        }
    }
    /**
     * set the document in unsaved loaded docs and set the document to documentData.document. This will be used
     * to check for modifications and on saving the documents
     * @private
     * @param {?} document the data
     * @param {?} unsavedDocumentListId the unsaved document list Id
     * @return {?}
     */
    setInLoadedDocs(document, unsavedDocumentListId) {
        if (document && document.documentId) {
            // copy the document and set to original documents list so that the loaded doc on form isn't a reference to the original
            this.unsavedDocumentService.addDocumentToUnsavedList(document, unsavedDocumentListId);
            this.setOriginalDocumentOnly(cloneDeep(document));
        }
        else {
            logger$e.error('Attempting to add null or undefined document to loaded docs');
        }
    }
    /**
     * set the template in unsaved loaded templates and set the template to documentData.template.This will be
     * used to store modified version of the template by rules
     * associate to its document.
     * @private
     * @param {?} template the data
     * @param {?} unsavedDocumentListId the unsaved document list Id
     * @param {?=} orgTemplateId the org template
     * @return {?}
     */
    setInLoadedTemplates(template, unsavedDocumentListId, orgTemplateId) {
        if (template && template.documentId) {
            // copy the template and set to original documents list so that the loaded template isn't a reference to the original
            this.unsavedDocumentService.addTemplateToUnsavedList(template, unsavedDocumentListId, orgTemplateId);
        }
        else {
            logger$e.error('Attempting to add null or undefined template to loaded templates');
        }
    }
    /**
     * @private
     * @param {?} documentData
     * @param {?} document
     * @param {?} template
     * @return {?}
     */
    updateDocumentData(documentData, document, template) {
        documentData.template = cloneDeep(template);
        documentData.templateId = template.documentId;
        documentData.document = cloneDeep(document);
        documentData.documentId = document.documentId;
    }
    /**
     * @private
     * @param {?} unsavedDocumentListId
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    updateDocumentInfo(unsavedDocumentListId, key, value) {
        /** @type {?} */
        const documentInfo = {
            [key]: value
        };
        this.appStore.dispatch(formSetDocumentInfo(unsavedDocumentListId, documentInfo));
    }
    // get the template for the document. If it is a template, return the document itself, otherwise return the
    // template matching the systemHeader.templateId of the document
    /**
     * @param {?} documentId
     * @param {?} documentData
     * @param {?} unsavedDocumentListId
     * @param {?} overrideTemplateId
     * @return {?}
     */
    getTemplateForDocument(documentId, documentData, unsavedDocumentListId, overrideTemplateId) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const _self = this;
            if (!documentData || typeof documentData !== 'object') {
                /** @type {?} */
                const msg = 'documentData needs to be an object so data can be set under it, which allows it to be ' +
                    'bound to';
                logger$e.error(msg);
                return Promise.reject(UtilError.createError(msg));
            }
            else {
                try {
                    /** @type {?} */
                    const options = {
                        ignoreSettingFormData: true
                    };
                    /** @type {?} */
                    const data = yield _self.getDocumentOnly(documentId, options);
                    if (data) {
                        /** @type {?} */
                        const orgData = cloneDeep(data);
                        if (data.systemHeader && data.systemHeader.systemType === SharedConstants.SYSTEM_TYPE_TEMPLATE && !overrideTemplateId) {
                            /** @type {?} */
                            const template = _self.updateDisableSaveTemplate(documentData.isNew, data, documentData.document);
                            // initialise the document as a new document and set into loaded docs
                            // Set document into documentData as well
                            _self.initialiseNewDocument(documentData, template);
                            // add the document to loaded docs in store, so it will be saved and have dirty checking applied
                            _self.setInLoadedDocs(cloneDeep(documentData.document), unsavedDocumentListId);
                            // add the template to loaded docs into store, so it will be modified and have field mandatory/visible/disable checking applied
                            _self.setInLoadedTemplates(documentData.template, unsavedDocumentListId);
                            _self.updateDocumentInfo(unsavedDocumentListId, 'isNew', documentData.isNew);
                            return Promise.resolve();
                        }
                        else {
                            // use the override template id if specified, otherwise get the templateId from the document systemHeader
                            /** @type {?} */
                            let templateId = overrideTemplateId;
                            if (!templateId && (data.systemHeader && data.systemHeader.templateId)) {
                                templateId = data.systemHeader.templateId;
                            }
                            if (templateId) {
                                try {
                                    // get the template for the document
                                    /** @type {?} */
                                    let template = yield _self.getDocumentOnly(templateId, options);
                                    template = _self.updateDisableSaveTemplate(documentData.isNew, template, data);
                                    // now set template into loaded templates and assign the its data to the documentData.template
                                    _self.setInLoadedTemplates(template, unsavedDocumentListId, templateId);
                                    /** @type {?} */
                                    const document = orgData;
                                    // update static values from template into existing document
                                    _self.setInitialValues(document, template);
                                    // add the document to the unsaved loaded docs so that it can be compared with the
                                    // original in this DocumentService.document.docs when saving
                                    _self.setInLoadedDocs(document, unsavedDocumentListId);
                                    _self.updateDocumentData(documentData, document, template);
                                    _self.updateDocumentInfo(unsavedDocumentListId, 'isNew', documentData.isNew);
                                    return Promise.resolve();
                                }
                                catch (err) {
                                    /** @type {?} */
                                    let errorMsg;
                                    if (err.name === UtilError.NOT_FOUND_ERROR) {
                                        errorMsg = 'Template for document not found: ' + templateId;
                                    }
                                    else if (err.name === UtilError.FORBIDDEN_ERROR) {
                                        errorMsg = err.message;
                                    }
                                    else if (err.name === UtilError.DELETED_ERROR) {
                                        errorMsg = 'Template for document has been deleted: ' + templateId;
                                    }
                                    else {
                                        errorMsg = 'Error getting template: ' + err.message ? err.message : err;
                                    }
                                    logger$e.error(errorMsg);
                                    return Promise.reject(UtilError.createError(errorMsg, err.name));
                                }
                            }
                            else {
                                /** @type {?} */
                                const errorMsg = 'No Template for document found by override template id or ' +
                                    'systemHeader.templateId: ' + documentId;
                                logger$e.error(errorMsg);
                                return Promise.reject(UtilError.createError(errorMsg));
                            }
                        }
                    }
                    else {
                        /** @type {?} */
                        const message = 'Document not found: ' + documentId;
                        logger$e.error(message);
                        return Promise.reject(UtilError.createError(message));
                    }
                }
                catch (err) {
                    /** @type {?} */
                    let error;
                    if (err.name === UtilError.NOT_FOUND_ERROR) {
                        error = UtilError.createError('Document not found: ' + documentId, err.name);
                    }
                    else if (err.name === UtilError.FORBIDDEN_ERROR) {
                        error = err;
                    }
                    else if (err.name === UtilError.DELETED_ERROR) {
                        error = UtilError.createError('Document was deleted: ' + documentId, err.name);
                    }
                    else {
                        error = UtilError.createError('Error getting document to determine template: ' +
                            err.message ? err.message : err, err.name);
                        if (err.statusText) {
                            error.status = err.status;
                            error.statusText = err.statusText;
                        }
                    }
                    return Promise.reject(error);
                }
            }
        });
    }
    /**
     * @private
     * @param {?} isNew
     * @param {?} template
     * @param {?=} document
     * @return {?}
     */
    updateDisableSaveTemplate(isNew, template, document) {
        /** @type {?} */
        const canCreate = this.clientAccessService.checkAccess(template, SharedConstants.OPERATION_TYPE_CREATE);
        /** @type {?} */
        const canUpdate = this.clientAccessService.checkAccess(document, SharedConstants.OPERATION_TYPE_UPDATE);
        if ((isNew && !canCreate) || (!isNew && !canUpdate)) {
            template = cloneDeep(template);
            if (template.components) {
                for (let i = 0; i < template.components.length; i++) {
                    if (!template.components[i].disableSave) {
                        template.components[i].enabled = false;
                    }
                }
            }
        }
        this.setLoadedDocumentOnly(template);
        return template;
    }
    /**
     * return the template for the document passed in
     * @param {?} doc - the document to get the template for
     * @return {?} the template object
     */
    getTemplateFromDoc(doc) {
        if (doc && doc.systemHeader && doc.systemHeader.templateId) {
            return this.getLoadedDocument(doc.systemHeader.templateId);
        }
        else {
            logger$e.warn('No template specified for document in systemHeader');
        }
        return null;
    }
    /**
     * @param {?} doc
     * @param {?=} versionId
     * @return {?}
     */
    setLoadedDocumentOnly(doc, versionId) {
        this.appStore.dispatch(formSetDocument(doc, versionId));
    }
    /**
     * @param {?} doc
     * @param {?=} versionId
     * @return {?}
     */
    setOriginalDocumentOnly(doc, versionId) {
        this.appStore.dispatch(formSetOrgDocument(doc, versionId));
    }
    /**
     * reset original doc to their clean state, with the latest copy of the original doc, so that any changes in
     * updates can be detected, also put new document after created successful on form.
     * @param {?} doc - the doc to reset
     * @return {?}
     */
    resetOriginalDocument(doc) {
        if (doc) {
            this.setLoadedDocumentOnly(doc);
            this.setOriginalDocumentOnly(doc);
        }
    }
    /**
     * reset original version to their clean state, with the latest copy of the original doc, so that any changes in
     * updates can be detected, also put new document after created successful on form.
     * @param {?} version - the version to reset
     * @return {?}
     */
    resetOriginalVersion(version) {
        if (version) {
            this.setLoadedDocumentOnly(version, version.systemHeader.versionId);
            this.setOriginalDocumentOnly(version, version.systemHeader.versionId);
        }
    }
    /**
     * @return {?}
     */
    clearDocuments() {
        this.appStore.dispatch(formClearDocuments());
    }
    /**
     * @return {?}
     */
    allDocuments() {
        /** @type {?} */
        const storedDocuments = this.appStore.getState().formState.documents;
        /** @type {?} */
        const documents = [];
        /** @type {?} */
        const keys = Object.keys(storedDocuments);
        keys.forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => {
            documents.push(storedDocuments[key]);
        }));
        return documents;
    }
    /**
     * @return {?}
     */
    getDocuments() {
        return this.allDocuments();
    }
    /**
     * @return {?}
     */
    getOrgDocuments() {
        return this.appStore.getState().formState.orgDocuments;
    }
    /**
     * @param {?} template
     * @return {?}
     */
    setInitialDocument(template) {
        /** @type {?} */
        const systemType = template.systemTypeOverride ? template.systemTypeOverride : SharedConstants.SYSTEM_TYPE_DOCUMENT;
        /** @type {?} */
        const newDocument = {
            systemHeader: {
                templateId: template.documentId,
                systemType: systemType
            }
        };
        this.setInitialValues(newDocument, template);
        return newDocument;
    }
    /**
     * @param {?} document
     * @param {?} template
     * @return {?}
     */
    setDisableSaveFieldDocument(document, template) {
        /** @type {?} */
        const key = document.documentId;
        /** @type {?} */
        const value = {};
        if (template && template.components && template.components.length) {
            template.components.forEach((/**
             * @param {?} tplItem
             * @return {?}
             */
            tplItem => {
                if (tplItem.disableSave === true) {
                    value[tplItem.name] = document[tplItem.name];
                }
            }));
        }
        this.appStore.dispatch(formSetDisableSaveFieldDocument(key, value));
    }
    /**
     * @param {?} documentId
     * @return {?}
     */
    getDisableSaveFieldDocument(documentId) {
        /** @type {?} */
        const disabledSaveFields = this.appStore.getState().formState.recordedDisableSaveFieldValues[documentId];
        return disabledSaveFields ? disabledSaveFields : {};
    }
    /**
     * @param {?} doc
     * @return {?}
     */
    resetDisableSaveFieldToDoc(doc) {
        /** @type {?} */
        const disabledSaveFields = this.getDisableSaveFieldDocument(doc.documentId);
        /** @type {?} */
        const fieldNames = Object.keys(disabledSaveFields);
        fieldNames.forEach((/**
         * @param {?} fieldName
         * @return {?}
         */
        fieldName => {
            doc[fieldName] = disabledSaveFields[fieldName];
        }));
    }
}
DocumentService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
DocumentService.ctorParameters = () => [
    { type: DataService },
    { type: ClientAccessService },
    { type: UnsavedDocumentService },
    { type: LocalStorageService },
    { type: AppStore }
];
/** @nocollapse */ DocumentService.ɵprov = ɵɵdefineInjectable({ factory: function DocumentService_Factory() { return new DocumentService(ɵɵinject(DataService), ɵɵinject(ClientAccessService), ɵɵinject(UnsavedDocumentService), ɵɵinject(LocalStorageService), ɵɵinject(AppStore)); }, token: DocumentService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    DocumentService.prototype.dataService;
    /**
     * @type {?}
     * @private
     */
    DocumentService.prototype.clientAccessService;
    /**
     * @type {?}
     * @private
     */
    DocumentService.prototype.unsavedDocumentService;
    /**
     * @type {?}
     * @private
     */
    DocumentService.prototype.localStorageService;
    /**
     * @type {?}
     * @private
     */
    DocumentService.prototype.appStore;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/client-system-header.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ClientSystemHeaderService {
    /**
     * @param {?} documentService
     */
    constructor(documentService) {
        this.documentService = documentService;
    }
    /**
     * @private
     * @param {?} templateId
     * @return {?}
     */
    getTemplate(templateId) {
        return this.documentService.getDocumentOnly(templateId);
    }
    ;
    /**
     * @param {?} bean
     * @param {?} template
     * @param {?} originalBean
     * @return {?}
     */
    updateSystemHeader(bean, template, originalBean) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (originalBean && originalBean.systemHeader) {
                if (!template) {
                    if (!originalBean.systemHeader.templateId) {
                        // no template to write system header with, so don't write the summary values
                        resolve(bean);
                    }
                    else {
                        _self.getTemplate(originalBean.systemHeader.templateId).then((/**
                         * @param {?} template
                         * @return {?}
                         */
                        function successFunc(template) {
                            UtilSystemHeader.writeSystemHeaderSummary(bean, template, originalBean);
                            resolve(bean);
                        }), (/**
                         * @param {?} err
                         * @return {?}
                         */
                        function errorFunc(err) {
                            resolve(bean);
                        }));
                    }
                }
                else {
                    UtilSystemHeader.writeSystemHeaderSummary(bean, template, originalBean);
                    resolve(bean);
                }
            }
            else {
                resolve(bean);
            }
        }));
    }
    ;
}
ClientSystemHeaderService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ClientSystemHeaderService.ctorParameters = () => [
    { type: DocumentService }
];
/** @nocollapse */ ClientSystemHeaderService.ɵprov = ɵɵdefineInjectable({ factory: function ClientSystemHeaderService_Factory() { return new ClientSystemHeaderService(ɵɵinject(DocumentService)); }, token: ClientSystemHeaderService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ClientSystemHeaderService.prototype.documentService;
    /* Skipping unhandled member: ;*/
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/current-document-info.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CurrentDocumentInfoService {
    /**
     * @param {?} appStore
     */
    constructor(appStore) {
        this.appStore = appStore;
    }
    /**
     * @return {?}
     */
    getDocumentInfo() {
        return this.appStore.getState().formState.documentInfo;
    }
    /**
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    getDocumentData(unsavedDocumentListId) {
        if (!unsavedDocumentListId) {
            return null;
        }
        /** @type {?} */
        const documentInfo = this.getDocumentInfo()[unsavedDocumentListId] ? this.getDocumentInfo()[unsavedDocumentListId] : {};
        /** @type {?} */
        const documentData = (/** @type {?} */ (Object.assign({}, documentInfo)));
        documentData.document = cloneDeep(this.appStore.getState().formState.documents[documentInfo.documentId]);
        documentData.template = cloneDeep(this.appStore.getState().formState.documents[documentInfo.templateId]);
        return documentData;
    }
    /**
     * @return {?}
     */
    getMainUnsavedDocumentListId() {
        /** @type {?} */
        const documentInfo = this.appStore.getState().formState.documentInfo;
        /** @type {?} */
        const unsavedDocumentListIds = Object.keys(documentInfo);
        return unsavedDocumentListIds.filter((/**
         * @param {?} unsavedDocumentListId
         * @return {?}
         */
        (unsavedDocumentListId) => {
            return documentInfo && documentInfo[unsavedDocumentListId] && documentInfo[unsavedDocumentListId].isMainDoc;
        }))[0];
    }
    /**
     * @return {?}
     */
    getMainDocumentData() {
        /** @type {?} */
        const mainUnsavedDocumentListId = this.getMainUnsavedDocumentListId();
        return this.getDocumentData(mainUnsavedDocumentListId);
    }
}
CurrentDocumentInfoService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CurrentDocumentInfoService.ctorParameters = () => [
    { type: AppStore }
];
/** @nocollapse */ CurrentDocumentInfoService.ɵprov = ɵɵdefineInjectable({ factory: function CurrentDocumentInfoService_Factory() { return new CurrentDocumentInfoService(ɵɵinject(AppStore)); }, token: CurrentDocumentInfoService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CurrentDocumentInfoService.prototype.appStore;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/current-document.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This service stores the document data for the document on main template.
 * It will be retrieved to navigate to document after creating from template, command bar buttons or left/right sidebar visibility...
 */
class CurrentDocumentService {
    /**
     * @param {?} appStore
     * @param {?} currentDocumentInfoService
     * @param {?} documentService
     */
    constructor(appStore, currentDocumentInfoService, documentService) {
        this.appStore = appStore;
        this.currentDocumentInfoService = currentDocumentInfoService;
        this.documentService = documentService;
        this.documentData = {
            document: null,
            template: null
        };
        this.documentDataSubject = new Subject();
        this.documentData$ = this.documentDataSubject.asObservable();
        this.documents$.subscribe((/**
         * @param {?} documents
         * @return {?}
         */
        documents => {
            this.updateDocumentData();
        }));
        this.documentInfo$.subscribe((/**
         * @param {?} documentInfos
         * @return {?}
         */
        documentInfos => {
            this.updateDocumentData();
        }));
    }
    /**
     * @private
     * @return {?}
     */
    updateDocumentData() {
        /** @type {?} */
        let changed = false;
        /** @type {?} */
        const documentInfos = this.appStore.getState().formState.documentInfo;
        if (documentInfos && documentInfos[this.mainUnsavedDocumentListId]) {
            /** @type {?} */
            const docInfo = documentInfos[this.mainUnsavedDocumentListId];
            this.documentData.documentId = docInfo.documentId;
            this.documentData.templateId = docInfo.templateId;
            this.documentData.options = docInfo.options;
            this.documentData.overrideTemplateId = docInfo.overrideTemplateId;
            this.documentData.showFormAfterCreated = docInfo.showFormAfterCreated;
            this.documentData.hierarchyInfo = docInfo.hierarchyInfo;
            this.documentData.altTemplateId = docInfo.altTemplateId;
            this.documentData.isNew = docInfo.isNew;
            this.documentData.isMainDoc = docInfo.isMainDoc;
            changed = true;
        }
        /** @type {?} */
        const documents = this.appStore.getState().formState.documents;
        if (documents && Object.keys(documents)) {
            /** @type {?} */
            const document = documents[this.documentData.documentId];
            if (document) {
                this.documentData.document = document;
                changed = true;
            }
            /** @type {?} */
            const template = documents[this.documentData.templateId];
            if (template) {
                this.documentData.template = template;
                changed = true;
            }
        }
        if (changed) {
            this.documentDataSubject.next(this.documentData);
        }
    }
    /**
     * @param {?} documentListId
     * @return {?}
     */
    setMainDocumentListId(documentListId) {
        this.mainUnsavedDocumentListId = documentListId;
    }
    /**
     * @return {?}
     */
    getMainDocumentListId() {
        return this.mainUnsavedDocumentListId;
    }
    /**
     * @return {?}
     */
    getDocumentData() {
        return this.currentDocumentInfoService.getMainDocumentData();
    }
    /**
     * get the document from the main document - which is the document that the object nav bar is linked to
     * @return {?}
     */
    getDocument() {
        return this.getDocumentData().document;
    }
    /**
     * @param {?} document
     * @return {?}
     */
    setDocument(document) {
        this.documentService.setLoadedDocumentOnly(document);
    }
    /**
     * get the template from the main document - which is the document that the object nav bar is linked to
     * @return {?}
     */
    getTemplate() {
        var _a;
        return (_a = this.getDocumentData()) === null || _a === void 0 ? void 0 : _a.template;
    }
    /**
     * @param {?} template
     * @return {?}
     */
    setTemplate(template) {
        this.documentService.setLoadedDocumentOnly(template);
    }
    /**
     * @return {?}
     */
    resetDocumentData() {
        /** @type {?} */
        const mainUnsavedDocListId = this.currentDocumentInfoService.getMainUnsavedDocumentListId();
        this.appStore.dispatch(formResetDocumentInfo(mainUnsavedDocListId));
    }
    /**
     * @return {?}
     */
    resetUndoRedo() {
        this.appStore.dispatch(resetUndoRedoDocument());
    }
    /**
     * @return {?}
     */
    resetInitDocumentData() {
        this.appStore.dispatch(formResetInitDocumentData(this.mainUnsavedDocumentListId));
    }
}
CurrentDocumentService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CurrentDocumentService.ctorParameters = () => [
    { type: AppStore },
    { type: CurrentDocumentInfoService },
    { type: DocumentService }
];
/** @nocollapse */ CurrentDocumentService.ɵprov = ɵɵdefineInjectable({ factory: function CurrentDocumentService_Factory() { return new CurrentDocumentService(ɵɵinject(AppStore), ɵɵinject(CurrentDocumentInfoService), ɵɵinject(DocumentService)); }, token: CurrentDocumentService, providedIn: "root" });
__decorate([
    select(['formState', 'documents']),
    __metadata("design:type", Observable)
], CurrentDocumentService.prototype, "documents$", void 0);
__decorate([
    select(['formState', 'documentInfo']),
    __metadata("design:type", Observable)
], CurrentDocumentService.prototype, "documentInfo$", void 0);
if (false) {
    /** @type {?} */
    CurrentDocumentService.prototype.documents$;
    /** @type {?} */
    CurrentDocumentService.prototype.documentInfo$;
    /**
     * @type {?}
     * @private
     */
    CurrentDocumentService.prototype.documentData;
    /**
     * @type {?}
     * @private
     */
    CurrentDocumentService.prototype.documentDataSubject;
    /** @type {?} */
    CurrentDocumentService.prototype.documentData$;
    /**
     * @type {?}
     * @private
     */
    CurrentDocumentService.prototype.mainUnsavedDocumentListId;
    /**
     * @type {?}
     * @private
     */
    CurrentDocumentService.prototype.appStore;
    /**
     * @type {?}
     * @private
     */
    CurrentDocumentService.prototype.currentDocumentInfoService;
    /**
     * @type {?}
     * @private
     */
    CurrentDocumentService.prototype.documentService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/template.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TemplateService {
    /**
     * @param {?} currentDocumentService
     * @param {?} documentService
     * @param {?} dataService
     */
    constructor(currentDocumentService, documentService, dataService) {
        this.currentDocumentService = currentDocumentService;
        this.documentService = documentService;
        this.dataService = dataService;
        this.sub = this.currentDocumentService.documentData$.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            this.documentData = data;
        }));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    /**
     * @param {?} doc
     * @param {?} unsavedTemplates
     * @return {?}
     */
    loadTemplate(doc, unsavedTemplates) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let tpl;
            /** @type {?} */
            let templateId = this.documentData.overrideTemplateId;
            if (templateId && this.documentData.document.documentId === doc.documentId) {
                tpl = this.documentService.getExistingDocument(templateId);
            }
            else {
                templateId = doc.systemHeader.templateId;
                if (!tpl && unsavedTemplates && unsavedTemplates[0].documentId === templateId) {
                    tpl = unsavedTemplates[0];
                }
            }
            if (tpl) {
                return Promise.resolve(tpl);
            }
            else {
                // template not loaded. This can happen in circumstances like editing in the template editor.
                // Get the template from the server
                return yield this.dataService.getDocument(templateId);
            }
        });
    }
}
TemplateService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
TemplateService.ctorParameters = () => [
    { type: CurrentDocumentService },
    { type: DocumentService },
    { type: DataService }
];
if (false) {
    /** @type {?} */
    TemplateService.prototype.documentData;
    /** @type {?} */
    TemplateService.prototype.sub;
    /**
     * @type {?}
     * @private
     */
    TemplateService.prototype.currentDocumentService;
    /**
     * @type {?}
     * @private
     */
    TemplateService.prototype.documentService;
    /**
     * @type {?}
     * @private
     */
    TemplateService.prototype.dataService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/search/search-filter.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SearchFilter() { }
if (false) {
    /** @type {?} */
    SearchFilter.prototype.filter;
    /** @type {?} */
    SearchFilter.prototype.queryToBeFiltered;
}
class SearchFilterService {
    /**
     * @param {?} localStorageService
     */
    constructor(localStorageService) {
        this.localStorageService = localStorageService;
        this.searchFilter = {
            filter: false,
            queryToBeFiltered: null
        };
        this.searchFilterSubject = new Subject();
        this.searchFilter$ = this.searchFilterSubject.asObservable();
    }
    /**
     * @param {?} query
     * @return {?}
     */
    setQueryToBeFiltered(query) {
        this.localStorageService.setItem(ClientConstants.FILTERED_QUERY, query);
        this.localStorageService.setItem(ClientConstants.FILTER, 'true');
        this.searchFilter.filter = true;
        this.searchFilter.queryToBeFiltered = query;
        this.searchFilterSubject.next(this.searchFilter);
    }
    /**
     * @return {?}
     */
    removeFilter() {
        this.searchFilter.filter = false;
        this.searchFilter.queryToBeFiltered = null;
        this.localStorageService.removeItem(ClientConstants.FILTER);
        this.localStorageService.removeItem(ClientConstants.FILTERED_QUERY);
        this.searchFilterSubject.next(this.searchFilter);
    }
}
SearchFilterService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
SearchFilterService.ctorParameters = () => [
    { type: LocalStorageService }
];
/** @nocollapse */ SearchFilterService.ɵprov = ɵɵdefineInjectable({ factory: function SearchFilterService_Factory() { return new SearchFilterService(ɵɵinject(LocalStorageService)); }, token: SearchFilterService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    SearchFilterService.prototype.searchFilter;
    /**
     * @type {?}
     * @private
     */
    SearchFilterService.prototype.searchFilterSubject;
    /** @type {?} */
    SearchFilterService.prototype.searchFilter$;
    /**
     * @type {?}
     * @private
     */
    SearchFilterService.prototype.localStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/search/search.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$f = console;
class SearchService {
    /**
     * @param {?} dataService
     * @param {?} configService
     */
    constructor(dataService, configService) {
        this.dataService = dataService;
        this.configService = configService;
        this.results = { data: [] };
    }
    /**
     * @template THIS
     * @this {THIS}
     * @return {THIS}
     */
    getInstance() {
        return (/** @type {?} */ (this));
    }
    /**
     * Do Elastic search on server side. If the browser is offline, do searching indexedDB.
     * @param {?} options consists of text, filter query to search
     * @param {?=} searchContext an object consists of additional params
     * @return {?} Promise
     */
    search(options, searchContext) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const exceedsMaxQueryLength = (/**
             * @param {?} query
             * @return {?}
             */
            query => {
                /** @type {?} */
                const maxSearchQueryLength = _self.configService.clientConfig().maxSearchQueryLength ||
                    SharedConstants.DEFAULT_MAX_SEARCH_QUERY_LENGTH;
                if (!query) {
                    return false;
                }
                else {
                    return JSON.stringify(query).length > maxSearchQueryLength;
                }
            });
            if (exceedsMaxQueryLength(options.filter)) {
                /** @type {?} */
                const message = 'The maximum length of a search query has been exceeded.';
                logger$f.error(message);
                reject(new Error(message));
                return;
            }
            _self.dataService.search(options, searchContext).then((/**
             * @param {?} returnData
             * @return {?}
             */
            function successFunc(returnData) {
                if (returnData.statusCode !== UtilHttpStatus.OK) {
                    /** @type {?} */
                    let msg = 'Search failed with status - ' + UtilHttpStatus.getStatusText(returnData.errorCode);
                    if (returnData.message.status === UtilHttpStatus.BAD_REQUEST + '') {
                        msg = 'Search failed with status - ' + 'filter is incorrectly set up';
                    }
                    reject(msg);
                }
                else {
                    _self.results = returnData;
                    resolve(returnData);
                }
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function errorFunc(err) {
                /** @type {?} */
                let message;
                if (err) {
                    if (err.message) {
                        message = 'Error in search: ' + err.message;
                    }
                    else {
                        if (err.errorCode) {
                            message = 'Search failed with error: ' + err.errorCode;
                        }
                        else {
                            message = 'Error in search. Please see an administrator';
                        }
                    }
                }
                else {
                    message = 'Error in search. Please see an administrator';
                }
                reject(new Error(message));
            }));
        }));
    }
}
SearchService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
SearchService.ctorParameters = () => [
    { type: DataService },
    { type: ConfigService }
];
/** @nocollapse */ SearchService.ɵprov = ɵɵdefineInjectable({ factory: function SearchService_Factory() { return new SearchService(ɵɵinject(DataService), ɵɵinject(ConfigService)); }, token: SearchService, providedIn: "root" });
if (false) {
    /** @type {?} */
    SearchService.prototype.results;
    /**
     * @type {?}
     * @private
     */
    SearchService.prototype.dataService;
    /**
     * @type {?}
     * @private
     */
    SearchService.prototype.configService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/session/session-test.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const serverRoutes$3 = SharedUrlRoutes.serverRoutes;
class SessionTestService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @return {?}
     */
    testSession() {
        // returns an observable that shows whether the session to the server is connected
        return this.testSessionObservable().toPromise();
    }
    /**
     * @return {?}
     */
    testSessionObservable() {
        return this.http.get(serverRoutes$3.sessionTest, { responseType: 'text' });
    }
}
SessionTestService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
SessionTestService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ SessionTestService.ɵprov = ɵɵdefineInjectable({ factory: function SessionTestService_Factory() { return new SessionTestService(ɵɵinject(HttpClient)); }, token: SessionTestService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    SessionTestService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/key-value-storage/key-value-storage.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$g = console;
class KeyValueStorageService {
    /**
     * @param {?} urlBasePathService
     * @param {?} localStorageService
     */
    constructor(urlBasePathService, localStorageService) {
        this.urlBasePathService = urlBasePathService;
        this.localStorageService = localStorageService;
        this.dbName = 'keyValueStorage';
        this.dbVersion = 1;
        this.objectName = 'keyValues';
        this.idb = null;
        this.openFailedError = false;
    }
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    setItem(key, value) {
        /** @type {?} */
        const self = this;
        if (self.openFailedError) {
            self.localStorageService.setItem(key, value);
            return Promise.resolve();
        }
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getDatabase().then((/**
             * @param {?} db
             * @return {?}
             */
            function success(db) {
                db.transaction('rw', db[self.objectName], (/**
                 * @param {?} result
                 * @return {?}
                 */
                (result) => {
                    db[self.objectName].put({ key: key, value: value }).then((/**
                     * @param {?} data
                     * @return {?}
                     */
                    (data) => {
                        resolve(result);
                    }), (/**
                     * @param {?} e
                     * @return {?}
                     */
                    (e) => {
                        logger$g.error('Error on IndexedDBService.saveEntry:');
                        logger$g.error(e);
                        reject(e);
                    }));
                })).catch((/**
                 * @param {?} e
                 * @return {?}
                 */
                e => {
                    if (e.name === 'OpenFailedError') {
                        logger$g.error('Error adding entry to IndexedDB, using localStorage instead.');
                        self.localStorageService.setItem(key, value);
                        self.openFailedError = true;
                        resolve(value);
                    }
                    else {
                        logger$g.error('Error adding entry to IndexedDB: ' + e.stack || e);
                        reject(e);
                    }
                }));
            }));
        }));
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getItem(key) {
        key = this.urlBasePathService.getBasePath() + key;
        /** @type {?} */
        const self = this;
        if (self.openFailedError) {
            /** @type {?} */
            const value = self.localStorageService.getItem(key);
            return Promise.resolve(value);
        }
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getDatabase().then((/**
             * @param {?} db
             * @return {?}
             */
            function success(db) {
                db[self.objectName].where('key').equals(key).each((/**
                 * @param {?} results
                 * @return {?}
                 */
                results => {
                    resolve(results.value);
                })).catch((/**
                 * @param {?} error
                 * @return {?}
                 */
                function (error) {
                    if (error.name === 'OpenFailedError') {
                        logger$g.error('Error getting dexie entries, using localStorage instead.');
                        /** @type {?} */
                        const value = self.localStorageService.getItem(key);
                        self.openFailedError = true;
                        resolve(value);
                    }
                    else {
                        logger$g.error('Error getting dexie entries: ' + error.message);
                        reject(error);
                    }
                }));
            }));
        }));
    }
    /**
     * @param {?} key
     * @return {?}
     */
    removeItem(key) {
        key = this.urlBasePathService.getBasePath() + key;
        /** @type {?} */
        const self = this;
        if (self.openFailedError) {
            self.localStorageService.removeItem(key);
            return Promise.resolve(1);
        }
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getDatabase().then((/**
             * @param {?} db
             * @return {?}
             */
            function success(db) {
                db[self.objectName].where('key').equals(key).delete().then((/**
                 * @param {?} deleteCount
                 * @return {?}
                 */
                deleteCount => {
                    resolve(deleteCount);
                })).catch((/**
                 * @param {?} error
                 * @return {?}
                 */
                function (error) {
                    if (error.name === 'OpenFailedError') {
                        logger$g.error('Error removing dexie entries, using localStorage instead.');
                        self.localStorageService.removeItem(key);
                        self.openFailedError = true;
                        resolve(1);
                    }
                    else {
                        logger$g.error('Error removing dexie entries: ' + error.message);
                        reject(error);
                    }
                }));
            }));
        }));
    }
    /**
     * @return {?}
     */
    getDatabase() {
        /** @type {?} */
        const self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            if (self.idb) {
                resolve(self.idb);
            }
            else {
                /** @type {?} */
                const db = new Dexie__default(self.dbName);
                db.version(self.dbVersion).stores({
                    keyValues: 'key'
                });
                self.idb = db;
                resolve(self.idb);
            }
        }));
    }
}
KeyValueStorageService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
KeyValueStorageService.ctorParameters = () => [
    { type: UrlBasePathService },
    { type: LocalStorageService }
];
/** @nocollapse */ KeyValueStorageService.ɵprov = ɵɵdefineInjectable({ factory: function KeyValueStorageService_Factory() { return new KeyValueStorageService(ɵɵinject(UrlBasePathService), ɵɵinject(LocalStorageService)); }, token: KeyValueStorageService, providedIn: "root" });
if (false) {
    /** @type {?} */
    KeyValueStorageService.prototype.dbName;
    /** @type {?} */
    KeyValueStorageService.prototype.dbVersion;
    /** @type {?} */
    KeyValueStorageService.prototype.objectName;
    /** @type {?} */
    KeyValueStorageService.prototype.idb;
    /** @type {?} */
    KeyValueStorageService.prototype.openFailedError;
    /**
     * @type {?}
     * @private
     */
    KeyValueStorageService.prototype.urlBasePathService;
    /**
     * @type {?}
     * @private
     */
    KeyValueStorageService.prototype.localStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/state/control-state-save.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ControlStateSaveService {
    /**
     * @param {?} keyValueStorageService
     */
    constructor(keyValueStorageService) {
        this.keyValueStorageService = keyValueStorageService;
    }
    /**
     * @param {?} stateName
     * @param {?} value
     * @return {?}
     */
    setControlState(stateName, value) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.keyValueStorageService.setItem(stateName, JSON.stringify(value));
        });
    }
    /**
     * @param {?} stateName
     * @return {?}
     */
    getControlState(stateName) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const value = yield this.keyValueStorageService.getItem(stateName);
            return JSON.parse(value);
        });
    }
    /**
     * @param {?} stateName
     * @return {?}
     */
    removeControlState(stateName) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.keyValueStorageService.removeItem(stateName);
        });
    }
}
ControlStateSaveService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ControlStateSaveService.ctorParameters = () => [
    { type: KeyValueStorageService }
];
/** @nocollapse */ ControlStateSaveService.ɵprov = ɵɵdefineInjectable({ factory: function ControlStateSaveService_Factory() { return new ControlStateSaveService(ɵɵinject(KeyValueStorageService)); }, token: ControlStateSaveService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ControlStateSaveService.prototype.keyValueStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/vendor-library/vendor-library.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VendorLibraryService {
    constructor() { }
    /**
     * @param {?} name
     * @return {?}
     */
    getVendorLibrary(name) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const clientResourcesReq = new Request('api/loadVendorLibrary/' + name, { credentials: 'include' });
            try {
                /** @type {?} */
                const response = yield fetch(clientResourcesReq);
                return response.json();
            }
            catch (err) {
                return null;
            }
        });
    }
    /**
     * @return {?}
     */
    getVendorLibs() {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const clientResourcesReq = new Request('api/loadVendorLibraries', { credentials: 'include' });
            try {
                /** @type {?} */
                const response = yield fetch(clientResourcesReq);
                return response.json();
            }
            catch (err) {
                return null;
            }
        });
    }
}
VendorLibraryService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
VendorLibraryService.ctorParameters = () => [];
/** @nocollapse */ VendorLibraryService.ɵprov = ɵɵdefineInjectable({ factory: function VendorLibraryService_Factory() { return new VendorLibraryService(); }, token: VendorLibraryService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/lazyload/lazy-script-loader.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Angular: Load External JavaScript/Stylesheet File Dynamically
 */
class LazyScriptLoaderService {
    /**
     * @param {?} document
     * @param {?} vendorLibraryService
     */
    constructor(document, vendorLibraryService) {
        this.document = document;
        this.vendorLibraryService = vendorLibraryService;
        this.loadedLibraries = {};
    }
    /**
     * @param {?} url
     * @return {?}
     */
    loadScript(url) {
        /** @type {?} */
        const _self = this;
        if (_self.loadedLibraries[url]) {
            return _self.loadedLibraries[url].toPromise();
        }
        _self.loadedLibraries[url] = new ReplaySubject();
        /** @type {?} */
        const script = _self.document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = url;
        script.onload = (/**
         * @return {?}
         */
        () => {
            _self.loadedLibraries[url].next();
            _self.loadedLibraries[url].complete();
        });
        _self.document.body.appendChild(script);
        return _self.loadedLibraries[url].toPromise();
    }
    /**
     * @param {?} url
     * @return {?}
     */
    loadStyle(url) {
        /** @type {?} */
        const _self = this;
        if (_self.loadedLibraries[url]) {
            return _self.loadedLibraries[url].toPromise();
        }
        _self.loadedLibraries[url] = new ReplaySubject();
        /** @type {?} */
        const style = _self.document.createElement('link');
        style.type = 'text/css';
        style.href = url;
        style.rel = 'stylesheet';
        style.onload = (/**
         * @return {?}
         */
        () => {
            _self.loadedLibraries[url].next();
            _self.loadedLibraries[url].complete();
        });
        /** @type {?} */
        const head = document.getElementsByTagName('head')[0];
        head.appendChild(style);
        return _self.loadedLibraries[url].toPromise();
    }
    /**
     * @param {?} dependencies
     * @return {?}
     */
    load(dependencies) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!dependencies || (!dependencies.name && !dependencies.documentId)) {
                return Promise.reject(new Error('Dependencies not specified correctly in lazyLoader.load'));
            }
            /** @type {?} */
            let files = [];
            if (!dependencies.files) {
                /** @type {?} */
                let vendorLib;
                if (dependencies.documentId) {
                    vendorLib = yield this.vendorLibraryService.getVendorLibrary(dependencies.documentId);
                }
                else {
                    vendorLib = yield this.vendorLibraryService.getVendorLibrary(dependencies.name);
                }
                if (vendorLib) {
                    if (vendorLib.fileName) {
                        files.push(vendorLib.fileName);
                    }
                    if (vendorLib.fileNames) {
                        files = files.concat(vendorLib.fileNames);
                    }
                }
            }
            else {
                files = dependencies.files;
            }
            if (!files.length) {
                return Promise.reject(new Error(`Dependencies specified in lazyLoader.load not found!`));
            }
            return yield loadjs(files, {
                returnPromise: true
            });
        });
    }
}
LazyScriptLoaderService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
LazyScriptLoaderService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: VendorLibraryService }
];
/** @nocollapse */ LazyScriptLoaderService.ɵprov = ɵɵdefineInjectable({ factory: function LazyScriptLoaderService_Factory() { return new LazyScriptLoaderService(ɵɵinject(DOCUMENT), ɵɵinject(VendorLibraryService)); }, token: LazyScriptLoaderService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    LazyScriptLoaderService.prototype.loadedLibraries;
    /**
     * @type {?}
     * @private
     */
    LazyScriptLoaderService.prototype.document;
    /**
     * @type {?}
     * @private
     */
    LazyScriptLoaderService.prototype.vendorLibraryService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/file/file-provider.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// Get window.URL object
/** @type {?} */
const URL = window.URL;
/*|| window.webkitURL;*/
/** @type {?} */
const logger$h = console;
/**
 * @record
 */
function options() { }
if (false) {
    /** @type {?|undefined} */
    options.prototype.isOnline;
    /** @type {?|undefined} */
    options.prototype.isCommandBarUpload;
    /** @type {?|undefined} */
    options.prototype.docFieldName;
}
class FileProviderService {
    /**
     * @param {?} loggedInUserService
     * @param {?} indexedDBService
     * @param {?} offlineStatusService
     * @param {?} httpClient
     * @param {?} dataService
     * @param {?} configService
     */
    constructor(loggedInUserService, indexedDBService, offlineStatusService, httpClient, dataService, configService) {
        this.loggedInUserService = loggedInUserService;
        this.indexedDBService = indexedDBService;
        this.offlineStatusService = offlineStatusService;
        this.httpClient = httpClient;
        this.dataService = dataService;
        this.configService = configService;
    }
    /**
     * Retrieves the file from offline storage first, if unsuccessful retrieve from server.
     * @param {?} file
     * @return {?}
     */
    getFileResources(file) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const fileNo = file.fileNo;
            /** @type {?} */
            const fileName = file.fileName || "";
            /** @type {?} */
            const resources = {
                url: SharedUrlRoutes.serverRoutes.loadFile + '/' + fileNo + '/' + fileName.replace(/ /g, '-'),
                base64strData: null
            };
            if (!_self.loggedInUserService.isUserOfflineMode()) {
                resolve(resources);
                return;
            }
            /** @type {?} */
            const offlineFileNo = file.fileNo;
            _self.indexedDBService.getFile(offlineFileNo, (/**
             * @param {?} record
             * @return {?}
             */
            function (record) {
                return __awaiter(this, void 0, void 0, function* () {
                    /** @type {?} */
                    const data = record && record.uploadConfig && record.uploadConfig.data ? record.uploadConfig.data : null;
                    if (data) {
                        resources.base64strData = data.uploadedFile;
                    }
                    if (!resources.base64strData && data && data.file) {
                        resources.base64strData = yield _self.indexedDBService.toBase64Str(data.file);
                    }
                    resolve(resources);
                });
            }));
        }));
    }
    /**
     * Sends the file directly to server.
     * @param {?} uploadConfig
     * @return {?}
     */
    onlineFileUpload(uploadConfig) {
        // prepare for actual upload
        // prepare for actual upload
        /** @type {?} */
        const fileData = uploadConfig.data;
        /** @type {?} */
        const type = fileData.mimetype;
        /** @type {?} */
        const self = this;
        /** @type {?} */
        const file = new File([fileData.file], fileData.originalname, { type: type });
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.uploadFileToServer(fileData.fileNo, file, fileData.documentId, fileData.documentName, { isOnline: true })
                .toPromise().then(success, error);
            /**
             * @param {?} response
             * @return {?}
             */
            function success(response) {
                /** @type {?} */
                const uploaded = response.body;
                self.dataService.getDocument(fileData.documentId).then((/**
                 * @param {?} orignalDoc
                 * @return {?}
                 */
                (orignalDoc) => {
                    /** @type {?} */
                    const document = cloneDeep(orignalDoc);
                    uploadConfig.fileNo = uploaded.fileNo;
                    uploadConfig.basePath = uploaded.basePath;
                    uploadConfig.fileType = uploaded.fileType;
                    self.updateFileInfo(document, uploadConfig);
                    self.dataService.deepDiffUpdate(orignalDoc, document).then((/**
                     * @param {?} data
                     * @return {?}
                     */
                    (data) => {
                        resolve({ data: uploaded });
                    }), (/**
                     * @param {?} error
                     * @return {?}
                     */
                    (error) => {
                        reject(error);
                    }));
                })).catch((/**
                 * @param {?} err
                 * @return {?}
                 */
                err => {
                    logger$h.error("Error on online file upload: " + JSON.stringify(err));
                    resolve({ data: uploaded });
                    //reject(err)
                }));
            }
            /**
             * @param {?} error
             * @return {?}
             */
            function error(error) {
                reject(error);
            }
        }));
    }
    /**
     * @private
     * @param {?} fileNo
     * @param {?} file
     * @param {?} documentId
     * @param {?} documentName
     * @param {?} options
     * @return {?}
     */
    uploadFileToServer(fileNo, file, documentId, documentName, options) {
        /** @type {?} */
        const maxUploadSize = parseInt(this.configService.clientConfig().maxUploadSize) || SharedConstants.DEFAULT_MAX_UPLOAD_SIZE;
        if (file && file.size && file.size > (maxUploadSize * 1024 * 1024)) {
            /** @type {?} */
            const errMsg = 'The file is too large. Allowed maximum size is ' + maxUploadSize + "mb";
            return from(Promise.reject(new Error(errMsg)));
        }
        else {
            /** @type {?} */
            const postUrl = SharedUrlRoutes.serverRoutes.uploadFiles;
            if (!options) {
                options = {};
            }
            if (this.loggedInUserService.isUserOfflineMode() && !options.isOnline) {
                /** @type {?} */
                let uploadConfig = {
                    data: {
                        fileNo: fileNo, file: file, originalname: file.name, mimetype: file.type,
                        documentId: documentId, documentName: documentName
                    }, isCommandBarUpload: options.isCommandBarUpload,
                    docFieldName: options.docFieldName
                };
                return from(this.offlineFileUpload(uploadConfig));
            }
            else {
                /** @type {?} */
                const myFormData = new FormData();
                myFormData.append('fileNo', fileNo);
                myFormData.append('file', file);
                myFormData.append('documentId', documentId);
                myFormData.append('documentName', documentName);
                /** @type {?} */
                const config = new HttpRequest('POST', postUrl, myFormData, {
                    reportProgress: true
                });
                return this.httpClient.request(config);
            }
        }
    }
    /**
     * Saves to offline database. The OfflinePoller sends it to the server later
     * @private
     * @param {?} uploadConfig
     * @return {?}
     */
    offlineFileUpload(uploadConfig) {
        //
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const record = {
                fileNo: uploadConfig.data.fileNo,
                uploadConfig: uploadConfig,
                status: IndexedDBConstants.OFFLINE_STATUS_PENDING // 'UPLOADED' or 'PENDING'
            };
            try {
                /** @type {?} */
                const reader = new FileReader();
                reader.onloadend = (/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) {
                    /** @type {?} */
                    const blob = new Blob([e.target.result], { type: "image/jpeg" });
                    uploadConfig.data.file = blob;
                    _self.indexedDBService.saveFile(record);
                    resolve({
                        body: { fileNo: uploadConfig.data.fileNo },
                        status: 200,
                        data: 'OK'
                    });
                });
                reader.readAsArrayBuffer(uploadConfig.data.file);
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    /**
     * @param {?} file
     * @return {?}
     */
    downloadFile(file) {
        if (!file.resources.base64strData) {
            window.open(file.resources.url);
            return;
        }
        /** @type {?} */
        const objectURL = URL.createObjectURL(this.dataURLtoFile(file.resources.base64strData, file.fileName));
        /** @type {?} */
        const anchor = document.createElement('a');
        anchor.download = file.fileName;
        anchor.href = objectURL;
        anchor.click();
        URL.revokeObjectURL(objectURL);
    }
    // helpers
    /**
     * @private
     * @param {?} dataurl
     * @param {?} filename
     * @return {?}
     */
    dataURLtoFile(dataurl, filename) {
        /** @type {?} */
        const arr = dataurl.split(',');
        /** @type {?} */
        const mime = arr[0].match(/:(.*?);/)[1];
        /** @type {?} */
        const bstr = atob(arr[1]);
        /** @type {?} */
        let n = bstr.length;
        /** @type {?} */
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }
    /**
     * @param {?} uploadConfig
     * @return {?}
     */
    uploadFile(uploadConfig) {
        if (this.loggedInUserService.isUserOfflineMode()) {
            uploadConfig.isOnline = false;
        }
        else {
            uploadConfig.isOnline = true;
        }
        return this.uploadFileToServer(uploadConfig.fileNo, uploadConfig.file, uploadConfig.documentId, uploadConfig.documentName, uploadConfig);
    }
    /**
     * @private
     * @param {?} document
     * @param {?} uploadConfig
     * @return {?}
     */
    updateFileInfo(document, uploadConfig) {
        if (uploadConfig.isCommandBarUpload) {
            /** @type {?} */
            const DOCUMENT_FIELD_NAME = SharedConstants.DOCUMENT_FIELD_NAME_UPLOAD_FILE;
            // save as the template's image on navbar
            document.systemHeader[DOCUMENT_FIELD_NAME] = uploadConfig.fileNo;
        }
        else {
            if (uploadConfig.docFieldName) {
                /** @type {?} */
                const fileRecord = {
                    fileNo: uploadConfig.fileNo,
                    fileName: uploadConfig.data.originalname,
                    fileType: uploadConfig.fileType,
                    basePath: uploadConfig.basePath,
                };
                /** @type {?} */
                let isExists = false;
                /** @type {?} */
                let documentFiles = document[uploadConfig.docFieldName];
                if (documentFiles && documentFiles.length > 0) {
                    for (let i = 0; i < documentFiles.length; i++) {
                        /** @type {?} */
                        const item = documentFiles[i];
                        if (item.fileNo === uploadConfig.data.fileNo) {
                            item.basePath = uploadConfig.basePath;
                            if (uploadConfig.fileNo) {
                                item.fileNo = uploadConfig.fileNo;
                                item.fileType = uploadConfig.fileType;
                            }
                            isExists = true;
                            break;
                        }
                    }
                }
                else {
                    documentFiles = [];
                }
                if (!isExists) {
                    document[uploadConfig.docFieldName] = [...documentFiles, fileRecord];
                }
            }
        }
    }
}
FileProviderService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FileProviderService.ctorParameters = () => [
    { type: LoggedInUserService },
    { type: IndexedDBService },
    { type: OfflineStatusService },
    { type: HttpClient },
    { type: DataService },
    { type: ConfigService }
];
/** @nocollapse */ FileProviderService.ɵprov = ɵɵdefineInjectable({ factory: function FileProviderService_Factory() { return new FileProviderService(ɵɵinject(LoggedInUserService), ɵɵinject(IndexedDBService), ɵɵinject(OfflineStatusService), ɵɵinject(HttpClient), ɵɵinject(DataService), ɵɵinject(ConfigService)); }, token: FileProviderService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    FileProviderService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    FileProviderService.prototype.indexedDBService;
    /**
     * @type {?}
     * @private
     */
    FileProviderService.prototype.offlineStatusService;
    /**
     * @type {?}
     * @private
     */
    FileProviderService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    FileProviderService.prototype.dataService;
    /**
     * @type {?}
     * @private
     */
    FileProviderService.prototype.configService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/indexeddb/indexed-dbqueue.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const serverRoutes$4 = SharedUrlRoutes.serverRoutes;
/** @type {?} */
const logger$i = console;
class IndexedDBQueueService {
    /**
     * @param {?} http
     * @param {?} indexedDBConnectorService
     * @param {?} indexedDBService
     * @param {?} offlineStatusService
     * @param {?} broadcastService
     * @param {?} fileProviderService
     */
    constructor(http, indexedDBConnectorService, indexedDBService, offlineStatusService, broadcastService, fileProviderService) {
        this.http = http;
        this.indexedDBConnectorService = indexedDBConnectorService;
        this.indexedDBService = indexedDBService;
        this.offlineStatusService = offlineStatusService;
        this.broadcastService = broadcastService;
        this.fileProviderService = fileProviderService;
    }
    /**
     * send offline data that is saved in IndexedDB queue
     * @private
     * @param {?} cachedObject - the document to update
     * @param {?} offlineDetails - details of the operation
     * @return {?}
     */
    sendOfflineData(cachedObject, offlineDetails) {
        if (!cachedObject) {
            return Promise.reject(new Error('Document not provided in sendOflineData'));
        }
        if (!offlineDetails) {
            return Promise.reject(new Error('Offline details not provided in sendOfflineData'));
        }
        /** @type {?} */
        const document = cloneDeep(cachedObject);
        // only send data and avoid updating on passed data
        /** @type {?} */
        let pushedData = document;
        /** @type {?} */
        let url = null;
        /** @type {?} */
        const operationType = offlineDetails.type;
        switch (operationType) {
            case ClientConstants.OPERATION_TYPE_POST:
                url = serverRoutes$4.document;
                if (document.systemHeader.currentVersion === false) {
                    document.systemHeader.currentVersion = true;
                }
                break;
            case ClientConstants.OPERATION_TYPE_PUT:
                // allows sending an old version into the server to replace the current version there
                // it will later then be overrideen when newer versions are submitted.
                // This assumes that updates are submitted only after the previous request succeeded.
                document.systemHeader.currentVersion = true;
                url = serverRoutes$4.documentDeepDiffUpdate + '/' + document.documentId;
                /** @type {?} */
                const options = {
                    updates: offlineDetails.updates,
                    isUpdateFromPreviousVersion: offlineDetails.isUpdateFromPreviousVersion,
                    makeCurrentVersion: offlineDetails.makeCurrentVersion,
                    importPreviousVersion: offlineDetails.importPreviousVersion
                };
                pushedData = {
                    document: document,
                    options: options
                };
                break;
            case ClientConstants.OPERATION_TYPE_DELETE:
                url = serverRoutes$4.document +
                    '/' + document.documentId +
                    '/' + document.systemHeader.templateId +
                    '/' + document.systemHeader.versionId;
                break;
            default:
                logger$i.error('Operation not yet implemented.');
                break;
        }
        /** @type {?} */
        const req = new HttpRequest(operationType, url, pushedData);
        return this.http.request(req).toPromise();
    }
    /**
     * @private
     * @param {?} cachedObject
     * @return {?}
     */
    doUpdateCachedObject(cachedObject) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.indexedDBService.saveEntry(IndexedDBConstants.DOCUMENT_TABLE_NAME, cachedObject, (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                if (!err) {
                    resolve();
                }
                else {
                    reject();
                }
            }));
        }));
    }
    /**
     * @private
     * @param {?} docId
     * @param {?} processedFiles
     * @return {?}
     */
    updateSentFileToOfflineDoc(docId, processedFiles) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const indexValue = docId;
            if (indexValue) {
                /** @type {?} */
                const tblName = IndexedDBConstants.DOCUMENT_TABLE_NAME;
                /** @type {?} */
                const indexName = IndexedDBConstants.DOCUMENT_INDEX_DOCUMENT_ID;
                _self.indexedDBService.getEntries(tblName, indexName, indexValue, (/**
                 * @param {?} cachedObjects
                 * @return {?}
                 */
                function (cachedObjects) {
                    /** @type {?} */
                    const subPromises = [];
                    for (let id = 0; id < cachedObjects.length; id++) {
                        /** @type {?} */
                        const cachedObject = cachedObjects[id];
                        logger$i.info('Update cached object for file attach.');
                        logger$i.info(cachedObject);
                        subPromises.push(_self.doUpdateCachedObject(cachedObject));
                    }
                    Promise.all(subPromises).then((/**
                     * @return {?}
                     */
                    function successFunc() {
                        resolve();
                    }), (/**
                     * @return {?}
                     */
                    function errorFunc() {
                        reject();
                    }));
                }));
            }
            else {
                resolve();
            }
        }));
    }
    /**
     * @private
     * @param {?} processedFiles
     * @return {?}
     */
    updateSentFileToOfflineDocs(processedFiles) {
        /** @type {?} */
        const promises = [];
        /** @type {?} */
        const self = this;
        /** @type {?} */
        const docMap = {};
        processedFiles.forEach((/**
         * @param {?} processedFile
         * @return {?}
         */
        function (processedFile) {
            /** @type {?} */
            const docId = processedFile.uploadConfig ? processedFile.uploadConfig.data.documentId : null;
            if (docId) {
                if (!docMap[docId]) {
                    docMap[docId] = [];
                }
                docMap[docId].push(processedFile);
            }
        }));
        /** @type {?} */
        const docIds = Object.keys(docMap);
        docIds.forEach((/**
         * @param {?} docId
         * @return {?}
         */
        function (docId) {
            promises.push(self.updateSentFileToOfflineDoc(docId, docMap[docId]));
        }));
        return Promise.all(promises);
    }
    /*
       * @param onItemProgress - Function to call for every progress of an item regardless if it failed or not
       * This will be used to update the poller's lastActive status and make the poller active
       * @return {promise}
       */
    /**
     * @param {?} onItemProgress
     * @return {?}
     */
    sendUnsyncedObjects(onItemProgress) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            let documentUploadDone = false;
            // flag
            /** @type {?} */
            let abort = false;
            _self.indexedDBService.getUnsentOfflineFilesInQueue((/**
             * @param {?} files
             * @return {?}
             */
            function (files) {
                if (files.length === 0) {
                    sendUnProcessedDocs();
                }
                else {
                    logger$i.info('Sending unsent offline files...');
                    /** @type {?} */
                    const processedFiles = [];
                    /** @type {?} */
                    let processedCount = 0;
                    for (let x = 0; x < files.length; x++) {
                        /** @type {?} */
                        const file = files[x];
                        _self.processOfflineUpload(file, onItemProgress, (/**
                         * @param {?} status
                         * @param {?} fileResult
                         * @return {?}
                         */
                        function onItemProcessed(status, fileResult) {
                            processedCount++;
                            if (fileResult || fileResult === false) {
                                processedFiles.push(fileResult);
                                _self.broadcastService.broadcast(ClientConstants.FILE_SENT_EVENT_NAME, fileResult);
                            }
                            else if (status === _self.indexedDBService.constants.OFFLINE_STATUS_PENDING) {
                                documentUploadDone = true;
                                terminatePromise();
                            }
                            if (processedCount === files.length) {
                                logger$i.info('All unsent offline files have been sent. Do update unprocessed docs.');
                                _self.updateSentFileToOfflineDocs(processedFiles).then((/**
                                 * @return {?}
                                 */
                                function sendOfflineDocs() {
                                    logger$i.info('All uploaded files are put into unprocessed docs. Sent these docs.');
                                    sendUnProcessedDocs();
                                }), (/**
                                 * @return {?}
                                 */
                                function error() {
                                    documentUploadDone = true;
                                    terminatePromise();
                                }));
                            }
                        }));
                    }
                }
            }));
            /**
             * @return {?}
             */
            function sendUnProcessedDocs() {
                _self.indexedDBService.getUnprocessedDocs((/**
                 * @param {?} cachedObjects
                 * @return {?}
                 */
                function (cachedObjects) {
                    _self.offlineStatusService.setPendingDocumentCount(cachedObjects.length);
                    if (cachedObjects.length === 0) {
                        documentUploadDone = true;
                        terminatePromise();
                        return;
                    }
                    logger$i.info('Sending unprocessed documents..');
                    /** @type {?} */
                    let documentProcessed = 0;
                    whilst(hasMoreDocuments, iterator, callbackFn);
                    /**
                     * @return {?}
                     */
                    function hasMoreDocuments() {
                        return !abort && documentProcessed < cachedObjects.length;
                    }
                    /**
                     * @param {?} callback
                     * @return {?}
                     */
                    function iterator(callback) {
                        // async.whilst second param
                        /** @type {?} */
                        const cachedObject = cachedObjects[documentProcessed];
                        /** @type {?} */
                        const docId = cachedObject.documentId;
                        /** @type {?} */
                        const docVersionId = cachedObject.systemHeader.versionId;
                        _self.indexedDBService.loadCachedDocByVersion(docId, docVersionId, (/**
                         * @param {?} dbCachedObject
                         * @return {?}
                         */
                        function (dbCachedObject) {
                            /** @type {?} */
                            const deleteOnComplete = dbCachedObject.systemHeader.offlineDetails.deleteOnComplete;
                            // do not send the offlineDetails to the server because the server does not use these values. The
                            // updates can cause ElasticSearch mapping conflicts
                            /** @type {?} */
                            const offlineDetails = dbCachedObject.systemHeader.offlineDetails;
                            delete dbCachedObject.systemHeader.offlineDetails;
                            _self.sendOfflineData(dbCachedObject, offlineDetails).then((/**
                             * @param {?} response
                             * @return {?}
                             */
                            function success(response) {
                                _self.offlineStatusService.setConnected();
                                onItemProgress(); // record activity
                                documentProcessed++;
                                /** @type {?} */
                                let versionConflict = false;
                                /** @type {?} */
                                const thisDcVersionId = dbCachedObject.systemHeader.versionId;
                                if (response.data != null && response.data._id != null) {
                                    /** @type {?} */
                                    const expectedVersion = thisDcVersionId;
                                    /** @type {?} */
                                    const retrievedVersion = response.data.systemHeader.versionId;
                                    versionConflict = expectedVersion !== retrievedVersion;
                                    /**
                                     * update the cache with the actual document in server
                                     * if there are conflicts as stated in issue 10049 (versionConflict === true),
                                     * the document response.data will not be identical with the sent document.
                                     * Whatever the server sent back, response.data in this case, will always be
                                     * the current document.
                                     */
                                    dbCachedObject = response.data;
                                }
                                /** @type {?} */
                                const tbl = _self.indexedDBService.constants.DOCUMENT_TABLE_NAME;
                                if (deleteOnComplete) {
                                    /** @type {?} */
                                    const index = _self.indexedDBService.constants.DOCUMENT_INDEX_VERSION_ID;
                                    // will delete only a single entry since versionID is our primary key
                                    _self.indexedDBService.deleteEntries(tbl, index, thisDcVersionId, null);
                                }
                                else {
                                    // update the doc - the offlineDetails need to be put back into the document before updating
                                    dbCachedObject.systemHeader.offlineDetails = offlineDetails;
                                    dbCachedObject.systemHeader.offlineDetails.status =
                                        _self.indexedDBService.constants.OFFLINE_STATUS_UPLOADED;
                                    dbCachedObject.systemHeader.offlineDetails.tries += 1;
                                    _self.indexedDBService.saveEntry(tbl, dbCachedObject);
                                }
                                _self.offlineStatusService.decPendingDocumentCount(); // update status bar
                                if (versionConflict) {
                                    // Remove all versions of this document to retain only the
                                    // most recent curent version from the server.
                                    _self.indexedDBService.documentReset(dbCachedObject.documentId);
                                    logger$i.info('A new version is available for document ' + dbCachedObject.documentId);
                                    // TODO: inform a service to reload the current document offline safe
                                }
                                // The save from server always returns current version
                                // (even the offline version is non-current), then the document is cached. It causes
                                // many current versions of one document in indexedDB.
                                // This will load all other uploaded current versions and update them to
                                // non-current version.
                                _self.indexedDBService.getProcessedCurrentVersionDocs((/**
                                 * @param {?} savedEntries
                                 * @return {?}
                                 */
                                function (savedEntries) {
                                    if (savedEntries && savedEntries.length) {
                                        for (let i = 0; i < savedEntries.length; i++) {
                                            /** @type {?} */
                                            const objectData = savedEntries[i];
                                            if (objectData
                                                && objectData.documentId === dbCachedObject.documentId
                                                && objectData.systemHeader
                                                && objectData.systemHeader.currentVersion
                                                && objectData.systemHeader.versionId !== thisDcVersionId) {
                                                objectData.systemHeader.currentVersion = false;
                                                logger$i.info('Set other cached current processed versions of the current ' +
                                                    'document to non current version: ' + objectData.systemHeader.versionId);
                                                _self.indexedDBService.saveEntry(tbl, savedEntries[i]);
                                            }
                                        }
                                    }
                                    callback();
                                }));
                            }), (/**
                             * @param {?} response
                             * @return {?}
                             */
                            function err(response) {
                                onItemProgress();
                                offlineDetails.tries += 1;
                                offlineDetails.lastRequestStatus = UtilHttpStatus.getStatusText(response.status);
                                if (response.status === UtilHttpStatus.SERVER_UNRESPONSIVE) { // item will be retrieved
                                    _self.offlineStatusService.setDisconnected();
                                    abort = true;
                                }
                                else { // other errors will not be retried
                                    documentProcessed++;
                                    offlineDetails.status = _self.indexedDBService.constants.OFFLINE_STATUS_FAILED;
                                    /** @type {?} */
                                    const errMsg = 'Error sending document. Server responded with status: ' + response.status;
                                    logger$i.error(errMsg);
                                    _self.offlineStatusService.decPendingDocumentCount();
                                }
                                // put the offlineDetails back into the document before saving to IndexedDB
                                dbCachedObject.systemHeader.offlineDetails = offlineDetails;
                                _self.indexedDBService.saveEntry(_self.indexedDBService.constants.DOCUMENT_TABLE_NAME, dbCachedObject);
                                // abort only if error can be retried, else continue on the next item
                                callback(abort ? abort : null);
                            }));
                        }));
                    }
                    /**
                     * @param {?} error
                     * @return {?}
                     */
                    function callbackFn(error) {
                        documentUploadDone = true;
                        terminatePromise();
                    }
                }));
            }
            // either the document upload or the file upload will terminate this process, depending on who completes last
            /**
             * @return {?}
             */
            function terminatePromise() {
                if (!documentUploadDone) { // wait for docs to finish uploading
                    return;
                }
                // Document upload is sequential so it has to abort if one item fails with a retriable error
                // But files can be uploaded anytime, if the upload fails it will just be retried. Unless
                // the error is a fatal one, which will not be retried and marked as OFFLINE_STATUS_FAILED
                if (abort) {
                    reject(new Error('Client is offline.'));
                }
                else {
                    resolve();
                }
            }
        }));
    }
    // moved into a function to isolate it and avoid context issues
    /**
     * @private
     * @param {?} record
     * @param {?} onItemProgress
     * @param {?} onItemProcessed
     * @return {?}
     */
    processOfflineUpload(record, onItemProgress, onItemProcessed) {
        /** @type {?} */
        const _self = this;
        _self.fileProviderService.onlineFileUpload(record.uploadConfig).then(successF, errorF);
        /**
         * @param {?} response
         * @return {?}
         */
        function successF(response) {
            onItemProgress(); // keep alive poller
            // keep alive poller
            /** @type {?} */
            const result = response.data;
            if (!result) {
                onItemProcessed(null, false); // false to ignore this file when changing its info in document
                logger$i.info('Error in File Upload. Did not receive appropriate response.');
                return;
            }
            // update the offline entry status to UPLOADED status
            record.status = _self.indexedDBService.constants.OFFLINE_STATUS_UPLOADED;
            _self.indexedDBService.saveFile(record);
            logger$i.info('File ' + record.fileNo + ' successfully uploaded via offline poller.');
            onItemProcessed(null, record);
        }
        /**
         * @param {?} response
         * @return {?}
         */
        function errorF(response) {
            onItemProgress(); // keep alive poller
            // keep alive poller
            /** @type {?} */
            let entryStatus;
            if (response.status === UtilHttpStatus.SERVER_UNRESPONSIVE) { // ignore these errors retry sending again
                entryStatus = _self.indexedDBService.constants.OFFLINE_STATUS_PENDING;
            }
            else { // else shall never be retried
                entryStatus = _self.indexedDBService.constants.OFFLINE_STATUS_FAILED;
            }
            record.status = entryStatus;
            // update the offline entry
            /** @type {?} */
            const errMsg = response.status + ': ' + UtilHttpStatus.getStatusText(response.status);
            /** @type {?} */
            const errCount = record.errorCount == null ? 1 : record.errorCount + 1;
            _self.indexedDBService.saveFile(record, errMsg, errCount);
            onItemProcessed(entryStatus);
        }
        /**
         * @param {?} response
         * @return {?}
         */
        function progressF(response) {
            // TODO: add progress indicator later
            onItemProgress();
        }
    }
}
IndexedDBQueueService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
IndexedDBQueueService.ctorParameters = () => [
    { type: HttpClient },
    { type: IndexedDBConnectorService },
    { type: IndexedDBService },
    { type: OfflineStatusService },
    { type: BroadcastService },
    { type: FileProviderService }
];
/** @nocollapse */ IndexedDBQueueService.ɵprov = ɵɵdefineInjectable({ factory: function IndexedDBQueueService_Factory() { return new IndexedDBQueueService(ɵɵinject(HttpClient), ɵɵinject(IndexedDBConnectorService), ɵɵinject(IndexedDBService), ɵɵinject(OfflineStatusService), ɵɵinject(BroadcastService), ɵɵinject(FileProviderService)); }, token: IndexedDBQueueService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    IndexedDBQueueService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    IndexedDBQueueService.prototype.indexedDBConnectorService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBQueueService.prototype.indexedDBService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBQueueService.prototype.offlineStatusService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBQueueService.prototype.broadcastService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBQueueService.prototype.fileProviderService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/indexeddb/indexed-dbproperties.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$j = console;
class IndexedDBPropertiesService {
    /**
     * @param {?} loggedInUserService
     * @param {?} indexedDBService
     */
    constructor(loggedInUserService, indexedDBService) {
        this.loggedInUserService = loggedInUserService;
        this.indexedDBService = indexedDBService;
    }
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    setItem(key, value) {
        if (!this.loggedInUserService.getUserConfigItem('cachingEnabled') === true) {
            logger$j.error('Attempting to use IndexedDBPropertiesService while caching disabled.');
            return Promise.reject(new Error('Offline is disabled.'));
        }
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const record = {
            key: key,
            value: value
        };
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.indexedDBService.saveEntry(IndexedDBConstants.FT_PROPERTIES_TABLE_NAME, record, (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                if (err) {
                    if (err.name === "OpenFailedError") {
                        reject(new Error('Offline is not supported in this browser. If using Private Mode, you may not be able to use it in this browser.'));
                    }
                    else {
                        reject(new Error('Error in setting IDBProperties key ' + key));
                    }
                }
                else {
                    resolve(record);
                }
            }));
        }));
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getItem(key) {
        /** @type {?} */
        const _self = this;
        if (!this.loggedInUserService.getUserConfigItem('cachingEnabled') === true) {
            logger$j.error('Attempting to use IndexedDBPropertiesService while caching disabled.');
            return Promise.reject('Offline is disabled.');
        }
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const tbl = IndexedDBConstants.FT_PROPERTIES_TABLE_NAME;
            /** @type {?} */
            const index = IndexedDBConstants.FT_PROPERTIES_TABLE_INDEX_KEY;
            _self.indexedDBService.getEntries(tbl, index, key, (/**
             * @param {?} entries
             * @return {?}
             */
            function (entries) {
                if (entries.length > 0) {
                    resolve(entries[0]); // get first item.
                }
                else {
                    reject(new Error('Error in getting IDBProperties key ' + key));
                }
            }));
        }));
    }
    /**
     * @param {?} key
     * @return {?}
     */
    removeItem(key) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const tbl = IndexedDBConstants.FT_PROPERTIES_TABLE_NAME;
            /** @type {?} */
            const index = IndexedDBConstants.FT_PROPERTIES_TABLE_INDEX_KEY;
            _self.indexedDBService.deleteEntries(tbl, index, key, (/**
             * @param {?} err
             * @param {?} count
             * @return {?}
             */
            function (err, count) {
                if (count === 0) {
                    logger$j.info('No entry to remove for key: ' + key);
                }
                resolve(true);
            }));
        }));
    }
}
IndexedDBPropertiesService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
IndexedDBPropertiesService.ctorParameters = () => [
    { type: LoggedInUserService },
    { type: IndexedDBService }
];
/** @nocollapse */ IndexedDBPropertiesService.ɵprov = ɵɵdefineInjectable({ factory: function IndexedDBPropertiesService_Factory() { return new IndexedDBPropertiesService(ɵɵinject(LoggedInUserService), ɵɵinject(IndexedDBService)); }, token: IndexedDBPropertiesService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    IndexedDBPropertiesService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    IndexedDBPropertiesService.prototype.indexedDBService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/user/user-settings.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UserSettingsService {
    /**
     * @param {?} localStorageService
     */
    constructor(localStorageService) {
        this.localStorageService = localStorageService;
    }
    /**
     * @private
     * @param {?} userSettings
     * @param {?} templateId
     * @param {?} name
     * @param {?} settings
     * @param {?} value
     * @return {?}
     */
    fillSettingsObject(userSettings, templateId, name, settings, value) {
        if (!userSettings[templateId]) {
            userSettings[templateId] = {};
        }
        if (!userSettings[templateId][name]) {
            userSettings[templateId][name] = {};
        }
        userSettings[templateId][name][settings] = value;
        return userSettings;
    }
    /**
     * @param {?} templateId
     * @param {?} name
     * @param {?} settings
     * @param {?} value
     * @return {?}
     */
    saveSettings(templateId, name, settings, value) {
        /** @type {?} */
        let userSettings = this.localStorageService.getItem(LocalStorageKeys.USER_SETTINGS);
        if (userSettings) {
            try {
                userSettings = JSON.parse(userSettings);
            }
            catch (e) {
                userSettings = {};
            }
            finally {
                userSettings = this.fillSettingsObject(userSettings, templateId, name, settings, value);
            }
        }
        else {
            userSettings = {};
            userSettings = this.fillSettingsObject(userSettings, templateId, name, settings, value);
        }
        this.localStorageService.setItem(LocalStorageKeys.USER_SETTINGS, JSON.stringify(userSettings));
    }
    /**
     * @param {?} templateId
     * @param {?} name
     * @param {?} settings
     * @return {?}
     */
    getSettings(templateId, name, settings) {
        /** @type {?} */
        let userSettings = this.localStorageService.getItem(LocalStorageKeys.USER_SETTINGS);
        if (userSettings) {
            try {
                userSettings = JSON.parse(userSettings);
                if (userSettings[templateId]
                    && userSettings[templateId][name]
                    && userSettings[templateId][name][settings]) {
                    return userSettings[templateId][name][settings];
                }
            }
            catch (e) { }
        }
        return null;
    }
}
UserSettingsService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
UserSettingsService.ctorParameters = () => [
    { type: LocalStorageService }
];
/** @nocollapse */ UserSettingsService.ɵprov = ɵɵdefineInjectable({ factory: function UserSettingsService_Factory() { return new UserSettingsService(ɵɵinject(LocalStorageService)); }, token: UserSettingsService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    UserSettingsService.prototype.localStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/offline/offline-util.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class OfflineUtilService {
    constructor() { }
    /**
     * @param {?} url
     * @return {?}
     */
    getNextId(url) {
        return UtilDocumentId.generateId();
    }
}
OfflineUtilService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
OfflineUtilService.ctorParameters = () => [];
/** @nocollapse */ OfflineUtilService.ɵprov = ɵɵdefineInjectable({ factory: function OfflineUtilService_Factory() { return new OfflineUtilService(); }, token: OfflineUtilService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/modified-field.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$k = console;
class ModifiedFieldService {
    /**
     * @param {?} documentService
     * @param {?} clientAccessService
     * @param {?} unsavedDocumentService
     * @param {?} broadcastService
     */
    constructor(documentService, clientAccessService, unsavedDocumentService, broadcastService) {
        this.documentService = documentService;
        this.clientAccessService = clientAccessService;
        this.unsavedDocumentService = unsavedDocumentService;
        this.broadcastService = broadcastService;
        // list of modified fields in a document
        this.modifiedFields = {};
        // controls the dirty checking
        this.formDirty = {
            showSpinner: false,
            isSaving: false,
            dirty: false,
            updateAllowed: false,
            validating: null
        };
        this.user$.subscribe((/**
         * @param {?} user
         * @return {?}
         */
        (user) => {
            this.user = user;
        }));
    }
    /**
     * @private
     * @param {?} targetDocument
     * @return {?}
     */
    canUpdateDoc(targetDocument) {
        if (!targetDocument) {
            return false;
        }
        // if the document is new
        if (targetDocument.systemHeader && !targetDocument.systemHeader.createdDate) {
            // check if user can create
            return this.clientAccessService.checkAccess(targetDocument, SharedConstants.OPERATION_TYPE_CREATE);
        }
        else {
            // check if user can update
            return this.clientAccessService.checkAccess(targetDocument, SharedConstants.OPERATION_TYPE_UPDATE);
        }
    }
    /**
     * Check if the current form is dirty, that make the save button appear and blink or display unsaved changes dialog
     * @return {?}
     */
    isDirty() {
        return this.formDirty.dirty;
    }
    /**
     * @param {?} documentListId
     * @return {?}
     */
    shouldApplyFlags(documentListId) {
        /** @type {?} */
        const unsavedDocInfo = this.unsavedDocumentService.getUnsavedDocumentInfo(documentListId);
        if ((unsavedDocInfo === null || unsavedDocInfo === void 0 ? void 0 : unsavedDocInfo.name) !== ClientConstants.DIALOG_DOCUMENT_INFO_LIST) {
            return true;
        }
        return false;
    }
    /**
     * Set current form to be dirty, that make the save button appear and blink
     * @param {?} isDirty is dirty
     * @param {?=} documentId the document id
     * @param {?=} unsavedDocumentListId
     * @return {?}
     */
    setDirty(isDirty, documentId, unsavedDocumentListId) {
        if (!this.shouldApplyFlags(unsavedDocumentListId)) {
            return;
        }
        if (isDirty !== this.formDirty.dirty) {
            // don't set the dirty value if save is in progress. Any change in a presave server rule will go into the save. The
            // isSaving flag should have been cleared by the time of a postSave rule so that the save button will appear if the
            // document is changed in the postSave rule
            if (isDirty) {
                if (!this.formDirty.isSaving) {
                    if (this.formDirty.updateAllowed) {
                        this.formDirty.dirty = isDirty;
                    }
                    else {
                        /** @type {?} */
                        const targetDoc = this.documentService.getExistingDocument(documentId);
                        if (this.canUpdateDoc(targetDoc)) {
                            this.formDirty.dirty = isDirty;
                        }
                    }
                }
            }
            else {
                this.formDirty.dirty = false;
            }
        }
        this.broadcastService.broadcast(ClientConstants.FORM_DIRTY_UPDATED, this.formDirty);
    }
    /**
     * @param {?} showSpinner
     * @param {?=} unsavedDocumentListId
     * @return {?}
     */
    setShowSpinner(showSpinner, unsavedDocumentListId) {
        if (!this.shouldApplyFlags(unsavedDocumentListId)) {
            return;
        }
        this.formDirty.showSpinner = showSpinner;
        this.broadcastService.broadcast(ClientConstants.SPINNER_UPDATED, showSpinner);
    }
    /**
     * Allow this form to be updatable.
     * @param {?} isAllowedUpdate is allowed update
     * @return {?}
     */
    setUpdateAllowed(isAllowedUpdate) {
        this.formDirty.updateAllowed = isAllowedUpdate;
    }
    /**
     * Reset the current form to its un-interacted state.
     * @return {?}
     */
    resetFormDirty() {
        this.setDirty(false);
    }
    /**
     * Sets the current form to be updatable depending on the current user's privileges.
     * @param {?} docData the doc data object
     * @return {?}
     */
    setFormAccess(docData) {
        this.setUpdateAllowed(false); // default to false
        // default to false
        /** @type {?} */
        const userAccount = this.user ? this.user.account : null;
        // do not allow update
        if (!docData || !userAccount) {
            return;
        }
        if (this.canUpdateDoc(docData)) {
            this.setUpdateAllowed(true);
        }
    }
    /**
     * @return {?}
     */
    isSaving() {
        return this.formDirty.isSaving;
    }
    /**
     * @param {?} isSaving
     * @param {?=} unsavedDocumentListId
     * @return {?}
     */
    setSaveFlag(isSaving, unsavedDocumentListId) {
        if (!this.shouldApplyFlags(unsavedDocumentListId)) {
            return;
        }
        this.formDirty.isSaving = isSaving;
    }
    /*
       * This method is used to add modified field by document id.
       * Before adding should check whether the version of the document has changed from the original because
       * there is a case reset current document from the one returned from server once it is saved.
       * @returns: true if adding successfully, otherwise: false
       */
    /**
     * @param {?} documentId
     * @param {?} changedFieldName
     * @param {?} documentListId
     * @param {?=} shouldCompareDocuments
     * @param {?=} overrideTemplateId
     * @return {?}
     */
    addModifiedField(documentId, changedFieldName, documentListId, shouldCompareDocuments, overrideTemplateId) {
        if (this.formDirty.isSaving) {
            logger$k.info('Document is saving. Ignore adding modified field.');
            return;
        }
        /** @type {?} */
        let result = false;
        if (!documentListId) {
            logger$k.error('Document list id not provided in addModifiedField');
        }
        else if (!documentId) {
            logger$k.error('Document id not provided in addModifiedField');
        }
        else if (!changedFieldName) {
            logger$k.error('Changed field name not provided in addModifiedField');
        }
        else if (!this.unsavedDocumentService.isDocumentsDefined(documentListId)) {
            logger$k.info('Unsaved Document List is not found');
        }
        else {
            /** @type {?} */
            let shouldAdd = false;
            if (shouldCompareDocuments === undefined || shouldCompareDocuments === true) {
                shouldAdd = this.isChangedField(documentId, changedFieldName, documentListId, overrideTemplateId);
            }
            else {
                shouldAdd = true;
            }
            if (shouldAdd) {
                if (!this.modifiedFields[documentId]) {
                    this.modifiedFields[documentId] = {};
                }
                this.modifiedFields[documentId][changedFieldName] = true;
                this.modifiedFields[documentId][ClientConstants.CHANGED_DOCUMENT_LIST_ID_KEY] = documentListId;
                this.setDirty(true, documentId, documentListId);
                logger$k.info('Adding new modified field. Doc: ' + documentId + ' - field: ' + changedFieldName);
                logger$k.info('Stored modified fields: ' + JSON.stringify(this.modifiedFields));
                result = true;
            }
        }
        return result;
    }
    /**
     * @return {?}
     */
    resetModifiedFields() {
        logger$k.info('Resetting all modified fields...');
        this.modifiedFields = {};
        this.broadcastService.broadcast(ClientConstants.FORM_RESET);
    }
    // Remove all changed fields of a document
    /**
     * @param {?} documentId
     * @return {?}
     */
    removeModifiedDocumentFields(documentId) {
        logger$k.info('Resetting all modified fields of a document...');
        delete this.modifiedFields[documentId];
    }
    // Remove all changed fields of a template
    /**
     * @param {?} templateId
     * @return {?}
     */
    removeTemplateFields(templateId) {
        logger$k.info('Removing changed fields of template: ' + templateId);
        delete this.modifiedFields[templateId];
    }
    /**
     * @param {?} documentId
     * @param {?} changedFieldName
     * @return {?}
     */
    removeChangedField(documentId, changedFieldName) {
        logger$k.warn('DEPRECATED: Please call ModifiedFieldService.removeModifiedField ' +
            'instead of ModifiedFieldService.removeChangedField');
        this.removeModifiedField(documentId, changedFieldName);
    }
    /**
     * @param {?} documentId
     * @param {?} changedFieldName
     * @return {?}
     */
    removeModifiedField(documentId, changedFieldName) {
        if (this.modifiedFields[documentId]) {
            logger$k.info('Removing changed field: ' + changedFieldName + ' of document: ' + documentId);
            delete this.modifiedFields[documentId][changedFieldName];
        }
        if (!this.hasAnyChanged()) {
            this.setDirty(false);
        }
    }
    /**
     * @param {?} documentId
     * @param {?} changedFieldName
     * @param {?} documentListId
     * @param {?=} overrideTemplateId
     * @return {?}
     */
    isChangedField(documentId, changedFieldName, documentListId, overrideTemplateId) {
        try {
            /** @type {?} */
            const currentDoc = this.unsavedDocumentService.getDocumentOnly(documentId);
            /** @type {?} */
            const currentOriginalDoc = this.documentService.getExistingDocument(documentId);
            if (currentDoc && !currentOriginalDoc || // create doc mode
                (currentDoc && currentOriginalDoc && // modify doc && component editor mode
                    !isEqual(currentDoc[changedFieldName], currentOriginalDoc[changedFieldName])) ||
                (overrideTemplateId && !isEqual(currentDoc, currentOriginalDoc))) { // override template
                return true;
            }
        }
        catch (e) {
        }
        return false;
    }
    /**
     * whether the document has changed
     * @param {?} documentId the document id
     * @return {?} the result
     */
    hasChanged(documentId) {
        logger$k.info('Checking changed document. Stored modified fields: ' + JSON.stringify(this.modifiedFields));
        /** @type {?} */
        const changes = this.getModifiedFieldsInDoc(documentId);
        return changes.length > 0;
    }
    /**
     * whether any documents have been changed
     * @return {?} the result
     */
    hasAnyChanged() {
        /** @type {?} */
        const documentIds = Object.keys(this.modifiedFields);
        if (documentIds) {
            for (let id = 0; id < documentIds.length; id++) {
                /** @type {?} */
                const infos = Object.keys(this.modifiedFields[documentIds[id]]);
                for (let i = 0; i < infos.length; i++) {
                    /** @type {?} */
                    const key = infos[i];
                    if (key !== ClientConstants.CHANGED_DOCUMENT_LIST_ID_KEY) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    /**
     * get the unsaved documents for the unsaved document list. This needs to be separate from UnsavedDocumentService to avoid
     * a circular dependency of Angular service injections
     * @param {?} unsavedDocumentListId - the id of the list to get the changed docs for
     * @return {?}
     */
    getModifiedDocuments(unsavedDocumentListId) {
        if (!unsavedDocumentListId) {
            throw new Error('Unsaved document list id not specified when getting loaded documents');
        }
        /** @type {?} */
        const self = this;
        /** @type {?} */
        const loadedDocs = this.unsavedDocumentService.getUnsavedDocuments(unsavedDocumentListId);
        // only return documents that have unsaved changes. Load the modified docs into unsavedDocs
        /** @type {?} */
        const unsavedDocs = [];
        if (loadedDocs) {
            loadedDocs.forEach((/**
             * @param {?} loadedDoc
             * @return {?}
             */
            function (loadedDoc) {
                if (self.hasChanged(loadedDoc.documentId)) {
                    unsavedDocs.push(loadedDoc);
                }
            }));
        }
        return unsavedDocs;
    }
    /**
     * @param {?} documentId
     * @return {?}
     */
    getChangedDocumentListId(documentId) {
        return this.modifiedFields[documentId] ?
            this.modifiedFields[documentId][ClientConstants.CHANGED_DOCUMENT_LIST_ID_KEY] : null;
    }
    /**
     * @return {?}
     */
    getAllChangedDocumentListIds() {
        /** @type {?} */
        const tmp = [];
        /** @type {?} */
        const keys = Object.keys(this.modifiedFields);
        for (let i = 0; i < keys.length; i++) {
            if (this.modifiedFields[keys[i]][ClientConstants.CHANGED_DOCUMENT_LIST_ID_KEY]) {
                tmp.push(this.modifiedFields[keys[i]][ClientConstants.CHANGED_DOCUMENT_LIST_ID_KEY]);
            }
        }
        return tmp;
    }
    /**
     * @param {?} documentId
     * @return {?}
     */
    getModifiedFieldsInDoc(documentId) {
        /** @type {?} */
        const changedFieldNames = [];
        /** @type {?} */
        const info = this.modifiedFields[documentId];
        if (info) {
            /** @type {?} */
            const keys = Object.keys(info);
            for (let i = 0; i < keys.length; i++) {
                /** @type {?} */
                const key = keys[i];
                if (key !== ClientConstants.CHANGED_DOCUMENT_LIST_ID_KEY) {
                    changedFieldNames.push(key);
                }
            }
        }
        return changedFieldNames;
    }
}
ModifiedFieldService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ModifiedFieldService.ctorParameters = () => [
    { type: DocumentService },
    { type: ClientAccessService },
    { type: UnsavedDocumentService },
    { type: BroadcastService }
];
/** @nocollapse */ ModifiedFieldService.ɵprov = ɵɵdefineInjectable({ factory: function ModifiedFieldService_Factory() { return new ModifiedFieldService(ɵɵinject(DocumentService), ɵɵinject(ClientAccessService), ɵɵinject(UnsavedDocumentService), ɵɵinject(BroadcastService)); }, token: ModifiedFieldService, providedIn: "root" });
__decorate([
    select(['userState', 'user']),
    __metadata("design:type", Observable)
], ModifiedFieldService.prototype, "user$", void 0);
if (false) {
    /** @type {?} */
    ModifiedFieldService.prototype.user$;
    /** @type {?} */
    ModifiedFieldService.prototype.user;
    /** @type {?} */
    ModifiedFieldService.prototype.modifiedFields;
    /** @type {?} */
    ModifiedFieldService.prototype.formDirty;
    /**
     * @type {?}
     * @private
     */
    ModifiedFieldService.prototype.documentService;
    /**
     * @type {?}
     * @private
     */
    ModifiedFieldService.prototype.clientAccessService;
    /**
     * @type {?}
     * @private
     */
    ModifiedFieldService.prototype.unsavedDocumentService;
    /**
     * @type {?}
     * @private
     */
    ModifiedFieldService.prototype.broadcastService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/template-html.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$l = console;
class TemplateHtmlService {
    /**
     * @param {?} factoryResolver
     */
    constructor(factoryResolver) {
        this.factoryResolver = factoryResolver;
    }
    /**
     * add the component to the view as a custom element
     * @param {?} componentDefinition
     * @param {?} documentData
     * @param {?} formParameters
     * @param {?} user
     * @param {?} key
     * @param {?} vcr
     * @param {?} dynamicContainerComponent
     * @return {?}
     */
    appendComponent(componentDefinition, documentData, formParameters, user, key, vcr, dynamicContainerComponent) {
        if (componentDefinition.componentName) {
            /** @type {?} */
            const factory = this.factoryResolver.resolveComponentFactory(dynamicContainerComponent);
            /** @type {?} */
            const component = factory.create(vcr.parentInjector);
            component.instance.formParameters = formParameters;
            component.instance.tplItem = componentDefinition;
            component.instance.documentData = documentData;
            component.instance.key = key;
            component.instance.user = user.filteredAccount;
            vcr.insert(component.hostView);
            // render a not found component if the component does not exist
            // const componentName = componentDefinition.componentName
            // const customElement = renderer.createElement(componentName);
            //
            // // pass the parameters of the component to the custom element
            // customElement.componentDefinition = componentDefinition;
            // customElement.document = documentData.document;
            // customElement.template = documentData.template;
            // customElement.formParameters = formParameters;
            // customElement.key = key;
            // customElement.account = user.filteredAccount;
            // customElement.fieldName = componentDefinition.name;
            // if (documentData.document) {
            //     customElement.fieldValue = documentData.document[componentDefinition.name];
            // }
            //
            // // insertBefore element to container
            // renderer.appendChild(el.nativeElement, customElement);
        }
    }
}
TemplateHtmlService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
TemplateHtmlService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [ComponentFactoryResolver,] }] }
];
if (false) {
    /** @type {?} */
    TemplateHtmlService.prototype.factoryResolver;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/component/component.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$m = console;
class ComponentService {
    /**
     * @param {?} http
     * @param {?} notificationService
     * @param {?} templateHtmlService
     * @param {?} configService
     */
    constructor(http, notificationService, templateHtmlService, configService) {
        this.http = http;
        this.notificationService = notificationService;
        this.templateHtmlService = templateHtmlService;
        this.configService = configService;
        this.loadedComponentDocs = {};
        this.loadedComponents = {};
        this.loadedVendorLibs = {};
    }
    /**
     * @param {?} vendorLibs
     * @return {?}
     */
    loadVendorLibs(vendorLibs) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const vendorLibraryBasePath = this.configService.clientConfig().vendorLibraryBasePath || '';
            return new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            (resolve, reject) => {
                eachSeries(vendorLibs, (/**
                 * @param {?} fileName
                 * @param {?} next
                 * @return {?}
                 */
                (fileName, next) => {
                    if (!this.loadedVendorLibs[fileName]) {
                        /** @type {?} */
                        const item = vendorLibs[fileName];
                        fileName = fileName.replace('${vendorLibraryBasePath}', vendorLibraryBasePath);
                        loadjs([fileName], {
                            returnPromise: true
                        }).then((/**
                         * @return {?}
                         */
                        () => {
                            this.loadedVendorLibs[fileName] = true;
                            next(null);
                        }), (/**
                         * @param {?} err
                         * @return {?}
                         */
                        (err) => {
                            next();
                            /** @type {?} */
                            const msg = 'Error loading component vendor library: ' + fileName;
                            console.log(msg);
                            this.notificationService.error(msg);
                        }));
                    }
                    else {
                        next();
                    }
                }), (/**
                 * @param {?} errorMsg
                 * @return {?}
                 */
                function (errorMsg) {
                    if (errorMsg) {
                        reject(new Error(errorMsg));
                    }
                    resolve();
                }));
            }));
        });
    }
    /**
     * @param {?} template
     * @return {?}
     */
    loadTemplateVendorLibs(template) {
        return __awaiter(this, void 0, void 0, function* () {
            if (template && template.vendorLibrariesRel) {
                /** @type {?} */
                const templateVendorLibs = this.getFileNamesFromVendorLib(template.vendorLibrariesRel);
                yield this.loadVendorLibs(templateVendorLibs);
            }
        });
    }
    /**
     * @param {?} componentDefs
     * @param {?} documentData
     * @param {?} formParameters
     * @param {?} user
     * @param {?} vcr
     * @param {?} dynamicContainerComponent
     * @return {?}
     */
    registerComponents(componentDefs, documentData, formParameters, user, vcr, dynamicContainerComponent) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!componentDefs) {
                return Promise.resolve();
            }
            /** @type {?} */
            const _self = this;
            /** @type {?} */
            let key = 0;
            eachSeries(componentDefs, (/**
             * @param {?} componentDef
             * @param {?} next
             * @return {?}
             */
            (componentDef, next) => {
                /** @type {?} */
                const directiveName = componentDef.componentName;
                if (directiveName && !startsWith(directiveName, 'ft-') && !startsWith(directiveName, 'cc-')) {
                    /** @type {?} */
                    const componentName = componentDef.componentName;
                    /** @type {?} */
                    const promise = _self.loadComponentDocAndVendorLibs(componentName).then((/**
                     * @return {?}
                     */
                    function successFunc() {
                        componentDef.componentName = _self.componentDocExists(componentDef.componentName) ?
                            componentDef.componentName : 'ft-component-error';
                        _self.templateHtmlService.appendComponent(componentDef, documentData, formParameters, user, key, vcr, dynamicContainerComponent);
                        key++;
                        next();
                    }));
                }
            }), (/**
             * @param {?} errorMsg
             * @return {?}
             */
            function (errorMsg) {
                if (errorMsg) {
                    return Promise.reject(new Error(errorMsg));
                }
                return Promise.resolve();
            }));
        });
    }
    /**
     * @private
     * @param {?} vendorLibrariesRel
     * @return {?}
     */
    getFileNamesFromVendorLib(vendorLibrariesRel) {
        /** @type {?} */
        const fileNames = [];
        if (vendorLibrariesRel && vendorLibrariesRel.length) {
            vendorLibrariesRel.forEach((/**
             * @param {?} vendorLib
             * @return {?}
             */
            (vendorLib) => {
                if (vendorLib.fileName) {
                    /** @type {?} */
                    const fileName = vendorLib.fileName;
                    if (!isEmpty(fileName) && !this.loadedVendorLibs[fileName]) {
                        fileNames.push(fileName);
                    }
                }
                else if (vendorLib.fileNames) {
                    fileNames.push(...vendorLib.fileNames);
                }
            }));
        }
        return fileNames;
    }
    /**
     * Load component document
     * @param {?} directiveName the directive name
     * @return {?} the promise of component doc
     */
    loadComponentDoc(directiveName) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const url = 'api/loadComponentDoc/' + directiveName;
            try {
                /** @type {?} */
                const result = yield this.http.get(url).toPromise();
                if (result === 404) {
                    throw new Error(`Component ${directiveName} not found.`);
                }
                return result;
            }
            catch (err) {
                throw new Error(err.message || 'Something went wrong when getting custom component document.');
            }
        });
    }
    /**
     * whether the component has been loaded
     * @param {?} directiveName the directive name
     * @return {?} the result
     */
    componentExists(directiveName) {
        return this.loadedComponents[directiveName];
    }
    /**
     * whether the component doc has been loaded
     * @param {?} directiveName the directive name
     * @return {?} the result
     */
    componentDocExists(directiveName) {
        return !!this.loadedComponentDocs[directiveName];
    }
    /**
     * @param {?} componentName
     * @return {?}
     */
    loadComponentDocAndVendorLibs(componentName) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (!_self.componentDocExists(componentName)) {
                _self.loadComponentDoc(componentName).then((/**
                 * @param {?} componentDoc
                 * @return {?}
                 */
                function successFunc(componentDoc) {
                    _self.loadedComponentDocs[componentName] = componentDoc;
                    /** @type {?} */
                    const compVendorLibRels = componentDoc.vendorLibrariesRel;
                    if (compVendorLibRels && compVendorLibRels.length) {
                        /** @type {?} */
                        const compVendorLibRel = componentDoc.vendorLibrariesRel;
                        /** @type {?} */
                        const compVendorLibs = _self.getFileNamesFromVendorLib(compVendorLibRel);
                        _self.loadVendorLibs(compVendorLibs).then((/**
                         * @return {?}
                         */
                        function sFunc() {
                            resolve(componentDoc);
                        }), (/**
                         * @return {?}
                         */
                        function eFunc() {
                            resolve(componentDoc);
                        }));
                    }
                    else {
                        resolve(componentDoc);
                    }
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function error(err) {
                    _self.loadedComponentDocs[componentName] = null;
                    // do not break the chain in order to load the next component document
                    resolve(null);
                }));
            }
            else {
                resolve(_self.loadedComponentDocs[componentName]);
            }
        }));
    }
}
ComponentService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ComponentService.ctorParameters = () => [
    { type: HttpClient },
    { type: NotificationService },
    { type: TemplateHtmlService },
    { type: ConfigService }
];
if (false) {
    /** @type {?} */
    ComponentService.prototype.loadedComponentDocs;
    /** @type {?} */
    ComponentService.prototype.loadedComponents;
    /**
     * @type {?}
     * @private
     */
    ComponentService.prototype.loadedVendorLibs;
    /**
     * @type {?}
     * @private
     */
    ComponentService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    ComponentService.prototype.notificationService;
    /**
     * @type {?}
     * @private
     */
    ComponentService.prototype.templateHtmlService;
    /**
     * @type {?}
     * @private
     */
    ComponentService.prototype.configService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/preprocessor/custom-field/custom-field-preprocessor.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$n = console;
class CustomFieldPreprocessorService {
    /**
     * @param {?} componentService
     */
    constructor(componentService) {
        this.componentService = componentService;
    }
    /**
     * @param {?} field
     * @param {?} document
     * @return {?}
     */
    preProcess(field, document) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.componentService.loadComponentDoc(field.componentName).then((/**
             * @param {?} component
             * @return {?}
             */
            function foundFunc(component) {
                try {
                    /** @type {?} */
                    const customFunc = component.clientPreprocessorFunction;
                    if (UtilValidation.hasValue(customFunc)) {
                        /** @type {?} */
                        const clientPreprocessorFunc = Function('return (' + customFunc + ')')();
                        if (component.preprocessorIsAsynchronous) {
                            clientPreprocessorFunc(field, document).then((/**
                             * @param {?} retVal
                             * @return {?}
                             */
                            function (retVal) {
                                resolve(retVal);
                            }), (/**
                             * @param {?} error
                             * @return {?}
                             */
                            function (error) {
                                reject(error);
                            }));
                        }
                        else {
                            /** @type {?} */
                            const retVal = clientPreprocessorFunc(field, document);
                            resolve(retVal);
                        }
                    }
                    else {
                        resolve(document);
                    }
                }
                catch (err) {
                    /** @type {?} */
                    const errMsg = ('Error in running custom component preprocessor function : ' + err);
                    logger$n.debug(errMsg);
                    reject(errMsg);
                }
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function notFoundFunc(err) {
                reject(err);
            }));
        }));
    }
}
CustomFieldPreprocessorService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CustomFieldPreprocessorService.ctorParameters = () => [
    { type: ComponentService }
];
/** @nocollapse */ CustomFieldPreprocessorService.ɵprov = ɵɵdefineInjectable({ factory: function CustomFieldPreprocessorService_Factory() { return new CustomFieldPreprocessorService(ɵɵinject(ComponentService)); }, token: CustomFieldPreprocessorService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CustomFieldPreprocessorService.prototype.componentService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/preprocessor/related-document.preprocessor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const cleanRelatedDocs = (/**
 * @param {?} docs
 * @return {?}
 */
function (docs) {
    // remove _uiSelectChoiceLocked field
    for (let i = 0; i < docs.length; i++) {
        if ('_uiSelectChoiceLocked' in docs[i]) {
            delete docs[i]['_uiSelectChoiceLocked'];
        }
    }
});
const ɵ0$1 = cleanRelatedDocs;
/** @type {?} */
const formatValueInDocument = (/**
 * @param {?} tplItem
 * @param {?} document
 * @return {?}
 */
function (tplItem, document) {
    /** @type {?} */
    const field = tplItem.name;
    /** @type {?} */
    const relatedFields = tplItem.relatedFields;
    if (document[field]) {
        for (let i = 0; i < document[field].length; i++) {
            /** @type {?} */
            const value = document[field][i];
            // if the value is in ElasticSearch format, convert it to the required related document format
            if (value._source) {
                /** @type {?} */
                const formattedValue = {
                    documentId: value._source.documentId,
                    name: ''
                };
                if (value._source.systemHeader.summaryName) {
                    formattedValue.name = value._source.systemHeader.summaryName;
                }
                if (relatedFields) {
                    /** @type {?} */
                    const keys = Object.keys(relatedFields);
                    for (let idx = 0; idx < keys.length; idx++) {
                        /** @type {?} */
                        const key = keys[idx];
                        /** @type {?} */
                        const val = relatedFields[key];
                        if (value._source[val]) {
                            formattedValue[key] = value._source[val];
                        }
                    }
                }
                document[field][i] = formattedValue;
            }
        }
    }
});
const ɵ1$1 = formatValueInDocument;
const ɵ2$1 = /**
 * @param {?} field
 * @param {?} document
 * @return {?}
 */
function (field, document) {
    if (document[field.name]) {
        cleanRelatedDocs(document[field.name]);
        formatValueInDocument(field, document);
    }
};
/** @type {?} */
const RelatedDocumentPreprocessor = {
    preProcess: (ɵ2$1),
    formatValueInDocument: formatValueInDocument
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/preprocessor/pre-processor-field.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreProcessorFieldService {
    /**
     * @param {?} customFieldPreprocessorService
     */
    constructor(customFieldPreprocessorService) {
        this.customFieldPreprocessorService = customFieldPreprocessorService;
    }
    /**
     * @param {?} field
     * @param {?} document
     * @return {?}
     */
    preProcessOneField(field, document) {
        if (SharedConstants.FIELD_TYPE_RELATED === field.type) {
            RelatedDocumentPreprocessor.preProcess(field, document);
        }
    }
    /**
     * @param {?} template
     * @param {?} document
     * @return {?}
     */
    preProcessField(template, document) {
        if (template && template.components) {
            for (let i = 0; i < template.components.length; i++) {
                /** @type {?} */
                const field = template.components[i];
                this.preProcessOneField(field, document);
            }
        }
    }
    /**
     * @private
     * @param {?} component
     * @return {?}
     */
    isCustomPreProcessor(component) {
        return component.componentName && !component.componentName.startsWith('ft-');
    }
    /**
     * @param {?} template
     * @param {?} document
     * @return {?}
     */
    preProcess(template, document) {
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const promises = [];
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (template && template.components) {
                template.components.forEach((/**
                 * @param {?} component
                 * @return {?}
                 */
                function (component) {
                    if (_self.isCustomPreProcessor(component)) {
                        promises.push(_self.customFieldPreprocessorService.preProcess(component, document));
                    }
                }));
                if (promises.length > 0) {
                    Promise.all(promises).then((/**
                     * @return {?}
                     */
                    function successFunc() {
                        resolve(promises.length);
                    }), (/**
                     * @param {?} err
                     * @return {?}
                     */
                    function errorFunc(err) {
                        reject(err);
                    }));
                }
                else {
                    resolve(0);
                }
            }
            else {
                resolve(0);
            }
        }));
    }
}
PreProcessorFieldService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
PreProcessorFieldService.ctorParameters = () => [
    { type: CustomFieldPreprocessorService }
];
/** @nocollapse */ PreProcessorFieldService.ɵprov = ɵɵdefineInjectable({ factory: function PreProcessorFieldService_Factory() { return new PreProcessorFieldService(ɵɵinject(CustomFieldPreprocessorService)); }, token: PreProcessorFieldService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    PreProcessorFieldService.prototype.customFieldPreprocessorService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/rules/client-rule-context.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$o = console;
class RuleContext {
    /**
     * @param {?} superObj
     * @param {?} eventName
     * @param {?} processDoc
     * @param {?} documentContext
     */
    constructor(superObj, eventName, processDoc, documentContext) {
        this.superObj = superObj;
        this.currentEventName = eventName;
        this.currentDocument = processDoc;
        this.currentTemplate = documentContext.template;
        this.currentDocumentContext = documentContext;
    }
    /**
     * @param {?} field
     * @param {?} flag
     * @return {?}
     */
    showField(field, flag) {
        this.setFieldFlag(field, 'visible', flag);
    }
    /**
     * @param {?} fields
     * @param {?} flag
     * @return {?}
     */
    showFields(fields, flag) {
        this.setFieldFlags(fields, 'visible', flag);
    }
    /**
     * @param {?} field
     * @param {?} flag
     * @return {?}
     */
    enableField(field, flag) {
        this.setFieldFlag(field, 'enabled', flag);
    }
    /**
     * @param {?} fields
     * @param {?} flag
     * @return {?}
     */
    enableFields(fields, flag) {
        this.setFieldFlags(fields, 'enabled', flag);
    }
    /**
     * @param {?} fields
     * @return {?}
     */
    filterAndSetAffectedDoc(fields) {
        /** @type {?} */
        const res = [];
        for (let i = 0; i < fields.length; i++) {
            /** @type {?} */
            let examDoc = this.determineAffectedDoc(fields[i]);
            if (this.affectedDoc) {
                /** @type {?} */
                const field = examDoc.docField;
                /** @type {?} */
                let tplItem = this.loadTplItem(field);
                if (!tplItem) {
                    logger$o.warn('Template does not contain field: ' + field + ' to mandate.');
                }
                else {
                    res.push(field);
                }
            }
        }
        return res;
    }
    /**
     * @param {?} field
     * @param {?} flag
     * @return {?}
     */
    mandateField(field, flag) {
        /** @type {?} */
        const examDoc = this.determineAffectedDoc(field);
        if (this.affectedDoc) {
            if (flag !== undefined) {
                /** @type {?} */
                const tplItem = this.loadTplItem(examDoc.docField);
                if (!tplItem) {
                    logger$o.warn('Template does not contain field: ' + field + ' to mandate.');
                    return;
                }
                /** @type {?} */
                const result = (flag === 'yes' || flag === 'true' || flag === true);
                this.superObj.dispatchStoreAction(formSetComponentFlagTemplate(this.affectedTpl.documentId, examDoc.docField, 'mandatory', result));
                if (!result) {
                    this.superObj.setValidationValue(this.affectedDoc, examDoc.docField, 'required', false);
                }
                this.superObj.broadcastService.broadcast(ClientConstants.FORM_DETECT_CHANGES, true);
            }
        }
    }
    /**
     * @param {?} fields
     * @param {?} flag
     * @return {?}
     */
    mandateFields(fields, flag) {
        /** @type {?} */
        const resFields = this.filterAndSetAffectedDoc(fields);
        if (resFields.length) {
            /** @type {?} */
            const result = (flag === 'yes' || flag === 'true' || flag === true);
            this.superObj.dispatchStoreAction(formSetListComponentsFlagTemplate(this.affectedTpl.documentId, resFields, 'mandatory', result));
            if (!result) {
                for (let i = 0; i < resFields.length; i++) {
                    this.superObj.setValidationValue(this.affectedDoc, resFields[i], 'required', false);
                }
            }
            this.superObj.broadcastService.broadcast(ClientConstants.FORM_DETECT_CHANGES, true);
        }
    }
    /**
     * @param {?} field
     * @param {?} value
     * @param {?} tmp
     * @return {?}
     */
    setFieldValue(field, value, tmp) {
        /** @type {?} */
        const examDoc = this.determineAffectedDoc(field);
        if (this.affectedDoc) {
            if (tmp) {
                logger$o.warn('Please use function setFieldValue(field, value) instead of setFieldValue(doc, field, value)');
                this.affectedDoc[value] = tmp;
            }
            else {
                this.affectedDoc[examDoc.docField] = value;
            }
        }
    }
    /**
     * @param {?} field
     * @param {?} tmp
     * @return {?}
     */
    getFieldValue(field, tmp) {
        /** @type {?} */
        const examDoc = this.determineAffectedDoc(field);
        if (this.affectedDoc) {
            if (tmp) {
                logger$o.warn('Please use function getFieldValue(field) instead of getFieldValue(doc, field)');
                return this.affectedDoc[tmp];
            }
            else {
                return this.affectedDoc[examDoc.docField];
            }
        }
    }
    /**
     * @param {?} field
     * @param {?} optionName
     * @param {?} checked
     * @return {?}
     */
    checkChecklistItem(field, optionName, checked) {
        /** @type {?} */
        const examDoc = this.determineAffectedDoc(field);
        /** @type {?} */
        let fieldValues = this.affectedDoc[examDoc.docField];
        if (fieldValues) {
            /** @type {?} */
            const matchIndex = UtilArray.containsIndex(fieldValues, optionName);
            if (checked === 'yes' || checked === true) {
                if (matchIndex === -1) {
                    fieldValues.push(optionName);
                }
            }
            else {
                if (matchIndex > -1) {
                    fieldValues.splice(matchIndex, 1);
                }
            }
        }
        else {
            if (checked === 'yes' || checked === true) {
                fieldValues = [];
                fieldValues.push(optionName);
            }
        }
        this.affectedDoc[examDoc.docField] = fieldValues;
        this.superObj.eventList[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME] = {};
        this.superObj.eventList[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME][SharedConstants.RULESET_RESULT_FLAG] = true;
        this.superObj.eventList[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME][SharedConstants.RULESET_AFFECTED_FIELD_NAME] = examDoc.docField;
        this.superObj.eventList[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME][SharedConstants.RULESET_AFFECTED_TEMPLATE_ID] = this.affectedTpl.documentId;
        this.superObj.eventList[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME][SharedConstants.RULESET_AFFECTED_DOCUMENT_ID] = this.affectedDoc.documentId;
        this.superObj.broadcastEvent(SharedConstants.EVENT_LIST_NAME, this.superObj.eventList);
    }
    /**
     * @param {?} field
     * @return {?}
     */
    getFilter(field) {
        return this.getGridFilter(field);
    }
    /**
     * @param {?} field
     * @param {?} newFilter
     * @return {?}
     */
    setGridFilter(field, newFilter) {
        this.setFilter(field, newFilter);
    }
    /**
     * @param {?} field
     * @param {?} newFilter
     * @return {?}
     */
    setFilter(field, newFilter) {
        /** @type {?} */
        const examDoc = this.determineAffectedDoc(field);
        /** @type {?} */
        const tplItem = this.loadTplItem(examDoc.docField);
        if (!tplItem) {
            logger$o.warn('Template does not contain field: ' + field + ' to set filter.');
            return;
        }
        this.superObj.dispatchStoreAction(formSetComponentFlagTemplate(this.affectedTpl.documentId, examDoc.docField, 'filter', newFilter));
        this.superObj.eventList[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME] = {};
        this.superObj.eventList[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME][SharedConstants.RULESET_NEW_FILTER] = newFilter;
        this.superObj.eventList[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME][SharedConstants.RULESET_AFFECTED_FIELD_NAME] = examDoc.docField;
        this.superObj.eventList[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME][SharedConstants.RULESET_AFFECTED_TEMPLATE_ID] = this.affectedTpl.documentId;
        this.superObj.eventList[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME][SharedConstants.RULESET_AFFECTED_DOCUMENT_ID] = this.affectedDoc.documentId;
        this.superObj.eventList[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME][SharedConstants.RULESET_EVENT_NAME] = this.currentEventName;
        this.superObj.broadcastEvent(SharedConstants.EVENT_LIST_NAME, this.superObj.eventList);
    }
    /**
     * @param {?} templateId
     * @param {?} initialData
     * @param {?} newWindow
     * @param {?} callback
     * @return {?}
     */
    openNewDocument(templateId, initialData, newWindow, callback) {
        this.superObj.tabService.openNewDocument(templateId, initialData, newWindow, callback);
    }
    /**
     * @return {?}
     */
    markDocumentChanged() {
        this.superObj.modifiedFieldService.setDirty(true);
    }
    /**
     * @param {?} doc
     * @return {?}
     */
    isNew(doc) {
        return UtilDocument.isNew(doc ? doc : this.affectedDoc);
    }
    /**
     * @param {?} field
     * @return {?}
     */
    determineAffectedDoc(field) {
        /** @type {?} */
        const result = (/** @type {?} */ ({}));
        if (field && field.indexOf('.') !== -1) {
            /** @type {?} */
            const temp = field.split('.');
            result.docPrefix = temp[0]; // Must be 'parentDoc' OR 'childDoc'
            result.docField = temp[1];
        }
        else {
            result.docField = field;
        }
        this.setAffectedItems(result.docPrefix);
        return result;
    }
    /**
     * Set affected items: document, templateId, template item
     * @param {?} docPrefix
     * @return {?}
     */
    setAffectedItems(docPrefix) {
        if (docPrefix === SharedConstants.RULESET_PARENT_DOCUMENT) {
            this.affectedDoc = this.currentDocumentContext.parentDocument;
            this.affectedTpl = this.currentDocumentContext.parentTemplate;
        }
        else if (docPrefix === SharedConstants.RULESET_CHILD_DOCUMENT) {
            this.affectedDoc = this.currentDocumentContext.childDocument;
            this.affectedTpl = this.currentDocumentContext.childTemplate;
        }
        else {
            this.affectedDoc = this.currentDocument;
            this.affectedTpl = this.currentTemplate;
        }
    }
    /**
     * @param {?} field
     * @param {?} fieldFlag
     * @param {?} flag
     * @return {?}
     */
    setFieldFlag(field, fieldFlag, flag) {
        /** @type {?} */
        const examDoc = this.determineAffectedDoc(field);
        if (this.affectedDoc) {
            if ('enabled' === fieldFlag) {
                if (!this.superObj.clientAccessService.hasPermission(this.affectedDoc, 'Update,Create')) {
                    return;
                }
            }
            if (flag !== undefined) {
                /** @type {?} */
                const tplItem = this.loadTplItem(examDoc.docField);
                if (!tplItem) {
                    logger$o.warn('Template does not contain field: ' + field + ' to show/enable.');
                    return;
                }
                /** @type {?} */
                const result = (flag === 'yes' || flag === 'true' || flag === true);
                this.superObj.dispatchStoreAction(formSetComponentFlagTemplate(this.affectedTpl.documentId, examDoc.docField, fieldFlag, result));
                this.superObj.broadcastService.broadcast(ClientConstants.FORM_DETECT_CHANGES, true);
                return result;
            }
        }
        return false;
    }
    /**
     * @param {?} fields
     * @param {?} fieldFlagName
     * @param {?} flag
     * @return {?}
     */
    setFieldFlags(fields, fieldFlagName, flag) {
        /** @type {?} */
        const resFields = this.filterAndSetAffectedDoc(fields);
        if (resFields.length) {
            if (flag !== undefined) {
                /** @type {?} */
                const result = (flag === 'yes' || flag === 'true' || flag === true);
                this.superObj.dispatchStoreAction(formSetListComponentsFlagTemplate(this.affectedTpl.documentId, resFields, fieldFlagName, result));
                this.superObj.broadcastService.broadcast(ClientConstants.FORM_DETECT_CHANGES, true);
                return result;
            }
        }
        return false;
    }
    /**
     * @param {?} field
     * @return {?}
     */
    getGridFilter(field) {
        /** @type {?} */
        const examDoc = this.determineAffectedDoc(field);
        if (this.affectedDoc) {
            /** @type {?} */
            const tplItem = this.loadTplItem(examDoc.docField);
            if (tplItem) {
                return tplItem.filter;
            }
        }
    }
    /**
     * @param {?} fieldName
     * @return {?}
     */
    loadTplItem(fieldName) {
        if (this.affectedTpl && this.affectedTpl.components) {
            for (let i = 0; i < this.affectedTpl.components.length; i++) {
                /** @type {?} */
                const tplItem = this.affectedTpl.components[i];
                if (tplItem.name === fieldName) {
                    return tplItem;
                }
            }
        }
        return null;
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    RuleContext.prototype.currentEventName;
    /**
     * @type {?}
     * @private
     */
    RuleContext.prototype.currentDocument;
    /**
     * @type {?}
     * @private
     */
    RuleContext.prototype.currentTemplate;
    /**
     * @type {?}
     * @private
     */
    RuleContext.prototype.currentDocumentContext;
    /**
     * @type {?}
     * @private
     */
    RuleContext.prototype.affectedDoc;
    /**
     * @type {?}
     * @private
     */
    RuleContext.prototype.affectedTpl;
    /**
     * @type {?}
     * @private
     */
    RuleContext.prototype.superObj;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/rules/rule-cache.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function RulesetCacheInfo() { }
if (false) {
    /** @type {?} */
    RulesetCacheInfo.prototype.rulesetId;
    /** @type {?} */
    RulesetCacheInfo.prototype.rulesetScriptFunc;
}
/**
 * @record
 */
function RulesetCache() { }
class RuleCacheService {
    // loadedRulesetIncludes: RulesetCache = {
    // }
    constructor() {
        this.loadedRulesets = {};
    }
    /**
     * @param {?} documentId
     * @param {?} rulesetScript
     * @return {?}
     */
    setRuleset(documentId, rulesetScript) {
        if (documentId && rulesetScript) {
            /** @type {?} */
            let rulesetInfo = {
                rulesetId: documentId,
                rulesetScriptFunc: rulesetScript
            };
            this.loadedRulesets[documentId] = rulesetInfo;
        }
    }
    // setRulesetInclude(documentId: string, rulesetIncludeScript: string) {
    //   if (documentId && rulesetScript) {
    //     let rulesetInfo: RulesetCacheInfo = {
    //       rulesetScript: rulesetIncludeScript
    //     };
    //     this.loadedRulesetIncludes[documentId] = rulesetInfo;
    //   }
    // }
    /**
     * @param {?} documentId
     * @return {?}
     */
    getRuleset(documentId) {
        return documentId ? this.loadedRulesets[documentId] : null;
    }
}
RuleCacheService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
RuleCacheService.ctorParameters = () => [];
/** @nocollapse */ RuleCacheService.ɵprov = ɵɵdefineInjectable({ factory: function RuleCacheService_Factory() { return new RuleCacheService(); }, token: RuleCacheService, providedIn: "root" });
if (false) {
    /** @type {?} */
    RuleCacheService.prototype.loadedRulesets;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/state/form-new.state.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFormNewState() { }
if (false) {
    /** @type {?} */
    IFormNewState.prototype.canUndo;
    /** @type {?} */
    IFormNewState.prototype.canRedo;
    /** @type {?} */
    IFormNewState.prototype.documents;
    /** @type {?} */
    IFormNewState.prototype.orgDocuments;
    /** @type {?} */
    IFormNewState.prototype.documentInfo;
    /** @type {?} */
    IFormNewState.prototype.documentChangedInfo;
    /** @type {?} */
    IFormNewState.prototype.recordedStateChanges;
    /** @type {?} */
    IFormNewState.prototype.recordedComponentTemplateChanges;
    /** @type {?} */
    IFormNewState.prototype.recordedDisableSaveFieldValues;
    /** @type {?} */
    IFormNewState.prototype.documentSession;
}
/**
 * @return {?}
 */
function getDefaultFormNewState() {
    return {
        canUndo: false,
        canRedo: false,
        documents: {},
        orgDocuments: {},
        documentInfo: {},
        documentChangedInfo: null,
        recordedStateChanges: null,
        recordedComponentTemplateChanges: {},
        recordedDisableSaveFieldValues: {},
        documentSession: {}
    };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/reducers/form-new.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
let changes = {};
/** @type {?} */
let currentVersion = -1;
/**
 * @param {?=} state
 * @param {?=} action
 * @return {?}
 */
function formNewReducer(state = getDefaultFormNewState(), action) {
    enablePatches();
    /** @type {?} */
    let shouldRecordPatches = false;
    /** @type {?} */
    const recordedPatches = {};
    /** @type {?} */
    let recordedUndoRedo = false;
    /** @type {?} */
    const changedSourceInfo = {};
    state = produce(state, (/**
     * @param {?} draft
     * @return {?}
     */
    draft => {
        switch (action.type) {
            case FORM_SETUP_DOCUMENT_LIST: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const documentListId = typedAction.payload.documentListId;
                /** @type {?} */
                const documentListType = typedAction.payload.documentListType;
                /** @type {?} */
                const isMainDoc = typedAction.payload.isMainDoc;
                /** @type {?} */
                const documentInfo = draft.documentInfo;
                if (isMainDoc) {
                    /** @type {?} */
                    const docListIds = Object.keys(documentInfo);
                    docListIds.forEach((/**
                     * @param {?} docListId
                     * @return {?}
                     */
                    docListId => {
                        if (documentInfo[docListId].isMainDoc) {
                            // remove previous main document information because we have only one main document on form
                            delete documentInfo[docListId];
                        }
                    }));
                }
                if (!draft.documentInfo[documentListId]) {
                    draft.documentInfo[documentListId] = {};
                }
                draft.documentInfo[documentListId].name = documentListType;
                draft.documentInfo[documentListId].isMainDoc = isMainDoc;
                draft.documentInfo[documentListId].documentId = null;
                draft.documentInfo[documentListId].templateId = null;
                draft.documentInfo[documentListId].altTemplateId = null;
                draft.documentInfo[documentListId].options = {};
                draft.documentInfo[documentListId].hierarchyDocInfo = {};
                draft.documentInfo[documentListId].initDocData = {
                    //processedFields: stores processed fields from components
                    processedFields: [],
                    // completedFields: stores the fields have been initialized.
                    // It will be set once the RESET action is dispatched.
                    // It will be used to compare to the processedFields in order to trigger Onload
                    completedFields: []
                };
                break;
            }
            case FORM_SET_ORG_DOCUMENT: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const document = typedAction.payload.document;
                draft.orgDocuments[document.documentId] = document;
                break;
            }
            case FORM_SET_DOCUMENT: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const document = typedAction.payload.document;
                if (typedAction.payload.versionId || document) {
                    /** @type {?} */
                    const key = typedAction.payload.versionId ? typedAction.payload.versionId : document.documentId;
                    draft.documents[key] = document;
                    shouldRecordPatches = true;
                }
                break;
            }
            case FORM_UPDATE_COMPONENT_DEFINITION: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const templateId = typedAction.payload.templateId;
                /** @type {?} */
                const fieldName = typedAction.payload.fieldName;
                /** @type {?} */
                const key = typedAction.payload.key;
                /** @type {?} */
                const compDef = typedAction.payload.componentDef;
                /** @type {?} */
                const components = draft.documents[templateId].components;
                if (!draft.recordedComponentTemplateChanges[templateId]) {
                    draft.recordedComponentTemplateChanges[templateId] = {};
                }
                if (!draft.recordedComponentTemplateChanges[templateId][fieldName]) {
                    draft.recordedComponentTemplateChanges[templateId][fieldName] = {};
                }
                if (components[key] && components[key].name && components[key].name === fieldName) {
                    components[key] = compDef;
                    draft.recordedComponentTemplateChanges[templateId][fieldName].key = key;
                    draft.recordedComponentTemplateChanges[templateId][fieldName].componentDef = compDef;
                }
                shouldRecordPatches = true;
                break;
            }
            case FORM_SET_COMPONENT_FLAG_TEMPLATE: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const flagName = typedAction.payload.flagName;
                /** @type {?} */
                const flagValue = typedAction.payload.flagValue;
                /** @type {?} */
                const fieldName = typedAction.payload.fieldName;
                /** @type {?} */
                const templateId = typedAction.payload.templateId;
                /** @type {?} */
                const template = draft.documents[templateId];
                if (!draft.recordedComponentTemplateChanges[templateId]) {
                    draft.recordedComponentTemplateChanges[templateId] = {};
                }
                if (!draft.recordedComponentTemplateChanges[templateId][fieldName]) {
                    draft.recordedComponentTemplateChanges[templateId][fieldName] = {};
                }
                template.components.forEach((/**
                 * @param {?} tplItem
                 * @param {?} idx
                 * @return {?}
                 */
                (tplItem, idx) => {
                    if (tplItem.name && tplItem.name === fieldName) {
                        tplItem[flagName] = flagValue;
                        draft.recordedComponentTemplateChanges[templateId][fieldName][flagName] = flagValue;
                        draft.recordedComponentTemplateChanges[templateId][fieldName].componentDef = tplItem;
                        draft.recordedComponentTemplateChanges[templateId][fieldName].key = idx;
                    }
                }));
                shouldRecordPatches = true;
                break;
            }
            case FORM_SET_LIST_COMPONENTS_FLAG_TEMPLATE: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const fieldNames = typedAction.payload.fieldNames;
                /** @type {?} */
                const flagName = typedAction.payload.flagName;
                /** @type {?} */
                const flagValue = typedAction.payload.flagValue;
                /** @type {?} */
                const templateId = typedAction.payload.templateId;
                /** @type {?} */
                const template = draft.documents[templateId];
                if (!draft.recordedComponentTemplateChanges[templateId]) {
                    draft.recordedComponentTemplateChanges[templateId] = {};
                }
                template.components.forEach((/**
                 * @param {?} tplItem
                 * @param {?} idx
                 * @return {?}
                 */
                (tplItem, idx) => {
                    /** @type {?} */
                    const fieldName = tplItem.name;
                    if (fieldNames.indexOf(fieldName) !== -1) {
                        tplItem[flagName] = flagValue;
                        if (!draft.recordedComponentTemplateChanges[templateId][fieldName]) {
                            draft.recordedComponentTemplateChanges[templateId][fieldName] = {};
                        }
                        draft.recordedComponentTemplateChanges[templateId][fieldName][flagName] = flagValue;
                        draft.recordedComponentTemplateChanges[templateId][fieldName].componentDef = tplItem;
                        draft.recordedComponentTemplateChanges[templateId][fieldName].key = idx;
                    }
                }));
                shouldRecordPatches = true;
                break;
            }
            case FORM_RESET_TEMPLATE_COMPONENT_DEFINITION: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const templateId = typedAction.payload.templateId;
                draft.recordedComponentTemplateChanges[templateId] = {};
                shouldRecordPatches = true;
                break;
            }
            case FORM_CLEAR_DOCUMENT: {
                /** @type {?} */
                const documentIds = Object.keys(draft.documents);
                documentIds.forEach((/**
                 * @param {?} docId
                 * @return {?}
                 */
                docId => {
                    if (draft.documents[docId].systemHeader.systemType === SharedConstants.SYSTEM_TYPE_DOCUMENT) {
                        // remove document from store
                        delete draft.documents[docId];
                    }
                }));
                shouldRecordPatches = true;
                break;
            }
            case FORM_DELETE_DOCUMENT: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const documentId = typedAction.payload.documentId;
                delete draft.documents[documentId];
                delete draft.orgDocuments[documentId];
                shouldRecordPatches = true;
                break;
            }
            case FORM_RESET_TO_ORG_DOCUMENT: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const documentId = typedAction.payload.documentId;
                draft.documents[documentId] = draft.orgDocuments[documentId];
                shouldRecordPatches = true;
                break;
            }
            case FORM_SET_DOCUMENT_INFO: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const documentInfo = typedAction.payload.documentInfo;
                /** @type {?} */
                const unsavedDocListId = typedAction.payload.unsavedDocumentListId;
                /** @type {?} */
                const currentDocumentInfo = draft.documentInfo[unsavedDocListId];
                /** @type {?} */
                const keys = Object.keys(documentInfo);
                keys.forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                key => {
                    if (key !== 'hierarchyInfo' && key !== 'options') {
                        currentDocumentInfo[key] = documentInfo[key];
                    }
                    else if (key === 'hierarchyInfo') {
                        if (!currentDocumentInfo.hierarchyInfo) {
                            currentDocumentInfo.hierarchyInfo = {};
                        }
                        /** @type {?} */
                        const hiKeys = Object.keys(documentInfo.hierarchyInfo);
                        hiKeys.forEach((/**
                         * @param {?} key1
                         * @return {?}
                         */
                        key1 => {
                            currentDocumentInfo.hierarchyInfo[key1] = documentInfo.hierarchyInfo[key1];
                        }));
                    }
                    else if (key === 'options') {
                        if (!currentDocumentInfo.options) {
                            currentDocumentInfo.options = {};
                        }
                        /** @type {?} */
                        const optKeys = Object.keys(documentInfo.options);
                        optKeys.forEach((/**
                         * @param {?} key2
                         * @return {?}
                         */
                        key2 => {
                            currentDocumentInfo.options[key2] = documentInfo.options[key2];
                        }));
                    }
                }));
                break;
            }
            case FORM_RESET_DOCUMENT_INFO: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                draft.documentInfo[typedAction.payload.unsavedDocumentListId] = {};
                break;
            }
            case FORM_UPDATE_INIT_DOCUMENT_DATA: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const unsavedDocListId = typedAction.payload.unsavedDocumentListId;
                if (unsavedDocListId) {
                    /** @type {?} */
                    const fieldName = typedAction.payload.fieldName;
                    /** @type {?} */
                    const fieldValue = typedAction.payload.fieldValue;
                    /** @type {?} */
                    const documentInfo = draft.documentInfo[unsavedDocListId];
                    if (!documentInfo.initDocData) {
                        documentInfo.initDocData = {
                            processedFields: [],
                            completedFields: []
                        };
                    }
                    /** @type {?} */
                    const initDocData = documentInfo.initDocData;
                    if (!initDocData.processedFields.includes(fieldName)) {
                        initDocData.processedFields.push(fieldName);
                    }
                    /** @type {?} */
                    const document = draft.documents[documentInfo.documentId];
                    if (fieldValue == null) {
                        delete document[fieldName];
                    }
                    else {
                        document[fieldName] = fieldValue;
                    }
                }
                break;
            }
            case FORM_RESET_INIT_DOCUMENT_DATA: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const unsavedDocListId = typedAction.payload.unsavedDocumentListId;
                /** @type {?} */
                const documentInfo = draft.documentInfo[unsavedDocListId];
                if (!documentInfo.initDocData) {
                    documentInfo.initDocData = {
                        processedFields: [],
                        completedFields: []
                    };
                }
                /** @type {?} */
                const initDocData = documentInfo.initDocData;
                if (initDocData.processedFields.length) {
                    initDocData.completedFields = [...initDocData.processedFields];
                    initDocData.processedFields = [];
                }
                break;
            }
            case FORM_UPDATE_DOCUMENT: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const changedInfo = typedAction.payload.documentChangedInfo;
                /** @type {?} */
                const documentId = changedInfo.documentId;
                /** @type {?} */
                const document = draft.documents[documentId];
                /** @type {?} */
                const newValues = changedInfo.newValue;
                if (newValues && newValues.length) {
                    newValues.forEach((/**
                     * @param {?} item
                     * @return {?}
                     */
                    item => {
                        document[item.fieldName] = item.remoteValue;
                    }));
                    changedSourceInfo.documentId = documentId;
                    changedSourceInfo.fieldName = changedInfo.fieldName;
                    changedSourceInfo.type = changedInfo.sourceType;
                    changedSourceInfo.controlName = changedInfo.controlName;
                    shouldRecordPatches = true;
                }
                break;
            }
            case FORM_CHANGE_DOCUMENT: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const changedInfo = typedAction.payload.documentChangedInfo;
                /** @type {?} */
                const documentId = changedInfo.documentId;
                /** @type {?} */
                const document = draft.documents[documentId];
                /** @type {?} */
                const fieldName = changedInfo.fieldName;
                changedInfo.oldValue = document[fieldName];
                document[fieldName] = changedInfo.newValue;
                if (!changedInfo.isInitValue) {
                    // const unsavedDocListId = changedInfo.formParameters.unsavedDocumentListId;
                    // const unsavedDocInfo = draft.documentInfo[unsavedDocListId];
                    // if (unsavedDocInfo?.name !== ClientConstants.DIALOG_DOCUMENT_INFO_LIST) {
                    //   draft.canUndo = true;
                    //   draft.canRedo = false;
                    // }
                    draft.documentChangedInfo = changedInfo;
                }
                changedSourceInfo.documentId = documentId;
                changedSourceInfo.fieldName = fieldName;
                changedSourceInfo.type = changedInfo.sourceType;
                changedSourceInfo.controlName = changedInfo.controlName;
                shouldRecordPatches = true;
                /** @type {?} */
                const template = draft.documents[document.systemHeader.templateId];
                if (template && template.components) {
                    /** @type {?} */
                    const tplItem = template.components.filter((/**
                     * @param {?} item
                     * @return {?}
                     */
                    item => {
                        return item.name && item.name === fieldName;
                    }))[0];
                    if ((tplItem === null || tplItem === void 0 ? void 0 : tplItem.disableSave) === true) {
                        if (!draft.recordedDisableSaveFieldValues[documentId]) {
                            draft.recordedDisableSaveFieldValues[documentId] = {};
                        }
                        draft.recordedDisableSaveFieldValues[documentId][fieldName] = document[fieldName];
                    }
                }
                break;
            }
            case FORM_RESET_CHANGE_DOCUMENT: {
                delete draft.documentChangedInfo;
                break;
            }
            case FORM_UNDO: {
                shouldRecordPatches = true;
                recordedUndoRedo = true;
                /** @type {?} */
                const newState = (/** @type {?} */ (applyPatches(state, changes[currentVersion--].undo)));
                return produce(newState, (/**
                 * @param {?} newDraft
                 * @return {?}
                 */
                newDraft => {
                    newDraft.canUndo = changes.hasOwnProperty(currentVersion);
                    newDraft.canRedo = true;
                }));
            }
            case FORM_REDO: {
                shouldRecordPatches = true;
                recordedUndoRedo = true;
                /** @type {?} */
                const newState = (/** @type {?} */ (applyPatches(state, changes[++currentVersion].redo)));
                return produce(newState, (/**
                 * @param {?} newDraft
                 * @return {?}
                 */
                newDraft => {
                    newDraft.canUndo = true;
                    newDraft.canRedo = changes.hasOwnProperty(currentVersion + 1);
                }));
            }
            case FORM_RESET_UNDO_REDO: {
                currentVersion = -1;
                changes = {};
                draft.canRedo = false;
                draft.canUndo = false;
                break;
            }
            case FORM_SET_DISABLE_SAVE_FIELD_DOCUMENT: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const documentId = typedAction.payload.documentId;
                /** @type {?} */
                const value = typedAction.payload.disabledFields;
                if (Object.keys(value).length) {
                    draft.recordedDisableSaveFieldValues[documentId] = value;
                }
                else {
                    delete draft.recordedDisableSaveFieldValues[documentId];
                }
                break;
            }
            case FORM_SET_DOCUMENT_SESSION: {
                /** @type {?} */
                const typedAction = (/** @type {?} */ (action));
                /** @type {?} */
                const document = typedAction.payload.documentSession;
                /** @type {?} */
                const key = typedAction.payload.documentId;
                draft.documentSession[key] = document;
                break;
            }
            default: {
                return state;
            }
        }
    }), (/**
     * @param {?} patches
     * @param {?} inversePatches
     * @return {?}
     */
    (patches, inversePatches) => {
        if (action.type === FORM_CHANGE_DOCUMENT) {
            /** @type {?} */
            const typedAction = (/** @type {?} */ (action));
            if (!typedAction.payload.documentChangedInfo.isInitValue) {
                currentVersion++;
                changes[currentVersion] = {
                    redo: patches,
                    undo: inversePatches
                };
            }
        }
        if (shouldRecordPatches) {
            recordedPatches.patches = patches;
            recordedPatches.inversePatches = inversePatches;
            recordedPatches.recordedUndoRedo = recordedUndoRedo;
            recordedPatches.changedSourceInfo = changedSourceInfo;
        }
    }));
    // set the changes to state from reducer so if any changes they should be triggered instead of listening whole state.
    return Object.assign(Object.assign({}, state), { recordedStateChanges: recordedPatches });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/state/user.state.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUserState() { }
if (false) {
    /** @type {?|undefined} */
    IUserState.prototype.user;
}
/**
 * @return {?}
 */
function getDefaultUserState() {
    return {
        user: {
            welcomeMsg: '',
            account: null,
            filteredAccount: null,
            menu: null,
            publicAccount: false,
            accountPublicURL: null,
            accountControlDocument: null,
            accountGroupConfigDocument: null
        }
    };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/reducers/user.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} state
 * @param {?=} action
 * @return {?}
 */
function userReducer(state = getDefaultUserState(), action) {
    switch (action.type) {
        case USER_SET_USER: {
            /** @type {?} */
            const typedAction = (/** @type {?} */ (action));
            return Object.assign(Object.assign({}, state), { user: typedAction.payload.user });
        }
        default: {
            return state;
        }
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/state/offline.state.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IOfflineState() { }
if (false) {
    /** @type {?|undefined} */
    IOfflineState.prototype.offlineStatus;
}
/**
 * @return {?}
 */
function getDefaultOfflineState() {
    return {
        offlineStatus: {
            unsyncedCount: 0,
            connected: true,
            connectionText: '',
            incomingCacheCount: 0,
            maxCacheCount: 0,
            currentCacheCount: 0,
            cacheLoading: false,
            pendingDocumentCount: 0,
            errorCacheCount: 0,
            initialCachingComplete: false,
            cachingApp: false,
            currentStaticResourceCount: 0,
            totalStaticResourceCount: 0,
            tileServerCacheCount: 0,
            tileServerMaxCacheCount: 0,
            errorCacheAttachedFile: []
        }
    };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/reducers/offline.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} state
 * @param {?=} action
 * @return {?}
 */
function offlineReducer(state = getDefaultOfflineState(), action) {
    switch (action.type) {
        case OFFLINE_SET_OFFLINE_STATUS: {
            /** @type {?} */
            const typedAction = (/** @type {?} */ (action));
            return Object.assign(Object.assign({}, state), { offlineStatus: typedAction.payload.offlineStatus });
        }
        default: {
            return state;
        }
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/reducers/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const rootReducer = combineReducers({
    offlineReducer: offlineReducer,
    formState: formNewReducer,
    userState: userReducer
});

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/store/store.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function getStore() {
    /** @type {?} */
    const globalWindow = (/** @type {?} */ (window));
    if (!globalWindow.formbirdStore) {
        // Create a Redux store holding the state of your app.
        // Store it on the window object so it is accessible from custom elements
        globalWindow.formbirdStore = createStore(rootReducer, globalWindow.__REDUX_DEVTOOLS_EXTENSION__ ? globalWindow.__REDUX_DEVTOOLS_EXTENSION__() :
            globalWindow.REDUX_DEVTOOLS_EXTENSION ? globalWindow.REDUX_DEVTOOLS_EXTENSION() : (/**
             * @param {?} f
             * @return {?}
             */
            f => f));
    }
    return globalWindow.formbirdStore;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/rules/include-document-data.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IncludeDocumentDataService {
    /**
     * @param {?} loggedInUserService
     * @param {?} indexedDBConnectorService
     * @param {?} http
     */
    constructor(loggedInUserService, indexedDBConnectorService, http) {
        this.loggedInUserService = loggedInUserService;
        this.indexedDBConnectorService = indexedDBConnectorService;
        this.http = http;
    }
    /**
     * @param {?} includeNames
     * @return {?}
     */
    getIncludeDocuments(includeNames) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                /** @type {?} */
                const offlineMode = this.loggedInUserService.getUserConfigItem('cachingEnabled') === true;
                if (offlineMode) {
                    return yield this.getIncludeDocumentsFromIndexedDB(includeNames);
                }
                else {
                    return yield this.getIncludeDocumentsFromServer(SharedUrlRoutes.serverRoutes.loadIncludeDocs, includeNames);
                }
            }
            catch (err) {
                console.error('Get ruleset include documents failed with error: ' + err);
                throw new Error(err);
            }
        });
    }
    /**
     * @private
     * @param {?} includeNames
     * @return {?}
     */
    getIncludeDocumentsFromIndexedDB(includeNames) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.indexedDBConnectorService.getDatabase().then((/**
             * @param {?} db
             * @return {?}
             */
            function (db) {
                db.documents.where('systemHeader.systemType').equals(SharedConstants.SYSTEM_TYPE_RULESET_INCLUDE).toArray((/**
                 * @param {?} documents
                 * @return {?}
                 */
                function (documents) {
                    try {
                        /** @type {?} */
                        var results = documents.filter((/**
                         * @param {?} document
                         * @return {?}
                         */
                        function (document) {
                            return document.systemHeader.currentVersion === true &&
                                includeNames.includes(document.name);
                        }));
                        resolve(results);
                    }
                    catch (err) {
                        reject(err);
                    }
                }));
            }));
        }));
    }
    /**
     * @private
     * @param {?} url
     * @param {?} includeNames
     * @return {?}
     */
    getIncludeDocumentsFromServer(url, includeNames) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.http.post(url, { includeNames: includeNames }).subscribe((/**
             * @param {?} results
             * @return {?}
             */
            (results) => {
                resolve(results);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                /** @type {?} */
                const msg = err ? err.message : 'Something went wrong when getting include documents.';
                /** @type {?} */
                const error = new FtError(msg);
                if (err) {
                    error.status = err.status;
                    error.statusText = err.statusText;
                    error.message = err.error;
                }
                reject(error);
            }));
        }));
    }
}
IncludeDocumentDataService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
IncludeDocumentDataService.ctorParameters = () => [
    { type: LoggedInUserService },
    { type: IndexedDBConnectorService },
    { type: HttpClient }
];
/** @nocollapse */ IncludeDocumentDataService.ɵprov = ɵɵdefineInjectable({ factory: function IncludeDocumentDataService_Factory() { return new IncludeDocumentDataService(ɵɵinject(LoggedInUserService), ɵɵinject(IndexedDBConnectorService), ɵɵinject(HttpClient)); }, token: IncludeDocumentDataService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    IncludeDocumentDataService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    IncludeDocumentDataService.prototype.indexedDBConnectorService;
    /**
     * @type {?}
     * @private
     */
    IncludeDocumentDataService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/rules/client-include-rule-set.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$p = console;
class ClientIncludeRuleSetService {
    /**
     * @param {?} configService
     * @param {?} includeDocumentDataService
     */
    constructor(configService, includeDocumentDataService) {
        this.configService = configService;
        this.includeDocumentDataService = includeDocumentDataService;
    }
    /**
     * @private
     * @param {?} includeNames
     * @param {?} callback
     * @return {?}
     */
    loadIncludeDocs(includeNames, callback) {
        this.includeDocumentDataService.getIncludeDocuments(includeNames).then((/**
         * @param {?} results
         * @return {?}
         */
        (results) => {
            /** @type {?} */
            let docs = results ? results : [];
            /** @type {?} */
            const tmpData = { data: docs, total: docs.length };
            callback(null, tmpData);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            logger$p.warn(err);
            callback(err);
        }));
    }
    /*
       * Including ruleset processing.
       * Include ruleset syntax: #include "rulesetName";
       */
    /**
     * @param {?} ruleFlow
     * @param {?} callback
     * @return {?}
     */
    addIncludesToRuleset(ruleFlow, callback) {
        /** @type {?} */
        const includeNames = UtilIncludeRuleSet.getIncludeNames(ruleFlow);
        if (includeNames && includeNames.length) {
            /** @type {?} */
            const remainIncludeNames = [];
            // remove commented #include
            for (let i = 0; i < includeNames.length; i++) {
                /** @type {?} */
                const beforeLength = ruleFlow.length;
                /** @type {?} */
                const commentLineExp = '//[\t ]*#include[\t ]+[\'"]' + includeNames[i] + '[\'"][\t ]*.*';
                ruleFlow = ruleFlow.replace(new RegExp(commentLineExp, 'g'), '');
                if (beforeLength === ruleFlow.length) {
                    // Keep not commented include name
                    remainIncludeNames.push(includeNames[i]);
                }
            }
            if (remainIncludeNames.length) {
                this.loadIncludeDocs(remainIncludeNames, (/**
                 * @param {?} error
                 * @param {?} result
                 * @return {?}
                 */
                (error, result) => {
                    if (error) {
                        callback({
                            status: SharedConstants.STATUS_ERROR,
                            message: 'Error loading include ruleset: ' + error.message
                        });
                    }
                    else if (result && result.total && result.total === remainIncludeNames.length) {
                        for (let id = 0; id < result.total; id++) {
                            /** @type {?} */
                            const includeDoc = result.data[id];
                            // replace #include by script for JS
                            /** @type {?} */
                            const exp = '#include[\t ]+[\'"]' + includeDoc.name + '[\'"][\t ]*,';
                            ruleFlow = ruleFlow.replace(new RegExp(exp, 'g'), includeDoc.ruleSetSnippet + ',');
                        }
                        callback({
                            status: SharedConstants.STATUS_SUCCESS,
                            ruleFlow: ruleFlow
                        });
                    }
                    else {
                        /** @type {?} */
                        let missedIncludes;
                        if (result && result.total) {
                            missedIncludes = [];
                            for (let i = 0; i < remainIncludeNames.length; i++) {
                                /** @type {?} */
                                let res = false;
                                for (let j = 0; j < result.total; j++) {
                                    if (result.data[j].name === remainIncludeNames[i]) {
                                        res = true;
                                        break;
                                    }
                                }
                                if (!res) {
                                    missedIncludes.push(remainIncludeNames[i]);
                                }
                            }
                        }
                        else {
                            missedIncludes = remainIncludeNames;
                        }
                        logger$p.error('There are missing ruleset includes for this document: ' + missedIncludes +
                            '. Please make sure the ruleset include documents exist and ' +
                            'the correct access keys are configured for them.');
                        /** @type {?} */
                        let errMsg = 'Ruleset Include(s) not found: ';
                        for (let i = 0; i < missedIncludes.length; i++) {
                            errMsg += '<br>- \'' + missedIncludes[i] + '\'';
                        }
                        callback({
                            status: SharedConstants.STATUS_ERROR,
                            message: errMsg
                        });
                    }
                }));
            }
            else {
                callback({
                    status: SharedConstants.STATUS_SUCCESS,
                    ruleFlow: ruleFlow
                });
            }
        }
        else {
            callback({
                status: SharedConstants.STATUS_SUCCESS,
                ruleFlow: ruleFlow
            });
        }
    }
}
ClientIncludeRuleSetService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ClientIncludeRuleSetService.ctorParameters = () => [
    { type: ConfigService },
    { type: IncludeDocumentDataService }
];
/** @nocollapse */ ClientIncludeRuleSetService.ɵprov = ɵɵdefineInjectable({ factory: function ClientIncludeRuleSetService_Factory() { return new ClientIncludeRuleSetService(ɵɵinject(ConfigService), ɵɵinject(IncludeDocumentDataService)); }, token: ClientIncludeRuleSetService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ClientIncludeRuleSetService.prototype.configService;
    /**
     * @type {?}
     * @private
     */
    ClientIncludeRuleSetService.prototype.includeDocumentDataService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/rules/client-rule-set-context.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$q = console;
class RulesetContext {
    constructor() {
    }
    /**
     * @param {?} collectionName
     * @param {?} callback
     * @return {?}
     */
    loadRecords(collectionName, callback) {
        logger$q.error('LoadRecords regards collectionName is not valid function.');
    }
    /**
     * @param {?} html
     * @return {?}
     */
    sanitizeHtml(html) {
        return this.sanitizer.sanitize(SecurityContext.HTML, html);
    }
}
RulesetContext.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
RulesetContext.ctorParameters = () => [];
/** @nocollapse */ RulesetContext.ɵprov = ɵɵdefineInjectable({ factory: function RulesetContext_Factory() { return new RulesetContext(); }, token: RulesetContext, providedIn: "root" });
if (false) {
    /** @type {?} */
    RulesetContext.prototype.user;
    /** @type {?} */
    RulesetContext.prototype.sharedValues;
    /** @type {?} */
    RulesetContext.prototype.modalService;
    /** @type {?} */
    RulesetContext.prototype.dataService;
    /** @type {?} */
    RulesetContext.prototype.DataService;
    /** @type {?} */
    RulesetContext.prototype.q;
    /** @type {?} */
    RulesetContext.prototype.logger;
    /** @type {?} */
    RulesetContext.prototype.ModalService;
    /** @type {?} */
    RulesetContext.prototype.hasDuplicate;
    /** @type {?} */
    RulesetContext.prototype.showNotification;
    /**
     * returns a boolean indicating whether the device is connected
     * @type {?}
     */
    RulesetContext.prototype.isOnline;
    /** @type {?} */
    RulesetContext.prototype.updateDocument;
    /** @type {?} */
    RulesetContext.prototype.deleteDocument;
    /** @type {?} */
    RulesetContext.prototype.findDocuments;
    /** @type {?} */
    RulesetContext.prototype.findDocumentsByElastic;
    /** @type {?} */
    RulesetContext.prototype.findDocumentsBySearch;
    /** @type {?} */
    RulesetContext.prototype.sendMessageBirdSMS;
    /** @type {?} */
    RulesetContext.prototype.addIncludesToRuleset;
    /** @type {?} */
    RulesetContext.prototype.createDocumentFromTemplate;
    /** @type {?} */
    RulesetContext.prototype.loadComponentLibrary;
    /** @type {?} */
    RulesetContext.prototype.setSharedValue;
    /** @type {?} */
    RulesetContext.prototype.getSharedValue;
    /** @type {?} */
    RulesetContext.prototype.RulesetError;
    /** @type {?} */
    RulesetContext.prototype.processSearchResults;
    /** @type {?} */
    RulesetContext.prototype.showDialog;
    /** @type {?} */
    RulesetContext.prototype.sanitizer;
    /** @type {?} */
    RulesetContext.prototype.ModifiedFieldService;
    /** @type {?} */
    RulesetContext.prototype.lazyLoader;
    /** @type {?} */
    RulesetContext.prototype.loggedInUserService;
    /** @type {?} */
    RulesetContext.prototype.clientIncludeRuleSetService;
    /** @type {?} */
    RulesetContext.prototype.documentService;
    /** @type {?} */
    RulesetContext.prototype.offlineStatusService;
    /** @type {?} */
    RulesetContext.prototype.http;
    /** @type {?} */
    RulesetContext.prototype.searchService;
    /** @type {?} */
    RulesetContext.prototype.notificationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/rules/client-rules.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$r = console;
class ClientRulesService {
    /**
     * @param {?} dataService
     * @param {?} loggedInUserService
     * @param {?} clientIncludeRuleSetService
     * @param {?} documentService
     * @param {?} offlineStatusService
     * @param {?} http
     * @param {?} lazyScriptLoaderService
     * @param {?} searchService
     * @param {?} notificationService
     * @param {?} modifiedFieldService
     * @param {?} sanitizer
     */
    constructor(dataService, loggedInUserService, clientIncludeRuleSetService, documentService, offlineStatusService, http, lazyScriptLoaderService, searchService, notificationService, modifiedFieldService, sanitizer) {
        this.dataService = dataService;
        this.loggedInUserService = loggedInUserService;
        this.clientIncludeRuleSetService = clientIncludeRuleSetService;
        this.documentService = documentService;
        this.offlineStatusService = offlineStatusService;
        this.http = http;
        this.lazyScriptLoaderService = lazyScriptLoaderService;
        this.searchService = searchService;
        this.notificationService = notificationService;
        this.modifiedFieldService = modifiedFieldService;
        this.sanitizer = sanitizer;
        this.sharedValues = (/** @type {?} */ ({}));
        this.user$.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        (data) => this.user = data));
    }
    /**
     * @return {?}
     */
    expose() {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const rulesetContext = new RulesetContext();
            rulesetContext.user = this.user;
            rulesetContext.sharedValues = this.sharedValues;
            rulesetContext.modalService = this.modalService;
            rulesetContext.dataService = this.dataService;
            rulesetContext.DataService = this.dataService; // used in rules for the old code convention
            rulesetContext.ModifiedFieldService = this.modifiedFieldService;
            rulesetContext.lazyLoader = this.lazyScriptLoaderService;
            rulesetContext.loggedInUserService = this.loggedInUserService;
            rulesetContext.clientIncludeRuleSetService = this.clientIncludeRuleSetService;
            rulesetContext.documentService = this.documentService;
            rulesetContext.offlineStatusService = this.offlineStatusService;
            rulesetContext.http = this.http;
            rulesetContext.searchService = this.searchService;
            rulesetContext.notificationService = this.notificationService;
            rulesetContext.q = Promise;
            rulesetContext.logger = logger$r;
            rulesetContext.ModalService = this.modalService;
            rulesetContext.hasDuplicate = this.hasDuplicate;
            rulesetContext.showNotification = this.showNotification;
            /**
             * returns a boolean indicating whether the device is connected
             */
            rulesetContext.isOnline = this.offlineStatusService.isConnected;
            rulesetContext.updateDocument = this.updateDocument;
            rulesetContext.deleteDocument = this.deleteDocument;
            rulesetContext.findDocuments = this.findDocuments;
            rulesetContext.findDocumentsByElastic = this.findDocumentsByElastic;
            rulesetContext.findDocumentsBySearch = this.findDocumentsBySearch;
            /*
                * Including ruleset processing.
                * Include ruleset syntax = #include 'rulesetName';
                */
            rulesetContext.addIncludesToRuleset = this.addIncludesToRuleset;
            rulesetContext.createDocumentFromTemplate = this.createDocumentFromTemplate;
            rulesetContext.loadComponentLibrary = this.loadComponentLibrary;
            rulesetContext.setSharedValue = this.setSharedValue;
            rulesetContext.getSharedValue = this.getSharedValue;
            rulesetContext.processSearchResults = SearchResultsProcessor.processSearchResults;
            rulesetContext.showDialog = this.showDialog;
            rulesetContext.sanitizer = this.sanitizer;
            rulesetContext.RulesetError = RulesetError;
            return rulesetContext;
        });
    }
    /**
     * @private
     * @param {?} templateId
     * @param {?} duplicateCondition
     * @param {?} IdToExclude
     * @return {?}
     */
    hasDuplicate(templateId, duplicateCondition, IdToExclude) {
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const query = ESQueryUtils.prepareESQuery(duplicateCondition);
        query.query.bool.must.push({ 'systemHeader.templateId': templateId });
        // Execute query
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.dataService.findByElastic(query).then((/**
             * @param {?} results
             * @return {?}
             */
            function successFunc(results) {
                // Check excluded ID
                /** @type {?} */
                let result = false;
                for (let i = 0; i < results.data.hits.total; i++) {
                    if (results.data.hits.hits[i]._source.documentId !== IdToExclude) {
                        result = true;
                        break;
                    }
                }
                resolve(result);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function errorFunc(err) {
                reject(err);
            }));
        }));
    }
    /**
     * @private
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    showNotification(message, status) {
        if (!status) {
            status = 'info';
        }
        status = status.toLowerCase();
        this.notificationService.printMessage(message, status, null, { x: 'right', y: 'top' });
    }
    /**
     * @private
     * @param {?} id
     * @param {?} change
     * @param {?} userId
     * @param {?} callback
     * @return {?}
     */
    updateDocument(id, change, userId, callback) {
        /** @type {?} */
        const _self = this;
        /**
         * @param {?} error
         * @return {?}
         */
        function convertToErrorObject(error) {
            /** @type {?} */
            let err = error;
            if (typeof err === 'string') {
                err = new Error(err);
            }
            return err;
        }
        /**
         * @param {?} orgDoc
         * @return {?}
         */
        function doUpdateDoc(orgDoc) {
            try {
                /** @type {?} */
                const clonedDoc = cloneDeep(orgDoc);
                DocumentUpdater.applyUpdatesSimple(clonedDoc, change);
                _self.dataService.jsonPatchUpdate(orgDoc, clonedDoc).then((/**
                 * @param {?} doc
                 * @return {?}
                 */
                function successFunc(doc) {
                    callback(null, doc);
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function errorFunc(err) {
                    /** @type {?} */
                    const errObj = convertToErrorObject(err);
                    callback(errObj);
                }));
            }
            catch (error) {
                /** @type {?} */
                const errObj = convertToErrorObject(error);
                callback(errObj);
            }
        }
        /** @type {?} */
        const originalDoc = _self.documentService.getExistingDocument(id);
        if (!originalDoc) {
            _self.dataService.getDocument(id).then((/**
             * @param {?} orgDoc
             * @return {?}
             */
            function successFunc(orgDoc) {
                doUpdateDoc(orgDoc);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function errorFunc(err) {
                callback(err);
            }));
        }
        else {
            doUpdateDoc(originalDoc);
        }
    }
    /**
     * @private
     * @param {?} id
     * @param {?} options
     * @param {?} callback
     * @return {?}
     */
    deleteDocument(id, options, callback) {
        /** @type {?} */
        const _self = this;
        if (isFunction(options)) {
            callback = options;
            options = null;
        }
        if (id) {
            _self.dataService.destroy(id).then((/**
             * @param {?} doc
             * @return {?}
             */
            function successFunc(doc) {
                callback();
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function errorFunc(err) {
                callback(err);
            }));
        }
    }
    /**
     * @private
     * @param {?} query
     * @param {?} userId
     * @param {?} callback
     * @return {?}
     */
    findDocuments(query, userId, callback) {
        logger$r.warn('===== Deprecated function: findDocuments. Use findDocumentsByElastic instead. =====');
        logger$r.warn('Passing userId to findDocuments is ignored. The logged in user will be used');
        /** @type {?} */
        const queryString = '?q=' + JSON.stringify(query);
        /** @type {?} */
        const url = SharedUrlRoutes.serverRoutes.loadDocsForRulesBaseUrl + '/' + userId + queryString;
        this.http.get(url).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            callback(null, response);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            callback(err);
        }));
    }
    /**
     * @param {?} ruleFlow
     * @param {?} callback
     * @return {?}
     */
    addIncludesToRuleset(ruleFlow, callback) {
        this.clientIncludeRuleSetService.addIncludesToRuleset(ruleFlow, callback);
    }
    /**
     * @private
     * @param {?} docInfo
     * @param {?} templateId
     * @param {?} userId
     * @param {?} callback
     * @return {?}
     */
    createDocumentFromTemplate(docInfo, templateId, userId, callback) {
        /** @type {?} */
        const loggedInUserId = this.user.account.documentId;
        if (userId && userId !== loggedInUserId) {
            logger$r.warn('Logged in user id will be used rather than the user id parameter ' +
                'passed to createDocumentFromTemplate');
        }
        if (!docInfo.documentId) {
            docInfo.documentId = UtilDocumentId.generateId();
        }
        if (!docInfo.systemHeader) {
            docInfo.systemHeader = {};
        }
        docInfo.systemHeader.templateId = templateId;
        this.dataService.insert(docInfo).then((/**
         * @param {?} result
         * @return {?}
         */
        function successFunc(result) {
            callback(null, result);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function errorFunc(err) {
            callback(err);
        }));
    }
    /**
     * @private
     * @param {?} serviceName
     * @param {?} callback
     * @return {?}
     */
    loadComponentLibrary(serviceName, callback) {
        /** @type {?} */
        const url = SharedUrlRoutes.serverRoutes.loadComponentLibrary + '/' + serviceName;
        /** @type {?} */
        let srv;
        try {
            // srv = this.$injector.get(ComponentLoader.getComponentLibraryScriptServiceName(serviceName));
        }
        catch (err) {
        }
        if (srv) {
            callback(null, srv);
        }
        else {
            callback(null, srv);
            // this.lazyLoader.load([{ type: 'js', path: url, serie: true }]).then(
            //   function (success) {
            //     srv = this.$injector.get(ComponentLoader.getComponentLibraryScriptServiceName(serviceName));
            //     if (srv) {
            //       callback(null, srv);
            //     } else {
            //       callback('Component library not found');
            //     }
            //   },
            //   function (error) {
            //     callback(error);
            //   });
        }
    }
    /**
     * @private
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    setSharedValue(key, value) {
        this.sharedValues[key] = value;
    }
    /**
     * @private
     * @param {?} key
     * @return {?}
     */
    getSharedValue(key) {
        return this.sharedValues[key];
    }
    /**
     * @param {?} query
     * @param {?} userId
     * @param {?} searchContext
     * @param {?} callback
     * @return {?}
     */
    findDocumentsBySearch(query, userId, searchContext, callback) {
        /** @type {?} */
        const _self = this;
        if (isFunction(searchContext)) {
            callback = searchContext;
            searchContext = {};
        }
        if (userId) {
            logger$r.warn('Passing userId to findDocumentsBySearch is ignored. The logged in user will be used');
        }
        /** @type {?} */
        const options = {
            filter: query
        };
        this.searchService.search(options, searchContext).then((/**
         * @param {?} data
         * @return {?}
         */
        function successFunc(data) {
            callback(null, data);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function errorFunc(err) {
            _self.notificationService.printMessage(err.message, 'error');
            callback(err);
        }));
    }
    /**
     * @param {?} query
     * @param {?} userId
     * @param {?} searchContext
     * @param {?} callback
     * @return {?}
     */
    findDocumentsByElastic(query, userId, searchContext, callback) {
        if (isFunction(searchContext)) {
            callback = searchContext;
            searchContext = {};
        }
        if (userId) {
            logger$r.warn('Passing userId to findDocumentsByElastic is ignored. The logged in user will be used');
        }
        this.dataService.findByElastic(query, searchContext).then((/**
         * @param {?} data
         * @return {?}
         */
        function successFunc(data) {
            // Need to refactor the result because of its requirement is the same as findDocuments
            callback(null, data);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function errorFunc(err) {
            callback(err);
        }));
    }
    /**
     * @param {?} message
     * @param {?} errorType
     * @param {?} succFunc
     * @param {?} errorFunc
     * @param {?} discardFunc
     * @return {?}
     */
    showDialog(message, errorType, succFunc, errorFunc, discardFunc) {
        this.modalService.showDialog(message, errorType, succFunc, errorFunc, discardFunc);
    }
    /**
     * set the modal service. This is set from the application importing the \@formbird/services
     *  library so that a native app can set its own implementation of ModalService
     * @param {?} modalService
     * @return {?}
     */
    setModalService(modalService) {
        this.modalService = modalService;
    }
}
ClientRulesService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ClientRulesService.ctorParameters = () => [
    { type: DataService },
    { type: LoggedInUserService },
    { type: ClientIncludeRuleSetService },
    { type: DocumentService },
    { type: OfflineStatusService },
    { type: HttpClient },
    { type: LazyScriptLoaderService },
    { type: SearchService },
    { type: NotificationService },
    { type: ModifiedFieldService },
    { type: DomSanitizer }
];
/** @nocollapse */ ClientRulesService.ɵprov = ɵɵdefineInjectable({ factory: function ClientRulesService_Factory() { return new ClientRulesService(ɵɵinject(DataService), ɵɵinject(LoggedInUserService), ɵɵinject(ClientIncludeRuleSetService), ɵɵinject(DocumentService), ɵɵinject(OfflineStatusService), ɵɵinject(HttpClient), ɵɵinject(LazyScriptLoaderService), ɵɵinject(SearchService), ɵɵinject(NotificationService), ɵɵinject(ModifiedFieldService), ɵɵinject(DomSanitizer)); }, token: ClientRulesService, providedIn: "root" });
__decorate([
    select(['userState', 'user']),
    __metadata("design:type", Observable)
], ClientRulesService.prototype, "user$", void 0);
if (false) {
    /** @type {?} */
    ClientRulesService.prototype.user$;
    /** @type {?} */
    ClientRulesService.prototype.user;
    /** @type {?} */
    ClientRulesService.prototype.modalService;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.sharedValues;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.dataService;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.clientIncludeRuleSetService;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.documentService;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.offlineStatusService;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.lazyScriptLoaderService;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.searchService;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.notificationService;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.modifiedFieldService;
    /**
     * @type {?}
     * @private
     */
    ClientRulesService.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/rules/rule-engine.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$s = console;
class RuleEngineService {
    /**
     * @param {?} clientRulesService
     * @param {?} configService
     * @param {?} localStorageService
     * @param {?} documentSessionService
     * @param {?} ruleCacheService
     */
    constructor(clientRulesService, configService, localStorageService, documentSessionService, ruleCacheService) {
        this.clientRulesService = clientRulesService;
        this.configService = configService;
        this.localStorageService = localStorageService;
        this.documentSessionService = documentSessionService;
        this.ruleCacheService = ruleCacheService;
        this.setProxyForDocument = (/**
         * @param {?} originalDoc
         * @param {?} documentContext
         * @param {?} dispatchedChangedActions
         * @return {?}
         */
        (originalDoc, documentContext, dispatchedChangedActions) => {
            /** @type {?} */
            const _self = this;
            /** @type {?} */
            const fieldsChangedByRuleset = {
                set: (/**
                 * @param {?} document
                 * @param {?} fldName
                 * @param {?} newValue
                 * @return {?}
                 */
                function (document, fldName, newValue) {
                    Reflect.set(document, fldName, newValue);
                    _self.attachChangedField(document, fldName, newValue, documentContext, dispatchedChangedActions);
                    console.log(`Setting value for field: ${fldName} - value: ${newValue}`);
                    return true;
                }),
                /**
                 * @param {?} document
                 * @param {?} fldName
                 * @return {?}
                 */
                deleteProperty(document, fldName) {
                    Reflect.deleteProperty(document, fldName);
                    _self.attachChangedField(document, fldName, undefined, documentContext, dispatchedChangedActions);
                    return true;
                }
            };
            return new Proxy(originalDoc, fieldsChangedByRuleset);
        });
    }
    /*
       * Process Rule flow string
       * @document - document object
       * @documentContext - additional objects will be used in rules
       * @ruleFlowInfo - rules flow as an object contains rulesetId and its script
       * @scope - additional scope objects will be plugged in to rules scope
       */
    /**
     * @param {?} document
     * @param {?} documentContext
     * @param {?} ruleFlowInfo
     * @param {?} ruleScope
     * @param {?} callback
     * @return {?}
     */
    processRuleFlow(document, documentContext, ruleFlowInfo, ruleScope, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const _self = this;
            /** @type {?} */
            const thisScope = yield this.clientRulesService.expose();
            if (ruleScope) {
                Object.keys(thisScope).forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                function (key) {
                    ruleScope[key] = thisScope[key];
                }));
                if (!documentContext) {
                    documentContext = {};
                }
                /** @type {?} */
                const documentId = document.documentId;
                documentContext.logger = logger$s;
                documentContext.appVersion = _self.localStorageService.getItem(LocalStorageKeys.APP_VERSION);
                documentContext.databaseMode = _self.configService.clientConfig().defaultSearchProvider;
                documentContext.documentSession = this.documentSessionService.getDocumentSession(documentId);
                /**
                 * @param {?} rulesetScriptFunc
                 * @return {?}
                 */
                function process(rulesetScriptFunc) {
                    if (rulesetScriptFunc) {
                        /** @type {?} */
                        const dispatchedChangedActions = {};
                        //defining proxy for document to get the changed fields from the ruleset.
                        /** @type {?} */
                        const proxyDocument = _self.setProxyForDocument(document, documentContext, dispatchedChangedActions);
                        RuleHelper.processJsonRuleset(proxyDocument, documentContext, rulesetScriptFunc, ruleScope, (/**
                         * @param {?} result
                         * @return {?}
                         */
                        function (result) {
                            _self.documentSessionService.setDocumentSession(documentId, documentContext.documentSession);
                            _self.dispatchChangedAction(dispatchedChangedActions);
                            callback(result);
                        }));
                    }
                }
                /** @type {?} */
                let rulesetCacheInfo = this.ruleCacheService.getRuleset(ruleFlowInfo.rulesetId);
                if (!rulesetCacheInfo || !(rulesetCacheInfo === null || rulesetCacheInfo === void 0 ? void 0 : rulesetCacheInfo.rulesetScriptFunc)) {
                    _self.clientRulesService.addIncludesToRuleset(ruleFlowInfo.ruleSetDSL, (/**
                     * @param {?} processedRuleFlowResult
                     * @return {?}
                     */
                    function (processedRuleFlowResult) {
                        if (processedRuleFlowResult.status === SharedConstants.STATUS_ERROR) {
                            callback(processedRuleFlowResult);
                        }
                        else {
                            /** @type {?} */
                            const processedRuleFlow = processedRuleFlowResult.ruleFlow;
                            if (processedRuleFlow) {
                                // Parse the rulesetScript into a JSON object of functions
                                /** @type {?} */
                                const ruleset = Function('return (' + processedRuleFlow + ')')();
                                _self.ruleCacheService.setRuleset(ruleFlowInfo.rulesetId, ruleset);
                                process(ruleset);
                            }
                            else {
                                callback();
                            }
                        }
                    }));
                }
                else {
                    process(rulesetCacheInfo.rulesetScriptFunc);
                }
            }
        });
    }
    /**
     * @param {?} dispatchedChangedActions
     * @return {?}
     */
    dispatchChangedAction(dispatchedChangedActions) {
        /** @type {?} */
        const fieldNames = Object.keys(dispatchedChangedActions);
        if (fieldNames.length) {
            fieldNames.forEach((/**
             * @param {?} fieldName
             * @return {?}
             */
            fieldName => {
                /** @type {?} */
                const action = dispatchedChangedActions[fieldName];
                console.log('Dispatching onfieldchange for field: ' + fieldName + ' - value: ' + action.payload.documentChangedInfo.newValue);
                getStore().dispatch(action);
            }));
        }
    }
    /**
     * @private
     * @param {?} document
     * @param {?} fldName
     * @param {?} newValue
     * @param {?} documentContext
     * @param {?} dispatchedChangedActions
     * @return {?}
     */
    attachChangedField(document, fldName, newValue, documentContext, dispatchedChangedActions) {
        if (this.isChangedTemplateFieldValue(fldName, documentContext.template)) {
            /** @type {?} */
            const currentChangedFields = documentContext.changedFields;
            /** @type {?} */
            const changedFields = documentContext.changedFields ? cloneDeep(currentChangedFields) : [];
            /** @type {?} */
            const sourceType = documentContext.changeSourceType;
            if (documentContext.eventName !== SharedConstants.RULESET_RELATIONSHIPS.ON_FIELD_CHANGE_EVENT_NAME.name) {
                return;
            }
            if (sourceType === ChangeSourceType.RULESET && (changedFields.includes(fldName) || documentContext.fieldChanged === fldName)) {
                //Stop the looping OnFieldChange on the current field
                return;
            }
            if (sourceType === ChangeSourceType.COMPONENT) {
                changedFields.push(documentContext.fieldChanged);
            }
            changedFields.push(fldName);
            /** @type {?} */
            const documentChangedInfo = {
                documentId: document.documentId,
                fieldName: fldName,
                newValue: newValue,
                formParameters: documentContext.formParameters,
                sourceType: ChangeSourceType.RULESET,
                changedFields: changedFields
            };
            dispatchedChangedActions[fldName] = formDocumentChanged(documentChangedInfo);
        }
    }
    /**
     * @private
     * @param {?} field
     * @param {?} template
     * @return {?}
     */
    isChangedTemplateFieldValue(field, template) {
        /** @type {?} */
        let flag = false;
        for (let i = 0; i < template.components.length; i++) {
            if (template.components[i].name === field) {
                flag = true;
                break;
            }
        }
        return flag;
    }
}
RuleEngineService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
RuleEngineService.ctorParameters = () => [
    { type: ClientRulesService },
    { type: ConfigService },
    { type: LocalStorageService },
    { type: DocumentSessionService },
    { type: RuleCacheService }
];
/** @nocollapse */ RuleEngineService.ɵprov = ɵɵdefineInjectable({ factory: function RuleEngineService_Factory() { return new RuleEngineService(ɵɵinject(ClientRulesService), ɵɵinject(ConfigService), ɵɵinject(LocalStorageService), ɵɵinject(DocumentSessionService), ɵɵinject(RuleCacheService)); }, token: RuleEngineService, providedIn: "root" });
if (false) {
    /** @type {?} */
    RuleEngineService.prototype.setProxyForDocument;
    /**
     * @type {?}
     * @private
     */
    RuleEngineService.prototype.clientRulesService;
    /**
     * @type {?}
     * @private
     */
    RuleEngineService.prototype.configService;
    /**
     * @type {?}
     * @private
     */
    RuleEngineService.prototype.localStorageService;
    /**
     * @type {?}
     * @private
     */
    RuleEngineService.prototype.documentSessionService;
    /**
     * @type {?}
     * @private
     */
    RuleEngineService.prototype.ruleCacheService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/tab/tab.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TabService {
    constructor() {
    }
    /**
     * @param {?} templateId
     * @param {?} initialData
     * @param {?} newTab
     * @param {?} callback
     * @return {?}
     */
    openNewDocument(templateId, initialData, newTab, callback) {
        if (!callback) {
            callback = (/**
             * @return {?}
             */
            function () {
            });
        }
        /** @type {?} */
        let target = '_blank';
        if ((newTab && newTab !== null && newTab === 'no') || newTab === false) {
            target = '_self';
        }
        /** @type {?} */
        const initialDataKey = 'initialData:' + templateId;
        localStorage.setItem(UrlBasePathUtil.basePath + initialDataKey, JSON.stringify(initialData));
        callback();
        window.open('form/' + templateId, target);
    }
}
TabService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
TabService.ctorParameters = () => [];
/** @nocollapse */ TabService.ɵprov = ɵɵdefineInjectable({ factory: function TabService_Factory() { return new TabService(); }, token: TabService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/validation/validation.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$t = console;
/**
 * @record
 */
function RulesData() { }
if (false) {
    /** @type {?} */
    RulesData.prototype.eventName;
    /** @type {?} */
    RulesData.prototype.document;
    /** @type {?} */
    RulesData.prototype.documentContext;
    /** @type {?|undefined} */
    RulesData.prototype.callback;
    /** @type {?|undefined} */
    RulesData.prototype.error;
    /** @type {?|undefined} */
    RulesData.prototype.results;
    /** @type {?|undefined} */
    RulesData.prototype.rulesetCount;
}
class ValidationService {
    /**
     * @param {?} documentService
     * @param {?} unsavedDocumentService
     * @param {?} notificationService
     * @param {?} modifiedFieldService
     * @param {?} ruleEngineService
     * @param {?} loggedInUserService
     * @param {?} currentDocumentService
     * @param {?} preProcessorFieldService
     * @param {?} configService
     * @param {?} broadcastService
     * @param {?} tabService
     * @param {?} clientAccessService
     * @param {?} appStore
     */
    constructor(documentService, unsavedDocumentService, notificationService, modifiedFieldService, ruleEngineService, loggedInUserService, currentDocumentService, preProcessorFieldService, configService, broadcastService, tabService, // do not remove. Used in ClientRuleContext
    clientAccessService, // do not remove. Used in ClientRuleContext
    appStore) {
        this.documentService = documentService;
        this.unsavedDocumentService = unsavedDocumentService;
        this.notificationService = notificationService;
        this.modifiedFieldService = modifiedFieldService;
        this.ruleEngineService = ruleEngineService;
        this.loggedInUserService = loggedInUserService;
        this.currentDocumentService = currentDocumentService;
        this.preProcessorFieldService = preProcessorFieldService;
        this.configService = configService;
        this.broadcastService = broadcastService;
        this.tabService = tabService;
        this.clientAccessService = clientAccessService;
        this.appStore = appStore;
        this.subs = new Subscription();
        /**
         * ------------------- Exported data -------------------------**
         */
        this.validationCtrlValues = {};
        /**
         * ------------------- Local data ----------------------------**
         */
        this.eventList = {};
        this.pendingSave = null;
        this.queue = new Subject();
        /**
         * ------------------- End Rule context -------------------***
         */
        this.validateFormFields = (/**
         * @param {?=} value
         * @return {?}
         */
        (value) => {
            this.broadcastEvent(ClientConstants.VALIDATE_FORM_FIELDS, value);
        });
        /** @type {?} */
        const subDocData = this.currentDocumentService.documentData$.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            this.documentData = data;
        }));
        /** @type {?} */
        const subUser = this.user$.subscribe((/**
         * @param {?} user
         * @return {?}
         */
        (user) => this.user = user));
        /** @type {?} */
        const documentChangedSub = this.documentChangedInfo$.subscribe((/**
         * @param {?} documentChangedData
         * @return {?}
         */
        (documentChangedData) => {
            this.handleOnFieldChange(documentChangedData);
        }));
        /** @type {?} */
        const results = this.queue.pipe(concatMap((/**
         * @param {?} rulesData
         * @return {?}
         */
        (rulesData) => {
            return this.executeDocumentEventPromise(rulesData);
        })));
        /** @type {?} */
        const ruleSub = results.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            var _a;
            if (data.rulesetCount) {
                logger$t.info(`%c${data === null || data === void 0 ? void 0 : data.rulesetCount} ${data === null || data === void 0 ? void 0 : data.eventName} rules done for document: ${(_a = data === null || data === void 0 ? void 0 : data.document) === null || _a === void 0 ? void 0 : _a.documentId}`, `color:green`);
            }
            data.callback(data.error, data.results);
        }));
        /** @type {?} */
        const destroyedSub = broadcastService.on(ClientConstants.DOCUMENT_DESTROYED).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            this.destroyedDocumentData = data;
        }));
        this.subs.add(subDocData);
        this.subs.add(subUser);
        this.subs.add(documentChangedSub);
        this.subs.add(ruleSub);
        this.subs.add(destroyedSub);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    /**
     * ------------------- Exported functions --------------------**
     * @param {?} tplItem
     * @param {?} fieldName
     * @return {?}
     */
    loadValidators(tplItem, fieldName) {
        /** @type {?} */
        const validators = [];
        /** @type {?} */
        const required = {
            'name': ClientConstants.VALIDATION_REQUIRED_KEY,
            'text': ClientConstants.VALIDATION_REQUIRED_MESSAGE
        };
        validators.push(required);
        /** @type {?} */
        const minLength = {
            'name': ClientConstants.VALIDATION_MIN_LENGTH_KEY,
            'text': ClientConstants.VALIDATION_MIN_LENGTH_MESSAGE.replace(/%s/g, tplItem.minLength)
        };
        validators.push(minLength);
        /** @type {?} */
        const maxLength = {
            'name': ClientConstants.VALIDATION_MAX_LENGTH_KEY,
            'text': ClientConstants.VALIDATION_MAX_LENGTH_MESSAGE.replace(/%s/g, tplItem.maxLength)
        };
        validators.push(maxLength);
        return validators;
    }
    /**
     * @param {?} save
     * @return {?}
     */
    waitPendingEvents(save) {
        logger$t.info('ModifiedFieldService.formDirty.validating ' + this.modifiedFieldService.formDirty.validating);
        if (this.modifiedFieldService.formDirty.validating) {
            this.modifiedFieldService.setShowSpinner(true);
            this.modifiedFieldService.setDirty(false);
            this.pendingSave = save;
        }
        else {
            save();
        }
    }
    /**
     * @private
     * @param {?} prevDocument
     * @param {?} document
     * @param {?} ruleContext
     * @return {?}
     */
    updateDocumentToStore(prevDocument, document, ruleContext) {
        /** @type {?} */
        const diffs = UtilConflict.getDiffs(prevDocument, document);
        if (diffs && diffs.length) {
            this.dispatchStoreAction(formSetDocument(document));
        }
    }
    /**
     * @private
     * @param {?} documentChangedData
     * @return {?}
     */
    handleOnFieldChange(documentChangedData) {
        if (documentChangedData) {
            /** @type {?} */
            const state = this.appStore.getState().formState;
            /** @type {?} */
            const documentId = documentChangedData.documentId;
            /** @type {?} */
            const document = cloneDeep(state.documents[documentId]);
            /** @type {?} */
            const formParams = documentChangedData.formParameters;
            /** @type {?} */
            const templateId = formParams && formParams.overrideTemplateId ? formParams.overrideTemplateId : document.systemHeader.templateId;
            /** @type {?} */
            const template = state.documents[templateId];
            /** @type {?} */
            const fieldName = documentChangedData.fieldName;
            /** @type {?} */
            const formParameters = documentChangedData.formParameters;
            /** @type {?} */
            const component = template.components.filter((/**
             * @param {?} comp
             * @return {?}
             */
            comp => comp.name === fieldName))[0] || {};
            if (documentChangedData.shouldCompareValues !== false) {
                if (isEqual(documentChangedData.newValue, documentChangedData.oldValue) ||
                    (!UtilValidation.hasValue(documentChangedData.oldValue) &&
                        !UtilValidation.hasValue(documentChangedData.newValue))) { // first run.
                    return;
                }
                /** @type {?} */
                const isChanged = this.modifiedFieldService.isChangedField(documentId, fieldName, formParameters.unsavedDocumentListId);
                if (!isChanged && isEqual(documentChangedData.newValue, documentChangedData.oldValue)) {
                    return;
                }
            }
            if (!component.disableSave) {
                this.modifiedFieldService.addModifiedField(documentId, fieldName, formParameters.unsavedDocumentListId);
            }
            this.preProcessorFieldService.preProcessOneField(component, document);
            /** @type {?} */
            const orgValue = this.appStore.getState().formState.orgDocuments[documentId][fieldName];
            /** @type {?} */
            const docContext = (/** @type {?} */ ({}));
            docContext.fieldChanged = fieldName;
            docContext.originValue = orgValue;
            docContext.newValue = documentChangedData.newValue;
            docContext.oldValue = documentChangedData.oldValue;
            docContext.templateId = template.documentId;
            docContext.formParameters = formParameters;
            docContext.template = template;
            docContext.databaseMode = this.configService.clientConfig().defaultSearchProvider;
            docContext.changeSourceType = documentChangedData.sourceType;
            docContext.changedFields = documentChangedData.changedFields;
            this.validateChangedField(component, document, template, documentChangedData.newValue, docContext);
        }
    }
    /**
     * @param {?} documentChangedInfo
     * @return {?}
     */
    executeOnFieldChangeWithNoChanges(documentChangedInfo) {
        this.handleOnFieldChange(documentChangedInfo);
    }
    /**
     * @private
     * @param {?} document
     * @param {?} docContext
     * @return {?}
     */
    executeOnFieldChange(document, docContext) {
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const currentValidating = new Date();
        _self.modifiedFieldService.formDirty.validating = currentValidating;
        _self.executeDocumentEvent(SharedConstants.RULESET_RELATIONSHIPS.ON_FIELD_CHANGE_EVENT_NAME.name, document, docContext, (/**
         * @param {?} error
         * @param {?} result
         * @return {?}
         */
        function (error, result) {
            if (result) {
                _self.broadcastValidationEvent();
            }
            if (_self.modifiedFieldService.formDirty.validating === currentValidating) {
                if (_self.pendingSave !== null) {
                    _self.pendingSave();
                }
                _self.modifiedFieldService.formDirty.validating = null;
                _self.pendingSave = null;
            }
        }));
    }
    /**
     * @private
     * @param {?} component
     * @param {?} document
     * @param {?} template
     * @param {?} newValue
     * @param {?} docContext
     * @return {?}
     */
    validateChangedField(component, document, template, newValue, docContext) {
        /** @type {?} */
        const fieldName = component.name;
        this.initFieldValidator(document, template, component, fieldName, newValue);
        this.executeOnFieldChange(document, docContext);
    }
    /**
     * @param {?} scope
     * @param {?} originValue
     * @param {?} newValue
     * @param {?} oldValue
     * @return {?}
     */
    validateChangedFieldValues(scope, originValue, newValue, oldValue) {
        /** @type {?} */
        const tplField = scope.tplItem;
        /** @type {?} */
        const fieldName = scope.fieldName;
        /** @type {?} */
        const document = scope.doc;
        /** @type {?} */
        const template = scope.tpl;
        this.initFieldValidator(document, template, tplField, fieldName, newValue);
        /** @type {?} */
        const docContext = (/** @type {?} */ ({}));
        docContext.fieldChanged = fieldName;
        docContext.originValue = originValue;
        docContext.newValue = newValue;
        docContext.oldValue = oldValue;
        docContext.templateId = scope.tplId;
        docContext.formParameters = scope.formParameters;
        docContext.template = scope.tpl;
        docContext.databaseMode = this.configService.clientConfig().defaultSearchProvider;
        this.executeOnFieldChange(scope.doc, docContext);
    }
    /**
     * @param {?} formParameters
     * @param {?} document
     * @param {?} docContext
     * @param {?} callback
     * @return {?}
     */
    preRenderDocument(formParameters, document, docContext, callback) {
        docContext.formParameters = formParameters;
        this.executeDocumentEvent(SharedConstants.RULESET_RELATIONSHIPS.PRERENDER_EVENT_NAME.name, document, docContext, callback);
    }
    /**
     * @param {?} formParameters
     * @param {?} document
     * @param {?} docContext
     * @param {?} callback
     * @return {?}
     */
    onLoadDocument(formParameters, document, docContext, callback) {
        /** @type {?} */
        const template = docContext.template;
        // reset validation values due to template/document OnLoad
        this.validationCtrlValues[document.documentId] = {
            templateId: template.documentId
        };
        docContext.formParameters = formParameters;
        this.executeDocumentEvent(SharedConstants.RULESET_RELATIONSHIPS.ONLOAD_EVENT_NAME.name, document, docContext, callback);
    }
    /**
     * @param {?} formParameters
     * @param {?} document
     * @param {?} docContext
     * @param {?} callback
     * @return {?}
     */
    onPreSaveDocument(formParameters, document, docContext, callback) {
        docContext.formParameters = formParameters;
        if (!docContext.formParameters) {
            /** @type {?} */
            const unsavedDocumentListId = docContext.unsavedDocumentListId;
            /** @type {?} */
            const unsavedDocs = this.unsavedDocumentService.getDocuments();
            if (unsavedDocs && unsavedDocs[unsavedDocumentListId]) {
                docContext.formParameters = {};
                docContext.formParameters.hierarchyDocInfo = unsavedDocs[unsavedDocumentListId].hierarchyDocInfo;
            }
        }
        this.executeDocumentEvent(SharedConstants.RULESET_RELATIONSHIPS.PRESAVE_EVENT_NAME.name, document, docContext, callback);
    }
    /**
     * @param {?} formParameters
     * @param {?} document
     * @param {?} docContext
     * @param {?} callback
     * @return {?}
     */
    onPostSaveClientDocument(formParameters, document, docContext, callback) {
        if (!formParameters) {
            /** @type {?} */
            const unsavedDocumentListId = docContext.unsavedDocumentListId;
            /** @type {?} */
            const unsavedDocs = this.unsavedDocumentService.getDocuments();
            if (unsavedDocs && unsavedDocs[unsavedDocumentListId]) {
                docContext.formParameters = {};
                docContext.formParameters.hierarchyDocInfo = unsavedDocs[unsavedDocumentListId].hierarchyDocInfo;
            }
        }
        else {
            docContext.formParameters = formParameters;
        }
        this.executeDocumentEvent(SharedConstants.RULESET_RELATIONSHIPS.POSTSAVE_CLIENT_EVENT_NAME.name, document, docContext, callback);
    }
    /**
     * @return {?}
     */
    broadcastValidationEvent() {
        this.broadcastEvent(SharedConstants.EVENT_VALIDATION_VALUES_NAME, this.validationCtrlValues);
    }
    /**
     * @param {?} eventName
     * @param {?=} eventValue
     * @return {?}
     */
    broadcastEvent(eventName, eventValue) {
        this.broadcastService.broadcast(eventName, eventValue);
    }
    /**
     * @param {?} action
     * @return {?}
     */
    dispatchStoreAction(action) {
        this.appStore.dispatch(action);
    }
    /**
     * ---------------------- Helper functions -----------------**
     * @private
     * @param {?} document
     * @param {?} template
     * @param {?} tplField
     * @param {?} fieldName
     * @param {?} fieldValue
     * @return {?}
     */
    initFieldValidator(document, template, tplField, fieldName, fieldValue) {
        this.initValidationValue(document, template, fieldName);
        if (tplField.mandatory === true) {
            this.setValidationValue(document, fieldName, 'required', !UtilValidation.hasValue(fieldValue));
        }
        if (tplField.minLength) {
            this.setValidationValue(document, fieldName, 'hasMinLength', !UtilValidation.validateMinLength(fieldValue, tplField.minLength));
        }
        if (tplField.maxLength) {
            this.setValidationValue(document, fieldName, 'hasMaxLength', !UtilValidation.validateMaxLength(fieldValue, tplField.maxLength));
        }
    }
    /**
     * @param {?} eventName
     * @param {?} processDoc
     * @param {?} documentContext
     * @param {?} eventRule
     * @return {?}
     */
    executeRuleSet(eventName, processDoc, documentContext, eventRule) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const _self = this;
            return new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            (resolve, reject) => {
                /** @type {?} */
                const prevDocument = cloneDeep(processDoc);
                documentContext.eventName = eventName;
                /** @type {?} */
                const ruleContext = new RuleContext(_self, eventName, processDoc, documentContext);
                _self.ruleEngineService.processRuleFlow(processDoc, documentContext, eventRule, ruleContext, (/**
                 * @param {?} result
                 * @return {?}
                 */
                function (result) {
                    /** @type {?} */
                    const msg = result ? result.message : null;
                    /** @type {?} */
                    const status = result ? result.status : SharedConstants.STATUS_SUCCESS;
                    if (msg) {
                        _self.notificationService.printMessage(msg, status, null, 'toast-top-right', false);
                    }
                    if (status && status.toLowerCase() === SharedConstants.STATUS_ERROR) {
                        reject(result);
                    }
                    else {
                        switch (eventName) {
                            case SharedConstants.RULESET_RELATIONSHIPS.ONLOAD_EVENT_NAME.name:
                                _self.broadcastEvent(SharedConstants.ONLOAD_DONE_RULES_EVENT_NAME, true);
                                break;
                        }
                        _self.updateDocumentToStore(prevDocument, processDoc, documentContext);
                        resolve(result);
                    }
                }));
            }));
        });
    }
    /**
     * @private
     * @param {?} rulesData
     * @return {?}
     */
    shouldRunRules(rulesData) {
        var _a, _b, _c, _d;
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const eventName = rulesData.eventName;
        /** @type {?} */
        const documentContext = rulesData.documentContext;
        if (SharedConstants.RULESET_RELATIONSHIPS.ON_FIELD_CHANGE_EVENT_NAME.name === eventName && !this.isExistsChangedFieldInRulesetTriggeredOn(eventName, documentContext)) {
            return false;
        }
        /** @type {?} */
        const document = rulesData.document;
        /** @type {?} */
        const unsavedDocumentListId = (_b = (_a = rulesData.documentContext) === null || _a === void 0 ? void 0 : _a.formParameters) === null || _b === void 0 ? void 0 : _b.unsavedDocumentListId;
        if (((_c = _self.destroyedDocumentData) === null || _c === void 0 ? void 0 : _c.documentId) === document.documentId && ((_d = _self.destroyedDocumentData) === null || _d === void 0 ? void 0 : _d.unsavedDocumentListId) === unsavedDocumentListId) {
            _self.destroyedDocumentData = null;
            /** @type {?} */
            const msg = `%cDocument: ${document.documentId} has been unloaded on form. Terminate processing ${eventName} rules.`;
            logger$t.info(msg, `color:green`);
            return false;
        }
        return true;
    }
    /**
     * @param {?} rulesData
     * @return {?}
     */
    executeDocumentEventPromise(rulesData) {
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const eventName = rulesData.eventName;
        /** @type {?} */
        let document = rulesData.document ? rulesData.document : {};
        /** @type {?} */
        const documentContext = rulesData.documentContext;
        /** @type {?} */
        const changedField = documentContext.fieldChanged;
        /** @type {?} */
        const newValue = documentContext.newValue;
        /** @type {?} */
        const changedFieldMsg = ` - changed field: ${changedField} - value: ${newValue}`;
        /** @type {?} */
        const msg = `%cChecking for and processing ${eventName} rules for document: ${document.documentId} ${changedField ? changedFieldMsg : ''}`;
        logger$t.info(msg, `color:green`);
        return new Promise((/**
         * @param {?} resolve
         * @return {?}
         */
        (resolve) => {
            if (_self.shouldRunRules(rulesData) === false) {
                resolve(rulesData);
                return;
            }
            _self.loadRule(eventName, documentContext.template).then((/**
             * @param {?} rulesets
             * @return {?}
             */
            function successFunc(rulesets) {
                rulesData.rulesetCount = rulesets.length;
                if (!rulesets.length) {
                    resolve(rulesData);
                    return;
                }
                /**
                 * @param {?} user
                 * @param {?} accountControl
                 * @return {?}
                 */
                function processEvent(user, accountControl) {
                    documentContext.user = user ? user : {};
                    documentContext.accountControl = accountControl;
                    _self.setParentTplDoc(documentContext, document);
                    _self.setChildTplDoc(documentContext, document);
                    /**
                     * @param {?} ruleset
                     * @return {?}
                     */
                    function asyncJob(ruleset) {
                        if (ruleset) {
                            /** @type {?} */
                            const state = _self.appStore.getState().formState;
                            document = cloneDeep(state.documents[document.documentId]);
                            return _self.executeRuleSet(eventName, document, documentContext, ruleset);
                        }
                    }
                    UtilSequenceProcess.processList(rulesets, asyncJob).then((/**
                     * @param {?} results
                     * @return {?}
                     */
                    function allPromiseSuccessFunc(results) {
                        rulesData.results = results;
                        resolve(rulesData);
                    }), (/**
                     * @param {?} err
                     * @return {?}
                     */
                    function errorFunc(err) {
                        rulesData.error = err;
                        resolve(rulesData);
                        if (eventName === SharedConstants.RULESET_RELATIONSHIPS.PRESAVE_EVENT_NAME.name) {
                            _self.broadcastEvent(ClientConstants.PRESAVE_DOCUMENT_FORM_RESET, {
                                document: document,
                                unsavedDocumentListId: documentContext.unsavedDocumentListId
                            });
                        }
                    }));
                }
                _self.loggedInUserService.loadLoggedUser().then((/**
                 * @param {?} result
                 * @return {?}
                 */
                function (result) {
                    processEvent(result.user, _self.user.accountControlDocument);
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function (err) {
                    /** @type {?} */
                    let msg = 'Error loading user data: ';
                    msg += err.message ? err.message : err.statusText ? err.statusText : ' Status code: ' + err.status;
                    logger$t.error(msg);
                    rulesData.error = new Error(msg);
                    resolve(rulesData);
                }));
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function errorFunc(err) {
                logger$t.error('Load rule error: ' + err);
                rulesData.error = err;
                resolve(rulesData);
            }));
        }));
    }
    /**
     * @param {?} eventName
     * @param {?} document
     * @param {?} documentContext
     * @param {?} callback
     * @return {?}
     */
    executeDocumentEvent(eventName, document, documentContext, callback) {
        /** @type {?} */
        const rulesData = {
            eventName,
            document,
            documentContext,
            callback
        };
        this.queue.next(rulesData);
    }
    /**
     * @param {?} unsavedListItems
     * @param {?} hierachyDoc
     * @return {?}
     */
    loadParentTplDocFromUnsavedList(unsavedListItems, hierachyDoc) {
        /** @type {?} */
        const result = {
            parentDoc: null,
            parentTpl: null
        };
        for (let i = 0; i < unsavedListItems.length; i++) {
            /** @type {?} */
            const parentId = hierachyDoc.parentDocumentId;
            result.parentDoc = this.unsavedDocumentService.getDocumentOnly(parentId);
            if (result.parentDoc) {
                if (this.documentData && this.documentData.overrideTemplateId) {
                    result.parentTpl = this.unsavedDocumentService.getTemplateOnly(this.documentData.overrideTemplateId);
                }
                else {
                    result.parentTpl = this.unsavedDocumentService.getTemplateOnly(result.parentDoc.systemHeader.templateId);
                }
                break;
            }
        }
        return result;
    }
    /**
     * @private
     * @param {?} documentContext
     * @param {?} document
     * @return {?}
     */
    setParentTplDoc(documentContext, document) {
        /** @type {?} */
        let result = (/** @type {?} */ ({}));
        /** @type {?} */
        const hasHierarchyDoc = documentContext.formParameters && documentContext.formParameters.hierarchyDocInfo;
        if (hasHierarchyDoc) {
            /** @type {?} */
            const hierachyDoc = documentContext.formParameters.hierarchyDocInfo;
            if (hierachyDoc.documentId === document.documentId ||
                documentContext.formParameters.selectedDocumentId === document.systemHeader.templateId) {
                documentContext.isChildDoc = true;
                // find the parent in the list of child document hierachy first (ie: ChildDocumentList)
                /** @type {?} */
                const unsavedChildListItems = this.unsavedDocumentService.getDocumentListByType(ClientConstants.CHILD_DOCUMENT_INFO_LIST);
                result = this.loadParentTplDocFromUnsavedList(unsavedChildListItems, hierachyDoc);
                if (!result.parentDoc) {
                    // if parent does not exist in the child document list, find it in the main document list
                    /** @type {?} */
                    const unsavedMainListItems = this.unsavedDocumentService.getDocumentListByType(ClientConstants.MAIN_DOCUMENT_INFO_LIST);
                    result = this.loadParentTplDocFromUnsavedList(unsavedMainListItems, hierachyDoc);
                }
            }
        }
        documentContext.parentDocument = result.parentDoc;
        documentContext.parentTemplate = result.parentTpl;
    }
    /**
     * @private
     * @param {?} documentContext
     * @param {?} document
     * @return {?}
     */
    setChildTplDoc(documentContext, document) {
        /** @type {?} */
        const documents = this.appStore.getState().formState.documents;
        /** @type {?} */
        let childDoc;
        /** @type {?} */
        let childTpl;
        // find in ChildDocumentList that this one is the parent
        /** @type {?} */
        const unsavedChildListItems = this.unsavedDocumentService.getDocumentListByType(ClientConstants.CHILD_DOCUMENT_INFO_LIST);
        if (unsavedChildListItems && unsavedChildListItems.length) {
            for (let i = 0; i < unsavedChildListItems.length; i++) {
                /** @type {?} */
                const hierarchyDocInfo = unsavedChildListItems[i].hierarchyDocInfo;
                if (hierarchyDocInfo.parentDocumentId === document.documentId) {
                    /** @type {?} */
                    const childDocId = hierarchyDocInfo.documentId;
                    childDoc = documents[childDocId];
                    if (childDoc) {
                        childTpl = documents[childDoc.systemHeader.templateId];
                        break;
                    }
                }
            }
        }
        documentContext.childDocument = childDoc;
        documentContext.childTemplate = childTpl;
    }
    /**
     * @private
     * @param {?} docId
     * @param {?} ruleName
     * @return {?}
     */
    loadRulesetById(docId, ruleName) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            _self.documentService.getDocumentOnly(docId).then((/**
             * @param {?} doc
             * @return {?}
             */
            function successFunc(doc) {
                resolve({
                    rulesetId: docId,
                    ruleSetDSL: doc.ruleSetDSL
                });
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function errorFunc(err) {
                /** @type {?} */
                let msg = ruleName + ' ruleset: ' + docId + ' not found due to error: ';
                msg += err && err.message ? err.message : err;
                if (ruleName === SharedConstants.RULESET_RELATIONSHIPS.ONLOAD_EVENT_NAME.name) {
                    reject(new Error(msg));
                }
                else {
                    _self.notificationService.printMessage(msg, SharedConstants.STATUS_WARNING, null, { x: 'right', y: 'top' });
                    // do not break the chain in order to load the next ruleset document
                    resolve(true);
                }
            }));
        }));
    }
    /**
     * @private
     * @param {?} ruleName
     * @param {?} template
     * @return {?}
     */
    loadRule(ruleName, template) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (template) {
                /** @type {?} */
                const relName = UtilRules.getRelatedName(ruleName);
                /** @type {?} */
                const rulesetRelValues = template[relName];
                if (rulesetRelValues) {
                    logger$t.info('Using number of related rulesets: ' + rulesetRelValues.length);
                    /** @type {?} */
                    const promises = [];
                    rulesetRelValues.forEach((/**
                     * @param {?} obj
                     * @return {?}
                     */
                    function (obj) {
                        promises.push(_self.loadRulesetById(obj.documentId, ruleName));
                    }));
                    Promise.all(promises).then((/**
                     * @param {?} ruleFlows
                     * @return {?}
                     */
                    function successFunc(ruleFlows) {
                        logger$t.info('Found related rulesets: ' + ruleFlows.length);
                        resolve(ruleFlows);
                    }), (/**
                     * @param {?} err
                     * @return {?}
                     */
                    function errorFunc(err) {
                        logger$t.warn('Not found related rulesets.');
                        reject(err);
                    }));
                }
                else {
                    /** @type {?} */
                    const rules = template.rules;
                    /** @type {?} */
                    const foundRuleset = [];
                    if (rules && rules.length) {
                        logger$t.info('Using embeded ruleset in template...');
                        for (let rId = 0; rId < rules.length; rId++) {
                            if (rules[rId].name === ruleName) {
                                logger$t.warn('DEPRECATED: please use the ruleset related document structure ' +
                                    'in the rules definition instead of having the ruleFlow script directly ' +
                                    'in template: ' + template.documentId);
                                foundRuleset.push(rules[rId].ruleFlow);
                            }
                        }
                    }
                    resolve(foundRuleset);
                }
            }
        }));
    }
    /**
     * @param {?} document
     * @param {?} template
     * @param {?} field
     * @return {?}
     */
    initValidationValue(document, template, field) {
        /** @type {?} */
        const affectedDocId = document.documentId;
        if (!this.validationCtrlValues[affectedDocId]) {
            this.validationCtrlValues[affectedDocId] = {
                templateId: template.documentId
            };
        }
        if (!this.validationCtrlValues[affectedDocId][field]) {
            this.validationCtrlValues[affectedDocId][field] = {};
        }
    }
    /**
     * @private
     * @param {?} affectedDoc
     * @param {?} field
     * @param {?} name
     * @param {?} flag
     * @return {?}
     */
    setValidationValue(affectedDoc, field, name, flag) {
        if (flag !== undefined) {
            // use string values of "yes" and "true" so that they can be used inside the rules.
            /** @type {?} */
            const result = (flag === 'yes' || flag === 'true' || flag === true);
            if (this.validationCtrlValues[affectedDoc.documentId] &&
                this.validationCtrlValues[affectedDoc.documentId][field]) {
                if (this.validationCtrlValues[affectedDoc.documentId][field][name] !== result) {
                    this.validationCtrlValues[affectedDoc.documentId][field][name] = result;
                    this.validateFormFields({
                        documentId: affectedDoc.documentId,
                        fieldName: field,
                        validateName: name
                    });
                }
            }
        }
    }
    /**
     * @private
     * @param {?} eventName
     * @param {?} documentContext
     * @return {?}
     */
    isExistsChangedFieldInRulesetTriggeredOn(eventName, documentContext) {
        /** @type {?} */
        let isChangedFieldFound = false;
        if (SharedConstants.RULESET_RELATIONSHIPS.ON_FIELD_CHANGE_EVENT_NAME.name === eventName) {
            /** @type {?} */
            const rulesetRelValues = documentContext.template[SharedConstants.RULESET_RELATIONSHIPS.ON_FIELD_CHANGE_EVENT_NAME.relName];
            if (rulesetRelValues && rulesetRelValues.length > 0) {
                for (let i = 0; i < rulesetRelValues.length; i++) {
                    /** @type {?} */
                    const ruleObj = rulesetRelValues[i];
                    isChangedFieldFound = !ruleObj.triggeredOn || includes(ruleObj.triggeredOn, documentContext.fieldChanged);
                    if (isChangedFieldFound) {
                        break;
                    }
                }
            }
        }
        return isChangedFieldFound;
    }
}
ValidationService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ValidationService.ctorParameters = () => [
    { type: DocumentService },
    { type: UnsavedDocumentService },
    { type: NotificationService },
    { type: ModifiedFieldService },
    { type: RuleEngineService },
    { type: LoggedInUserService },
    { type: CurrentDocumentService },
    { type: PreProcessorFieldService },
    { type: ConfigService },
    { type: BroadcastService },
    { type: TabService },
    { type: ClientAccessService },
    { type: AppStore }
];
/** @nocollapse */ ValidationService.ɵprov = ɵɵdefineInjectable({ factory: function ValidationService_Factory() { return new ValidationService(ɵɵinject(DocumentService), ɵɵinject(UnsavedDocumentService), ɵɵinject(NotificationService), ɵɵinject(ModifiedFieldService), ɵɵinject(RuleEngineService), ɵɵinject(LoggedInUserService), ɵɵinject(CurrentDocumentService), ɵɵinject(PreProcessorFieldService), ɵɵinject(ConfigService), ɵɵinject(BroadcastService), ɵɵinject(TabService), ɵɵinject(ClientAccessService), ɵɵinject(AppStore)); }, token: ValidationService, providedIn: "root" });
__decorate([
    select(['formState', 'documentChangedInfo']),
    __metadata("design:type", Observable)
], ValidationService.prototype, "documentChangedInfo$", void 0);
__decorate([
    select(['userState', 'user']),
    __metadata("design:type", Observable)
], ValidationService.prototype, "user$", void 0);
if (false) {
    /** @type {?} */
    ValidationService.prototype.documentChangedInfo$;
    /** @type {?} */
    ValidationService.prototype.user$;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.subs;
    /** @type {?} */
    ValidationService.prototype.documentData;
    /** @type {?} */
    ValidationService.prototype.user;
    /**
     * ------------------- Exported data -------------------------**
     * @type {?}
     */
    ValidationService.prototype.validationCtrlValues;
    /**
     * ------------------- Local data ----------------------------**
     * @type {?}
     */
    ValidationService.prototype.eventList;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.pendingSave;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.queue;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.destroyedDocumentData;
    /**
     * ------------------- End Rule context -------------------***
     * @type {?}
     */
    ValidationService.prototype.validateFormFields;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.documentService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.unsavedDocumentService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.notificationService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.modifiedFieldService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.ruleEngineService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.currentDocumentService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.preProcessorFieldService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.configService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.broadcastService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.tabService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.clientAccessService;
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.appStore;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/changed-document.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ChangedDocumentService {
    /**
     * @param {?} appStore
     * @param {?} validationService
     */
    constructor(appStore, validationService) {
        this.appStore = appStore;
        this.validationService = validationService;
    }
    /**
     * @param {?} action
     * @return {?}
     */
    dispatchAction(action) {
        this.appStore.dispatch(action);
    }
    /**
     * Provide the change information for the specified document field that the component binds to
     * @param {?} component the component binds to the field
     * @param {?} newValue the changed/new value
     * @param {?=} controlName the registered control manages the field value
     * @param {?=} options the options
     * @return {?}
     */
    valueChanged(component, newValue, controlName, options) {
        /** @type {?} */
        const documentChangedInfo = {
            documentId: component.document.documentId,
            fieldName: component.fieldName,
            newValue: newValue,
            formParameters: component.formParameters,
            // default source value change is made from the component
            sourceType: (options === null || options === void 0 ? void 0 : options.sourceType) ? options === null || options === void 0 ? void 0 : options.sourceType : ChangeSourceType.COMPONENT,
            controlName: controlName
        };
        this.appStore.dispatch(formDocumentChanged(documentChangedInfo));
    }
    /**
     * @param {?} component
     * @return {?}
     */
    executeOnFieldChangeWithNoChanges(component) {
        /** @type {?} */
        const documentChangedInfo = {
            documentId: component.document.documentId,
            fieldName: component.fieldName,
            newValue: null,
            formParameters: component.formParameters,
            // default source value change is made from the component
            sourceType: ChangeSourceType.COMPONENT,
            shouldCompareValues: false
        };
        this.validationService.executeOnFieldChangeWithNoChanges(documentChangedInfo);
    }
    /**
     * @return {?}
     */
    resetChangeDocument() {
        this.appStore.dispatch(formResetDocumentChanged());
    }
    /**
     * @param {?} component
     * @param {?=} shouldDispatchEmptyFieldValue
     * @return {?}
     */
    notifyIntializedField(component, shouldDispatchEmptyFieldValue) {
        var _a;
        /** @type {?} */
        const unsavedDocumentListId = (_a = component === null || component === void 0 ? void 0 : component.formParameters) === null || _a === void 0 ? void 0 : _a.unsavedDocumentListId;
        /** @type {?} */
        const fieldName = component === null || component === void 0 ? void 0 : component.fieldName;
        /** @type {?} */
        const fieldValue = shouldDispatchEmptyFieldValue !== false ? component === null || component === void 0 ? void 0 : component.fieldValue : undefined;
        this.appStore.dispatch(formUpdateInitDocumentData(unsavedDocumentListId, fieldName, fieldValue));
    }
    /**
     * Recorded state changes path format come from the rfc6902 pattern but the array instead of string.
     * The path for each the state documents change should be:
     *     0: "documents"
     *     1: <documentId> ==> CHANGED_DOCUMENT_PATTERN_LENGTH
     *     2: <changedFieldName> ===> CHANGED_FIELD_PATTERN_LENGTH
     * @private
     * @param {?} documentId
     * @param {?} fieldName
     * @param {?} changedItem
     * @param {?} inversePatches
     * @return {?}
     */
    filterChangedField(documentId, fieldName, changedItem, inversePatches) {
        // path pattern is: ['documents', '<documentId>', '<fieldName>']
        if (changedItem.path.length >= ChangedDocumentService.CHANGED_FIELD_PATTERN_LENGTH) {
            return changedItem.path[0] === 'documents' && changedItem.path[1] === documentId && changedItem.path[2] === fieldName;
        }
        // path pattern is: ['documents', '<documentId>']
        if (changedItem.path.length === ChangedDocumentService.CHANGED_DOCUMENT_PATTERN_LENGTH) {
            /** @type {?} */
            const changedDocument = changedItem.value;
            /** @type {?} */
            const inversedDocuments = inversePatches.filter((/**
             * @param {?} item
             * @return {?}
             */
            item => {
                return item.path.length === ChangedDocumentService.CHANGED_DOCUMENT_PATTERN_LENGTH &&
                    item.path[0] === 'documents' &&
                    item.path[1] === documentId;
            }));
            if (inversedDocuments && inversedDocuments.length) {
                return !isEqual(changedDocument[fieldName], inversedDocuments[0].value[fieldName]);
            }
        }
        return false;
    }
    /**
     * @private
     * @param {?} stateChanges
     * @param {?} fieldName
     * @param {?} documentId
     * @return {?}
     */
    filterSelectedField(stateChanges, fieldName, documentId) {
        if (stateChanges.patches) {
            return stateChanges.patches.filter((/**
             * @param {?} item
             * @return {?}
             */
            item => {
                return this.filterChangedField(documentId, fieldName, item, stateChanges.inversePatches);
            }));
        }
        return false;
    }
    /**
     * @private
     * @param {?} documentId
     * @param {?} changedItem
     * @param {?} inversePatches
     * @return {?}
     */
    filterChangedDocument(documentId, changedItem, inversePatches) {
        // return changedItem.path.length >= ChangedDocumentService.CHANGED_DOCUMENT_PATTERN_LENGTH &&
        //   changedItem.path[0] === 'documents' &&
        //   changedItem.path[1] === documentId;
        // path pattern is: ['documents', '<documentId>', '<fieldName>']
        if (changedItem.path.length >= ChangedDocumentService.CHANGED_FIELD_PATTERN_LENGTH) {
            return changedItem.path[0] === 'documents' && changedItem.path[1] === documentId;
        }
        // path pattern is: ['documents', '<documentId>']
        if (changedItem.path.length === ChangedDocumentService.CHANGED_DOCUMENT_PATTERN_LENGTH) {
            /** @type {?} */
            const changedDocument = changedItem.value;
            /** @type {?} */
            const inversedDocuments = inversePatches.filter((/**
             * @param {?} item
             * @return {?}
             */
            item => {
                return item.path.length === ChangedDocumentService.CHANGED_DOCUMENT_PATTERN_LENGTH &&
                    item.path[0] === 'documents' &&
                    item.path[1] === documentId;
            }));
            if (inversedDocuments && inversedDocuments.length) {
                return !isEqual(changedDocument, inversedDocuments[0].value);
            }
        }
        return false;
    }
    /**
     * @private
     * @param {?} stateChanges
     * @param {?} documentId
     * @return {?}
     */
    filterSelectedDocument(stateChanges, documentId) {
        if (stateChanges.patches) {
            return stateChanges.patches.filter((/**
             * @param {?} item
             * @return {?}
             */
            item => {
                return this.filterChangedDocument(documentId, item, stateChanges.inversePatches);
            }));
        }
        return false;
    }
    /**
     * @private
     * @param {?} stateChanges
     * @param {?} fieldName
     * @param {?} documentId
     * @param {?=} controlName
     * @return {?}
     */
    isChangedFromTheSameSource(stateChanges, fieldName, documentId, controlName) {
        /** @type {?} */
        const changedSourceInfo = stateChanges.changedSourceInfo;
        return changedSourceInfo
            && changedSourceInfo.type === ChangeSourceType.COMPONENT
            && changedSourceInfo.fieldName === fieldName
            && changedSourceInfo.documentId === documentId
            && changedSourceInfo.controlName === controlName;
    }
    /**
     * Listen value changes on a specified document field
     * @param {?} fieldName the field name of document
     * @param {?} documentId the document id
     * @param {?=} controlName the registered control that holds the field value in this component. It is used to check on the source of change
     * to avoid applying changes itself and also applying the value from the components that share the field name.
     * @param {?=} options provides more information for the watch.
     * @return {?}
     */
    watch(fieldName, documentId, controlName, options) {
        return this.recordedStateChanges$.pipe(filter((/**
         * @param {?} stateChanges
         * @return {?}
         */
        (stateChanges) => {
            return (stateChanges.recordedUndoRedo || this.filterSelectedField(stateChanges, fieldName, documentId).length)
                && ((options === null || options === void 0 ? void 0 : options.forceWatch) || !this.isChangedFromTheSameSource(stateChanges, fieldName, documentId, controlName));
        })), map((/**
         * @param {?} stateChanges
         * @return {?}
         */
        (stateChanges) => {
            return this.appStore.getState().formState.documents[documentId][fieldName];
        })));
    }
    /**
     * @param {?} templateId
     * @return {?}
     */
    watchComponentTemplate(templateId) {
        return this.recordedComponentTemplateChanges$.pipe(filter((/**
         * @param {?} tplChange
         * @return {?}
         */
        (tplChange) => {
            return tplChange[templateId];
        })), map((/**
         * @param {?} tplChanges
         * @return {?}
         */
        (tplChanges) => {
            return this.appStore.getState().formState.documents[templateId].components;
        })));
    }
    /**
     * @param {?} documentId
     * @return {?}
     */
    watchDocument(documentId) {
        return this.recordedStateChanges$.pipe(filter((/**
         * @param {?} stateChanges
         * @return {?}
         */
        (stateChanges) => {
            return stateChanges.recordedUndoRedo || this.filterSelectedDocument(stateChanges, documentId).length;
        })), map((/**
         * @param {?} stateChanges
         * @return {?}
         */
        (stateChanges) => {
            return this.appStore.getState().formState.documents[documentId];
        })));
    }
    /**
     * @return {?}
     */
    watchStoreChanges() {
        return this.recordedStateChanges$;
    }
    /**
     * @param {?} templateId
     * @return {?}
     */
    watchComponentStateChanges(templateId) {
        return this.recordedComponentTemplateChanges$.pipe(filter((/**
         * @param {?} tplChange
         * @return {?}
         */
        (tplChange) => {
            return tplChange[templateId];
        })), map((/**
         * @param {?} tplChanges
         * @return {?}
         */
        (tplChanges) => {
            return tplChanges;
        })));
    }
}
ChangedDocumentService.CHANGED_DOCUMENT_PATTERN_LENGTH = 2;
ChangedDocumentService.CHANGED_FIELD_PATTERN_LENGTH = 3;
ChangedDocumentService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ChangedDocumentService.ctorParameters = () => [
    { type: AppStore },
    { type: ValidationService }
];
/** @nocollapse */ ChangedDocumentService.ɵprov = ɵɵdefineInjectable({ factory: function ChangedDocumentService_Factory() { return new ChangedDocumentService(ɵɵinject(AppStore), ɵɵinject(ValidationService)); }, token: ChangedDocumentService, providedIn: "root" });
__decorate([
    select(['formState', 'documents']),
    __metadata("design:type", Observable)
], ChangedDocumentService.prototype, "documents$", void 0);
__decorate([
    select(['formState', 'recordedStateChanges']),
    __metadata("design:type", Observable)
], ChangedDocumentService.prototype, "recordedStateChanges$", void 0);
__decorate([
    select(['formState', 'recordedComponentTemplateChanges']),
    __metadata("design:type", Observable)
], ChangedDocumentService.prototype, "recordedComponentTemplateChanges$", void 0);
if (false) {
    /**
     * @type {?}
     * @private
     */
    ChangedDocumentService.CHANGED_DOCUMENT_PATTERN_LENGTH;
    /**
     * @type {?}
     * @private
     */
    ChangedDocumentService.CHANGED_FIELD_PATTERN_LENGTH;
    /** @type {?} */
    ChangedDocumentService.prototype.documents$;
    /** @type {?} */
    ChangedDocumentService.prototype.recordedStateChanges$;
    /** @type {?} */
    ChangedDocumentService.prototype.recordedComponentTemplateChanges$;
    /**
     * @type {?}
     * @private
     */
    ChangedDocumentService.prototype.appStore;
    /**
     * @type {?}
     * @private
     */
    ChangedDocumentService.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/current-child-document.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CurrentChildDocumentService {
    /**
     * @param {?} appStore
     * @param {?} documentService
     */
    constructor(appStore, documentService) {
        this.appStore = appStore;
        this.documentService = documentService;
    }
    /**
     * @param {?} unsavedDocumentListId
     * @param {?} template
     * @return {?}
     */
    setTemplate(unsavedDocumentListId, template) {
        this.documentService.setLoadedDocumentOnly(template);
        /** @type {?} */
        const docInfo = {
            templateId: template.documentId
        };
        this.appStore.dispatch(formSetDocumentInfo(unsavedDocumentListId, docInfo));
    }
    /**
     * @param {?} unsavedDocumentListId
     * @param {?} document
     * @return {?}
     */
    setDocument(unsavedDocumentListId, document) {
        this.documentService.setLoadedDocumentOnly(document);
        /** @type {?} */
        const docInfo = {
            documentId: document.documentId
        };
        this.appStore.dispatch(formSetDocumentInfo(unsavedDocumentListId, docInfo));
    }
    /**
     * @param {?} unsavedDocumentListId
     * @param {?} documentData
     * @return {?}
     */
    setDocumentData(unsavedDocumentListId, documentData) {
        this.documentService.setLoadedDocumentOnly(documentData.document);
        this.documentService.setLoadedDocumentOnly(documentData.template);
        /** @type {?} */
        const docInfo = {
            documentId: documentData.document.documentId,
            templateId: documentData.template.documentId
        };
        this.appStore.dispatch(formSetDocumentInfo(unsavedDocumentListId, docInfo));
    }
    /**
     * @param {?} unsavedDocumentList
     * @return {?}
     */
    resetDocumentData(unsavedDocumentList) {
        this.appStore.dispatch(formResetDocumentInfo(unsavedDocumentList));
    }
    /**
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    setupDocumentData(unsavedDocumentListId) {
        this.appStore.dispatch(formSetupDocumentList(unsavedDocumentListId, ClientConstants.CHILD_DOCUMENT_INFO_LIST));
    }
}
CurrentChildDocumentService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CurrentChildDocumentService.ctorParameters = () => [
    { type: AppStore },
    { type: DocumentService }
];
/** @nocollapse */ CurrentChildDocumentService.ɵprov = ɵɵdefineInjectable({ factory: function CurrentChildDocumentService_Factory() { return new CurrentChildDocumentService(ɵɵinject(AppStore), ɵɵinject(DocumentService)); }, token: CurrentChildDocumentService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CurrentChildDocumentService.prototype.appStore;
    /**
     * @type {?}
     * @private
     */
    CurrentChildDocumentService.prototype.documentService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/layout/form-color.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormColorService {
    constructor() {
        this.color = {
            background: ''
        };
        this.colorSubject = new Subject();
        this.color$ = this.colorSubject.asObservable();
    }
    /**
     * @param {?} formColor
     * @return {?}
     */
    setColor(formColor) {
        this.color.background = formColor;
        this.colorSubject.next(this.color);
    }
    /**
     * @return {?}
     */
    setBackgroundColor() {
        this.setColor(FormColorService.COLOR_WHITE);
    }
}
FormColorService.COLOR_WHITE = '#ffffff';
FormColorService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FormColorService.ctorParameters = () => [];
/** @nocollapse */ FormColorService.ɵprov = ɵɵdefineInjectable({ factory: function FormColorService_Factory() { return new FormColorService(); }, token: FormColorService, providedIn: "root" });
if (false) {
    /** @type {?} */
    FormColorService.COLOR_WHITE;
    /** @type {?} */
    FormColorService.prototype.color$;
    /**
     * @type {?}
     * @private
     */
    FormColorService.prototype.colorSubject;
    /** @type {?} */
    FormColorService.prototype.color;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/navigation/default-state.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$u = console;
class DefaultStateService {
    /**
     * @param {?} loggedInUserService
     * @param {?} router
     * @param {?} configService
     */
    constructor(loggedInUserService, router, configService) {
        this.loggedInUserService = loggedInUserService;
        this.router = router;
        this.configService = configService;
        this.user$.subscribe((/**
         * @param {?} user
         * @return {?}
         */
        (user) => this.user = user));
    }
    /**
     * @return {?}
     */
    isPathAccountDefault() {
        /** @type {?} */
        let userBean;
        if (this.user) {
            userBean = this.user.account;
        }
        /** @type {?} */
        const pathArray = this.router.url.split('/');
        return userBean && userBean.defaultURL === pathArray[2];
    }
    /**
     * @param {?=} nextState
     * @param {?=} userBean
     * @return {?}
     */
    changeToDefaultState(nextState, userBean) {
        logger$u.info('Changing to default URL');
        /** @type {?} */
        const defaultURL = this.configService.clientConfig().defaultURL;
        /** @type {?} */
        const user = this.user.account;
        /** @type {?} */
        let publicAccount = false;
        /** @type {?} */
        let accountPublicURL;
        if (user && user.publicAccount) {
            publicAccount = true;
            accountPublicURL = user.accountPublicURL;
        }
        if (!userBean) {
            userBean = this.user.account;
        }
        /** @type {?} */
        let id = '';
        if (defaultURL && defaultURL !== '') {
            id = defaultURL;
        }
        if (userBean && userBean.defaultURL && userBean.defaultURL !== '') {
            id = userBean.defaultURL;
        }
        if (nextState) {
            if (id && id !== '') {
                /** @type {?} */
                const locationParams = {};
                if (publicAccount) {
                    locationParams.replaceUrl = false;
                }
                this.router.navigate([nextState, id], locationParams);
            }
            else {
                this.router.navigate([nextState]);
            }
        }
        else {
            if (publicAccount) {
                this.router.navigate([`/${accountPublicURL}`, 'form', id]);
            }
            else if (id !== '') {
                this.router.navigate(['/form', id]);
            }
            else {
                this.router.navigate(['/form']);
            }
        }
    }
}
DefaultStateService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
DefaultStateService.ctorParameters = () => [
    { type: LoggedInUserService },
    { type: Router },
    { type: ConfigService }
];
/** @nocollapse */ DefaultStateService.ɵprov = ɵɵdefineInjectable({ factory: function DefaultStateService_Factory() { return new DefaultStateService(ɵɵinject(LoggedInUserService), ɵɵinject(Router), ɵɵinject(ConfigService)); }, token: DefaultStateService, providedIn: "root" });
__decorate([
    select(['userState', 'user']),
    __metadata("design:type", Observable)
], DefaultStateService.prototype, "user$", void 0);
if (false) {
    /** @type {?} */
    DefaultStateService.prototype.user$;
    /** @type {?} */
    DefaultStateService.prototype.user;
    /**
     * @type {?}
     * @private
     */
    DefaultStateService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    DefaultStateService.prototype.router;
    /**
     * @type {?}
     * @private
     */
    DefaultStateService.prototype.configService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/navigation/navigation.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function NavMenu() { }
if (false) {
    /** @type {?} */
    NavMenu.prototype.template;
    /** @type {?} */
    NavMenu.prototype.user;
    /** @type {?} */
    NavMenu.prototype.sideMenuOpen;
}
/**
 * @record
 */
function NavImage() { }
if (false) {
    /** @type {?} */
    NavImage.prototype.homeButtonImage;
}
class NavigationService {
    /**
     * @param {?} loggedInUserService
     * @param {?} defaultStateService
     */
    constructor(loggedInUserService, defaultStateService) {
        this.loggedInUserService = loggedInUserService;
        this.defaultStateService = defaultStateService;
        this.subs = new Subscription();
        this.menusSubject = new Subject();
        this.menus$ = this.menusSubject.asObservable();
        this.imagesSubject = new Subject();
        this.images$ = this.imagesSubject.asObservable();
        this.reset();
        /** @type {?} */
        const sub = this.user$.subscribe((/**
         * @param {?} user
         * @return {?}
         */
        (user) => this.user = user));
        this.subs.add(sub);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    /**
     * @return {?}
     */
    reset() {
        this.menus = {
            template: null,
            user: null,
            sideMenuOpen: false
        };
        this.images = {
            homeButtonImage: null
        };
        this.menusSubject.next(this.menus);
        this.imagesSubject.next(this.images);
    }
    /**
     * @param {?} template
     * @return {?}
     */
    setCurrentTemplate(template) {
        if (template) {
            // setting home Button Image
            if (template.homeButtonImage) {
                this.images.homeButtonImage = template.homeButtonImage;
            }
            // setting menu
            this.menus.user = this.user.menu;
            // assign template menu if default path regardless of undefined or not
            if (template.menu || this.defaultStateService.isPathAccountDefault()) {
                this.menus.template = template.menu;
            }
            this.menusSubject.next(this.menus);
            this.imagesSubject.next(this.images);
        }
    }
}
NavigationService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
NavigationService.ctorParameters = () => [
    { type: LoggedInUserService },
    { type: DefaultStateService }
];
/** @nocollapse */ NavigationService.ɵprov = ɵɵdefineInjectable({ factory: function NavigationService_Factory() { return new NavigationService(ɵɵinject(LoggedInUserService), ɵɵinject(DefaultStateService)); }, token: NavigationService, providedIn: "root" });
__decorate([
    select(['userState', 'user']),
    __metadata("design:type", Observable)
], NavigationService.prototype, "user$", void 0);
if (false) {
    /** @type {?} */
    NavigationService.prototype.user$;
    /** @type {?} */
    NavigationService.prototype.user;
    /**
     * @type {?}
     * @private
     */
    NavigationService.prototype.menus;
    /**
     * @type {?}
     * @private
     */
    NavigationService.prototype.menusSubject;
    /** @type {?} */
    NavigationService.prototype.menus$;
    /**
     * @type {?}
     * @private
     */
    NavigationService.prototype.images;
    /**
     * @type {?}
     * @private
     */
    NavigationService.prototype.imagesSubject;
    /** @type {?} */
    NavigationService.prototype.images$;
    /** @type {?} */
    NavigationService.prototype.subs;
    /**
     * @type {?}
     * @private
     */
    NavigationService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    NavigationService.prototype.defaultStateService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/layout/modified-css.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModifiedCSSService {
    /**
     * @param {?} localStorageService
     */
    constructor(localStorageService) {
        this.localStorageService = localStorageService;
        this.dynamicCSSObj = {
            commandBarCSS: null
        };
    }
    /**
     * @param {?} templateId
     * @param {?} commandBarCSS
     * @return {?}
     */
    setCommandBarCSS(templateId, commandBarCSS) {
        this.dynamicCSSObj.commandBarCSS = commandBarCSS;
        /** @type {?} */
        const fromStorage = this.localStorageService.getItem(LocalStorageKeys.COMMAND_BAR_CSS);
        /** @type {?} */
        const entry = fromStorage ? JSON.parse(fromStorage) : {};
        entry[templateId] = commandBarCSS;
        this.localStorageService.setItem('commandBarCSS', JSON.stringify(entry));
    }
    /**
     * @param {?} templateId
     * @return {?}
     */
    getStoredCommandBarCSS(templateId) {
        /** @type {?} */
        const fromStorage = this.localStorageService.getItem(LocalStorageKeys.COMMAND_BAR_CSS);
        /** @type {?} */
        const entry = fromStorage ? JSON.parse(fromStorage) : {};
        return entry[templateId];
    }
}
ModifiedCSSService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ModifiedCSSService.ctorParameters = () => [
    { type: LocalStorageService }
];
/** @nocollapse */ ModifiedCSSService.ɵprov = ɵɵdefineInjectable({ factory: function ModifiedCSSService_Factory() { return new ModifiedCSSService(ɵɵinject(LocalStorageService)); }, token: ModifiedCSSService, providedIn: "root" });
if (false) {
    /** @type {?} */
    ModifiedCSSService.prototype.dynamicCSSObj;
    /**
     * @type {?}
     * @private
     */
    ModifiedCSSService.prototype.localStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/document-update.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$v = console;
class DocumentUpdateService {
    /**
     * @param {?} documentService
     * @param {?} modifiedFieldService
     * @param {?} validationService
     * @param {?} unsavedDocumentService
     * @param {?} preProcessorFieldService
     * @param {?} broadcastService
     * @param {?} appStore
     */
    constructor(documentService, modifiedFieldService, validationService, unsavedDocumentService, preProcessorFieldService, broadcastService, appStore) {
        this.documentService = documentService;
        this.modifiedFieldService = modifiedFieldService;
        this.validationService = validationService;
        this.unsavedDocumentService = unsavedDocumentService;
        this.preProcessorFieldService = preProcessorFieldService;
        this.broadcastService = broadcastService;
        this.appStore = appStore;
    }
    /**
     * @private
     * @param {?} currentVersion
     * @return {?}
     */
    updatePrevCurrentVersion(currentVersion) {
        /** @type {?} */
        const _self = this;
        // in case the provided version is current one so set currentVersion of the previous one to false
        // This case for updating document from pulling documents on reconnection
        /** @type {?} */
        const documentId = currentVersion.documentId;
        /** @type {?} */
        const loadedDocs = _self.unsavedDocumentService.getAllLoadedDocs();
        /** @type {?} */
        const orgDocs = _self.documentService.getOrgDocuments();
        /** @type {?} */
        const keys = Object.keys(orgDocs);
        for (let i = 0; i < keys.length; i++) {
            /** @type {?} */
            const versionId = keys[i];
            /** @type {?} */
            const orgDoc = orgDocs[versionId];
            if (documentId === orgDoc.documentId &&
                versionId !== documentId &&
                versionId !== currentVersion.systemHeader.versionId &&
                orgDoc.systemHeader.currentVersion) {
                orgDoc.systemHeader.currentVersion = false;
                _self.documentService.setOriginalDocumentOnly(orgDoc, orgDoc.systemHeader.versionId);
                loadedDocs.forEach((/**
                 * @param {?} loadedDoc
                 * @return {?}
                 */
                function (loadedDoc) {
                    if (loadedDoc.systemHeader.versionId === orgDoc.systemHeader.versionId) {
                        loadedDoc.systemHeader.currentVersion = false;
                        _self.documentService.setLoadedDocumentOnly(cloneDeep(loadedDoc), orgDoc.systemHeader.versionId);
                    }
                }));
                return;
            }
        }
    }
    /**
     * @param {?} versions
     * @return {?}
     */
    updateVersions(versions) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const _self = this;
            if (versions && versions.length) {
                /** @type {?} */
                const currentVersion = versions.filter((/**
                 * @param {?} version
                 * @return {?}
                 */
                version => version.systemHeader.currentVersion))[0];
                if (currentVersion) {
                    this.documentService.resetDisableSaveFieldToDoc(currentVersion);
                    if (versions.length === 1) {
                        _self.updatePrevCurrentVersion(currentVersion);
                    }
                    /** @type {?} */
                    const documentId = currentVersion.documentId;
                    logger$v.info('Updating document in memory: ' + documentId);
                    /** @type {?} */
                    const loadedDoc = cloneDeep(_self.documentService.getLoadedDocument(documentId));
                    // use current version to update loaded document on form
                    yield _self.applyDocumentChanges(loadedDoc, currentVersion);
                    // update the loaded document in store
                    _self.documentService.setLoadedDocumentOnly(loadedDoc);
                    // use current version to update org version in store
                    _self.documentService.setOriginalDocumentOnly(currentVersion);
                    logger$v.info('Update document on form to latest one.');
                    _self.broadcastService.broadcast('document:updated', [currentVersion]);
                }
                /** @type {?} */
                const nonCurrentVersions = versions.filter((/**
                 * @param {?} version
                 * @return {?}
                 */
                version => version.systemHeader.currentVersion === false));
                if (nonCurrentVersions.length) {
                    // user non current version to update loaded non-current version in store
                    nonCurrentVersions.forEach((/**
                     * @param {?} version
                     * @return {?}
                     */
                    function (version) {
                        return __awaiter(this, void 0, void 0, function* () {
                            /** @type {?} */
                            const versionId = version.systemHeader.versionId;
                            /** @type {?} */
                            const loadedVersion = _self.documentService.getLoadedDocument(versionId);
                            if (loadedVersion) {
                                yield _self.applyDocumentChanges(loadedVersion, version);
                                // update loaded non-current version on form
                                _self.documentService.setLoadedDocumentOnly(cloneDeep(loadedVersion), versionId);
                                // use non-current version to update its version in store
                                _self.documentService.setOriginalDocumentOnly(version, versionId);
                            }
                        });
                    }));
                }
            }
        });
    }
    /**
     * @param {?} oldOrgDoc
     * @param {?} latestDoc
     * @return {?}
     */
    applyDocumentChanges(oldOrgDoc, latestDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const documentId = latestDoc.documentId;
            logger$v.info('Applying document changes for doc: ' + documentId);
            /** @type {?} */
            const modifiedFields = this.modifiedFieldService.getModifiedFieldsInDoc(documentId);
            /** @type {?} */
            var excludedOptions = {};
            excludedOptions[SharedConstants.MAKE_CURRENT_VERSION_KEY] = true;
            /** @type {?} */
            const loadedDocs = this.unsavedDocumentService.getAllLoadedDocs(excludedOptions);
            for (let i = 0; i < loadedDocs.length; i++) {
                /** @type {?} */
                const loadedDoc = cloneDeep(loadedDocs[i]);
                if (loadedDoc.documentId === documentId) {
                    /** @type {?} */
                    const updates = yield DocumentUpdater.getUpdates(oldOrgDoc, latestDoc);
                    if (updates.updates && updates.updates.length) {
                        if (modifiedFields && modifiedFields.length) {
                            modifiedFields.forEach((/**
                             * @param {?} modifiedField
                             * @return {?}
                             */
                            function (modifiedField) {
                                modifiedField = UtilString.convertToObjectPath(modifiedField, '/');
                                updates.updates.forEach((/**
                                 * @param {?} update
                                 * @param {?} index
                                 * @return {?}
                                 */
                                function (update, index) {
                                    /** @type {?} */
                                    const path = UtilString.convertToObjectPath(update.path, '/');
                                    if (modifiedField === path &&
                                        !isEqual(loadedDoc[modifiedField], latestDoc[modifiedField])) {
                                        logger$v.warn('Field in pushed document: \'' +
                                            modifiedField + '\' has been changed to: \'' + JSON.stringify(update.value));
                                        delete updates.updates[index];
                                    }
                                }));
                            }));
                        }
                        yield DocumentUpdater.applyUpdates(oldOrgDoc, updates);
                    }
                }
            }
        });
    }
    /**
     * @param {?} unsavedDocuments
     * @param {?} doc
     * @return {?}
     */
    updateFormDocument(unsavedDocuments, doc) {
        return __awaiter(this, void 0, void 0, function* () {
            if (unsavedDocuments.length) {
                // just mutate the document if so that references to this object are not cutoff
                // also update loaded docs too
                for (let j = 0; j < unsavedDocuments.length; j++) {
                    /** @type {?} */
                    const unsavedDoc = cloneDeep(unsavedDocuments[j]);
                    if (unsavedDoc.documentId === doc.documentId) {
                        /** @type {?} */
                        const updates = yield DocumentUpdater.getUpdates(unsavedDoc, doc);
                        yield DocumentUpdater.applyUpdates(unsavedDoc, updates);
                        this.appStore.dispatch(formSetDocument(unsavedDoc));
                        break;
                    }
                }
            }
        });
    }
}
DocumentUpdateService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
DocumentUpdateService.ctorParameters = () => [
    { type: DocumentService },
    { type: ModifiedFieldService },
    { type: ValidationService },
    { type: UnsavedDocumentService },
    { type: PreProcessorFieldService },
    { type: BroadcastService },
    { type: AppStore }
];
/** @nocollapse */ DocumentUpdateService.ɵprov = ɵɵdefineInjectable({ factory: function DocumentUpdateService_Factory() { return new DocumentUpdateService(ɵɵinject(DocumentService), ɵɵinject(ModifiedFieldService), ɵɵinject(ValidationService), ɵɵinject(UnsavedDocumentService), ɵɵinject(PreProcessorFieldService), ɵɵinject(BroadcastService), ɵɵinject(AppStore)); }, token: DocumentUpdateService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    DocumentUpdateService.prototype.documentService;
    /**
     * @type {?}
     * @private
     */
    DocumentUpdateService.prototype.modifiedFieldService;
    /**
     * @type {?}
     * @private
     */
    DocumentUpdateService.prototype.validationService;
    /**
     * @type {?}
     * @private
     */
    DocumentUpdateService.prototype.unsavedDocumentService;
    /**
     * @type {?}
     * @private
     */
    DocumentUpdateService.prototype.preProcessorFieldService;
    /**
     * @type {?}
     * @private
     */
    DocumentUpdateService.prototype.broadcastService;
    /**
     * @type {?}
     * @private
     */
    DocumentUpdateService.prototype.appStore;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/finalise-value-field.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FinaliseValueFieldService {
    /**
     * @param {?} modifiedFieldService
     */
    constructor(modifiedFieldService) {
        this.modifiedFieldService = modifiedFieldService;
        this.finaliseValueFunctions = {};
    }
    /**
     * @private
     * @param {?} templateId
     * @return {?}
     */
    ensureTemplateExist(templateId) {
        if (!this.finaliseValueFunctions[templateId]) {
            this.finaliseValueFunctions[templateId] = {};
        }
    }
    /**
     * @param {?} templateId
     * @param {?} fieldName
     * @param {?} func
     * @return {?}
     */
    addFinaliseValueFunction(templateId, fieldName, func) {
        this.ensureTemplateExist(templateId);
        this.finaliseValueFunctions[templateId][fieldName] = func;
    }
    /**
     * @param {?} templateId
     * @param {?} fieldName
     * @return {?}
     */
    getFinaliseValueFunction(templateId, fieldName) {
        this.ensureTemplateExist(templateId);
        return this.finaliseValueFunctions[templateId][fieldName];
    }
    /**
     * @param {?} document
     * @param {?} template
     * @return {?}
     */
    finaliseFieldValues(document, template) {
        if (document && this.modifiedFieldService.hasChanged(document.documentId)) {
            for (let t = 0, len = template.components.length; t < len; t++) {
                /** @type {?} */
                const fld = template.components[t];
                /** @type {?} */
                const finaliseFunc = this.getFinaliseValueFunction(template.documentId, fld.name);
                if (finaliseFunc) {
                    finaliseFunc(document);
                }
            }
        }
    }
}
FinaliseValueFieldService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FinaliseValueFieldService.ctorParameters = () => [
    { type: ModifiedFieldService }
];
/** @nocollapse */ FinaliseValueFieldService.ɵprov = ɵɵdefineInjectable({ factory: function FinaliseValueFieldService_Factory() { return new FinaliseValueFieldService(ɵɵinject(ModifiedFieldService)); }, token: FinaliseValueFieldService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    FinaliseValueFieldService.prototype.finaliseValueFunctions;
    /**
     * @type {?}
     * @private
     */
    FinaliseValueFieldService.prototype.modifiedFieldService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/MandatoryValueProcessor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MandatoryValueProcessor {
    /**
     * @param {?} mandatoryValuesArray
     * @param {?} fieldValue
     * @param {?} label
     * @return {?}
     */
    static processMandatoryValues(mandatoryValuesArray, fieldValue, label) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let mandatoryValuesLabel;
            // the mandatoryValuesArray can only be applied to an object
            if (!fieldValue) {
                return;
            }
            else if (!isObject(fieldValue)) {
                return;
            }
            // mandatoryValuesArray must be an array
            if (!mandatoryValuesArray) {
                return;
            }
            else if (!isArray(mandatoryValuesArray)) {
                return;
            }
            for (let i = 0; i < mandatoryValuesArray.length; i++) {
                try {
                    /** @type {?} */
                    const JSONPath = ((/** @type {?} */ (window))).JSONPath;
                    /** @type {?} */
                    const matches = JSONPath.JSONPath({ path: mandatoryValuesArray[i].jsonPathQuery, json: fieldValue });
                    if (matches.length === 0) {
                        if (!mandatoryValuesLabel) {
                            mandatoryValuesLabel = label;
                        }
                        // the mandatoryValuesLabel is output to html so use, <br> for the break
                        mandatoryValuesLabel += '<br> ➡ ' + mandatoryValuesArray[i].name;
                    }
                }
                catch (err) {
                    console.error(err);
                    return err;
                }
            }
            return mandatoryValuesLabel;
        });
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/mandatory-field.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MandatoryFieldService {
    /**
     * @param {?} modifiedFieldService
     * @param {?} templateService
     */
    constructor(modifiedFieldService, templateService) {
        this.modifiedFieldService = modifiedFieldService;
        this.templateService = templateService;
        this.mandatoryFields = { components: [] };
        this.checkMandatoryFields = this.checkMandatoryFields.bind(this);
    }
    /**
     * @param {?} fieldInput the input field
     * @param {?} fld field
     * @param {?} isValidationArray
     * @return {?} the label that will be shown for mandatory fields that are missing
     */
    checkMandatoryValues(fieldInput, fld, isValidationArray) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let label = fld.label;
            if (!fld.label || fld.label === '') {
                label = fld.name;
            }
            if (!fieldInput && fieldInput !== 0) {
                return label;
            }
            else if (isArray(fieldInput) && isEqual([], fieldInput)) {
                return label;
            }
            else if (isObject(fieldInput) && !isDate(fieldInput)) {
                if (isEqual({}, fieldInput)) {
                    return label;
                }
                else {
                    /** @type {?} */
                    const valuesArray = isValidationArray ? fld.validationsArray : fld.mandatoryValuesArray;
                    if (valuesArray) {
                        /** @type {?} */
                        const mandatoryValuesLabel = yield MandatoryValueProcessor.processMandatoryValues(valuesArray, fieldInput, label);
                        if (mandatoryValuesLabel) {
                            // there are some conditions that do not match the mandatory requirements, so do not do any further
                            // processing of the save
                            return mandatoryValuesLabel;
                        }
                    }
                }
            }
            return null;
        });
    }
    /**
     * @param {?} fieldInput the input field
     * @param {?} fld field
     * @return {?} the label that will be shown for mandatory fields that are missing
     */
    checkMandatoryFields(fieldInput, fld) {
        /** @type {?} */
        let label = fld.label;
        if (!fld.label || fld.label === '') {
            label = fld.name;
        }
        if (!fieldInput && fieldInput !== 0) {
            return label;
        }
        else if (isArray(fieldInput) && isEqual([], fieldInput)) {
            return label;
        }
        else if (isObject(fieldInput) && !isDate(fieldInput)) {
            if (isEqual({}, fieldInput)) {
                return label;
            }
            else {
                /** @type {?} */
                const mandatoryFields = fld.mandatoryFields || [];
                if (!mandatoryFields.length) {
                    if (fld.mandatoryValues) {
                        /** @type {?} */
                        const keys = Object.keys(fld.mandatoryValues) || [];
                        for (let i = 0; i < keys.length; i++) {
                            /** @type {?} */
                            const key = keys[i];
                            if (fld.mandatoryValues[key]) {
                                mandatoryFields.push(key);
                            }
                        }
                    }
                }
                if (mandatoryFields && mandatoryFields.length) {
                    /** @type {?} */
                    const keys = Object.keys(fieldInput);
                    for (let id = 0; id < keys.length; id++) {
                        /** @type {?} */
                        const key = keys[id];
                        /** @type {?} */
                        const obj = fieldInput[key];
                        if (isString(obj)) {
                            if (mandatoryFields) {
                                for (let m = 0, len = mandatoryFields.length; m < len; m++) {
                                    if (mandatoryFields[m] === key) {
                                        if (obj === undefined || obj === '') {
                                            return label + ' ➡ ' + mandatoryFields[m];
                                        }
                                    }
                                }
                            }
                            else {
                                if (obj === undefined || obj === '') {
                                    return label;
                                }
                            }
                        }
                        else if (isObject(obj)) {
                            if (this.checkMandatoryFields(obj, fld)) {
                                return label;
                            }
                        }
                    }
                }
            }
        }
        return null;
    }
    /**
     * @param {?} unsavedDocuments
     * @param {?} unsavedTemplates
     * @return {?}
     */
    isMandatoryAnswered(unsavedDocuments, unsavedTemplates) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!unsavedDocuments) {
                return Promise.reject(new Error('Unsaved document list not provided in mandatory field check'));
            }
            else {
                /** @type {?} */
                const templateService = this.templateService;
                /** @type {?} */
                const modifiedFieldService = this.modifiedFieldService;
                /** @type {?} */
                const checkMandatoryValues = this.checkMandatoryValues;
                /** @type {?} */
                const checkMandatoryFields = this.checkMandatoryFields;
                /** @type {?} */
                let unansweredMandatoryFieldMsg = 'Mandatory item(s) not completed: ';
                /** @type {?} */
                let hasUnansweredMandatoryFields = false;
                /** @type {?} */
                const doCheckMandatory = (/**
                 * @param {?} bean
                 * @return {?}
                 */
                function (bean) {
                    return __awaiter(this, void 0, void 0, function* () {
                        if (modifiedFieldService.hasChanged(bean.documentId)) {
                            try {
                                /** @type {?} */
                                const tpl = yield templateService.loadTemplate(bean, unsavedTemplates);
                                for (let t = 0, len = tpl.components.length; t < len; t++) {
                                    /** @type {?} */
                                    const fld = tpl.components[t];
                                    /** @type {?} */
                                    const value = bean[fld.name];
                                    // add the mandatory fields to a message that can be output once all mandatory fields
                                    // are checked. This way all mandatory fields can be displayed in the message
                                    /** @type {?} */
                                    let processMandatoryFields = null;
                                    /** @type {?} */
                                    let isValidationArray = false;
                                    if (fld.mandatoryValuesArray && fld.mandatory) {
                                        processMandatoryFields = checkMandatoryValues;
                                    }
                                    else if (fld.mandatory) {
                                        processMandatoryFields = checkMandatoryFields;
                                    }
                                    else if (fld.validationsArray && !isEmpty(value)) {
                                        processMandatoryFields = checkMandatoryFields;
                                        isValidationArray = true;
                                    }
                                    if (processMandatoryFields) {
                                        /** @type {?} */
                                        const missingField = yield processMandatoryFields(value, fld, isValidationArray);
                                        if (isError(missingField)) {
                                            return Promise.reject(missingField);
                                        }
                                        else if (missingField) {
                                            if (fld.mandatoryMessage) {
                                                unansweredMandatoryFieldMsg += `<br><span class='mandatory-item'>${fld.mandatoryMessage}</span>`;
                                            }
                                            else {
                                                unansweredMandatoryFieldMsg += `<br><span class='mandatory-item'>${missingField}</span>`;
                                            }
                                            hasUnansweredMandatoryFields = true;
                                        }
                                    }
                                }
                            }
                            catch (err) {
                                /** @type {?} */
                                let msg;
                                if (err.name === UtilError.NOT_FOUND_ERROR) {
                                    msg = 'Template not found';
                                }
                                else {
                                    msg = 'Error getting template to determine mandatory field: ' + err.message;
                                }
                                return Promise.reject(new Error(msg));
                            }
                        }
                        else {
                            return Promise.resolve();
                        }
                    });
                });
                /** @type {?} */
                const keys = Object.keys(unsavedDocuments);
                for (let idx = 0; idx < keys.length; idx++) {
                    /** @type {?} */
                    const docId = keys[idx];
                    yield doCheckMandatory(unsavedDocuments[docId]);
                }
                if (hasUnansweredMandatoryFields) {
                    // reject with the the mandatory message so it can be output by the caller
                    return Promise.reject(new Error(unansweredMandatoryFieldMsg));
                }
                else {
                    return Promise.resolve(true);
                }
            }
        });
    }
}
MandatoryFieldService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
MandatoryFieldService.ctorParameters = () => [
    { type: ModifiedFieldService },
    { type: TemplateService }
];
if (false) {
    /** @type {?} */
    MandatoryFieldService.prototype.mandatoryFields;
    /**
     * @type {?}
     * @private
     */
    MandatoryFieldService.prototype.modifiedFieldService;
    /**
     * @type {?}
     * @private
     */
    MandatoryFieldService.prototype.templateService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/document-save.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$w = console;
class DocumentSaveService {
    /**
     * @param {?} dataService
     * @param {?} loggedInUserService
     * @param {?} notificationService
     * @param {?} documentService
     * @param {?} unsavedDocumentService
     * @param {?} currentDocumentService
     * @param {?} currentChildDocumentService
     * @param {?} mandatoryFieldService
     * @param {?} modifiedFieldService
     * @param {?} validationService
     * @param {?} clientSystemHeaderService
     * @param {?} documentUpdateService
     * @param {?} configService
     * @param {?} broadcastService
     * @param {?} clientAccessService
     * @param {?} changedDocumentService
     * @param {?} finaliseValueService
     * @param {?} appStore
     */
    constructor(dataService, loggedInUserService, notificationService, documentService, unsavedDocumentService, currentDocumentService, currentChildDocumentService, mandatoryFieldService, modifiedFieldService, validationService, clientSystemHeaderService, documentUpdateService, configService, broadcastService, clientAccessService, changedDocumentService, finaliseValueService, appStore) {
        this.dataService = dataService;
        this.loggedInUserService = loggedInUserService;
        this.notificationService = notificationService;
        this.documentService = documentService;
        this.unsavedDocumentService = unsavedDocumentService;
        this.currentDocumentService = currentDocumentService;
        this.currentChildDocumentService = currentChildDocumentService;
        this.mandatoryFieldService = mandatoryFieldService;
        this.modifiedFieldService = modifiedFieldService;
        this.validationService = validationService;
        this.clientSystemHeaderService = clientSystemHeaderService;
        this.documentUpdateService = documentUpdateService;
        this.configService = configService;
        this.broadcastService = broadcastService;
        this.clientAccessService = clientAccessService;
        this.changedDocumentService = changedDocumentService;
        this.finaliseValueService = finaliseValueService;
        this.appStore = appStore;
        this.currentDocumentService.documentData$.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            this.documentData = data;
        }));
    }
    /**
     * @private
     * @param {?} document
     * @return {?}
     */
    loadOverrideTemplate(document) {
        /** @type {?} */
        const documentData = this.currentDocumentService.getDocumentData();
        if (documentData.overrideTemplateId && documentData.document.documentId === document.documentId) {
            return documentData.overrideTemplateId;
        }
    }
    /**
     * @private
     * @param {?} document
     * @return {?}
     */
    loadTemplate(document) {
        /** @type {?} */
        const overrideTemplateId = this.loadOverrideTemplate(document);
        /** @type {?} */
        const templateId = overrideTemplateId ? overrideTemplateId : document.systemHeader.templateId;
        return this.unsavedDocumentService.getTemplateOnly(templateId);
    }
    /**
     * @private
     * @param {?} document
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    doPreSaveData(document, unsavedDocumentListId) {
        /** @type {?} */
        const docBean = cloneDeep(document);
        /** @type {?} */
        const template = this.loadTemplate(docBean);
        this.finaliseValueService.finaliseFieldValues(docBean, template);
        if (!docBean.systemHeader) {
            docBean.systemHeader = {};
        }
        if (!docBean.systemHeader.systemType) {
            docBean.systemHeader.systemType = SharedConstants.SYSTEM_TYPE_DOCUMENT;
        }
        if (UtilDocument.isNew(docBean) && !docBean.systemHeader.templateId) {
            docBean.systemHeader.templateId = template.documentId;
        }
        this.clientAccessService.writeKeysToDocument(docBean, template);
        /** @type {?} */
        const overrideTemplateId = this.loadOverrideTemplate(document);
        if (overrideTemplateId) {
            docBean.systemHeader.createdWith = overrideTemplateId;
        }
        else {
            docBean.systemHeader.createdWith = document.systemHeader.templateId;
        }
        /** @type {?} */
        const docContext = (/** @type {?} */ ({}));
        docContext.template = template;
        docContext.templateId = document.systemHeader.templateId;
        docContext.unsavedDocumentListId = unsavedDocumentListId;
        return this.preSaveValidation(docBean, docContext);
    }
    /**
     * @private
     * @param {?} document
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    doPostSaveData(document, unsavedDocumentListId) {
        /** @type {?} */
        const docBean = cloneDeep(document);
        /** @type {?} */
        const template = this.loadTemplate(docBean);
        /** @type {?} */
        const docContext = (/** @type {?} */ ({}));
        docContext.template = template;
        docContext.templateId = document.systemHeader.templateId;
        docContext.unsavedDocumentListId = unsavedDocumentListId;
        return this.postSaveClientValidation(docBean, docContext);
    }
    /**
     * @private
     * @param {?} docBean
     * @param {?} docContext
     * @return {?}
     */
    preSaveValidation(docBean, docContext) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            // const formParameters = _self.$rootScope.formParameters;
            /** @type {?} */
            const formParameters = {};
            _self.appStore.dispatch(formSetDocument(docBean));
            _self.validationService.onPreSaveDocument(formParameters, docBean, docContext, (/**
             * @param {?} error
             * @param {?} result
             * @return {?}
             */
            function (error, result) {
                if (error) {
                    reject(error);
                }
                else {
                    _self.validationService.broadcastValidationEvent();
                    /** @type {?} */
                    const latestDocument = cloneDeep(_self.documentService.getLoadedDocument(docBean.documentId));
                    resolve(latestDocument);
                }
            }));
        }));
    }
    /**
     * @private
     * @param {?} docBean
     * @param {?} docContext
     * @return {?}
     */
    postSaveClientValidation(docBean, docContext) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.validationService.onPostSaveClientDocument(null, docBean, docContext, (/**
             * @param {?} error
             * @param {?} result
             * @return {?}
             */
            (error, result) => {
                if (error) {
                    reject(error);
                }
                else {
                    this.validationService.broadcastValidationEvent();
                    /** @type {?} */
                    const latestDocument = cloneDeep(this.documentService.getLoadedDocument(docBean.documentId));
                    resolve(latestDocument);
                }
            }));
        }));
    }
    /**
     * @private
     * @param {?} documentListId
     * @return {?}
     */
    shouldApplyFlags(documentListId) {
        /** @type {?} */
        const unsavedDocInfo = this.unsavedDocumentService.getUnsavedDocumentInfo(documentListId);
        if ((unsavedDocInfo === null || unsavedDocInfo === void 0 ? void 0 : unsavedDocInfo.name) !== ClientConstants.DIALOG_DOCUMENT_INFO_LIST) {
            return true;
        }
        return false;
    }
    /**
     * @private
     * @param {?} doc
     * @param {?=} unsavedDocumentListId
     * @return {?}
     */
    resetCleanStateDocument(doc, unsavedDocumentListId) {
        this.documentService.resetDisableSaveFieldToDoc(doc);
        this.documentService.resetOriginalDocument(doc);
        if (this.shouldApplyFlags(unsavedDocumentListId)) {
            this.currentDocumentService.resetUndoRedo();
        }
        this.changedDocumentService.resetChangeDocument();
    }
    /**
     * @private
     * @param {?} doc
     * @param {?=} unsavedDocumentListId
     * @return {?}
     */
    performPostSaveEach(doc, unsavedDocumentListId) {
        this.doPostSaveData(doc, unsavedDocumentListId);
        this.notificationService.success('Saved successfully');
        this.modifiedFieldService.removeModifiedDocumentFields(doc.documentId);
        this.resetCleanStateDocument(doc, unsavedDocumentListId);
        // Put doc into an array due to avoid changing the handler in custom component
        this.broadcastService.broadcast('document:updated', [doc]);
    }
    /**
     * @private
     * @param {?} modifiedDocument
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    processSaveEach(modifiedDocument, unsavedDocumentListId) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const result = DocumentIdValidator.validateDocumentId(modifiedDocument.documentId, _self.configService.clientConfig().documentIdRules);
            if (!result.valid) {
                reject(new Error(result.reason));
            }
            _self.reloadDocumentAndApplyUpdates(modifiedDocument, unsavedDocumentListId).then((/**
             * @param {?} newModifiedDoc
             * @return {?}
             */
            function successFunc(newModifiedDoc) {
                _self.doPreSaveData(newModifiedDoc, unsavedDocumentListId).then((/**
                 * @param {?} processedDoc
                 * @return {?}
                 */
                function preSaveSuccessFunc(processedDoc) {
                    if (processedDoc) {
                        _self.doSaveEach(processedDoc, unsavedDocumentListId).then((/**
                         * @param {?} doc
                         * @return {?}
                         */
                        function (doc) {
                            _self.performPostSaveEach(doc, unsavedDocumentListId);
                            resolve(doc);
                        }), (/**
                         * @param {?} err
                         * @return {?}
                         */
                        function (err) {
                            reject(err);
                        }));
                    }
                    else {
                        /** @type {?} */
                        const msg = 'There is error in PreSave.';
                        logger$w.error(msg);
                        reject(new Error(msg));
                    }
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                function errorFunc(error) {
                    logger$w.info('Saving data error...' + JSON.stringify(error));
                    reject(error);
                }));
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function errorFunc(err) {
                logger$w.info('Saving data error...' + JSON.stringify(err));
                reject(err);
            }));
        }));
    }
    /**
     * @private
     * @param {?} docBean
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    doSaveEach(docBean, unsavedDocumentListId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (docBean) {
                logger$w.info('Saving document: ' + docBean.documentId);
                /** @type {?} */
                const includeDeleted = true;
                /** @type {?} */
                const docExists = yield this.dataService.documentExists(docBean.documentId, includeDeleted);
                /** @type {?} */
                const tpl = this.documentService.getTemplateFromDoc(docBean);
                /** @type {?} */
                let originalDoc;
                if (docExists) {
                    originalDoc = this.documentService.getExistingDocument(docBean.documentId);
                    if (!originalDoc && this.configService.clientConfig().useSaveConflictResolution) {
                        originalDoc = this.documentService.getExistingDocument(docBean.systemHeader.previousVersionId);
                    }
                    else if (!originalDoc) {
                        originalDoc = this.documentService.getExistingDocument(docBean.systemHeader.versionId);
                    }
                }
                /** @type {?} */
                const isCreationMode = UtilDocument.isNew(docBean) || !docExists;
                if (isCreationMode) {
                    /** @type {?} */
                    const savedDoc = yield this.dataService.insert(docBean);
                    this.savedDocs.push(savedDoc);
                    logger$w.info('Document inserted: ' + savedDoc.documentId);
                    return savedDoc;
                }
                else {
                    if (!originalDoc) { // docExists but no access
                        throw new Error('Unable to update! No access to document: ' + docBean.documentId);
                    }
                    else if (!this.clientSystemHeaderService.updateSystemHeader(docBean, tpl, originalDoc)) {
                        throw new Error('Error writing system header');
                    }
                    else {
                        /** @type {?} */
                        const options = {
                            templateId: originalDoc ? originalDoc.templateId : docBean.systemHeader.templateId,
                            makeCurrentVersion: this.unsavedDocumentService.getDocumentOptionKey(unsavedDocumentListId, docBean.documentId, SharedConstants.MAKE_CURRENT_VERSION_KEY),
                            importPreviousVersion: this.unsavedDocumentService.getDocumentOptionKey(unsavedDocumentListId, docBean.documentId, SharedConstants.IMPORT_PREVIOUS_VERSION)
                        };
                        /** @type {?} */
                        const savedDoc = yield this.dataService.jsonPatchUpdate(originalDoc, docBean, options);
                        this.savedDocs.push(savedDoc);
                        logger$w.info('Document updated: ' + savedDoc.documentId);
                        return savedDoc;
                    }
                }
            }
        });
    }
    /**
     * @param {?} dirtyFlag
     * @param {?} spinnerFlag
     * @param {?} saveFlag
     * @param {?=} unsavedDocumentListId
     * @return {?}
     */
    setFlags(dirtyFlag, spinnerFlag, saveFlag, unsavedDocumentListId) {
        if (spinnerFlag !== undefined) {
            this.modifiedFieldService.setShowSpinner(spinnerFlag, unsavedDocumentListId);
        }
        if (saveFlag !== undefined) {
            this.modifiedFieldService.setSaveFlag(saveFlag, unsavedDocumentListId);
        }
        if (saveFlag) {
            // Saving means the update on form is allowed,
            // so set updateAllowed flag to true in order to show the dirty again in case saving errors
            this.modifiedFieldService.setUpdateAllowed(true);
        }
        if (dirtyFlag !== undefined) {
            this.modifiedFieldService.setDirty(dirtyFlag, null, unsavedDocumentListId);
        }
    }
    /**
     * @private
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    doSave(unsavedDocumentListId) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            try {
                // check mandatory fields in all documents getUnsavedDocuments will throw an exception
                // if the unsavedDocumentListId is unknown
                /** @type {?} */
                const unsavedDocuments = _self.unsavedDocumentService.getUnsavedDocuments(unsavedDocumentListId);
                /** @type {?} */
                const unsavedTemplates = _self.unsavedDocumentService.getUnsavedTemplates(unsavedDocumentListId);
                _self.mandatoryFieldService.isMandatoryAnswered(unsavedDocuments, unsavedTemplates).then((/**
                 * @return {?}
                 */
                function successFunc() {
                    // 11003: only save modified documents. Don't save the parent if only a child has changed
                    /** @type {?} */
                    const modifiedDocuments = _self.modifiedFieldService.getModifiedDocuments(unsavedDocumentListId);
                    if (modifiedDocuments && modifiedDocuments.length) {
                        _self.savedDocs = [];
                        // save documents sequentially so that all document saves aren't sent to the server at the
                        // same time. See the notes of Mantis 11213 for further details
                        UtilSequenceProcess.processList(modifiedDocuments, (/**
                         * @param {?} modifiedDocument
                         * @return {?}
                         */
                        (modifiedDocument) => {
                            return _self.processSaveEach(modifiedDocument, unsavedDocumentListId);
                        })).then((/**
                         * @return {?}
                         */
                        function allPromiseSuccessFunc() {
                            if (_self.savedDocs && _self.savedDocs.length > 0) {
                                resolve(_self.savedDocs);
                            }
                            else {
                                reject(new Error('No results returned from save'));
                            }
                        }), (/**
                         * @param {?} err
                         * @return {?}
                         */
                        function errorFunc(err) {
                            logger$w.info('Saving data got errors...' + JSON.stringify(err));
                            reject(err);
                        }));
                    }
                    else {
                        logger$w.info('Exit saving because there is no modified document.');
                        // resolve with no document because there's no save
                        resolve();
                    }
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function errorFunc(err) {
                    reject(err);
                }));
            }
            catch (e) {
                // pass through the error with no additional messages so that the error is
                // nicely formatted for display
                reject(new Error(e));
            }
        }));
    }
    /**
     * @private
     * @param {?} modifiedDoc
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    reloadDocumentAndApplyUpdates(modifiedDoc, unsavedDocumentListId) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            var isMakingCurVer = _self.unsavedDocumentService.getDocumentOptionKey(unsavedDocumentListId, modifiedDoc.documentId, SharedConstants.MAKE_CURRENT_VERSION_KEY);
            if (UtilDocument.isNew(modifiedDoc) || UtilDocument.isPreviousVersion(modifiedDoc) || isMakingCurVer) {
                resolve(modifiedDoc);
            }
            else {
                /** @type {?} */
                const documentId = modifiedDoc.documentId;
                /** @type {?} */
                let oldOriginalDoc = _self.documentService.getExistingDocument(documentId);
                if (!oldOriginalDoc) {
                    oldOriginalDoc = _self.documentService.getExistingDocument(modifiedDoc.systemHeader.versionId);
                }
                if (oldOriginalDoc) {
                    // load the latest version from DB first
                    _self.dataService.getDocument(documentId).then((/**
                     * @param {?} latestDoc
                     * @return {?}
                     */
                    function successFunc(latestDoc) {
                        /** @type {?} */
                        let diffs = UtilConflict.getDiffs(oldOriginalDoc, latestDoc);
                        if (diffs.length) {
                            // get the changed fields by rules and user on form
                            diffs = UtilConflict.getDiffs(oldOriginalDoc, modifiedDoc);
                            // update the latest version to current original version
                            _self.documentService.resetOriginalDocument(latestDoc);
                            // create a new copied version from the latest one
                            /** @type {?} */
                            const newModifiedDoc = cloneDeep(latestDoc);
                            // apply the changes by rules and user on form to the new document
                            if (diffs.length) {
                                diffs.forEach((/**
                                 * @param {?} diff
                                 * @return {?}
                                 */
                                function (diff) {
                                    newModifiedDoc[diff.fieldName] = modifiedDoc[diff.fieldName];
                                }));
                            }
                            /** @type {?} */
                            const template = _self.loadTemplate(newModifiedDoc);
                            if (template && template.components && template.components.length) {
                                template.components.forEach((/**
                                 * @param {?} component
                                 * @return {?}
                                 */
                                function (component) {
                                    if (!UtilType.isDefined(newModifiedDoc[component.name])) {
                                        if (UtilType.isDefined(component.defaultValue)) {
                                            newModifiedDoc[component.name] = component.defaultValue;
                                        }
                                    }
                                }));
                            }
                            // set the new changed version to unsaved list
                            _self.unsavedDocumentService.setDocument(unsavedDocumentListId, newModifiedDoc);
                            resolve(newModifiedDoc);
                        }
                        else {
                            resolve(modifiedDoc);
                        }
                    }), (/**
                     * @param {?} err
                     * @return {?}
                     */
                    function errorFunc(err) {
                        reject(err);
                    }));
                }
                else {
                    resolve(modifiedDoc);
                }
            }
        }));
    }
    /**
     * @param {?} unsavedDocumentListId
     * @return {?}
     */
    save(unsavedDocumentListId) {
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (!unsavedDocumentListId) {
                reject(new Error('Unsaved document list id not provided in save'));
            }
            else if (_self.modifiedFieldService.isSaving()) {
                reject(new Error('Save is already in progress'));
            }
            else {
                _self.setFlags(false, true, true, unsavedDocumentListId);
                /** @type {?} */
                const unsavedDocuments = _self.modifiedFieldService.getModifiedDocuments(unsavedDocumentListId);
                _self.doSave(unsavedDocumentListId).then((/**
                 * @param {?} docs
                 * @return {?}
                 */
                function doSaveSuccess(docs) {
                    return __awaiter(this, void 0, void 0, function* () {
                        // reset temporary array of saved documents
                        _self.savedDocs = null;
                        if (docs) {
                            for (let id = 0; id < docs.length; id++) {
                                /** @type {?} */
                                const doc = cloneDeep(docs[id]);
                                // Remove offline info before applying the changes
                                if (doc.systemHeader) {
                                    delete doc.systemHeader.offlineDetails;
                                }
                                yield _self.documentUpdateService.updateFormDocument(unsavedDocuments, doc);
                            }
                        }
                        _self.setFlags(false, false, false, unsavedDocumentListId);
                        resolve(docs);
                    });
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function errorFunc(err) {
                    _self.setFlags(true, false, false, unsavedDocumentListId);
                    reject(err);
                }));
            }
        }));
    }
}
DocumentSaveService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
DocumentSaveService.ctorParameters = () => [
    { type: DataService },
    { type: LoggedInUserService },
    { type: NotificationService },
    { type: DocumentService },
    { type: UnsavedDocumentService },
    { type: CurrentDocumentService },
    { type: CurrentChildDocumentService },
    { type: MandatoryFieldService },
    { type: ModifiedFieldService },
    { type: ValidationService },
    { type: ClientSystemHeaderService },
    { type: DocumentUpdateService },
    { type: ConfigService },
    { type: BroadcastService },
    { type: ClientAccessService },
    { type: ChangedDocumentService },
    { type: FinaliseValueFieldService },
    { type: AppStore }
];
/** @nocollapse */ DocumentSaveService.ɵprov = ɵɵdefineInjectable({ factory: function DocumentSaveService_Factory() { return new DocumentSaveService(ɵɵinject(DataService), ɵɵinject(LoggedInUserService), ɵɵinject(NotificationService), ɵɵinject(DocumentService), ɵɵinject(UnsavedDocumentService), ɵɵinject(CurrentDocumentService), ɵɵinject(CurrentChildDocumentService), ɵɵinject(MandatoryFieldService), ɵɵinject(ModifiedFieldService), ɵɵinject(ValidationService), ɵɵinject(ClientSystemHeaderService), ɵɵinject(DocumentUpdateService), ɵɵinject(ConfigService), ɵɵinject(BroadcastService), ɵɵinject(ClientAccessService), ɵɵinject(ChangedDocumentService), ɵɵinject(FinaliseValueFieldService), ɵɵinject(AppStore)); }, token: DocumentSaveService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.savedDocs;
    /** @type {?} */
    DocumentSaveService.prototype.documentData;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.dataService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.notificationService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.documentService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.unsavedDocumentService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.currentDocumentService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.currentChildDocumentService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.mandatoryFieldService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.modifiedFieldService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.validationService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.clientSystemHeaderService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.documentUpdateService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.configService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.broadcastService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.clientAccessService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.changedDocumentService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.finaliseValueService;
    /**
     * @type {?}
     * @private
     */
    DocumentSaveService.prototype.appStore;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/document/child-document-list.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$x = console;
class ChildDocumentListService {
    /**
     * @param {?} documentSaveService
     * @param {?} unsavedDocumentService
     * @param {?} modifiedFieldService
     * @param {?} validationService
     */
    constructor(documentSaveService, unsavedDocumentService, modifiedFieldService, validationService) {
        this.documentSaveService = documentSaveService;
        this.unsavedDocumentService = unsavedDocumentService;
        this.modifiedFieldService = modifiedFieldService;
        this.validationService = validationService;
        /*
           childDocumentInfo = {
            'documentListId': {
              hierarchyDocInfo: {
                parentDocumentId: 'parentDocumentId',
                childDocumentId: 'childDocumentId',
                documentId: 'documentId'
              }
            }
          };*/
        this.childDocumentInfo = (/** @type {?} */ ({}));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // this.sub = this.currentDocumentService.documentData$.subscribe(documentData => {
        //   this.documentData = documentData;
        // });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        // this.sub.unsubscribe();
    }
    /**
     * setup the document list id
     * @return {?}
     */
    setupChildDocumentListId() {
        /** @type {?} */
        const documentListId = this.unsavedDocumentService.createUnsavedDocumentList(ClientConstants.CHILD_DOCUMENT_INFO_LIST);
        this.childDocumentInfo[documentListId] = {
            documentListId: documentListId,
            hierarchyDocInfo: {
                parentDocumentId: null,
                childDocumentId: null,
                documentId: null
            }
        };
        logger$x.info('Setup child document list id...' + documentListId);
        return this.childDocumentInfo[documentListId];
    }
    /**
     * perform save of the all child document list
     * @return {?}
     */
    save() {
        logger$x.info('Saving child documents...');
        /** @type {?} */
        const _self = this;
        return new Promise((/**
         * @param {?} resolve
         * @return {?}
         */
        (resolve) => {
            // wait for onFieldChange to finish before saving
            _self.validationService.waitPendingEvents((/**
             * @return {?}
             */
            function () {
                /** @type {?} */
                const saveChildPromise = _self.saveChildDocumentList();
                resolve(saveChildPromise);
            }));
        }));
    }
    /**
     * @return {?}
     */
    saveChildDocumentList() {
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const documentListIds = Object.keys(_self.childDocumentInfo);
        /** @type {?} */
        const unsavedDocumentListIds = _self.modifiedFieldService.getAllChangedDocumentListIds();
        // save documents sequentially so that all document saves aren't sent to the server at the
        // same time. See the notes of Mantis 11213 for further details
        /**
         * @param {?} documentListId
         * @return {?}
         */
        function asyncJob(documentListId) {
            if (documentListId) {
                if (UtilArray.contains(unsavedDocumentListIds, documentListId)) {
                    return _self.documentSaveService.save(documentListId);
                }
            }
        }
        return UtilSequenceProcess.processList(documentListIds, asyncJob);
    }
    /**
     * @param {?} childDocumentListId
     * @return {?}
     */
    getChildDocumentInfo(childDocumentListId) {
        return this.childDocumentInfo[childDocumentListId];
    }
    /**
     * @return {?}
     */
    resetChildDocumentListId() {
        this.childDocumentInfo.documentListId = null;
        this.childDocumentInfo.hierarchyDocInfo = [];
        logger$x.info('Child Document Info has been reset.');
    }
    /**
     * @param {?} childDocumentListId
     * @return {?}
     */
    removeChildDocumentInfo(childDocumentListId) {
        if (childDocumentListId) {
            delete this.childDocumentInfo[childDocumentListId];
        }
    }
    /**
     * @param {?} childDocumentListId
     * @return {?}
     */
    clearDocuments(childDocumentListId) {
        /** @type {?} */
        const _self = this;
        if (childDocumentListId) {
            /** @type {?} */
            const unsavedDocuments = _self.unsavedDocumentService.getUnsavedDocuments(childDocumentListId);
            if (unsavedDocuments) {
                /** @type {?} */
                const docIds = Object.keys(unsavedDocuments);
                docIds.forEach((/**
                 * @param {?} docId
                 * @return {?}
                 */
                function (docId) {
                    /** @type {?} */
                    const unsavedDoc = unsavedDocuments[docId];
                    _self.modifiedFieldService.removeModifiedDocumentFields(unsavedDoc.documentId);
                }));
            }
            _self.unsavedDocumentService.removeDocumentList(childDocumentListId);
            _self.removeChildDocumentInfo(childDocumentListId);
        }
    }
}
ChildDocumentListService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ChildDocumentListService.ctorParameters = () => [
    { type: DocumentSaveService },
    { type: UnsavedDocumentService },
    { type: ModifiedFieldService },
    { type: ValidationService }
];
/** @nocollapse */ ChildDocumentListService.ɵprov = ɵɵdefineInjectable({ factory: function ChildDocumentListService_Factory() { return new ChildDocumentListService(ɵɵinject(DocumentSaveService), ɵɵinject(UnsavedDocumentService), ɵɵinject(ModifiedFieldService), ɵɵinject(ValidationService)); }, token: ChildDocumentListService, providedIn: "root" });
if (false) {
    /** @type {?} */
    ChildDocumentListService.prototype.childDocumentInfo;
    /**
     * @type {?}
     * @private
     */
    ChildDocumentListService.prototype.documentSaveService;
    /**
     * @type {?}
     * @private
     */
    ChildDocumentListService.prototype.unsavedDocumentService;
    /**
     * @type {?}
     * @private
     */
    ChildDocumentListService.prototype.modifiedFieldService;
    /**
     * @type {?}
     * @private
     */
    ChildDocumentListService.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/url/url.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UrlService {
    constructor() {
        this.urls = {
            external: null,
            lastEntered: null,
            // last entered before login
            lastVisited: null,
            // last visited within the app
            current: null // current viewed url
        };
    }
    /**
     * @return {?}
     */
    getUrls() {
        return this.urls;
    }
}
UrlService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
UrlService.ctorParameters = () => [];
/** @nocollapse */ UrlService.ɵprov = ɵɵdefineInjectable({ factory: function UrlService_Factory() { return new UrlService(); }, token: UrlService, providedIn: "root" });
if (false) {
    /** @type {?} */
    UrlService.prototype.urls;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/resource/client-resource.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ClientResourceService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @return {?}
     */
    getClientResources() {
        return this.http.get(SharedUrlRoutes.serverRoutes.clientResources).toPromise();
    }
    /**
     * @return {?}
     */
    getCachedFilesCount() {
        return Promise.resolve(0);
        // Will be checked later because caches object is undefined
        // return new Promise((resolve, reject) => {
        //   if (caches) {
        //     caches.keys().then(keyList => {
        //
        //       const promises = [];
        //       for (let i = 0; i < keyList.length - 1; i++) {
        //         const key = keyList[i];
        //         promises.push(caches.open(key));
        //       }
        //
        //       return Promise.all(promises);
        //
        //     }).then(returnedCaches => {
        //       const promises = [];
        //       for (let i = 0; i < returnedCaches.length; i++) {
        //         const cache = returnedCaches[i];
        //         promises.push(cache.keys());
        //       }
        //
        //       return Promise.all(promises);
        //
        //     }).then((cachedFilesArray) => {
        //       let totalCount = 0;
        //       for (let i = 0; i < cachedFilesArray.length; i++) {
        //         totalCount += cachedFilesArray[i].length;
        //       }
        //
        //       resolve(totalCount);
        //     });
        //   } else {
        //     resolve(0);
        //   }
        // });
    }
}
ClientResourceService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ClientResourceService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ ClientResourceService.ɵprov = ɵɵdefineInjectable({ factory: function ClientResourceService_Factory() { return new ClientResourceService(ɵɵinject(HttpClient)); }, token: ClientResourceService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ClientResourceService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/event/storage-event.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
let StorageEventService$;
class StorageEventService {
    constructor() {
        this.listeners = [];
        StorageEventService$ = this;
    }
    /**
     * @param {?} callback
     * @return {?}
     */
    addListener(callback) {
        this.listeners.push(callback);
    }
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    storage(event) {
        for (let i = 0; i < StorageEventService$.listeners.length; i++) {
            StorageEventService$.listeners[i](event);
        }
    }
    ;
    /**
     * @return {?}
     */
    start() {
        window.addEventListener('storage', this.storage);
    }
    /**
     * @return {?}
     */
    end() {
        this.listeners = [];
        window.removeEventListener('storage', this.storage);
    }
}
StorageEventService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
StorageEventService.ctorParameters = () => [];
/** @nocollapse */ StorageEventService.ɵprov = ɵɵdefineInjectable({ factory: function StorageEventService_Factory() { return new StorageEventService(); }, token: StorageEventService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    StorageEventService.prototype.listeners;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/utils/assert.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @hidden
 * @type {?}
 */
const assert = (/**
 * @param {?} condition
 * @param {?} message
 * @return {?}
 */
(condition, message) => {
    if (!condition) {
        throw new Error(message);
    }
});

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/utils/get-in.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets a deeply-nested property value from an object, given a 'path'
 * of property names or array indices.
 *
 * @hidden
 * @param {?} v
 * @param {?} pathElems
 * @return {?}
 */
function getIn(v, pathElems) {
    if (!v) {
        return v;
    }
    // If this is an ImmutableJS structure, use existing getIn function
    if ('function' === typeof v.getIn) {
        return v.getIn(pathElems);
    }
    const [firstElem, ...restElems] = pathElems;
    if (undefined === v[firstElem]) {
        return undefined;
    }
    if (restElems.length === 0) {
        return v[firstElem];
    }
    return getIn(v[firstElem], restElems);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/utils/set-in.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Sets a deeply-nested property value from an object, given a 'path'
 * of property names or array indices. Path elements are created if
 * not there already. Does not mutate the given object.
 *
 * @hidden
 * @type {?}
 */
const setIn = (/**
 * @param {?} obj
 * @param {?} __1
 * @param {?} value
 * @return {?}
 */
(obj, [firstElem, ...restElems], value) => 'function' === typeof (obj[firstElem] || {}).setIn
    ? Object.assign(Object.assign({}, obj), { [firstElem]: obj[firstElem].setIn(restElems, value) }) : Object.assign(Object.assign({}, obj), { [firstElem]: restElems.length === 0
        ? value
        : setIn(obj[firstElem] || {}, restElems, value) }));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/components/fractal-reducer-map.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
let reducerMap = {};
/** @type {?} */
const composeReducers = (/**
 * @param {...?} reducers
 * @return {?}
 */
(...reducers) => (/**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => reducers.reduce((/**
 * @param {?} subState
 * @param {?} reducer
 * @return {?}
 */
(subState, reducer) => reducer(subState, action)), state)));
const ɵ0$2 = composeReducers;
/**
 * @param {?} rootReducer Call this on your root reducer to enable SubStore
 * functionality for pre-configured stores (e.g. using AppStore.provideStore()).
 * AppStore.configureStore
 * does it for you under the hood.
 * @return {?}
 */
function enableFractalReducers(rootReducer) {
    reducerMap = {};
    return composeReducers(rootFractalReducer, rootReducer);
}
/**
 * @hidden
 * @param {?} basePath
 * @param {?} localReducer
 * @return {?}
 */
function registerFractalReducer(basePath, localReducer) {
    /** @type {?} */
    const existingFractalReducer = reducerMap[JSON.stringify(basePath)];
    if (existingFractalReducer && existingFractalReducer !== localReducer) {
        throw new Error(`attempt to overwrite fractal reducer for basePath ${basePath}`);
    }
    reducerMap[JSON.stringify(basePath)] = localReducer;
}
/**
 * @hidden
 * @param {?} basePath
 * @param {?} nextLocalReducer
 * @return {?}
 */
function replaceLocalReducer(basePath, nextLocalReducer) {
    reducerMap[JSON.stringify(basePath)] = nextLocalReducer;
}
/**
 * @param {?=} state
 * @param {?=} action
 * @return {?}
 */
function rootFractalReducer(state = {}, action) {
    /** @type {?} */
    const fractalKey = action['@angular-redux::fractalkey'];
    /** @type {?} */
    const fractalPath = fractalKey ? JSON.parse(fractalKey) : [];
    /** @type {?} */
    const localReducer = reducerMap[fractalKey || ''];
    return fractalKey && localReducer
        ? setIn(state, fractalPath, localReducer(getIn(state, fractalPath), action))
        : state;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/selectors/selectors.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @hidden
 * @type {?}
 */
const sniffSelectorType = (/**
 * @template RootState, S
 * @param {?=} selector
 * @return {?}
 */
(selector) => !selector
    ? 'nil'
    : Array.isArray(selector)
        ? 'path'
        : 'function' === typeof selector
            ? 'function'
            : 'property');
/**
 * @hidden
 * @type {?}
 */
const resolver = (/**
 * @template RootState, S
 * @param {?=} selector
 * @return {?}
 */
(selector) => ({
    property: (/**
     * @param {?} state
     * @return {?}
     */
    (state) => state ? state[(/** @type {?} */ (selector))] : undefined),
    path: (/**
     * @param {?} state
     * @return {?}
     */
    (state) => getIn$1(state, (/** @type {?} */ (selector)))),
    function: (/** @type {?} */ (selector)),
    nil: (/**
     * @param {?} state
     * @return {?}
     */
    (state) => state),
}));
/**
 * @hidden
 * @type {?}
 */
const resolveToFunctionSelector = (/**
 * @template RootState, S
 * @param {?=} selector
 * @return {?}
 */
(selector) => resolver(selector)[sniffSelectorType(selector)]);
/**
 * Gets a deeply-nested property value from an object, given a 'path'
 * of property names or array indices.
 *
 * @hidden
 * @param {?} v
 * @param {?} pathElems
 * @return {?}
 */
function getIn$1(v, pathElems) {
    if (!v) {
        return v;
    }
    // If this is an ImmutableJS structure, use existing getIn function
    if ('function' === typeof v.getIn) {
        return v.getIn(pathElems);
    }
    const [firstElem, ...restElems] = pathElems;
    if (undefined === v[firstElem]) {
        return undefined;
    }
    if (restElems.length === 0) {
        return v[firstElem];
    }
    return getIn$1(v[firstElem], restElems);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/components/selectors.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @hidden
 * @type {?}
 */
const sniffSelectorType$1 = (/**
 * @template RootState, S
 * @param {?=} selector
 * @return {?}
 */
(selector) => !selector
    ? 'nil'
    : Array.isArray(selector)
        ? 'path'
        : 'function' === typeof selector
            ? 'function'
            : 'property');
/**
 * @hidden
 * @type {?}
 */
const resolver$1 = (/**
 * @template RootState, S
 * @param {?=} selector
 * @return {?}
 */
(selector) => ({
    property: (/**
     * @param {?} state
     * @return {?}
     */
    (state) => state ? state[(/** @type {?} */ (selector))] : undefined),
    path: (/**
     * @param {?} state
     * @return {?}
     */
    (state) => getIn(state, (/** @type {?} */ (selector)))),
    function: (/** @type {?} */ (selector)),
    nil: (/**
     * @param {?} state
     * @return {?}
     */
    (state) => state),
}));
/**
 * @hidden
 * @type {?}
 */
const resolveToFunctionSelector$1 = (/**
 * @template RootState, S
 * @param {?=} selector
 * @return {?}
 */
(selector) => resolver$1(selector)[sniffSelectorType$1(selector)]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/components/sub-store.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @hidden
 * @template State
 */
class SubStore {
    /**
     * @param {?} rootStore
     * @param {?} basePath
     * @param {?} localReducer
     */
    constructor(rootStore, basePath, localReducer) {
        this.rootStore = rootStore;
        this.basePath = basePath;
        this.dispatch = (/**
         * @param {?} action
         * @return {?}
         */
        action => this.rootStore.dispatch(Object.assign(Object.assign({}, ((/** @type {?} */ (action)))), { '@angular-redux::fractalkey': JSON.stringify(this.basePath) })));
        this.getState = (/**
         * @return {?}
         */
        () => getIn(this.rootStore.getState(), this.basePath));
        this.configureSubStore = (/**
         * @template SubState
         * @param {?} basePath
         * @param {?} localReducer
         * @return {?}
         */
        (basePath, localReducer) => new SubStore(this.rootStore, [...this.basePath, ...basePath], localReducer));
        this.select = (/**
         * @template SelectedState
         * @param {?=} selector
         * @param {?=} comparator
         * @return {?}
         */
        (selector, comparator) => this.rootStore.select(this.basePath).pipe(map(resolveToFunctionSelector$1(selector)), distinctUntilChanged(comparator)));
        this.subscribe = (/**
         * @param {?} listener
         * @return {?}
         */
        (listener) => {
            /** @type {?} */
            const subscription = this.select().subscribe(listener);
            return (/**
             * @return {?}
             */
            () => subscription.unsubscribe());
        });
        this.replaceReducer = (/**
         * @param {?} nextLocalReducer
         * @return {?}
         */
        (nextLocalReducer) => replaceLocalReducer(this.basePath, nextLocalReducer));
        registerFractalReducer(basePath, localReducer);
    }
}
if (false) {
    /** @type {?} */
    SubStore.prototype.dispatch;
    /** @type {?} */
    SubStore.prototype.getState;
    /** @type {?} */
    SubStore.prototype.configureSubStore;
    /** @type {?} */
    SubStore.prototype.select;
    /** @type {?} */
    SubStore.prototype.subscribe;
    /** @type {?} */
    SubStore.prototype.replaceReducer;
    /**
     * @type {?}
     * @private
     */
    SubStore.prototype.rootStore;
    /**
     * @type {?}
     * @private
     */
    SubStore.prototype.basePath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/store/root.store.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @hidden
 * @template RootState
 */
class RootStore extends AppStore {
    constructor() {
        super();
        this.store = undefined;
        this.configureStore = (/**
         * @param {?} rootReducer
         * @param {?} initState
         * @param {?=} middleware
         * @param {?=} enhancers
         * @return {?}
         */
        (rootReducer, initState, middleware = [], enhancers = []) => {
            assert(!this.store, 'Store already configured!');
            // Variable-arity compose in typescript FTW.
            this.setStore(compose(applyMiddleware(...middleware), ...enhancers)(createStore)(enableFractalReducers(rootReducer), initState));
        });
        this.provideStore = (/**
         * @param {?} store
         * @return {?}
         */
        (store) => {
            assert(!this.store, 'Store already configured!');
            this.setStore(store);
        });
        this.getState = (/**
         * @return {?}
         */
        () => (/** @type {?} */ (this.store)).getState());
        this.subscribe = (/**
         * @param {?} listener
         * @return {?}
         */
        (listener) => (/** @type {?} */ (this.store)).subscribe(listener));
        this.replaceReducer = (/**
         * @param {?} nextReducer
         * @return {?}
         */
        (nextReducer) => {
            (/** @type {?} */ (this.store)).replaceReducer(nextReducer);
        });
        this.dispatch = (/**
         * @template A
         * @param {?} action
         * @return {?}
         */
        (action) => {
            assert(!!this.store, 'Dispatch failed: did you forget to configure your store? ');
            return (/** @type {?} */ (this.store)).dispatch(action);
        });
        this.select = (/**
         * @template SelectedType
         * @param {?=} selector
         * @param {?=} comparator
         * @return {?}
         */
        (selector, comparator) => this.store$.pipe(distinctUntilChanged(), map(resolveToFunctionSelector(selector)), distinctUntilChanged(comparator)));
        this.configureSubStore = (/**
         * @template SubState
         * @param {?} basePath
         * @param {?} localReducer
         * @return {?}
         */
        (basePath, localReducer) => new SubStore(this, basePath, localReducer));
        this.storeToObservable = (/**
         * @param {?} store
         * @return {?}
         */
        (store) => new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            observer.next(store.getState());
            /** @type {?} */
            const unsubscribeFromRedux = store.subscribe((/**
             * @return {?}
             */
            () => observer.next(store.getState())));
            return (/**
             * @return {?}
             */
            () => {
                unsubscribeFromRedux();
                observer.complete();
            });
        })));
        AppStore.instance = this;
        this.store$ = (/** @type {?} */ (new BehaviorSubject(undefined).pipe(filter((/**
         * @param {?} n
         * @return {?}
         */
        n => n !== undefined)), switchMap((/**
         * @param {?} observableStore
         * @return {?}
         */
        observableStore => (/** @type {?} */ (observableStore)))))));
    }
    /**
     * @private
     * @param {?} store
     * @return {?}
     */
    setStore(store) {
        this.store = store;
        /** @type {?} */
        const storeServable = this.storeToObservable(store);
        this.store$.next((/** @type {?} */ (storeServable)));
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    RootStore.prototype.store;
    /**
     * @type {?}
     * @private
     */
    RootStore.prototype.store$;
    /** @type {?} */
    RootStore.prototype.configureStore;
    /** @type {?} */
    RootStore.prototype.provideStore;
    /** @type {?} */
    RootStore.prototype.getState;
    /** @type {?} */
    RootStore.prototype.subscribe;
    /** @type {?} */
    RootStore.prototype.replaceReducer;
    /** @type {?} */
    RootStore.prototype.dispatch;
    /** @type {?} */
    RootStore.prototype.select;
    /** @type {?} */
    RootStore.prototype.configureSubStore;
    /**
     * @type {?}
     * @private
     */
    RootStore.prototype.storeToObservable;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/formbird-services.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// TODO: add dialog to entry files in app.module.ts
/**
 * @return {?}
 */
function appStoreFactory() {
    return new RootStore();
}
class FormbirdServicesModule {
    /**
     * @param {?} appStore
     */
    constructor(appStore) {
        /** @type {?} */
        const store = getStore();
        appStore.provideStore(store);
    }
}
FormbirdServicesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                entryComponents: [],
                imports: [
                    HttpClientModule,
                    FormbirdSharedModule,
                    FormbirdTypesModule
                ],
                exports: [],
                providers: [
                    { provide: AppStore, useFactory: appStoreFactory },
                    LoggedInUserService,
                    LocalStorageService,
                    DataService,
                    RestDataService,
                    ClientAccessService,
                    BroadcastService,
                    DocumentService,
                    TemplateService,
                    ComponentService,
                    CurrentDocumentService,
                    CurrentChildDocumentService,
                    CurrentDocumentInfoService,
                    UnsavedDocumentService,
                    ChangedDocumentService,
                    ClientSystemHeaderService,
                    SearchFilterService,
                    OfflineStatusService,
                    SearchService,
                    ControlStateSaveService,
                    SessionTestService,
                    LazyScriptLoaderService,
                    IndexedDBQueueService,
                    IndexedDBPropertiesService,
                    IndexedDBService,
                    ElasticIndexedDBService,
                    IndexedDBConnectorService,
                    DexieSearchService,
                    PageVisibilityService,
                    UserSettingsService,
                    FileProviderService,
                    OfflineUtilService,
                    FormColorService,
                    ModifiedCSSService,
                    DefaultStateService,
                    NavigationService,
                    ValidationService,
                    CustomFieldPreprocessorService,
                    PreProcessorFieldService,
                    ModifiedFieldService,
                    TabService,
                    RuleCacheService,
                    ClientRulesService,
                    ClientIncludeRuleSetService,
                    RuleEngineService,
                    NotificationService,
                    ChildDocumentListService,
                    DocumentSaveService,
                    DocumentUpdateService,
                    MandatoryFieldService,
                    TemplateHtmlService,
                    UrlService,
                    ClientResourceService,
                    StorageEventService,
                    UrlBasePathService,
                    VendorLibraryService,
                    FinaliseValueFieldService,
                    IncludeDocumentDataService
                ]
            },] }
];
/** @nocollapse */
FormbirdServicesModule.ctorParameters = () => [
    { type: AppStore }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/ControlStateConstants.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ControlStateConstants {
}
ControlStateConstants.CONTROL_STATE_STORAGE_PREFIX = 'ControlState_';
ControlStateConstants.CONTROL_STATE_SIDEBAR_TOGGLE = ControlStateConstants.CONTROL_STATE_STORAGE_PREFIX + 'SideBarToggle';
ControlStateConstants.CONTROL_STATE_SIDEBAR_TOGGLE_XS_SM = ControlStateConstants.CONTROL_STATE_STORAGE_PREFIX + 'SideBarToggleXsSm';
if (false) {
    /** @type {?} */
    ControlStateConstants.CONTROL_STATE_STORAGE_PREFIX;
    /** @type {?} */
    ControlStateConstants.CONTROL_STATE_SIDEBAR_TOGGLE;
    /** @type {?} */
    ControlStateConstants.CONTROL_STATE_SIDEBAR_TOGGLE_XS_SM;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/offline/offline-poller.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$y = console;
/** @type {?} */
let OfflinePollerService$;
class OfflinePollerService {
    /**
     * @param {?} storageEventService
     * @param {?} offlineStatusService
     * @param {?} loggedInUserService
     * @param {?} configService
     * @param {?} localStorageService
     * @param {?} indexedDBQueueService
     */
    constructor(storageEventService, offlineStatusService, loggedInUserService, configService, localStorageService, indexedDBQueueService) {
        this.storageEventService = storageEventService;
        this.offlineStatusService = offlineStatusService;
        this.loggedInUserService = loggedInUserService;
        this.configService = configService;
        this.localStorageService = localStorageService;
        this.indexedDBQueueService = indexedDBQueueService;
        this.poller = {
            pollerId: UtilDocumentId.generateId(),
            sending: false,
            // active or inactive
            lastActive: null // rule: poller will expire if inactive for 30 seconds and another poller instance will replace it
        };
        this.timer = null;
        this.startup = true;
        OfflinePollerService$ = this;
        /** @type {?} */
        const _self = this;
        // Add listener to reset the timer if the main poller's status is updated (for waiting pollers)
        this.storageEventService.addListener((/**
         * @param {?} event
         * @return {?}
         */
        function onPollerStatusUpdate(event) {
            if (event.key === OfflinePollerService.LOCAL_STORAGE_MAIN_POLLER_KEY) {
                /** @type {?} */
                let mainPoller = event.newValue;
                if (isString(mainPoller)) {
                    try {
                        mainPoller = JSON.parse(mainPoller);
                    }
                    catch (e) {
                    }
                }
                if (mainPoller.pollerId === _self.poller.pollerId) { // if this is the main poller then ignore
                    return;
                }
                // reset timer
                if (_self.timer != null) {
                    clearTimeout(_self.timer);
                    // Note that even the main poller will get informed, so inform the main poller to just ignore
                    // it so it won't call the mainPollerSequence again.
                    _self.start(true);
                }
            }
            else if (event.key === ClientConstants.LOCAL_STORAGE_OFFLINE_STATUS_KEY) {
                /** @type {?} */
                let newOfflineStatus = event.newValue;
                if (isString(newOfflineStatus)) {
                    try {
                        newOfflineStatus = JSON.parse(newOfflineStatus);
                        if (newOfflineStatus) {
                            _self.offlineStatusService.mergeOfflineStatusData(newOfflineStatus);
                        }
                    }
                    catch (e) {
                        logger$y.error(e);
                    }
                }
            }
        }));
    }
    /**
     * @param {?=} isStorageEvent
     * @return {?}
     */
    start(isStorageEvent) {
        /** @type {?} */
        const _self = this;
        //allows enabling or disabling of offline feature; assuming cachingEnabled is a boolean value
        if (!_self.loggedInUserService.getUserConfigItem('cachingEnabled') === true) {
            return;
        }
        /** @type {?} */
        let mainPoller = _self.getMainPoller();
        if (mainPoller && mainPoller.pollerId === _self.poller.pollerId && isStorageEvent === undefined) {
            _self.mainPollerSequence();
            return;
        }
        else if (mainPoller == null || !OfflinePollerService.isPollerActive(mainPoller)) {
            logger$y.info('Poller started and assigned as main. PollerID: ' + _self.poller.pollerId);
            _self.poller.lastActive = Date.now(); // timestamp in millis
            _self.updateMainPoller(_self.poller);
            _self.mainPollerSequence(false);
        }
        else {
            // still waiting for the main poller to die
            if (_self.startup) {
                logger$y.info('Offline poller not starting because there is already a poller. ' +
                    'Poller will start if the existing poller is closed. PollerID: ' + _self.poller.pollerId);
            }
            /** @type {?} */
            let configuredPollerLookupInterval = _self.configService.clientConfig().pollerLookupInterval;
            if (!configuredPollerLookupInterval) {
                configuredPollerLookupInterval = OfflinePollerService.DEFAULT_POLLER_LOOKUP_INTERVAL;
            }
            _self.timer = setTimeout((/**
             * @return {?}
             */
            function () {
                _self.start();
            }), configuredPollerLookupInterval);
        }
        _self.startup = false;
    }
    /**
     * @return {?}
     */
    end() {
        if (this.timer != null) {
            clearTimeout(this.timer);
        }
    }
    /**
     * @private
     * @param {?=} needTimeout
     * @return {?}
     */
    mainPollerSequence(needTimeout) {
        /** @type {?} */
        const _self = this;
        _self.keepPollerAlive();
        _self.poller.sending = false;
        if (needTimeout === false) {
            _self.checkForUnsyncedRecords();
        }
        else {
            // Read from config to get latest timeout value
            /** @type {?} */
            const configuredSyncTime = _self.configService.clientConfig().unsyncedRecordCheckTime;
            /** @type {?} */
            const unsyncedRecordCheckTime = configuredSyncTime ? configuredSyncTime : OfflinePollerService.DEFAULT_UNSYNCED_RECORD_CHECK_INTERVAL;
            _self.timer = setTimeout((/**
             * @return {?}
             */
            function () {
                _self.checkForUnsyncedRecords();
            }), unsyncedRecordCheckTime);
        }
    }
    /**
     * @private
     * @param {?} p
     * @return {?}
     */
    static isPollerActive(p) {
        if (p.lastActive == null) {
            return false;
        }
        /** @type {?} */
        const secondsSinceLastUpdate = Math.floor((Date.now() - p.lastActive) / 1000);
        return secondsSinceLastUpdate < OfflinePollerService.DEFAULT_POLLER_TIMEOUT;
    }
    /**
     * Keep alive poller if it's the main poller.
     * Called every time an item progresses (doc or file is sent/failed; file upload progresses)
     * @private
     * @return {?}
     */
    keepPollerAlive() {
        /** @type {?} */
        const mainPoller = OfflinePollerService$.getMainPoller();
        if (mainPoller.pollerId === OfflinePollerService$.poller.pollerId) {
            /** @type {?} */
            const secondsSinceLastUpdate = Math.floor((Date.now() - mainPoller.lastActive) / 1000);
            if (secondsSinceLastUpdate > 0) { // only update in a significant interval
                mainPoller.lastActive = Date.now();
                OfflinePollerService$.updateMainPoller(mainPoller);
            }
        }
    }
    /**
     * @private
     * @param {?} newValue
     * @return {?}
     */
    updateMainPoller(newValue) {
        OfflinePollerService$.localStorageService.setItem(OfflinePollerService.LOCAL_STORAGE_MAIN_POLLER_KEY, JSON.stringify(newValue));
    }
    /**
     * @private
     * @return {?}
     */
    getMainPoller() {
        /** @type {?} */
        const mainPoller = OfflinePollerService$.localStorageService.getItem(OfflinePollerService.LOCAL_STORAGE_MAIN_POLLER_KEY);
        return mainPoller ? JSON.parse(mainPoller) : null;
    }
    /**
     * @private
     * @return {?}
     */
    checkForUnsyncedRecords() {
        /** @type {?} */
        const _self = this;
        if (!_self.poller.sending) {
            _self.poller.sending = true;
            // send any offline objects
            _self.indexedDBQueueService.sendUnsyncedObjects(_self.keepPollerAlive).then((/**
             * @return {?}
             */
            function successFunc() {
                _self.start();
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function errorFunc(err) {
                logger$y.error('Synching offline objects failed: ' + err);
                _self.start();
            }));
        }
    }
}
/**
 * Time to wait before another cycle of processing offline files is initiated.
 */
OfflinePollerService.DEFAULT_UNSYNCED_RECORD_CHECK_INTERVAL = 5000;
/**
 * The interval in which a poller instance would lookup local storage again and see if it could become the main poller
 * replacing the old poller. If for some reason the main poller is still active but was replaced, it must terminate itself.
 *
 * This would mean that if a poller becomes inactive (reaches the timeout limit) it will be replaced in less than
 * 30 seconds (DEFAULT_POLLER_LOOKUP_INTERVAL) time.
 */
OfflinePollerService.DEFAULT_POLLER_LOOKUP_INTERVAL = 30 * 1000; //30 seconds
//30 seconds
/**
 * If the lastActive status is not updated and reaches a value greater than TIMEOUT, then it will be replaced.
 */
OfflinePollerService.DEFAULT_POLLER_TIMEOUT = 30; //in seconds
//in seconds
OfflinePollerService.LOCAL_STORAGE_MAIN_POLLER_KEY = 'MainOfflinePoller';
OfflinePollerService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
OfflinePollerService.ctorParameters = () => [
    { type: StorageEventService },
    { type: OfflineStatusService },
    { type: LoggedInUserService },
    { type: ConfigService },
    { type: LocalStorageService },
    { type: IndexedDBQueueService }
];
/** @nocollapse */ OfflinePollerService.ɵprov = ɵɵdefineInjectable({ factory: function OfflinePollerService_Factory() { return new OfflinePollerService(ɵɵinject(StorageEventService), ɵɵinject(OfflineStatusService), ɵɵinject(LoggedInUserService), ɵɵinject(ConfigService), ɵɵinject(LocalStorageService), ɵɵinject(IndexedDBQueueService)); }, token: OfflinePollerService, providedIn: "root" });
if (false) {
    /**
     * Time to wait before another cycle of processing offline files is initiated.
     * @type {?}
     */
    OfflinePollerService.DEFAULT_UNSYNCED_RECORD_CHECK_INTERVAL;
    /**
     * The interval in which a poller instance would lookup local storage again and see if it could become the main poller
     * replacing the old poller. If for some reason the main poller is still active but was replaced, it must terminate itself.
     *
     * This would mean that if a poller becomes inactive (reaches the timeout limit) it will be replaced in less than
     * 30 seconds (DEFAULT_POLLER_LOOKUP_INTERVAL) time.
     * @type {?}
     */
    OfflinePollerService.DEFAULT_POLLER_LOOKUP_INTERVAL;
    /**
     * If the lastActive status is not updated and reaches a value greater than TIMEOUT, then it will be replaced.
     * @type {?}
     */
    OfflinePollerService.DEFAULT_POLLER_TIMEOUT;
    /** @type {?} */
    OfflinePollerService.LOCAL_STORAGE_MAIN_POLLER_KEY;
    /**
     * @type {?}
     * @private
     */
    OfflinePollerService.prototype.poller;
    /**
     * @type {?}
     * @private
     */
    OfflinePollerService.prototype.timer;
    /**
     * @type {?}
     * @private
     */
    OfflinePollerService.prototype.startup;
    /**
     * @type {?}
     * @private
     */
    OfflinePollerService.prototype.storageEventService;
    /**
     * @type {?}
     * @private
     */
    OfflinePollerService.prototype.offlineStatusService;
    /**
     * @type {?}
     * @private
     */
    OfflinePollerService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    OfflinePollerService.prototype.configService;
    /**
     * @type {?}
     * @private
     */
    OfflinePollerService.prototype.localStorageService;
    /**
     * @type {?}
     * @private
     */
    OfflinePollerService.prototype.indexedDBQueueService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/tag/dynamic-meta-tag.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const serverRoutes$5 = SharedUrlRoutes.serverRoutes;
class DynamicMetaTagService {
    /**
     * @param {?} localStorageService
     */
    constructor(localStorageService) {
        this.localStorageService = localStorageService;
        this.metaDefaultTitle = 'Formbird Version ' + this.localStorageService.getItem(LocalStorageKeys.APP_VERSION);
        this.metaDefaultDesc = 'Copyright ' + new Date().getFullYear() + ' Formbird Pty Ltd. All rights reserved.';
        this.metaDefaultImg = '../../../../../images/formbird-logo.png';
    }
    /**
     * set the meta tags in the html head of the page. This can be used by other applications to see details about the current
     * document in the page, eg. with document unfurling in Skype or Slack
     * @param {?} title
     * @param {?} description
     * @param {?} img
     * @return {?}
     */
    set(title, description, img) {
        this.metaTitleData = title ? title : this.metaDefaultTitle;
        this.metaDescData = description ? description : this.metaDefaultDesc;
        this.metaImgData = img ? (serverRoutes$5.loadFile + '/' + img) : this.metaDefaultImg;
        /** @type {?} */
        const metaTitleElm = document.getElementById('metaTitle');
        if (metaTitleElm) {
            metaTitleElm.setAttribute('content', this.metaTitleData);
        }
        /** @type {?} */
        const metaDescElm = document.getElementById('metaDesc');
        if (metaDescElm) {
            metaDescElm.setAttribute('content', this.metaDescData);
        }
        /** @type {?} */
        const metaImgElm = document.getElementById('metaImg');
        if (metaImgElm) {
            metaImgElm.setAttribute('content', this.metaImgData);
        }
    }
    /**
     * @return {?}
     */
    title() {
        return this.metaTitleData;
    }
    /**
     * @return {?}
     */
    description() {
        return this.metaDescData;
    }
    /**
     * @return {?}
     */
    image() {
        return this.metaImgData;
    }
}
DynamicMetaTagService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
DynamicMetaTagService.ctorParameters = () => [
    { type: LocalStorageService }
];
/** @nocollapse */ DynamicMetaTagService.ɵprov = ɵɵdefineInjectable({ factory: function DynamicMetaTagService_Factory() { return new DynamicMetaTagService(ɵɵinject(LocalStorageService)); }, token: DynamicMetaTagService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    DynamicMetaTagService.prototype.metaDefaultTitle;
    /**
     * @type {?}
     * @private
     */
    DynamicMetaTagService.prototype.metaDefaultDesc;
    /**
     * @type {?}
     * @private
     */
    DynamicMetaTagService.prototype.metaDefaultImg;
    /**
     * @type {?}
     * @private
     */
    DynamicMetaTagService.prototype.metaTitleData;
    /**
     * @type {?}
     * @private
     */
    DynamicMetaTagService.prototype.metaDescData;
    /**
     * @type {?}
     * @private
     */
    DynamicMetaTagService.prototype.metaImgData;
    /**
     * @type {?}
     * @private
     */
    DynamicMetaTagService.prototype.localStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/redux/state/application.state.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IApplicationState() { }
if (false) {
    /** @type {?|undefined} */
    IApplicationState.prototype.formState;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/socket/web-socket.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$z = console;
/** @type {?} */
const urlBasePath = UrlBasePathUtil.basePathWithSlashPrefix;
/** @type {?} */
const path = { path: 'socket.io' };
/** @type {?} */
const WEB_SOCKET_RECONNECT_TIME = 1000;
class WebSocketService {
    /**
     * @param {?} notificationService
     * @param {?} offlineStatusService
     * @param {?} unsavedDocumentService
     * @param {?} dataService
     * @param {?} restDataService
     * @param {?} loggedInUserService
     * @param {?} documentUpdateService
     * @param {?} configService
     * @param {?} broadcastService
     */
    constructor(notificationService, offlineStatusService, unsavedDocumentService, dataService, restDataService, loggedInUserService, documentUpdateService, configService, broadcastService) {
        this.notificationService = notificationService;
        this.offlineStatusService = offlineStatusService;
        this.unsavedDocumentService = unsavedDocumentService;
        this.dataService = dataService;
        this.restDataService = restDataService;
        this.loggedInUserService = loggedInUserService;
        this.documentUpdateService = documentUpdateService;
        this.configService = configService;
        this.broadcastService = broadcastService;
    }
    /**
     * @private
     * @return {?}
     */
    getTransports() {
        if (this.configService.clientConfig().socketIO && this.configService.clientConfig().socketIO.transports) {
            return this.configService.clientConfig().socketIO.transports;
        }
        return null;
    }
    /**
     * cache any documents saved while offline. This can either be when the browser was closed or the device was offline
     * @private
     * @return {?}
     */
    loadDocumentsSavedWhileOffline() {
        /** @type {?} */
        const _self = this;
        logger$z.info('Device has come online or app has been started. Loading any data saved while offline');
        /** @type {?} */
        const promise = _self.dataService.loadDataCache(false);
        promise.then(updateCachedDocuments);
        /**
         * @param {?} newDocuments
         * @return {?}
         * @this {*}
         */
        function updateCachedDocuments(newDocuments) {
            return __awaiter(this, void 0, void 0, function* () {
                if (newDocuments) {
                    for (let i = 0; i < newDocuments.length; i++) {
                        /** @type {?} */
                        let newDocument = newDocuments[i];
                        yield _self.documentUpdateService.updateVersions([newDocument]);
                    }
                }
                return newDocuments;
            });
        }
    }
    /**
     * @return {?}
     */
    start() {
        logger$z.info('Starting websocket...');
        /** @type {?} */
        const _self = this;
        /** @type {?} */
        const options = {
            resource: path,
            path: null,
            transports: null
        };
        /** @type {?} */
        const transports = _self.getTransports();
        if (transports) {
            options.transports = transports;
        }
        options.path = urlBasePath + '/socket.io';
        _self.socket = connect('/', options);
        /**
         * @return {?}
         */
        function startReconnect() {
            if (!_self.socket.connected) {
                setTimeout(doReconnect, WEB_SOCKET_RECONNECT_TIME);
            }
        }
        /**
         * @return {?}
         */
        function doReconnect() {
            if (!_self.socket.connected) {
                startReconnect();
                _self.socket.connect();
            }
        }
        _self.socket.on(SharedConstants.WEB_SOCKET_MESSAGE_SAVE_DOCUMENT, (/**
         * @param {?} docInfo
         * @return {?}
         */
        function (docInfo) {
            if (_self.loggedInUserService.getUserConfigItem('cachingEnabled') === true ||
                _self.unsavedDocumentService.documentIsLoaded(docInfo.documentId)) {
                return _self.restDataService.loadVersions(docInfo.versionIds).then((/**
                 * @param {?} versions
                 * @return {?}
                 */
                function successFunc(versions) {
                    return __awaiter(this, void 0, void 0, function* () {
                        yield _self.documentUpdateService.updateVersions(versions);
                        if (_self.loggedInUserService.getUserConfigItem('cachingEnabled') === true) {
                            _self.offlineStatusService.addToMaxCacheCount(1);
                            // pass versions in. If it was not fetched already
                            _self.dataService.cacheDocument(docInfo, versions).then((/**
                             * @param {?} versions
                             * @return {?}
                             */
                            function successFunc(versions) {
                                logger$z.info("Cached pushed document for offline use: " + docInfo.documentId);
                            }), (/**
                             * @param {?} err
                             * @return {?}
                             */
                            function errorFunc(err) {
                                logger$z.info("Not found document from received pushed versions: " + docInfo.documentId);
                            }));
                        }
                    });
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function errorFunc(err) {
                    logger$z.error("Error loading pushed document: " + err.message);
                }));
            }
        }));
        _self.socket.on('reconnect', (/**
         * @param {?} attempt
         * @return {?}
         */
        function (attempt) {
            _self.loadDocumentsSavedWhileOffline();
        }));
        _self.socket.on('connect', (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            logger$z.info('Connected to notification socket. Setting status to connected.');
            _self.offlineStatusService.setConnected();
            // _self.utilService.scopeApply(_self.$rootScope);
            _self.loadDocumentsSavedWhileOffline();
        }));
        _self.socket.on('connect_error', (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            logger$z.info('Error in notification socket. Setting status to disconnected');
            _self.offlineStatusService.setDisconnected();
            // _self.utilService.scopeApply(_self.$rootScope);
        }));
        _self.socket.on('disconnect', (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            logger$z.info('Disconnected from notification socket. Setting status to disconnected');
            _self.offlineStatusService.setDisconnected();
            startReconnect();
        }));
        _self.socket.on(SharedConstants.WEB_SOCKET_MESSAGE_PASSWORD_RESET, (/**
         * @param {?} userId
         * @return {?}
         */
        function (userId) {
            _self.emit(SharedConstants.PASSWORD_RESET, userId);
        }));
    }
    /**
     * end the websocket session
     * @return {?}
     */
    end() {
        // disconnect from the socket. No callback is fired on doing this. A disconnect event is fired but only if the socket is
        // currently connected
        if (this.socket) {
            this.socket.disconnect();
        }
    }
    /**
     * @param {?} eventName
     * @param {?} data
     * @return {?}
     */
    emit(eventName, data) {
        this.socket.emit(eventName, data);
    }
    /**
     * @param {?} eventName
     * @param {?} eventHandlerFunc
     * @return {?}
     */
    addEventListener(eventName, eventHandlerFunc) {
        this.socket.on(eventName, eventHandlerFunc);
    }
    /**
     * @param {?} eventName
     * @return {?}
     */
    removeEventListener(eventName) {
        this.socket.off(eventName);
    }
}
WebSocketService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
WebSocketService.ctorParameters = () => [
    { type: NotificationService },
    { type: OfflineStatusService },
    { type: UnsavedDocumentService },
    { type: DataService },
    { type: RestDataService },
    { type: LoggedInUserService },
    { type: DocumentUpdateService },
    { type: ConfigService },
    { type: BroadcastService }
];
/** @nocollapse */ WebSocketService.ɵprov = ɵɵdefineInjectable({ factory: function WebSocketService_Factory() { return new WebSocketService(ɵɵinject(NotificationService), ɵɵinject(OfflineStatusService), ɵɵinject(UnsavedDocumentService), ɵɵinject(DataService), ɵɵinject(RestDataService), ɵɵinject(LoggedInUserService), ɵɵinject(DocumentUpdateService), ɵɵinject(ConfigService), ɵɵinject(BroadcastService)); }, token: WebSocketService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    WebSocketService.prototype.socket;
    /**
     * @type {?}
     * @private
     */
    WebSocketService.prototype.notificationService;
    /**
     * @type {?}
     * @private
     */
    WebSocketService.prototype.offlineStatusService;
    /**
     * @type {?}
     * @private
     */
    WebSocketService.prototype.unsavedDocumentService;
    /**
     * @type {?}
     * @private
     */
    WebSocketService.prototype.dataService;
    /**
     * @type {?}
     * @private
     */
    WebSocketService.prototype.restDataService;
    /**
     * @type {?}
     * @private
     */
    WebSocketService.prototype.loggedInUserService;
    /**
     * @type {?}
     * @private
     */
    WebSocketService.prototype.documentUpdateService;
    /**
     * @type {?}
     * @private
     */
    WebSocketService.prototype.configService;
    /**
     * @type {?}
     * @private
     */
    WebSocketService.prototype.broadcastService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: formbird-services.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AppStore, BroadcastService, ChangedDocumentService, ChildDocumentListService, ClientAccessService, ClientConstants, ClientIncludeRuleSetService, ClientResourceService, ClientRulesService, ClientSystemHeaderService, ComponentService, ConfigService, ControlStateConstants, ControlStateSaveService, CurrentChildDocumentService, CurrentDocumentInfoService, CurrentDocumentService, CustomFieldPreprocessorService, DataService, DefaultStateService, DexieSearchService, DocumentSaveService, DocumentService, DocumentSessionService, DocumentUpdateService, DynamicMetaTagService, ElasticIndexedDBService, FORM_CHANGE_DOCUMENT, FORM_CLEAR_DOCUMENT, FORM_DELETE_DOCUMENT, FORM_REDO, FORM_RESET_CHANGE_DOCUMENT, FORM_RESET_DOCUMENT_INFO, FORM_RESET_INIT_DOCUMENT_DATA, FORM_RESET_TEMPLATE_COMPONENT_DEFINITION, FORM_RESET_TO_ORG_DOCUMENT, FORM_RESET_UNDO_REDO, FORM_SETUP_DOCUMENT_LIST, FORM_SET_COMPONENT_FLAG_TEMPLATE, FORM_SET_DISABLE_SAVE_FIELD_DOCUMENT, FORM_SET_DOCUMENT, FORM_SET_DOCUMENT_INFO, FORM_SET_DOCUMENT_SESSION, FORM_SET_LIST_COMPONENTS_FLAG_TEMPLATE, FORM_SET_ORG_DOCUMENT, FORM_UNDO, FORM_UPDATE_COMPONENT_DEFINITION, FORM_UPDATE_DOCUMENT, FORM_UPDATE_INIT_DOCUMENT_DATA, FileProviderService, FinaliseValueFieldService, FormColorService, FormbirdServicesModule, IndexedDBConnectorService, IndexedDBPropertiesService, IndexedDBQueueService, IndexedDBService, KeyValueStorageService, LazyScriptLoaderService, LocalStorageKeys, LocalStorageService, LoggedInUserService, MandatoryFieldService, MandatoryValueProcessor, ModifiedCSSService, ModifiedFieldService, NavigationService, NotificationService, OfflinePollerService, OfflineStatusService, OfflineUtilService, PageVisibilityService, PreProcessorFieldService, RelatedDocumentPreprocessor, RestDataService, RuleCacheService, RuleContext, RuleEngineService, SearchFilterService, SearchService, SessionTestService, StorageEventService, TabService, TemplateService, UnsavedDocumentService, UrlBasePathService, UrlBasePathUtil, UrlService, UserSettingsService, ValidationService, VendorLibraryService, WebSocketService, appStoreFactory, formClearDocuments, formDeleteDocument, formDocumentChanged, formDocumentUpdated, formNewReducer, formRedoDocument, formResetDocumentChanged, formResetDocumentInfo, formResetInitDocumentData, formResetTemplateComponentDefinition, formResetToOrgDocument, formSetComponentFlagTemplate, formSetDisableSaveFieldDocument, formSetDocument, formSetDocumentInfo, formSetDocumentSession, formSetListComponentsFlagTemplate, formSetOrgDocument, formSetupDocumentList, formUndoDocument, formUpdateComponentDefinition, formUpdateInitDocumentData, getDefaultFormNewState, getIn$1 as getIn, getStore, resetUndoRedoDocument, resolveToFunctionSelector, resolver, select, select$, sniffSelectorType, RootStore as ɵa, TemplateHtmlService as ɵb, IncludeDocumentDataService as ɵc };
//# sourceMappingURL=formbird-services.js.map
